/**
 * A function to create a log object for the 'myAccountSelectSiteFromSiteListPopup' event (evid: 129)
 *
 * Event description: my account -> select site from site-list popup.
 *
 * @param {myAccountSelectSiteFromSiteListPopupParams} params - The parameters for this event
 * @property {GUID} site_id - site_id
 * @property {string} view_type - view_type
 * @property {string} sub_view - sub_view
 * @property {GUID} c1 - msid
 * @property {number} i1 - site_type
 * @property {number} num_selected_sites - num_selected_sites
 * @property {string} origin - origin
 * @property {string} place - place
 * @property {string} platform - platform
 * @property {string} hosting - hosting
 * @property {GUID} msid - msid
 * @property {string} view - view
 * @return {LogObject<myAccountSelectSiteFromSiteListPopupParams>} LogObject<myAccountSelectSiteFromSiteListPopupParams>
 */
export function myAccountSelectSiteFromSiteListPopup(params) {
    return { evid: 129, src: 2, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'myAccountEditSite' event (evid: 71)
 *
 * Event description: my account -> Edit site.
 *
 * @param {myAccountEditSiteParams} params - The parameters for this event
 * @property {GUID} site_id - site id
 * @property {string} view_type - view_type
 * @property {string} ds_origin - adi/editor
 * @property {string} origin - msid if was inside a site dashboard, 'my-sites' if was in my-sites page
 * @property {string} place - button/left-nav/my-sites
 * @property {number} site_type_enriched - site_type
 * @property {GUID} esi -  the editing session guid
 * @property {string} platform - platform
 * @property {string} hosting - hosting
 * @property {GUID} msid - msid
 * @return {LogObject<myAccountEditSiteParams>} LogObject<myAccountEditSiteParams>
 */
export function myAccountEditSite(params) {
    return { evid: 71, src: 2, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'dashboardDeleteAndRestoreSiteOpenPopup' event (evid: 100)
 *
 * Event description: user clicks on Move to Trash/Restore/Remove from Trash  button from popup window
 *
 * @param {dashboardDeleteAndRestoreSiteOpenPopupParams} params - The parameters for this event
 * @property {string} name - deprecated
 * @property {string} view_type - view_type
 * @property {string} platform - platform
 * @property {GUID} msid - -
 * @property {string} popup_name - popup_name
 * @return {LogObject<dashboardDeleteAndRestoreSiteOpenPopupParams>} LogObject<dashboardDeleteAndRestoreSiteOpenPopupParams>
 */
export function dashboardDeleteAndRestoreSiteOpenPopup(params) {
    return { evid: 100, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'dashboardDeleteAndRestoreSiteRestoreSiteClick' event (evid: 101)
 *
 * Event description: user clicks on Move to Trash/Restore/Remove from Trash  button from popup window
 *
 * @param {dashboardDeleteAndRestoreSiteRestoreSiteClickParams} params - The parameters for this event
 * @property {string} view_type - view_type
 * @property {string} origin - button name
 * @property {string} platform - platform
 * @property {GUID} msid - -
 * @return {LogObject<dashboardDeleteAndRestoreSiteRestoreSiteClickParams>} LogObject<dashboardDeleteAndRestoreSiteRestoreSiteClickParams>
 */
export function dashboardDeleteAndRestoreSiteRestoreSiteClick(params) {
    return { evid: 101, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'dashboardSiteActivityCenterClickDeleteItem' event (evid: 102)
 *
 * Event description: dashboard > site -> activity center -> click delete item.
 *
 * @param {dashboardSiteActivityCenterClickDeleteItemParams} params - The parameters for this event
 * @property {string} name - name
 * @property {GUID} item_id - item_id
 * @property {string} source - source
 * @property {boolean} is_deleted - is_deleted
 * @property {string} view_type - view_type
 * @property {string} origin - origin
 * @property {number} items_count - items_count
 * @property {string} type - type
 * @property {string} platform - platform
 * @property {GUID} msid - msid
 * @property {boolean} is_archived - is_archived
 * @property {GUID} feed_id - feed_id
 * @return {LogObject<dashboardSiteActivityCenterClickDeleteItemParams>} LogObject<dashboardSiteActivityCenterClickDeleteItemParams>
 */
export function dashboardSiteActivityCenterClickDeleteItem(params) {
    return { evid: 102, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'dashboardSiteActivityCenterClickUndoDeletedItem' event (evid: 103)
 *
 * Event description: dashboard > site -> activity center -> click undo deleted item.
 *
 * @param {dashboardSiteActivityCenterClickUndoDeletedItemParams} params - The parameters for this event
 * @property {GUID} item_id - item_id
 * @property {string} source - source
 * @property {boolean} is_deleted - is_deleted
 * @property {string} view_type - view_type
 * @property {string} action_url - action_url
 * @property {string} referral - referral
 * @property {string} action_desc - action_desc
 * @property {string} origin - origin
 * @property {number} items_count - items_count
 * @property {number} expire - expire
 * @property {string} type - type
 * @property {string} platform - platform
 * @property {GUID} msid - msid
 * @property {boolean} is_archived - is_archived
 * @property {GUID} feed_id - feed_id
 * @return {LogObject<dashboardSiteActivityCenterClickUndoDeletedItemParams>} LogObject<dashboardSiteActivityCenterClickUndoDeletedItemParams>
 */
export function dashboardSiteActivityCenterClickUndoDeletedItem(params) {
    return { evid: 103, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'dashboardSiteActivityCenterClickOnArchiveItem' event (evid: 104)
 *
 * Event description: dashboard > site -> activity center -> click on archive item.
 *
 * @param {dashboardSiteActivityCenterClickOnArchiveItemParams} params - The parameters for this event
 * @property {GUID} item_id - item_id
 * @property {string} source - source
 * @property {boolean} is_deleted - is_deleted
 * @property {string} view_type - view_type
 * @property {string} action_url - action_url
 * @property {string} referral - referral
 * @property {string} action_desc - action_desc
 * @property {string} origin - origin
 * @property {number} items_count - items_count
 * @property {number} expire - expire
 * @property {string} type - type
 * @property {string} platform - platform
 * @property {GUID} msid - msid
 * @property {boolean} is_archived - is_archived
 * @property {GUID} feed_id - feed_id
 * @return {LogObject<dashboardSiteActivityCenterClickOnArchiveItemParams>} LogObject<dashboardSiteActivityCenterClickOnArchiveItemParams>
 */
export function dashboardSiteActivityCenterClickOnArchiveItem(params) {
    return { evid: 104, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'dashboardUserClickedOnContactSNameFromUserActivity' event (evid: 105)
 *
 * Event description: Click on contact's name in a feed that was added from a TPA due to UoU activity
 *
 * @param {dashboardUserClickedOnContactSNameFromUserActivityParams} params - The parameters for this event
 * @property {string} name - name
 * @property {GUID} item_id - item_id
 * @property {string} source - source
 * @property {string} view_type - view_type
 * @property {string} origin - origin
 * @property {string} type - type
 * @property {string} platform - platform
 * @property {GUID} msid - msid
 * @property {GUID} feed_id - feed_id
 * @return {LogObject<dashboardUserClickedOnContactSNameFromUserActivityParams>} LogObject<dashboardUserClickedOnContactSNameFromUserActivityParams>
 */
export function dashboardUserClickedOnContactSNameFromUserActivity(params) {
    return { evid: 105, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'clickOnSidebarSHeader' event (evid: 106)
 *
 * Event description: user clicks on sidebar's header and returns to the dashboard
 *
 * @param {clickOnSidebarSHeaderParams} params - The parameters for this event
 * @property {string} name - unique name that doesn't change when changing the name on the side bar
 * @property {string} view_type - view_type
 * @property {string} app_id - app_id of the item
 * @property {string} platform - platform
 * @property {string} hosting - MA/editor
 * @property {GUID} msid - metasite id
 * @return {LogObject<clickOnSidebarSHeaderParams>} LogObject<clickOnSidebarSHeaderParams>
 */
export function clickOnSidebarSHeader(params) {
    return { evid: 106, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'sidebarState107' event (evid: 107)
 *
 * Event description: on each Bizmgr page, the event sends the current state of the sidebar.
 * this event will be sent also when the user arrives to Bizgmr from an external link.
 * e.g. main menu/setting menu/marketing tools menu etc.
 *
 * @param {sidebarState107Params} params - The parameters for this event
 * @property {string} sub_section_name - when the sidebar is opened on a third level item- should represents the second level of the active name field, else=null
 * @property {string} hosting_platform - accountmanagr/bizmanagr/devcenter/etc.
 * @property {string} section_name - the name of the section (highest level in the shown sidebar) -in case of expand it will be the expanded menu name
 * @property {string} category_items_list - list of category items in the main sidebar menu (might be under the fold)
 * @property {string} items_below_fold - items_below_fold
 * @property {string} referral_info - referral of previous page
 * @property {string} view_type - view_type
 * @property {string} active_item - the active sidebar item the user is navigated to
 * @property {string} prev_page_id - the previous page id
 * @property {string} page_id - the active page id
 * @property {string} active_item_cta - deprecated
 * @property {string} sub_category_items_list - list of sub_category items (second level) in the expanded sidebar menu (might be under the fold)
 * @property {string} second_sub_category_items_list - when the sidebar is opened on a third level item- list of third level items in the expanded sidebar menu, else null
 * @property {string} platform - deprecated
 * @property {string} items_above_fold - items_above_fold
 * @property {string} hosting_platform_context_id - context id: when the context is site - msid, when the context is app_id (like in devCenter f.e) - appDefId. In account manager is null
 * @property {string} hosting - MA/editor
 * @property {GUID} msid - --
 * @property {string} view - the page loaded with the sidebar (not internal page - module)
 * @return {LogObject<sidebarState107Params>} LogObject<sidebarState107Params>
 */
export function sidebarState107(params) {
    return { evid: 107, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'mobileDashboardCreateNewSite' event (evid: 108)
 *
 * Event description: when a user creates a new site from the mobile dashboard
 *
 * @param {mobileDashboardCreateNewSiteParams} params - The parameters for this event
 * @property {string} view_type - view_type
 * @property {string} platform - platform
 * @property {string} view - siteless/ my-sites
 * @return {LogObject<mobileDashboardCreateNewSiteParams>} LogObject<mobileDashboardCreateNewSiteParams>
 */
export function mobileDashboardCreateNewSite(params) {
    return { evid: 108, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'automationsClickOnDuplicateAutomation' event (evid: 109)
 *
 * Event description: user click on duplicate automation
 *
 * @param {automationsClickOnDuplicateAutomationParams} params - The parameters for this event
 * @property {string} view_type - view_type
 * @property {GUID} rule_id - the origin rule_id
 * @property {string} recipeName - recipeName
 * @property {string} origin - 'home' / 'my automations page'
 * @property {string} rule_name - rule_name
 * @property {string} platform - platform
 * @property {GUID} msid - msid
 * @return {LogObject<automationsClickOnDuplicateAutomationParams>} LogObject<automationsClickOnDuplicateAutomationParams>
 */
export function automationsClickOnDuplicateAutomation(params) {
    return { evid: 109, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'accountManagerStartLoadingAccountManager' event (evid: 110)
 *
 * Event description: start loading account manager
 *
 * @param {accountManagerStartLoadingAccountManagerParams} params - The parameters for this event
 * @property {string} referral_info - referral_info
 * @property {string} view_type - view_type
 * @property {boolean} initial_load - initial_load
 * @property {string} platform - platform
 * @return {LogObject<accountManagerStartLoadingAccountManagerParams>} LogObject<accountManagerStartLoadingAccountManagerParams>
 */
export function accountManagerStartLoadingAccountManager(params) {
    return { evid: 110, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'accountManagerFinishLoadingAccountManager' event (evid: 111)
 *
 * Event description: start loading account manager
 *
 * @param {accountManagerFinishLoadingAccountManagerParams} params - The parameters for this event
 * @property {string} referral_info - referral_info
 * @property {string} view_type - view_type
 * @property {boolean} initial_load - initial_load
 * @property {string} platform - platform
 * @property {number} loading_time - loading_time from 110
 * @return {LogObject<accountManagerFinishLoadingAccountManagerParams>} LogObject<accountManagerFinishLoadingAccountManagerParams>
 */
export function accountManagerFinishLoadingAccountManager(params) {
    return { evid: 111, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'crmHomeIntegrationsMarketingConnect' event (evid: 1114)
 *
 * Event description: CRM Home - integrations - marketing view all
 *
 * @param {crmHomeIntegrationsMarketingConnectParams} params - The parameters for this event
 * @property {string} view_type - view_type
 * @property {string} connectTab - which connection the user choose
 * @property {string} platform - platform
 * @property {GUID} msid - msid
 * @return {LogObject<crmHomeIntegrationsMarketingConnectParams>} LogObject<crmHomeIntegrationsMarketingConnectParams>
 */
export function crmHomeIntegrationsMarketingConnect(params) {
    return { evid: 1114, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'crmHomeIntegrationsFinanceViewAll' event (evid: 1115)
 *
 * Event description: CRM Home - integrations - marketing view all
 *
 * @param {crmHomeIntegrationsFinanceViewAllParams} params - The parameters for this event
 * @property {string} view_type - view_type
 * @property {string} platform - platform
 * @property {GUID} msid - msid
 * @return {LogObject<crmHomeIntegrationsFinanceViewAllParams>} LogObject<crmHomeIntegrationsFinanceViewAllParams>
 */
export function crmHomeIntegrationsFinanceViewAll(params) {
    return { evid: 1115, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'crmHomeIntegrationsFinanceConnect' event (evid: 1116)
 *
 * Event description: CRM Home - integrations - finance connect
 *
 * @param {crmHomeIntegrationsFinanceConnectParams} params - The parameters for this event
 * @property {string} view_type - view_type
 * @property {string} connectTab - which connection the user choose
 * @property {string} platform - platform
 * @property {GUID} msid - msid
 * @return {LogObject<crmHomeIntegrationsFinanceConnectParams>} LogObject<crmHomeIntegrationsFinanceConnectParams>
 */
export function crmHomeIntegrationsFinanceConnect(params) {
    return { evid: 1116, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'accountSettingsDisableSocialAccountConfirmationModalLoad' event (evid: 1119)
 *
 * Event description: When the user clicks on "disable" Apple social login, and they don't have any other social login connected, he will see a modal with confirmation message
 *
 * @param {accountSettingsDisableSocialAccountConfirmationModalLoadParams} params - The parameters for this event
 * @property {string} provider_id - the social provider the user tried to disable (apple/google/facebook)
 * @property {string} view_type - view_type
 * @property {string} platform - platform
 * @return {LogObject<accountSettingsDisableSocialAccountConfirmationModalLoadParams>} LogObject<accountSettingsDisableSocialAccountConfirmationModalLoadParams>
 */
export function accountSettingsDisableSocialAccountConfirmationModalLoad(params) {
    return { evid: 1119, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'accountManagerPageComponentStartLoadingAccountManager' event (evid: 112)
 *
 * Event description: page component start loading account manager module
 *
 * @param {accountManagerPageComponentStartLoadingAccountManagerParams} params - The parameters for this event
 * @property {string} referral_info - referral_info
 * @property {string} view_type - view_type
 * @property {string} sub_view - sub_view
 * @property {string} prev_view - prev_view
 * @property {string} prev_sub_view - prev_sub_view
 * @property {string} platform - platform
 * @property {string} view - view
 * @return {LogObject<accountManagerPageComponentStartLoadingAccountManagerParams>} LogObject<accountManagerPageComponentStartLoadingAccountManagerParams>
 */
export function accountManagerPageComponentStartLoadingAccountManager(params) {
    return { evid: 112, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'accountSettingsDisableSocialAccountClickDisableInConfirmationModal' event (evid: 1120)
 *
 * Event description: The user clicked on "disable" in the confirmation message shown once trying to disable Apple social account
 *
 * @param {accountSettingsDisableSocialAccountClickDisableInConfirmationModalParams} params - The parameters for this event
 * @property {string} provider_id - the social provider the user tried to disable (apple/google/facebook)
 * @property {string} view_type - view_type
 * @property {string} platform - platform
 * @return {LogObject<accountSettingsDisableSocialAccountClickDisableInConfirmationModalParams>} LogObject<accountSettingsDisableSocialAccountClickDisableInConfirmationModalParams>
 */
export function accountSettingsDisableSocialAccountClickDisableInConfirmationModal(params) {
    return { evid: 1120, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'crmHomeGoToMarketingTools' event (evid: 1122)
 *
 * Event description: CRM Home - go to marketing tools
 *
 * @param {crmHomeGoToMarketingToolsParams} params - The parameters for this event
 * @property {string} view_type - view_type
 * @property {string} platform - platform
 * @property {GUID} msid - msid
 * @return {LogObject<crmHomeGoToMarketingToolsParams>} LogObject<crmHomeGoToMarketingToolsParams>
 */
export function crmHomeGoToMarketingTools(params) {
    return { evid: 1122, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'accountManagerPageComponentFinishLoadingAccountManager' event (evid: 113)
 *
 * Event description: start loading account manager module
 *
 * @param {accountManagerPageComponentFinishLoadingAccountManagerParams} params - The parameters for this event
 * @property {string} referral_info - referral_info
 * @property {string} view_type - view_type
 * @property {string} sub_view - sub_view
 * @property {string} prev_view - prev_view
 * @property {string} prev_sub_view - prev_sub_view
 * @property {string} platform - platform
 * @property {string} view - view
 * @property {number} loading_time - loading_time
 * @return {LogObject<accountManagerPageComponentFinishLoadingAccountManagerParams>} LogObject<accountManagerPageComponentFinishLoadingAccountManagerParams>
 */
export function accountManagerPageComponentFinishLoadingAccountManager(params) {
    return { evid: 113, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'accountManagerClickOnSidebarItem' event (evid: 114)
 *
 * Event description: user clicks on an item from the sidebar in the account manager
 *
 * @param {accountManagerClickOnSidebarItemParams} params - The parameters for this event
 * @property {string} name - unique name that doesn't change when changing the name on the side bar
 * @property {string} sidebar_name - the name that appears in the sidebar - can be changed
 * @property {string} referral_info - referral_info
 * @property {string} view_type - view_type
 * @property {string} platform - platform
 * @return {LogObject<accountManagerClickOnSidebarItemParams>} LogObject<accountManagerClickOnSidebarItemParams>
 */
export function accountManagerClickOnSidebarItem(params) {
    return { evid: 114, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'accountManagerClickOnBackInSidebarItem' event (evid: 115)
 *
 * Event description: user clicks on back from the sidebar in the account manager
 *
 * @param {accountManagerClickOnBackInSidebarItemParams} params - The parameters for this event
 * @property {string} name - unique name that doesn't change when changing the name on the side bar
 * @property {string} sidebar_name - the name that appears in the sidebar - can be changed
 * @property {string} referral_info - referral_info
 * @property {string} view_type - view_type
 * @property {string} platform - platform
 * @return {LogObject<accountManagerClickOnBackInSidebarItemParams>} LogObject<accountManagerClickOnBackInSidebarItemParams>
 */
export function accountManagerClickOnBackInSidebarItem(params) {
    return { evid: 115, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'settingsLobbySectionIsSeen' event (evid: 1156)
 *
 * Event description: when a section is seen (actually) in setting lobby page
 *
 * @param {settingsLobbySectionIsSeenParams} params - The parameters for this event
 * @property {string} section_name - site-details/general/ecommerce/..
 * @property {string} view_type - view_type
 * @property {string} platform - platform
 * @property {string} section_loaction_on_page - the location of section in page (order from 0,1,..)
 * @property {string} hosting - MA/editor/onboarding
 * @property {GUID} msid - --
 * @return {LogObject<settingsLobbySectionIsSeenParams>} LogObject<settingsLobbySectionIsSeenParams>
 */
export function settingsLobbySectionIsSeen(params) {
    return { evid: 1156, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'settingsLobbyClickOnItem' event (evid: 1158)
 *
 * Event description: when a user clicks on an item in one of the settings' sections,
 *
 * @param {settingsLobbyClickOnItemParams} params - The parameters for this event
 * @property {number} item_location_on_page - the location of item in page (order from 0,1,..
 * @property {string} section_name - site-details/general/ecommerce/..
 * @property {string} click_type - if the helper is dismiss then the value is 'dismissed'
 * @property {string} view_type - view_type
 * @property {string} cta_name - the cta value (if exists) - f.e. “Get a business number”
 * @property {string} page_id - page component id of lined page
 * @property {string} item_location - item_location in this format {section,column,row}
 * @property {string} item_name - upgrade/connect_domain/.../website settings/business info/ roles and permissions/.../accept payments…
 * @property {string} status - If the red badge is shown when the user clicks then "true", if not "false"
 * @property {string} platform - platform
 * @property {string} hosting - MA/editor/onboarding
 * @property {GUID} msid - --
 * @return {LogObject<settingsLobbyClickOnItemParams>} LogObject<settingsLobbyClickOnItemParams>
 */
export function settingsLobbyClickOnItem(params) {
    return { evid: 1158, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'foldersMarkUnmarkSelectAllButton' event (evid: 116)
 *
 * Event description: mark/unmark 'select all' button
 *
 * @param {foldersMarkUnmarkSelectAllButtonParams} params - The parameters for this event
 * @property {string} name - mark/unmark
 * @property {string} view_type - view_type
 * @property {string} sub_view - grid/ list-view
 * @property {string} platform - platform
 * @property {string} hosting - MA
 * @property {string} view - my-sites
 * @return {LogObject<foldersMarkUnmarkSelectAllButtonParams>} LogObject<foldersMarkUnmarkSelectAllButtonParams>
 */
export function foldersMarkUnmarkSelectAllButton(params) {
    return { evid: 116, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'foldersClickOnChangeViewMode' event (evid: 117)
 *
 * Event description: sort list view
 *
 * @param {foldersClickOnChangeViewModeParams} params - The parameters for this event
 * @property {string} click_name - list-view/grid
 * @property {string} view_mode - list-view/grid - shows the previous mode
 * @property {string} view_type - view_type
 * @property {string} sub_view - sub_view
 * @property {string} origin - origin
 * @property {string} platform - platform
 * @property {string} hosting - MA/editor
 * @property {string} view - my-sites
 * @return {LogObject<foldersClickOnChangeViewModeParams>} LogObject<foldersClickOnChangeViewModeParams>
 */
export function foldersClickOnChangeViewMode(params) {
    return { evid: 117, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'foldersTooltipShown' event (evid: 118)
 *
 * Event description: When a user moves a site to Trash for the first time show a tooltip.
 *
 * @param {foldersTooltipShownParams} params - The parameters for this event
 * @property {string} name - trash_tooltip
 * @property {string} view_type - view_type
 * @property {string} sub_view - grid/list
 * @property {string} platform - platform
 * @property {string} hosting - MA
 * @property {string} view - my-sites
 * @return {LogObject<foldersTooltipShownParams>} LogObject<foldersTooltipShownParams>
 */
export function foldersTooltipShown(params) {
    return { evid: 118, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'dashboardSiteSettingsLocationsModalPageView' event (evid: 1189)
 *
 * Event description: Locations Modal page view
 *
 * @param {dashboardSiteSettingsLocationsModalPageViewParams} params - The parameters for this event
 * @property {string} view_type - view_type
 * @property {string} origin - name of previous tab
 * @property {string} fields - not sent
 * @property {string} platform - platform
 * @property {string} location_details - 0- first location (create), 1-second location, 2- third location,...
 * @property {string} hosting - from where user arrived to locations modal (Editor/MA/bookings...)
 * @property {GUID} msid - msid
 * @return {LogObject<dashboardSiteSettingsLocationsModalPageViewParams>} LogObject<dashboardSiteSettingsLocationsModalPageViewParams>
 */
export function dashboardSiteSettingsLocationsModalPageView(params) {
    return { evid: 1189, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'foldersClickOnShowMoreShoeLess' event (evid: 119)
 *
 * Event description: Click on 'show more' or 'show less' button from my-sites to see more/less folders
 *
 * @param {foldersClickOnShowMoreShoeLessParams} params - The parameters for this event
 * @property {string} name - the name of the button
 * @property {string} view_mode - grid
 * @property {string} view_type - view_type
 * @property {string} sub_view - sub_view
 * @property {string} platform - platform
 * @property {string} hosting - MA
 * @property {string} view - my-sites
 * @return {LogObject<foldersClickOnShowMoreShoeLessParams>} LogObject<foldersClickOnShowMoreShoeLessParams>
 */
export function foldersClickOnShowMoreShoeLess(params) {
    return { evid: 119, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'dashboardUpgradeLink' event (evid: 12)
 *
 * Event description: click on upgrade from my account
 *
 * @param {dashboardUpgradeLinkParams} params - The parameters for this event
 * @property {string} name - name
 * @property {string} view_type - view_type
 * @property {string} origin - upgrade button
 * @property {string} platform - platform
 * @return {LogObject<dashboardUpgradeLinkParams>} LogObject<dashboardUpgradeLinkParams>
 */
export function dashboardUpgradeLink(params) {
    return { evid: 12, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'ascendPagePageNavigationClick' event (evid: 120)
 *
 * Event description: click on one of the items in the page
 *
 * @param {ascendPagePageNavigationClickParams} params - The parameters for this event
 * @property {string} referral_info - referral_info
 * @property {string} view_type - view_type
 * @property {string} item_name - inbox /chat/seo wiz/ coupons etc.
 * @property {string} category - marketing / customer
 * @property {string} prev_view - prev_view
 * @property {string} platform - platform
 * @property {number} loading_time - loading_time
 * @return {LogObject<ascendPagePageNavigationClickParams>} LogObject<ascendPagePageNavigationClickParams>
 */
export function ascendPagePageNavigationClick(params) {
    return { evid: 120, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'invoicesAddAProductVariantOpenModal' event (evid: 1209)
 *
 * Event description: Invoices - Add a product Variant - open modal
 *
 * @param {invoicesAddAProductVariantOpenModalParams} params - The parameters for this event
 * @property {string} view_type - view_type
 * @property {string} platform - platform
 * @property {string} msid - msid
 * @return {LogObject<invoicesAddAProductVariantOpenModalParams>} LogObject<invoicesAddAProductVariantOpenModalParams>
 */
export function invoicesAddAProductVariantOpenModal(params) {
    return { evid: 1209, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'ascendPageAscendVideoClick' event (evid: 121)
 *
 * Event description: when user clicked on the video
 *
 * @param {ascendPageAscendVideoClickParams} params - The parameters for this event
 * @property {string} referral_info - referral_info
 * @property {string} view_type - view_type
 * @property {string} prev_view - prev_view
 * @property {string} platform - platform
 * @property {number} loading_time - loading_time
 * @return {LogObject<ascendPageAscendVideoClickParams>} LogObject<ascendPageAscendVideoClickParams>
 */
export function ascendPageAscendVideoClick(params) {
    return { evid: 121, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'invoicesAddAProductVariantAddToInvoice' event (evid: 1210)
 *
 * Event description: Invoices - Add a product Variant - add to invoice
 *
 * @param {invoicesAddAProductVariantAddToInvoiceParams} params - The parameters for this event
 * @property {string} view_type - view_type
 * @property {string} platform - platform
 * @property {string} msid - msid
 * @return {LogObject<invoicesAddAProductVariantAddToInvoiceParams>} LogObject<invoicesAddAProductVariantAddToInvoiceParams>
 */
export function invoicesAddAProductVariantAddToInvoice(params) {
    return { evid: 1210, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'invoicesCreateOrderNewInvoiceClick' event (evid: 1213)
 *
 * Event description: Invoices - Add a product Variant - add to invoice
 *
 * @param {invoicesCreateOrderNewInvoiceClickParams} params - The parameters for this event
 * @property {string} view_type - view_type
 * @property {string} platform - platform
 * @property {string} msid - msid
 * @return {LogObject<invoicesCreateOrderNewInvoiceClickParams>} LogObject<invoicesCreateOrderNewInvoiceClickParams>
 */
export function invoicesCreateOrderNewInvoiceClick(params) {
    return { evid: 1213, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'dashboardFinishLoadingLoadingTimeFromStartModule' event (evid: 1215)
 *
 * Event description: event to check the loading time from start loading
 *
 * @param {dashboardFinishLoadingLoadingTimeFromStartModuleParams} params - The parameters for this event
 * @property {string} view_type - view_type
 * @property {string} sub_view - sub_view
 * @property {string} platform - --
 * @property {string} hosting - dashboard/editor/onboarding
 * @property {string} refferal_info - refferal
 * @property {GUID} msid - --
 * @property {string} view - requested view
 * @property {number} loading_time - loading from start loading the page
 * @return {LogObject<dashboardFinishLoadingLoadingTimeFromStartModuleParams>} LogObject<dashboardFinishLoadingLoadingTimeFromStartModuleParams>
 */
export function dashboardFinishLoadingLoadingTimeFromStartModule(params) {
    return { evid: 1215, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'deleteLocationModalIsOpened' event (evid: 1217)
 *
 * Event description: When the delete modal is opened (after clicking delete location)
 *
 * @param {deleteLocationModalIsOpenedParams} params - The parameters for this event
 * @property {boolean} is_multiple_choice - true/ false if the modal present a few options to choose from
 * @property {boolean} is_default - true if trying to delete default location
 * @property {string} page_view - business info
 * @property {string} view_type - view_type
 * @property {boolean} is_draft - true if the location is a draft or not
 * @property {string} platform - platform
 * @property {string} hosting - dashboard/editor/ADI
 * @property {GUID} msid - msid
 * @return {LogObject<deleteLocationModalIsOpenedParams>} LogObject<deleteLocationModalIsOpenedParams>
 */
export function deleteLocationModalIsOpened(params) {
    return { evid: 1217, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'successfullyDeletedLocation' event (evid: 1218)
 *
 * Event description: When the user clicks on delete location and the location successfully deleted and removed from the db
 *
 * @param {successfullyDeletedLocationParams} params - The parameters for this event
 * @property {boolean} is_multiple_choice - true/ false if the modal present a few options to choose from
 * @property {boolean} is_default - true if trying to delete default location
 * @property {string} page_view - business info
 * @property {string} view_type - view_type
 * @property {string} platform - platform
 * @property {string} hosting - dashboard/editor/ADI
 * @property {GUID} msid - msid
 * @return {LogObject<successfullyDeletedLocationParams>} LogObject<successfullyDeletedLocationParams>
 */
export function successfullyDeletedLocation(params) {
    return { evid: 1218, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'foldersClickOnCreateNewFolder' event (evid: 122)
 *
 * Event description: when a user clicks on the 'Create New Folder' button from my-site or dialog
 *
 * @param {foldersClickOnCreateNewFolderParams} params - The parameters for this event
 * @property {string} source - top-bar/dialog/topbar-folder-dropdown
 * @property {string} view_type - view_type
 * @property {string} sub_view - grid / list-view
 * @property {number} nesting_level - 0 (my-sites)/1 (folder) /2/3...
 * @property {string} origin - origin
 * @property {string} view_level - search/filter/folder/root
 * @property {string} platform - platform
 * @property {string} hosting - MA
 * @property {string} view - sites-list-enterprise-page/ enterprise-folder-view
 * @return {LogObject<foldersClickOnCreateNewFolderParams>} LogObject<foldersClickOnCreateNewFolderParams>
 */
export function foldersClickOnCreateNewFolder(params) {
    return { evid: 122, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'locationModalFloatingNotification' event (evid: 1225)
 *
 * Event description: If the server returns an error for adding a new location, we should show an error notification while keeping the modal with all the same input values before the add action.
 *
 * @param {locationModalFloatingNotificationParams} params - The parameters for this event
 * @property {string} name - notification name
 * @property {string} page_view - locations-modal
 * @property {string} view_type - view_type
 * @property {string} origin - which app the modal is opened from
 * @property {string} type - error
 * @property {string} platform - platform
 * @property {string} hosting - dashboard/editor/ADI
 * @property {GUID} msid - metasite id
 * @return {LogObject<locationModalFloatingNotificationParams>} LogObject<locationModalFloatingNotificationParams>
 */
export function locationModalFloatingNotification(params) {
    return { evid: 1225, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'featureWizardTypingBusinessType' event (evid: 1226)
 *
 * Event description: When a user is typing the business type
 *
 * @param {featureWizardTypingBusinessTypeParams} params - The parameters for this event
 * @property {string} sub_category - the last sub-category the site had.
 * @property {string} widget_name - on top of which widget the modal is opened
 * @property {string} view_type - view_type
 * @property {string} text - searched text. When the results shown from clicking a tag send the event null.
 * @property {string} origin - tag/edit/search
 * @property {number} cnt_results - how many results the user sees, 0 for zero matches. (without related)
 * @property {string} platform - platform
 * @property {string} hosting - dashboard/onboarding/editor
 * @property {GUID} msid - --
 * @return {LogObject<featureWizardTypingBusinessTypeParams>} LogObject<featureWizardTypingBusinessTypeParams>
 */
export function featureWizardTypingBusinessType(params) {
    return { evid: 1226, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'foldersClickOnCreateNewFolderInDialog' event (evid: 123)
 *
 * Event description: when a user clicks on 'Create' from new folder dialog
 *
 * @param {foldersClickOnCreateNewFolderInDialogParams} params - The parameters for this event
 * @property {string} view_type - view_type
 * @property {string} sub_view - grid/list-view
 * @property {number} nesting_level - 0 (my-sites)/1 (folder) /2/3..
 * @property {string} platform - platform
 * @property {string} hosting - MA
 * @property {string} folder_name - the name of the folder
 * @property {string} view - my-sites/folder-view
 * @return {LogObject<foldersClickOnCreateNewFolderInDialogParams>} LogObject<foldersClickOnCreateNewFolderInDialogParams>
 */
export function foldersClickOnCreateNewFolderInDialog(params) {
    return { evid: 123, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'apesSaveEditedNotificationSrc5Evid1234' event (evid: 1234)
 *
 * Event description: APeS - Save edited notification
 *
 * @param {apesSaveEditedNotificationSrc5Evid1234Params} params - The parameters for this event
 * @property {string} view_type - view_type
 * @property {GUID} rule_id - rule id
 * @property {string} componentChanged - which component was changed
 * @property {string} platform - platform
 * @property {GUID} msid - msid
 * @return {LogObject<apesSaveEditedNotificationSrc5Evid1234Params>} LogObject<apesSaveEditedNotificationSrc5Evid1234Params>
 */
export function apesSaveEditedNotificationSrc5Evid1234(params) {
    return { evid: 1234, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'apesSaveEditedNotification' event (evid: 1235)
 *
 * Event description: APeS - Save edited notification
 *
 * @param {apesSaveEditedNotificationParams} params - The parameters for this event
 * @property {string} view_type - view_type
 * @property {GUID} rule_id - rule id
 * @property {string} componentChanged - which component was changed
 * @property {string} platform - platform
 * @property {GUID} msid - msid
 * @return {LogObject<apesSaveEditedNotificationParams>} LogObject<apesSaveEditedNotificationParams>
 */
export function apesSaveEditedNotification(params) {
    return { evid: 1235, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'apesEditNotificationSelectAudience' event (evid: 1238)
 *
 * Event description: APeS - Save edited notification
 *
 * @param {apesEditNotificationSelectAudienceParams} params - The parameters for this event
 * @property {string} audience - which audience was chosen
 * @property {string} view_type - view_type
 * @property {GUID} rule_id - rule id
 * @property {string} platform - platform
 * @property {GUID} msid - msid
 * @return {LogObject<apesEditNotificationSelectAudienceParams>} LogObject<apesEditNotificationSelectAudienceParams>
 */
export function apesEditNotificationSelectAudience(params) {
    return { evid: 1238, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'foldersClickOnMoveToFolderFromDialog' event (evid: 124)
 *
 * Event description: When a user clicks on ‘Move to Folder’ from the dialog shown
 *
 * @param {foldersClickOnMoveToFolderFromDialogParams} params - The parameters for this event
 * @property {Url} referral_url - The url of the current page
 * @property {number} destination_nesting_level - 0 (my-sites), 1 (folder), 2(folder in 1 folder) etc
 * @property {number} num_sites_moved - number of sites move to the folder
 * @property {string} view_type - view_type
 * @property {number} origin_nesting_level - 0 (my-sites), 1 (folder), 2(folder in 1 folder)
 * @property {string} folder - the name of the chosen folder
 * @property {string} origin - site-list \ site-list-enterprise
 * @property {string} moved_item_type - folder \ site
 * @property {string} platform - platform
 * @property {number} num_folders_moved - number of folders move to the folder
 * @property {string} msid - The site msid
 * @return {LogObject<foldersClickOnMoveToFolderFromDialogParams>} LogObject<foldersClickOnMoveToFolderFromDialogParams>
 */
export function foldersClickOnMoveToFolderFromDialog(params) {
    return { evid: 124, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'suggestionsFeedbackClickOnNavigationButtonInPopup' event (evid: 1240)
 *
 * Event description: When the header is loaded with a logo
 *
 * @param {suggestionsFeedbackClickOnNavigationButtonInPopupParams} params - The parameters for this event
 * @property {string} logo_value - logo_value
 * @property {string} hosting_platform - Deprecated - will be implicit in the future
 * @property {string} platformName - account managr/BM/devcenter/etc. (biPageView )
 * @property {string} view_type - view_type
 * @property {string} platform - platform
 * @property {string} hosting - hosting
 * @property {GUID} msid - msid
 * @return {LogObject<suggestionsFeedbackClickOnNavigationButtonInPopupParams>} LogObject<suggestionsFeedbackClickOnNavigationButtonInPopupParams>
 */
export function suggestionsFeedbackClickOnNavigationButtonInPopup(params) {
    return { evid: 1240, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'automationsClickOnBannerCarrouselArrow' event (evid: 1244)
 *
 * Event description: User clicks on banner carrousel arrow to see more tips & recipes
 *
 * @param {automationsClickOnBannerCarrouselArrowParams} params - The parameters for this event
 * @property {boolean} isEnd - he last click in the carrousel
 * @property {string} view_type - view_type
 * @property {string} platform - platform
 * @property {GUID} msid - msid
 * @return {LogObject<automationsClickOnBannerCarrouselArrowParams>} LogObject<automationsClickOnBannerCarrouselArrowParams>
 */
export function automationsClickOnBannerCarrouselArrow(params) {
    return { evid: 1244, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'foldersClickOnFolderSQuickActions' event (evid: 125)
 *
 * Event description: click folder's quick actions
 *
 * @param {foldersClickOnFolderSQuickActionsParams} params - The parameters for this event
 * @property {string} name - name of quick action
 * @property {string} view_mode - grid/list-view
 * @property {string} view_type - view_type
 * @property {string} sub_view - sub_view
 * @property {number} nesting_level - 0 (my-sites)/1/2/3… the number define the nested folder number.
 * @property {string} origin - sites-list-enterprise\site-list
 * @property {string} cta - top menu/folder
 * @property {string} view_level - page(ROOT)/ folder/ search/filter
 * @property {string} platform - platform
 * @return {LogObject<foldersClickOnFolderSQuickActionsParams>} LogObject<foldersClickOnFolderSQuickActionsParams>
 */
export function foldersClickOnFolderSQuickActions(params) {
    return { evid: 125, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'customerNotificationsSettingsClickInsidePageWithoutEmailsSections' event (evid: 1250)
 *
 * Event description: Click on the main page
 * without sections -
 * Automated emails you created,
 * Recommended automated emails,
 * System Notifications
 *
 * @param {customerNotificationsSettingsClickInsidePageWithoutEmailsSectionsParams} params - The parameters for this event
 * @property {string} name - button name - f.e. "go to events"
 * @property {string} section_name - name of the component - f.e. "More notifications"
 * @property {string} view_type - view_type
 * @property {string} page_id - page id of the next page - f.e. page_id of stores settings
 * @property {string} platform - platform
 * @property {GUID} msid - msid
 * @return {LogObject<customerNotificationsSettingsClickInsidePageWithoutEmailsSectionsParams>} LogObject<customerNotificationsSettingsClickInsidePageWithoutEmailsSectionsParams>
 */
export function customerNotificationsSettingsClickInsidePageWithoutEmailsSections(params) {
    return { evid: 1250, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'customerNotificationsSettingsClickOnHideUnhide' event (evid: 1251)
 *
 * Event description: When the user clicks on "hide/unhide" in each section in the page
 *
 * @param {customerNotificationsSettingsClickOnHideUnhideParams} params - The parameters for this event
 * @property {string} section_name - component name: notifications_channel/more_notifications/automated_emails you created/system_notifications
 * @property {string} view_type - view_type
 * @property {string} origin - from where the hide/unhide happened
 * @property {boolean} status - true - click on unhide , false - click on hide
 * @property {string} platform - platform
 * @property {GUID} msid - msid
 * @property {string} template_id - template_id
 * @return {LogObject<customerNotificationsSettingsClickOnHideUnhideParams>} LogObject<customerNotificationsSettingsClickOnHideUnhideParams>
 */
export function customerNotificationsSettingsClickOnHideUnhide(params) {
    return { evid: 1251, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'customerNotificationsSettingsPreviewEditClickOnToggle' event (evid: 1252)
 *
 * Event description: When the user clicks on the toggle to mute/unmute each channel
 *
 * @param {customerNotificationsSettingsPreviewEditClickOnToggleParams} params - The parameters for this event
 * @property {string} channel - email/mobile/sms
 * @property {string} view_type - view_type
 * @property {GUID} rule_id - automations rule_id
 * @property {boolean} status - on=true, off=false
 * @property {string} platform - platform
 * @property {GUID} msid - msid
 * @property {string} template_id - ping template_id
 * @return {LogObject<customerNotificationsSettingsPreviewEditClickOnToggleParams>} LogObject<customerNotificationsSettingsPreviewEditClickOnToggleParams>
 */
export function customerNotificationsSettingsPreviewEditClickOnToggle(params) {
    return { evid: 1252, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'customerNotificationsSettingsPageLoad' event (evid: 1253)
 *
 * Event description: When the page is loaded
 *
 * @param {customerNotificationsSettingsPageLoadParams} params - The parameters for this event
 * @property {string} available_sections - all the components loaded to the user
 * @property {string} view_type - view_type
 * @property {string} platform - platform
 * @property {GUID} msid - msid
 * @return {LogObject<customerNotificationsSettingsPageLoadParams>} LogObject<customerNotificationsSettingsPageLoadParams>
 */
export function customerNotificationsSettingsPageLoad(params) {
    return { evid: 1253, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'bizManagerShowWarningMessage' event (evid: 1254)
 *
 * Event description: warning message is shown
 *
 * @param {bizManagerShowWarningMessageParams} params - The parameters for this event
 * @property {string} name - the name of the message (for example unsupported language message)
 * @property {string} page_view - The page where the warning message is shown
 * @property {string} view_type - view_type
 * @property {string} unsupported_language - the chosen language
 * @property {string} unsupport_apps - unsupport_apps
 * @property {string} fold_name - fold_name
 * @property {string} platform - deprecated
 * @property {string} hosting - MA/editor
 * @property {GUID} msid - msid
 * @return {LogObject<bizManagerShowWarningMessageParams>} LogObject<bizManagerShowWarningMessageParams>
 */
export function bizManagerShowWarningMessage(params) {
    return { evid: 1254, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'customerNotificationsSettingsPreviewEditShowTooltip' event (evid: 1259)
 *
 * Event description: when the user tries to mute all channels the last button is disabled and if he hovers over it a tooltip is shown
 *
 * @param {customerNotificationsSettingsPreviewEditShowTooltipParams} params - The parameters for this event
 * @property {string} view_type - view_type
 * @property {string} rule_id - automations rule id
 * @property {string} platform - deprecated
 * @property {GUID} msid - msid
 * @property {string} error_name - turn_off_all_channels
 * @property {string} template_id - ping template_id
 * @return {LogObject<customerNotificationsSettingsPreviewEditShowTooltipParams>} LogObject<customerNotificationsSettingsPreviewEditShowTooltipParams>
 */
export function customerNotificationsSettingsPreviewEditShowTooltip(params) {
    return { evid: 1259, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'foldersApproveActionFromFolderSQuickActionPopup' event (evid: 126)
 *
 * Event description: approve action from folder's quick action popup
 *
 * @param {foldersApproveActionFromFolderSQuickActionPopupParams} params - The parameters for this event
 * @property {string} view_type - view_type
 * @property {number} nesting_level - 0 (my-sites)/1 (folder) /2/3...
 * @property {string} origin - site-list \ site-list-enterprise
 * @property {string} cta - folder’s quick action / quick actions button
 * @property {string} platform - platform
 * @property {string} popup_name - delete_folder/rename_folder
 * @property {string} folder_name - the name of the folder
 * @return {LogObject<foldersApproveActionFromFolderSQuickActionPopupParams>} LogObject<foldersApproveActionFromFolderSQuickActionPopupParams>
 */
export function foldersApproveActionFromFolderSQuickActionPopup(params) {
    return { evid: 126, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'automationBannerDisplayCarrousel' event (evid: 1260)
 *
 * Event description: Automation banner is displayed on the automation home page
 *
 * @param {automationBannerDisplayCarrouselParams} params - The parameters for this event
 * @property {string} view_type - view_type
 * @property {string} recipeIdList - recipe ids by items order
 * @property {string} platform - platform
 * @property {string} offerIdList - Dealer Offer id list by items order
 * @property {GUID} msid - msid
 * @return {LogObject<automationBannerDisplayCarrouselParams>} LogObject<automationBannerDisplayCarrouselParams>
 */
export function automationBannerDisplayCarrousel(params) {
    return { evid: 1260, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'automationsCreationModalCategorySelected' event (evid: 1261)
 *
 * Event description: Automations > user click on a category in the creation modal or scroll down to a category
 *
 * @param {automationsCreationModalCategorySelectedParams} params - The parameters for this event
 * @property {string} recipeCategory - recipe Category
 * @property {string} view_type - view_type
 * @property {string} type - type
 * @property {string} platform - platform
 * @property {GUID} msid - msid
 * @return {LogObject<automationsCreationModalCategorySelectedParams>} LogObject<automationsCreationModalCategorySelectedParams>
 */
export function automationsCreationModalCategorySelected(params) {
    return { evid: 1261, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'automationsUserCloseCreationModal' event (evid: 1262)
 *
 * Event description: Automations > user click on the X and close the creation modal
 *
 * @param {automationsUserCloseCreationModalParams} params - The parameters for this event
 * @property {string} view_type - view_type
 * @property {string} platform - platform
 * @property {GUID} msid - msid
 * @return {LogObject<automationsUserCloseCreationModalParams>} LogObject<automationsUserCloseCreationModalParams>
 */
export function automationsUserCloseCreationModal(params) {
    return { evid: 1262, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'automationsCreationModalUserSearchFocusOut' event (evid: 1269)
 *
 * Event description: Automations > creation modal - user search focus out
 *
 * @param {automationsCreationModalUserSearchFocusOutParams} params - The parameters for this event
 * @property {string} view_type - view_type
 * @property {string} searchText - what the user search for
 * @property {string} platform - platform
 * @property {number} numOfResults - num_of_results
 * @property {GUID} msid - msid
 * @return {LogObject<automationsCreationModalUserSearchFocusOutParams>} LogObject<automationsCreationModalUserSearchFocusOutParams>
 */
export function automationsCreationModalUserSearchFocusOut(params) {
    return { evid: 1269, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'foldersSortListView' event (evid: 127)
 *
 * Event description: sort list view
 *
 * @param {foldersSortListViewParams} params - The parameters for this event
 * @property {string} name - name/date_created/last_edited(name of field sorted by)
 * @property {string} view_type - view_type
 * @property {string} sub_view - list-view
 * @property {string} order - desc/asc
 * @property {string} platform - platform
 * @property {string} view - my-sites
 * @return {LogObject<foldersSortListViewParams>} LogObject<foldersSortListViewParams>
 */
export function foldersSortListView(params) {
    return { evid: 127, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'verticalsEmailNotificationSentSrc5Evid1270' event (evid: 1270)
 *
 * Event description: When A vertical send an email notification which doesn't go via Ping!
 *
 * @param {verticalsEmailNotificationSentSrc5Evid1270Params} params - The parameters for this event
 * @property {string} channel - email
 * @property {string} view_type - view_type
 * @property {GUID} notificationId - Notification ID
 * @property {string} contact_id - If the email has been sent to member/contact
 * @property {string} platform - platform
 * @property {GUID} msid - msid
 * @property {string} template_id - Descriptive name for the type of email. e.g. Identity.Member_Approved
 * @return {LogObject<verticalsEmailNotificationSentSrc5Evid1270Params>} LogObject<verticalsEmailNotificationSentSrc5Evid1270Params>
 */
export function verticalsEmailNotificationSentSrc5Evid1270(params) {
    return { evid: 1270, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'verticalsEmailNotificationSent' event (evid: 1271)
 *
 * Event description: When a user opens vertical's email  notification which doesn't go via Ping!
 *
 * @param {verticalsEmailNotificationSentParams} params - The parameters for this event
 * @property {string} channel - email
 * @property {string} view_type - view_type
 * @property {string} contact_id - If the email has been sent to member/contact
 * @property {string} platform - platform
 * @property {string} notificationid - Notification ID
 * @property {GUID} msid - msid
 * @property {string} template_id - Descriptive name for the type of email. e.g. Identity.Member_Approved
 * @return {LogObject<verticalsEmailNotificationSentParams>} LogObject<verticalsEmailNotificationSentParams>
 */
export function verticalsEmailNotificationSent(params) {
    return { evid: 1271, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'verticalsEmailNotificationClicked' event (evid: 1272)
 *
 * Event description: When a user clicks on a CTA on a vertical's email notification which doesn't go via Ping!
 *
 * @param {verticalsEmailNotificationClickedParams} params - The parameters for this event
 * @property {string} channel - email
 * @property {string} button_name - cta name (in english)
 * @property {string} view_type - view_type
 * @property {string} contact_id - If the email has been sent to member/contact
 * @property {string} platform - platform
 * @property {string} notificationid - notification_id
 * @property {GUID} msid - msid
 * @property {string} deep_link - deep_link
 * @property {string} template_id - Descriptive name for the type of email. e.g. Identity.Member_Approved
 * @return {LogObject<verticalsEmailNotificationClickedParams>} LogObject<verticalsEmailNotificationClickedParams>
 */
export function verticalsEmailNotificationClicked(params) {
    return { evid: 1272, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'automationsCreationModalClearSearch' event (evid: 1273)
 *
 * Event description: the user click on 'clear search' button
 *
 * @param {automationsCreationModalClearSearchParams} params - The parameters for this event
 * @property {string} view_type - view_type
 * @property {string} platform - platform
 * @property {GUID} msid - msid
 * @return {LogObject<automationsCreationModalClearSearchParams>} LogObject<automationsCreationModalClearSearchParams>
 */
export function automationsCreationModalClearSearch(params) {
    return { evid: 1273, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'automationsBrokenRules' event (evid: 1275)
 *
 * Event description: Automations > validation process failed (unknown error)
 *
 * @param {automationsBrokenRulesParams} params - The parameters for this event
 * @property {boolean} withTriggersCatalog - is with triggers catalog
 * @property {string} view_type - view_type
 * @property {GUID} rule_id - the rule_id that the user started/edited
 * @property {string} ruleType - is it preinstalled or not
 * @property {string} additionalInfo - info off the error
 * @property {string} platform - platform
 * @property {GUID} msid - msid
 * @property {string} action - actions
 * @property {string} trigger - trigger
 * @return {LogObject<automationsBrokenRulesParams>} LogObject<automationsBrokenRulesParams>
 */
export function automationsBrokenRules(params) {
    return { evid: 1275, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'apesLoadSystemNotificationsModalEnd' event (evid: 1277)
 *
 * Event description: APeS - load system notifications modal - start
 *
 * @param {apesLoadSystemNotificationsModalEndParams} params - The parameters for this event
 * @property {boolean} isPreinstalled - if the automation is pre installed
 * @property {string} view_type - view_type
 * @property {string} origin - app id
 * @property {number} loadTime - how much time it took to load the modal
 * @property {boolean} edited - is it second time that the modal is opened (after edit mode)
 * @property {string} platform - platform
 * @property {GUID} msid - msid
 * @return {LogObject<apesLoadSystemNotificationsModalEndParams>} LogObject<apesLoadSystemNotificationsModalEndParams>
 */
export function apesLoadSystemNotificationsModalEnd(params) {
    return { evid: 1277, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'accountSettingsCloseYourWixAccountEnterPage' event (evid: 1278)
 *
 * Event description: new UX for the close your account
 *
 * https://docs.google.com/presentation/d/1toummTuN1-7cxFR3TgbGMi5F5UR-vYntZHpCRfYhkOo/edit#slide=id.gaa2182f012_3_18
 *
 * @param {accountSettingsCloseYourWixAccountEnterPageParams} params - The parameters for this event
 * @property {GUID} uuid - user id
 * @property {boolean} is_workspace - is this form for closing workspace
 * @property {string} view_type - view_type
 * @property {string} platform - platform
 * @return {LogObject<accountSettingsCloseYourWixAccountEnterPageParams>} LogObject<accountSettingsCloseYourWixAccountEnterPageParams>
 */
export function accountSettingsCloseYourWixAccountEnterPage(params) {
    return { evid: 1278, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'accountSettingsCloseYourWixAccountCloseAccountRequestSubmited' event (evid: 1279)
 *
 * Event description: the user clicks on the "close my account" button
 *
 * https://docs.google.com/presentation/d/1toummTuN1-7cxFR3TgbGMi5F5UR-vYntZHpCRfYhkOo/edit#slide=id.gaa2182f012_3_18
 *
 * @param {accountSettingsCloseYourWixAccountCloseAccountRequestSubmitedParams} params - The parameters for this event
 * @property {string} context - is this form closes only a workspace\account\workspace and closes the account
 * @property {GUID} uuid - user id
 * @property {boolean} is_workspace - is the user closing his workspace or his account
 * @property {string} view_type - view_type
 * @property {string} reason - why are you closing the account
 * @property {string} platform - platform
 * @property {string} free_text - users feedback
 * @return {LogObject<accountSettingsCloseYourWixAccountCloseAccountRequestSubmitedParams>} LogObject<accountSettingsCloseYourWixAccountCloseAccountRequestSubmitedParams>
 */
export function accountSettingsCloseYourWixAccountCloseAccountRequestSubmited(params) {
    return { evid: 1279, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'foldersMarkASite' event (evid: 128)
 *
 * Event description: marking a site
 *
 * @param {foldersMarkASiteParams} params - The parameters for this event
 * @property {string} name - mark/unmark
 * @property {string} view_type - view_type
 * @property {string} sub_view - grid/ list-view
 * @property {string} platform - platform
 * @property {string} hosting - MA
 * @property {GUID} msid - msid
 * @property {string} view - my-sites
 * @return {LogObject<foldersMarkASiteParams>} LogObject<foldersMarkASiteParams>
 */
export function foldersMarkASite(params) {
    return { evid: 128, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'myAccountSelectSiteFromSiteListPopupSrc5Evid129' event (evid: 129)
 *
 * Event description: multi selection 'Move to Folder' button (mapped to 2/129)
 *
 * @param {myAccountSelectSiteFromSiteListPopupSrc5Evid129Params} params - The parameters for this event
 * @property {GUID} site_id - site_id
 * @property {string} view_type - view_type
 * @property {string} sub_view - grid/list-view
 * @property {number} num_selected_sites - number of sites selected
 * @property {string} origin - origin
 * @property {string} place - place
 * @property {string} platform - platform
 * @property {string} hosting - MA
 * @property {GUID} msid - msid
 * @property {string} view - my-sites
 * @return {LogObject<myAccountSelectSiteFromSiteListPopupSrc5Evid129Params>} LogObject<myAccountSelectSiteFromSiteListPopupSrc5Evid129Params>
 */
export function myAccountSelectSiteFromSiteListPopupSrc5Evid129(params) {
    return { evid: 129, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'dashboardSearch' event (evid: 13)
 *
 * Event description: dashboard > search.
 *
 * @param {dashboardSearchParams} params - The parameters for this event
 * @property {string} view_type - view_type
 * @property {number} no_of_html_sites - number of html sites
 * @property {string} text - deprecated
 * @property {number} no_of_folders - number of folders
 * @property {string} place - where the search took place: site-home, my-sites
 * @property {number} no_of_sites - deprecated
 * @property {string} platform - platform
 * @property {GUID} msid - deprecated
 * @return {LogObject<dashboardSearchParams>} LogObject<dashboardSearchParams>
 */
export function dashboardSearch(params) {
    return { evid: 13, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'foldersClickOnFolder' event (evid: 130)
 *
 * Event description: click on the folder from my-sites and see it's content
 *
 * @param {foldersClickOnFolderParams} params - The parameters for this event
 * @property {string} view_type - view_type
 * @property {string} sub_view - list-view/grid
 * @property {string} platform - platform
 * @property {string} hosting - MA
 * @property {GUID} msid - --
 * @property {string} folder_name - the name of the folder
 * @property {string} view - my-sites
 * @return {LogObject<foldersClickOnFolderParams>} LogObject<foldersClickOnFolderParams>
 */
export function foldersClickOnFolder(params) {
    return { evid: 130, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'crmHomeScrollDown' event (evid: 1300)
 *
 * Event description: CRM Home - scroll down
 *
 * @param {crmHomeScrollDownParams} params - The parameters for this event
 * @property {string} view_type - view_type
 * @property {string} platform - platform
 * @property {GUID} msid - msid
 * @return {LogObject<crmHomeScrollDownParams>} LogObject<crmHomeScrollDownParams>
 */
export function crmHomeScrollDown(params) {
    return { evid: 1300, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'financialServicesSettingsChangeTab' event (evid: 1301)
 *
 * Event description: Financial Services Settings - Change Tab
 *
 * @param {financialServicesSettingsChangeTabParams} params - The parameters for this event
 * @property {string} tabTo - tabTo
 * @property {string} view_type - view_type
 * @property {string} tabFrom - tabFrom
 * @property {string} platform - platform
 * @property {GUID} msid - msid
 * @return {LogObject<financialServicesSettingsChangeTabParams>} LogObject<financialServicesSettingsChangeTabParams>
 */
export function financialServicesSettingsChangeTab(params) {
    return { evid: 1301, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'financialServicesSettingsInvoicesClickCard' event (evid: 1302)
 *
 * Event description: Financial Services Settings - invoices - click card
 *
 * @param {financialServicesSettingsInvoicesClickCardParams} params - The parameters for this event
 * @property {string} view_type - view_type
 * @property {string} platform - platform
 * @property {string} card - which card was clicked
 * @property {GUID} msid - msid
 * @return {LogObject<financialServicesSettingsInvoicesClickCardParams>} LogObject<financialServicesSettingsInvoicesClickCardParams>
 */
export function financialServicesSettingsInvoicesClickCard(params) {
    return { evid: 1302, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'financialServicesSettingsInvoicesEditNumbering' event (evid: 1303)
 *
 * Event description: Financial Services Settings - invoices - edit numbering
 *
 * @param {financialServicesSettingsInvoicesEditNumberingParams} params - The parameters for this event
 * @property {string} view_type - view_type
 * @property {string} platform - platform
 * @property {GUID} msid - msid
 * @return {LogObject<financialServicesSettingsInvoicesEditNumberingParams>} LogObject<financialServicesSettingsInvoicesEditNumberingParams>
 */
export function financialServicesSettingsInvoicesEditNumbering(params) {
    return { evid: 1303, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'financialServicesSettingsInvoicesEditLogo' event (evid: 1304)
 *
 * Event description: Financial Services Settings - invoices - edit logo
 *
 * @param {financialServicesSettingsInvoicesEditLogoParams} params - The parameters for this event
 * @property {string} view_type - view_type
 * @property {string} platform - platform
 * @property {GUID} msid - msid
 * @return {LogObject<financialServicesSettingsInvoicesEditLogoParams>} LogObject<financialServicesSettingsInvoicesEditLogoParams>
 */
export function financialServicesSettingsInvoicesEditLogo(params) {
    return { evid: 1304, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'financialServicesSettingsInvoicesBusinessInfoEditThem' event (evid: 1305)
 *
 * Event description: Financial Services Settings - invoices - business info - edit them
 *
 * @param {financialServicesSettingsInvoicesBusinessInfoEditThemParams} params - The parameters for this event
 * @property {string} view_type - view_type
 * @property {string} platform - platform
 * @property {GUID} msid - msid
 * @return {LogObject<financialServicesSettingsInvoicesBusinessInfoEditThemParams>} LogObject<financialServicesSettingsInvoicesBusinessInfoEditThemParams>
 */
export function financialServicesSettingsInvoicesBusinessInfoEditThem(params) {
    return { evid: 1305, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'financialServicesSettingsInvoicesBusinessInfoEditField' event (evid: 1306)
 *
 * Event description: Financial Services Settings - invoices - business info - edit field
 *
 * @param {financialServicesSettingsInvoicesBusinessInfoEditFieldParams} params - The parameters for this event
 * @property {string} field - field
 * @property {string} view_type - view_type
 * @property {string} platform - platform
 * @property {GUID} msid - msid
 * @return {LogObject<financialServicesSettingsInvoicesBusinessInfoEditFieldParams>} LogObject<financialServicesSettingsInvoicesBusinessInfoEditFieldParams>
 */
export function financialServicesSettingsInvoicesBusinessInfoEditField(params) {
    return { evid: 1306, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'financialServicesSettingsInvoicesDefaultsNotesEditNotes' event (evid: 1307)
 *
 * Event description: Financial Services Settings - invoices - defaults notes - edit notes
 *
 * @param {financialServicesSettingsInvoicesDefaultsNotesEditNotesParams} params - The parameters for this event
 * @property {string} view_type - view_type
 * @property {string} platform - platform
 * @property {GUID} msid - msid
 * @return {LogObject<financialServicesSettingsInvoicesDefaultsNotesEditNotesParams>} LogObject<financialServicesSettingsInvoicesDefaultsNotesEditNotesParams>
 */
export function financialServicesSettingsInvoicesDefaultsNotesEditNotes(params) {
    return { evid: 1307, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'financialServicesSettingsInvoicesDefaultsNotesLegalTerms' event (evid: 1308)
 *
 * Event description: Financial Services Settings - invoices - defaults notes - legal terms
 *
 * @param {financialServicesSettingsInvoicesDefaultsNotesLegalTermsParams} params - The parameters for this event
 * @property {string} view_type - view_type
 * @property {string} platform - platform
 * @property {GUID} msid - msid
 * @return {LogObject<financialServicesSettingsInvoicesDefaultsNotesLegalTermsParams>} LogObject<financialServicesSettingsInvoicesDefaultsNotesLegalTermsParams>
 */
export function financialServicesSettingsInvoicesDefaultsNotesLegalTerms(params) {
    return { evid: 1308, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'financialServicesSettingsInvoicesDefaultsNotesPreviewInvoice' event (evid: 1309)
 *
 * Event description: Financial Services Settings - invoices - defaults notes - preview invoice
 *
 * @param {financialServicesSettingsInvoicesDefaultsNotesPreviewInvoiceParams} params - The parameters for this event
 * @property {string} view_type - view_type
 * @property {string} platform - platform
 * @property {GUID} msid - msid
 * @return {LogObject<financialServicesSettingsInvoicesDefaultsNotesPreviewInvoiceParams>} LogObject<financialServicesSettingsInvoicesDefaultsNotesPreviewInvoiceParams>
 */
export function financialServicesSettingsInvoicesDefaultsNotesPreviewInvoice(params) {
    return { evid: 1309, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'ascendPpPageView' event (evid: 131)
 *
 * Event description: User view Ascend PP
 *
 * @param {ascendPpPageViewParams} params - The parameters for this event
 * @property {string} referralInfo - button name open PP
 * @property {string} view_type - view_type
 * @property {string} origin - product name open PP
 * @property {GUID} app_id - app_id
 * @property {number} num_of_packages - num_of_packages presented in the PP
 * @property {string} platform - native or web
 * @return {LogObject<ascendPpPageViewParams>} LogObject<ascendPpPageViewParams>
 */
export function ascendPpPageView(params) {
    return { evid: 131, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'financialServicesSettingsPriceQuotesBusinessDetailsSiteSettings' event (evid: 1310)
 *
 * Event description: Financial Services Settings - Price Quotes - business details - site settings
 *
 * @param {financialServicesSettingsPriceQuotesBusinessDetailsSiteSettingsParams} params - The parameters for this event
 * @property {string} view_type - view_type
 * @property {string} platform - platform
 * @property {GUID} msid - msid
 * @return {LogObject<financialServicesSettingsPriceQuotesBusinessDetailsSiteSettingsParams>} LogObject<financialServicesSettingsPriceQuotesBusinessDetailsSiteSettingsParams>
 */
export function financialServicesSettingsPriceQuotesBusinessDetailsSiteSettings(params) {
    return { evid: 1310, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'financialServicesSettingsPriceQuotesBusinessDetailsGoToSiteSettings' event (evid: 1311)
 *
 * Event description: Financial Services Settings - Price Quotes - business details - go to site settings
 *
 * @param {financialServicesSettingsPriceQuotesBusinessDetailsGoToSiteSettingsParams} params - The parameters for this event
 * @property {string} view_type - view_type
 * @property {string} platform - platform
 * @property {GUID} msid - msid
 * @return {LogObject<financialServicesSettingsPriceQuotesBusinessDetailsGoToSiteSettingsParams>} LogObject<financialServicesSettingsPriceQuotesBusinessDetailsGoToSiteSettingsParams>
 */
export function financialServicesSettingsPriceQuotesBusinessDetailsGoToSiteSettings(params) {
    return { evid: 1311, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'financialServicesSettingsPriceQuotesEditNumbering' event (evid: 1312)
 *
 * Event description: Financial Services Settings - Price Quotes - edit numbering
 *
 * @param {financialServicesSettingsPriceQuotesEditNumberingParams} params - The parameters for this event
 * @property {string} view_type - view_type
 * @property {string} platform - platform
 * @property {GUID} msid - msid
 * @return {LogObject<financialServicesSettingsPriceQuotesEditNumberingParams>} LogObject<financialServicesSettingsPriceQuotesEditNumberingParams>
 */
export function financialServicesSettingsPriceQuotesEditNumbering(params) {
    return { evid: 1312, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'financialServicesSettingsInvoicesSettingsClick' event (evid: 1313)
 *
 * Event description: Financial Services Settings - Invoices - Settings click
 *
 * @param {financialServicesSettingsInvoicesSettingsClickParams} params - The parameters for this event
 * @property {string} view_type - view_type
 * @property {string} origin - holds the origin of click
 * @property {string} platform - platform
 * @property {GUID} msid - msid
 * @return {LogObject<financialServicesSettingsInvoicesSettingsClickParams>} LogObject<financialServicesSettingsInvoicesSettingsClickParams>
 */
export function financialServicesSettingsInvoicesSettingsClick(params) {
    return { evid: 1313, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'crmHomeGeneralVideo' event (evid: 1314)
 *
 * Event description: CRM Home - General Video
 *
 * @param {crmHomeGeneralVideoParams} params - The parameters for this event
 * @property {string} view_type - view_type
 * @property {string} origin - origin of the video
 * @property {string} platform - platform
 * @property {GUID} msid - msid
 * @return {LogObject<crmHomeGeneralVideoParams>} LogObject<crmHomeGeneralVideoParams>
 */
export function crmHomeGeneralVideo(params) {
    return { evid: 1314, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'invoicesItemsListChooseAProduct' event (evid: 1315)
 *
 * Event description: Invoices - Items List - choose a product
 *
 * @param {invoicesItemsListChooseAProductParams} params - The parameters for this event
 * @property {boolean} ifVariantModal - For subscriptions, the item selection is not from dropdown, it’s from the modal
 * @property {string} view_type - view_type
 * @property {GUID} appDefId - appDefId
 * @property {string} invoiceType - ’recurringAutoCharge’/ 'recurring'/ 'one time'
 * @property {string} origin - invoice/ invoice and order
 * @property {string} platform - platform
 * @property {GUID} msid - msid
 * @return {LogObject<invoicesItemsListChooseAProductParams>} LogObject<invoicesItemsListChooseAProductParams>
 */
export function invoicesItemsListChooseAProduct(params) {
    return { evid: 1315, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'invoicesItemsListAddNewProduct' event (evid: 1316)
 *
 * Event description: Invoices - Items List - add new product
 *
 * @param {invoicesItemsListAddNewProductParams} params - The parameters for this event
 * @property {string} view_type - view_type
 * @property {string} platform - platform
 * @property {GUID} msid - msid
 * @return {LogObject<invoicesItemsListAddNewProductParams>} LogObject<invoicesItemsListAddNewProductParams>
 */
export function invoicesItemsListAddNewProduct(params) {
    return { evid: 1316, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'invoicesItemsListLinkInTooltipProducts' event (evid: 1317)
 *
 * Event description: Invoices - Items List - link in tooltip products
 *
 * @param {invoicesItemsListLinkInTooltipProductsParams} params - The parameters for this event
 * @property {string} view_type - view_type
 * @property {GUID} appDefId - appDefId
 * @property {string} platform - platform
 * @property {GUID} msid - msid
 * @return {LogObject<invoicesItemsListLinkInTooltipProductsParams>} LogObject<invoicesItemsListLinkInTooltipProductsParams>
 */
export function invoicesItemsListLinkInTooltipProducts(params) {
    return { evid: 1317, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'automationsStoresChooseSpecificProductDropdown' event (evid: 1318)
 *
 * Event description: Automations -  choose specific product dropdown
 *
 * @param {automationsStoresChooseSpecificProductDropdownParams} params - The parameters for this event
 * @property {string} view_type - view_type
 * @property {string} platform - platform
 * @property {GUID} msid - msid
 * @return {LogObject<automationsStoresChooseSpecificProductDropdownParams>} LogObject<automationsStoresChooseSpecificProductDropdownParams>
 */
export function automationsStoresChooseSpecificProductDropdown(params) {
    return { evid: 1318, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'ascendPpClickOnShowMoreLess' event (evid: 132)
 *
 * Event description: User click on show more/less in Ascend PP
 *
 * @param {ascendPpClickOnShowMoreLessParams} params - The parameters for this event
 * @property {string} referralInfo - button name open PP
 * @property {string} view_type - view_type
 * @property {string} ascend_product - CRM / Promote product  - click show more
 * @property {string} origin - product name open PP
 * @property {string} productName - product name of show more/less
 * @property {string} platform - platform
 * @property {string} action - more/less
 * @return {LogObject<ascendPpClickOnShowMoreLessParams>} LogObject<ascendPpClickOnShowMoreLessParams>
 */
export function ascendPpClickOnShowMoreLess(params) {
    return { evid: 132, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'invoicesWidgetMoreAction' event (evid: 1320)
 *
 * Event description: Invoices - widget - more action
 *
 * @param {invoicesWidgetMoreActionParams} params - The parameters for this event
 * @property {string} view_type - view_type
 * @property {GUID} invoiceId - invoice id
 * @property {GUID} contactId - contact id
 * @property {string} platform - platform
 * @property {GUID} msid - msid
 * @return {LogObject<invoicesWidgetMoreActionParams>} LogObject<invoicesWidgetMoreActionParams>
 */
export function invoicesWidgetMoreAction(params) {
    return { evid: 1320, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'invoicesWidgetMoreActionChooseAnAction' event (evid: 1321)
 *
 * Event description: Invoices - widget - more action - choose an action
 *
 * @param {invoicesWidgetMoreActionChooseAnActionParams} params - The parameters for this event
 * @property {string} view_type - view_type
 * @property {GUID} invoiceId - invoice id
 * @property {string} origin - ‘crm home widget/ ‘os-dashboard’
 * @property {GUID} contactId - contact id
 * @property {string} platform - platform
 * @property {GUID} msid - msid
 * @property {string} action - action name
 * @return {LogObject<invoicesWidgetMoreActionChooseAnActionParams>} LogObject<invoicesWidgetMoreActionChooseAnActionParams>
 */
export function invoicesWidgetMoreActionChooseAnAction(params) {
    return { evid: 1321, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'invoicesWidgetResendViaEmail' event (evid: 1322)
 *
 * Event description: Invoices - widget - resend via email
 *
 * @param {invoicesWidgetResendViaEmailParams} params - The parameters for this event
 * @property {string} view_type - view_type
 * @property {GUID} invoiceId - invoice id
 * @property {GUID} contactId - contact id
 * @property {string} platform - platform
 * @property {GUID} msid - msid
 * @return {LogObject<invoicesWidgetResendViaEmailParams>} LogObject<invoicesWidgetResendViaEmailParams>
 */
export function invoicesWidgetResendViaEmail(params) {
    return { evid: 1322, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'invoicesWidgetChangeTab' event (evid: 1323)
 *
 * Event description: Invoices - widget - Change tab
 *
 * @param {invoicesWidgetChangeTabParams} params - The parameters for this event
 * @property {string} tabTo - tab to
 * @property {string} view_type - view_type
 * @property {string} tabFrom - tab from
 * @property {string} origin - ‘crm home widget/ ‘os-dashboard’
 * @property {string} platform - platform
 * @property {GUID} msid - msid
 * @return {LogObject<invoicesWidgetChangeTabParams>} LogObject<invoicesWidgetChangeTabParams>
 */
export function invoicesWidgetChangeTab(params) {
    return { evid: 1323, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'invoicesWidgetCreateNew' event (evid: 1324)
 *
 * Event description: Invoices - widget - Create New
 *
 * @param {invoicesWidgetCreateNewParams} params - The parameters for this event
 * @property {string} view_type - view_type
 * @property {string} origin - ‘crm home widget/ ‘os-dashboard’
 * @property {string} platform - platform
 * @property {GUID} msid - msid
 * @return {LogObject<invoicesWidgetCreateNewParams>} LogObject<invoicesWidgetCreateNewParams>
 */
export function invoicesWidgetCreateNew(params) {
    return { evid: 1324, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'invoicesWidgetPreviewInvoice' event (evid: 1325)
 *
 * Event description: Invoices - widget - Create New
 *
 * @param {invoicesWidgetPreviewInvoiceParams} params - The parameters for this event
 * @property {string} view_type - view_type
 * @property {GUID} invoiceId - invoice Id
 * @property {string} origin - ‘crm home widget/ ‘os-dashboard'
 * @property {GUID} contactId - contact id
 * @property {string} platform - platform
 * @property {GUID} msid - msid
 * @return {LogObject<invoicesWidgetPreviewInvoiceParams>} LogObject<invoicesWidgetPreviewInvoiceParams>
 */
export function invoicesWidgetPreviewInvoice(params) {
    return { evid: 1325, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'invoicesWidgetSeeAllInvoices' event (evid: 1326)
 *
 * Event description: Invoices - widget - see all invoices
 *
 * @param {invoicesWidgetSeeAllInvoicesParams} params - The parameters for this event
 * @property {GUID} externalId - An external id of an entity, relevant to the invoiceSource application
 * @property {string} view_type - view_type
 * @property {GUID} appDefId - appDefId of the source
 * @property {string} origin - ‘invoice preview’, ‘crm home widget/ ‘os-dashboard)
 * @property {string} platform - platform
 * @property {GUID} msid - msid
 * @return {LogObject<invoicesWidgetSeeAllInvoicesParams>} LogObject<invoicesWidgetSeeAllInvoicesParams>
 */
export function invoicesWidgetSeeAllInvoices(params) {
    return { evid: 1326, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'invoicesWidgetReportsViewReport' event (evid: 1327)
 *
 * Event description: Invoices - widget - see all invoices
 *
 * @param {invoicesWidgetReportsViewReportParams} params - The parameters for this event
 * @property {string} view_type - view_type
 * @property {string} origin - ‘crm home widget/ ‘os-dashboard’
 * @property {string} platform - platform
 * @property {GUID} msid - msid
 * @return {LogObject<invoicesWidgetReportsViewReportParams>} LogObject<invoicesWidgetReportsViewReportParams>
 */
export function invoicesWidgetReportsViewReport(params) {
    return { evid: 1327, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'invoicesWidgetReportsTimePicker' event (evid: 1328)
 *
 * Event description: Invoices - widget - see all invoices
 *
 * @param {invoicesWidgetReportsTimePickerParams} params - The parameters for this event
 * @property {string} time_frame - time picker
 * @property {string} view_type - view_type
 * @property {string} origin - ‘crm home widget/ ‘os-dashboard’
 * @property {string} platform - platform
 * @property {GUID} msid - msid
 * @return {LogObject<invoicesWidgetReportsTimePickerParams>} LogObject<invoicesWidgetReportsTimePickerParams>
 */
export function invoicesWidgetReportsTimePicker(params) {
    return { evid: 1328, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'invoicesEditModesEditInvoice' event (evid: 1329)
 *
 * Event description: Invoices - edit invoice
 *
 * @param {invoicesEditModesEditInvoiceParams} params - The parameters for this event
 * @property {boolean} ifOrderExist - if order exist
 * @property {boolean} hasViewedInvoice - if the uou seen the invoice
 * @property {string} view_type - view_type
 * @property {string} origin - origin of the invoice
 * @property {string} platform - platform
 * @property {GUID} msid - msid
 * @property {string} invoiceStatus - status of the invoice
 * @return {LogObject<invoicesEditModesEditInvoiceParams>} LogObject<invoicesEditModesEditInvoiceParams>
 */
export function invoicesEditModesEditInvoice(params) {
    return { evid: 1329, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'ascendPpScrollToEnd' event (evid: 133)
 *
 * Event description: User scroll to end of table
 *
 * @param {ascendPpScrollToEndParams} params - The parameters for this event
 * @property {number} timeInPage - in milisec
 * @property {string} referralInfo - button name open PP
 * @property {string} view_type - view_type
 * @property {string} origin - product name open PP
 * @property {string} platform - platform
 * @return {LogObject<ascendPpScrollToEndParams>} LogObject<ascendPpScrollToEndParams>
 */
export function ascendPpScrollToEnd(params) {
    return { evid: 133, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'invoicesEditModesEditCustomerInfoModalChoose' event (evid: 1330)
 *
 * Event description: Invoices - edit modes - edit customer info modal
 *
 * @param {invoicesEditModesEditCustomerInfoModalChooseParams} params - The parameters for this event
 * @property {string} option - option chosen - cancel or proceed
 * @property {string} view_type - view_type
 * @property {string} platform - platform
 * @property {GUID} msid - msid
 * @property {string} invoiceStatus - which status was the invoice
 * @return {LogObject<invoicesEditModesEditCustomerInfoModalChooseParams>} LogObject<invoicesEditModesEditCustomerInfoModalChooseParams>
 */
export function invoicesEditModesEditCustomerInfoModalChoose(params) {
    return { evid: 1330, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'invoicesEditModesNegativePriceToast' event (evid: 1331)
 *
 * Event description: Invoices - edit modes - negative price toast
 *
 * @param {invoicesEditModesNegativePriceToastParams} params - The parameters for this event
 * @property {string} view_type - view_type
 * @property {string} platform - platform
 * @property {GUID} msid - msid
 * @property {string} invoiceStatus - if no status then create
 * @return {LogObject<invoicesEditModesNegativePriceToastParams>} LogObject<invoicesEditModesNegativePriceToastParams>
 */
export function invoicesEditModesNegativePriceToast(params) {
    return { evid: 1331, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'crmDiscoverCrmTools' event (evid: 1333)
 *
 * Event description: CRM - Discover CRM Tools
 *
 * @param {crmDiscoverCrmToolsParams} params - The parameters for this event
 * @property {string} view_type - view_type
 * @property {string} pageView - which page clicked this link
 * @property {string} platform - platform
 * @property {GUID} msid - msid
 * @return {LogObject<crmDiscoverCrmToolsParams>} LogObject<crmDiscoverCrmToolsParams>
 */
export function crmDiscoverCrmTools(params) {
    return { evid: 1333, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'automationCreationModalOpened' event (evid: 1335)
 *
 * Event description: Complex Phone - help panel opened
 *
 * @param {automationCreationModalOpenedParams} params - The parameters for this event
 * @property {string} view_type - view_type
 * @property {string} origin - button location
 * @property {string} platform - platform
 * @property {GUID} msid - msid
 * @return {LogObject<automationCreationModalOpenedParams>} LogObject<automationCreationModalOpenedParams>
 */
export function automationCreationModalOpened(params) {
    return { evid: 1335, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'automationHomePageClickOnTabInAutomationTable' event (evid: 1336)
 *
 * Event description: Automation > home page - click on tab in automation table (all automations / pre installed / created by you)
 *
 * @param {automationHomePageClickOnTabInAutomationTableParams} params - The parameters for this event
 * @property {string} view_type - view_type
 * @property {string} tabName - tab_name
 * @property {string} platform - platform
 * @property {GUID} msid - msid
 * @property {string} previousTab - ‘all’ / ‘pre_installed’ / ‘created_by_you’
 * @return {LogObject<automationHomePageClickOnTabInAutomationTableParams>} LogObject<automationHomePageClickOnTabInAutomationTableParams>
 */
export function automationHomePageClickOnTabInAutomationTable(params) {
    return { evid: 1336, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'ascendPpClickOnPackageInPp' event (evid: 134)
 *
 * Event description: User click on select in pp
 *
 * @param {ascendPpClickOnPackageInPpParams} params - The parameters for this event
 * @property {boolean} isChecked - is most popular
 * @property {number} timeInPage - in milisec
 * @property {string} referralInfo - button name open PP
 * @property {string} buttonType - regular/hover/swipe_reg/swipe_hover
 * @property {string} view_type - view_type
 * @property {string} package_name - package name
 * @property {string} origin - product name open PP
 * @property {GUID} packageId - package id
 * @property {string} platform - platform
 * @return {LogObject<ascendPpClickOnPackageInPpParams>} LogObject<ascendPpClickOnPackageInPpParams>
 */
export function ascendPpClickOnPackageInPp(params) {
    return { evid: 134, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'ascendPpCyclePageView' event (evid: 135)
 *
 * Event description: User view Ascend cycle page
 *
 * @param {ascendPpCyclePageViewParams} params - The parameters for this event
 * @property {string} referralInfo - button name open PP
 * @property {string} view_type - view_type
 * @property {string} package_name - package name
 * @property {string} origin - product name open PP
 * @property {GUID} app_id - app_id
 * @property {GUID} packageId - package id
 * @property {string} platform - platform
 * @return {LogObject<ascendPpCyclePageViewParams>} LogObject<ascendPpCyclePageViewParams>
 */
export function ascendPpCyclePageView(params) {
    return { evid: 135, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'automationHomePageClickOnTableActions' event (evid: 1350)
 *
 * Event description: Automation > home page - click on table actions. Click on filter button or search line
 *
 * @param {automationHomePageClickOnTableActionsParams} params - The parameters for this event
 * @property {string} view_type - view_type
 * @property {string} type - filter / search
 * @property {string} platform - platform
 * @property {GUID} msid - msid
 * @return {LogObject<automationHomePageClickOnTableActionsParams>} LogObject<automationHomePageClickOnTableActionsParams>
 */
export function automationHomePageClickOnTableActions(params) {
    return { evid: 1350, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'automationHomePageSortAutomationTable' event (evid: 1351)
 *
 * Event description: Automation > home page -  sort automation table
 *
 * @param {automationHomePageSortAutomationTableParams} params - The parameters for this event
 * @property {string} field - rule / status / last_updated
 * @property {string} view_type - view_type
 * @property {string} sortType - sort_type
 * @property {string} platform - platform
 * @property {GUID} msid - msid
 * @return {LogObject<automationHomePageSortAutomationTableParams>} LogObject<automationHomePageSortAutomationTableParams>
 */
export function automationHomePageSortAutomationTable(params) {
    return { evid: 1351, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'automationHomePageAutomationTableMoreActions' event (evid: 1352)
 *
 * Event description: Automation > automation more actions per specific automation, more actions = 3 dots
 *
 * @param {automationHomePageAutomationTableMoreActionsParams} params - The parameters for this event
 * @property {string} view_type - view_type
 * @property {string} origin - where from the user clicked
 * @property {string} status - automation status
 * @property {string} platform - platform
 * @property {GUID} msid - msid
 * @property {GUID} ruleId - ruleId
 * @return {LogObject<automationHomePageAutomationTableMoreActionsParams>} LogObject<automationHomePageAutomationTableMoreActionsParams>
 */
export function automationHomePageAutomationTableMoreActions(params) {
    return { evid: 1352, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'automationFilterMenuAutomationTableExitClear' event (evid: 1355)
 *
 * Event description: Automation > filter automation table - exit / clear
 *
 * @param {automationFilterMenuAutomationTableExitClearParams} params - The parameters for this event
 * @property {string} view_type - view_type
 * @property {string} origin - from where this action was called
 * @property {string} type - clear_filter / exit_filter
 * @property {string} platform - platform
 * @property {GUID} msid - msid
 * @return {LogObject<automationFilterMenuAutomationTableExitClearParams>} LogObject<automationFilterMenuAutomationTableExitClearParams>
 */
export function automationFilterMenuAutomationTableExitClear(params) {
    return { evid: 1355, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'ascendPpClickOnCycleInPp' event (evid: 136)
 *
 * Event description: User click on a cycle
 *
 * @param {ascendPpClickOnCycleInPpParams} params - The parameters for this event
 * @property {string} cycle_name - cycle name
 * @property {string} referralInfo - button name open PP
 * @property {string} view_type - view_type
 * @property {string} package_name - packagename
 * @property {string} origin - product name open PP
 * @property {GUID} packageId - packageid
 * @property {string} platform - platform
 * @property {number} cycleId - cycle id
 * @return {LogObject<ascendPpClickOnCycleInPpParams>} LogObject<ascendPpClickOnCycleInPpParams>
 */
export function ascendPpClickOnCycleInPp(params) {
    return { evid: 136, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'automationAutomationTableFilterMenuCheckboxes' event (evid: 1362)
 *
 * Event description: Automation > automation table > filter menu - checkboxes
 *
 * @param {automationAutomationTableFilterMenuCheckboxesParams} params - The parameters for this event
 * @property {string} view_type - view_type
 * @property {boolean} checkbox - checked or enchecked
 * @property {string} filter - filter
 * @property {string} platform - platform
 * @property {GUID} msid - msid
 * @property {string} value - ‘running’ / ‘inactive’ etc
 * @return {LogObject<automationAutomationTableFilterMenuCheckboxesParams>} LogObject<automationAutomationTableFilterMenuCheckboxesParams>
 */
export function automationAutomationTableFilterMenuCheckboxes(params) {
    return { evid: 1362, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'toolcastHoverOnTheSpeaker' event (evid: 1364)
 *
 * Event description: when user hover and if the toolcast in the first step
 * and if the hover is from the focus widget or panel
 *
 * @param {toolcastHoverOnTheSpeakerParams} params - The parameters for this event
 * @property {boolean} firstStep - If the toolcast is first step and the user see the text
 * @property {string} view_type - view_type
 * @property {string} stepName - The name of the toolcast step
 * @property {string} origin - from Panel or Dashboard steps or bubble
 * @property {string} offeringGuid - offer guid
 * @property {string} campaignId - from dealer
 * @property {string} platform - platform
 * @return {LogObject<toolcastHoverOnTheSpeakerParams>} LogObject<toolcastHoverOnTheSpeakerParams>
 */
export function toolcastHoverOnTheSpeaker(params) {
    return { evid: 1364, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'toolcastClickOnTheSpeaker' event (evid: 1365)
 *
 * Event description: when user click and if the toolcast in the first step and if the click is from the focus widget or panel
 *
 * @param {toolcastClickOnTheSpeakerParams} params - The parameters for this event
 * @property {boolean} firstStep - if the toolcast in the first step he can see text, bool.
 * @property {string} clickType - deprecated
 * @property {string} view_type - view_type
 * @property {string} stepName - The name of the toolcast step
 * @property {string} origin - From where the user click panel or dashboard
 * @property {string} offeringGuid - offer guid from dealer
 * @property {string} campaignId - from dealer
 * @property {string} platform - platform
 * @return {LogObject<toolcastClickOnTheSpeakerParams>} LogObject<toolcastClickOnTheSpeakerParams>
 */
export function toolcastClickOnTheSpeaker(params) {
    return { evid: 1365, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'toolcastClickOnLetsGoThePopUp' event (evid: 1366)
 *
 * Event description: when user click on Lets go in the pop up toolcast in the first step and if the click is from the focus widget or panel
 *
 * @param {toolcastClickOnLetsGoThePopUpParams} params - The parameters for this event
 * @property {boolean} firstStep - if the toolcast in the first step he can see text, bool.
 * @property {string} clickType - From where the user click panel or dashboard
 * @property {string} view_type - view_type
 * @property {string} stepName - The name of the toolcast step
 * @property {string} origin - From where the user click panel or dashboard or bubble
 * @property {string} offeringGuid - offer guid
 * @property {string} campaignId - from dealer
 * @property {string} platform - platform
 * @return {LogObject<toolcastClickOnLetsGoThePopUpParams>} LogObject<toolcastClickOnLetsGoThePopUpParams>
 */
export function toolcastClickOnLetsGoThePopUp(params) {
    return { evid: 1366, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'toolcastClickOnXOnThePopUp' event (evid: 1367)
 *
 * Event description: when user click exist X on the pop up of the toolcast
 *
 * @param {toolcastClickOnXOnThePopUpParams} params - The parameters for this event
 * @property {boolean} firstStep - If the toolcast is first step and the user see the text
 * @property {string} clickType - click X from Panel or Dashboard steps
 * @property {string} view_type - view_type
 * @property {string} stepName - The name of the toolcast step
 * @property {string} origin - click X from Panel or Dashboard steps or bubble
 * @property {string} offeringGuid - offer guid
 * @property {string} campaignId - from dealer
 * @property {string} platform - platform
 * @return {LogObject<toolcastClickOnXOnThePopUpParams>} LogObject<toolcastClickOnXOnThePopUpParams>
 */
export function toolcastClickOnXOnThePopUp(params) {
    return { evid: 1367, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'toolcastGuideLoadedSuccessfully' event (evid: 1368)
 *
 * Event description: If the guide loaded
 *
 * @param {toolcastGuideLoadedSuccessfullyParams} params - The parameters for this event
 * @property {string} view_type - view_type
 * @property {string} offeringGuid - from dealer
 * @property {string} campaignId - from dealer
 * @property {string} platform - platform
 * @return {LogObject<toolcastGuideLoadedSuccessfullyParams>} LogObject<toolcastGuideLoadedSuccessfullyParams>
 */
export function toolcastGuideLoadedSuccessfully(params) {
    return { evid: 1368, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'ascendPpClickOnNextInCyclePage' event (evid: 137)
 *
 * Event description: User click on select in cycle page
 *
 * @param {ascendPpClickOnNextInCyclePageParams} params - The parameters for this event
 * @property {string} cycle_name - cycle name
 * @property {boolean} isChecked - is most popular
 * @property {number} timeInPage - in milisec
 * @property {string} referralInfo - button name open PP
 * @property {string} view_type - view_type
 * @property {string} package_name - package name
 * @property {string} origin - product name open PP
 * @property {number} cycle_id - cycle id
 * @property {GUID} packageId - packageid
 * @property {string} platform - platform
 * @return {LogObject<ascendPpClickOnNextInCyclePageParams>} LogObject<ascendPpClickOnNextInCyclePageParams>
 */
export function ascendPpClickOnNextInCyclePage(params) {
    return { evid: 137, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'toolcastClickContinueInTheGuide' event (evid: 1371)
 *
 * Event description: when user click continue on the guide
 *
 * @param {toolcastClickContinueInTheGuideParams} params - The parameters for this event
 * @property {string} view_type - view_type
 * @property {string} ctaName - cta name
 * @property {string} offeringGuid - offer guid
 * @property {string} campaignId - from dealer
 * @property {string} platform - platform
 * @return {LogObject<toolcastClickContinueInTheGuideParams>} LogObject<toolcastClickContinueInTheGuideParams>
 */
export function toolcastClickContinueInTheGuide(params) {
    return { evid: 1371, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'toolcastUserExposure' event (evid: 1372)
 *
 * Event description: when user expose to the toolcast
 * and if the toolcast in the first step or in the panel bubble or dashboard
 *
 * @param {toolcastUserExposureParams} params - The parameters for this event
 * @property {boolean} firstStep - if the toolcast in the next step
 * @property {string} view_type - view_type
 * @property {string} stepName - The name of the toolcast step
 * @property {string} origin - from Panel or Dashboard steps or bubble
 * @property {string} offeringGuid - offer guid
 * @property {string} campaignId - from dealer
 * @property {string} platform - platform
 * @return {LogObject<toolcastUserExposureParams>} LogObject<toolcastUserExposureParams>
 */
export function toolcastUserExposure(params) {
    return { evid: 1372, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'toolcastClickXInTheGuide' event (evid: 1373)
 *
 * Event description: when the user click on exist X in the guide
 *
 * @param {toolcastClickXInTheGuideParams} params - The parameters for this event
 * @property {string} view_type - view_type
 * @property {string} offeringGuid - offer id
 * @property {string} campaignId - campaign id from dealer
 * @property {string} platform - deprecated
 * @return {LogObject<toolcastClickXInTheGuideParams>} LogObject<toolcastClickXInTheGuideParams>
 */
export function toolcastClickXInTheGuide(params) {
    return { evid: 1373, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'customerNotificationsSettingsPreviewEditChooseAudience' event (evid: 1375)
 *
 * Event description: When the user chooses an audience for blog
 *
 * @param {customerNotificationsSettingsPreviewEditChooseAudienceParams} params - The parameters for this event
 * @property {string} name - the audience selection in english. f.e "site members"
 * @property {string} view_type - view_type
 * @property {GUID} rule_id - automations rule id
 * @property {string} platform - platform
 * @property {GUID} msid - msid
 * @property {string} template_id - ping template id
 * @return {LogObject<customerNotificationsSettingsPreviewEditChooseAudienceParams>} LogObject<customerNotificationsSettingsPreviewEditChooseAudienceParams>
 */
export function customerNotificationsSettingsPreviewEditChooseAudience(params) {
    return { evid: 1375, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'dashboardSiteSelectorIsOpen' event (evid: 1377)
 *
 * Event description: When the site dropdown in the header is opened successfully (the image is loaded and there is no error)
 *
 * @param {dashboardSiteSelectorIsOpenParams} params - The parameters for this event
 * @property {string} page_view - my-sites /dashboard / account settings
 * @property {string} view_type - view_type
 * @property {string} site_list - a list with all the msids shown to the user, the first item is the first item, second item is the second msid and so on…)
 * @property {string} platform - platform
 * @property {GUID} msid - metasite id
 * @property {number} loading_time - loading_time
 * @return {LogObject<dashboardSiteSelectorIsOpenParams>} LogObject<dashboardSiteSelectorIsOpenParams>
 */
export function dashboardSiteSelectorIsOpen(params) {
    return { evid: 1377, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'dashboardSiteSelectorIsLoadedWithoutScreenshots' event (evid: 1378)
 *
 * Event description: When the site  dropdown in the header is shown and returns with zero sites
 *
 * @param {dashboardSiteSelectorIsLoadedWithoutScreenshotsParams} params - The parameters for this event
 * @property {string} page_view - my-sites /dashboard / account settings/partners-dashboard
 * @property {string} view_type - view_type
 * @property {string} platform - platform
 * @property {number} loading_time - loading time
 * @return {LogObject<dashboardSiteSelectorIsLoadedWithoutScreenshotsParams>} LogObject<dashboardSiteSelectorIsLoadedWithoutScreenshotsParams>
 */
export function dashboardSiteSelectorIsLoadedWithoutScreenshots(params) {
    return { evid: 1378, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'dashboardSiteSelectorErrorLoading' event (evid: 1379)
 *
 * Event description: When the site  dropdown in the header list failed to load (error is presented)
 *
 * @param {dashboardSiteSelectorErrorLoadingParams} params - The parameters for this event
 * @property {boolean} is_from_search - Did the error happen when the user searched in the dropdown?
 * @property {string} page_view - my-sites /dashboard / account settings
 * @property {string} view_type - view_type
 * @property {string} platform - platform
 * @property {GUID} msid - metasite id
 * @property {number} loading_time - from click to error
 * @return {LogObject<dashboardSiteSelectorErrorLoadingParams>} LogObject<dashboardSiteSelectorErrorLoadingParams>
 */
export function dashboardSiteSelectorErrorLoading(params) {
    return { evid: 1379, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'ascendPpPurchasePageView' event (evid: 138)
 *
 * Event description: User view Payment page
 *
 * @param {ascendPpPurchasePageViewParams} params - The parameters for this event
 * @property {string} cycle_name - cycle name
 * @property {string} referralInfo - button name open PP
 * @property {string} view_type - view_type
 * @property {string} package_name - package name
 * @property {string} origin - product name open PP
 * @property {GUID} app_id - app_id
 * @property {GUID} packageId - package id
 * @property {string} platform - platform
 * @property {number} cycleId - cycle id
 * @return {LogObject<ascendPpPurchasePageViewParams>} LogObject<ascendPpPurchasePageViewParams>
 */
export function ascendPpPurchasePageView(params) {
    return { evid: 138, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'dashboardSiteSelectorClickOnSite' event (evid: 1380)
 *
 * Event description: When the user  dropdown in the header on a site in the site selector
 *
 * @param {dashboardSiteSelectorClickOnSiteParams} params - The parameters for this event
 * @property {string} location - the location of the site in the list (0 is first, 1 is second…)
 * @property {boolean} is_from_search - is the site selection out of a search results list?
 * @property {string} page_view - my-sites /dashboard / account settings
 * @property {GUID} msid_clicked - msid_clicked
 * @property {string} view_type - view_type
 * @property {string} platform - platform
 * @property {GUID} msid - metasite id
 * @return {LogObject<dashboardSiteSelectorClickOnSiteParams>} LogObject<dashboardSiteSelectorClickOnSiteParams>
 */
export function dashboardSiteSelectorClickOnSite(params) {
    return { evid: 1380, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'dashboardClickInSiteSelector' event (evid: 1381)
 *
 * Event description: When the user clicks on “create new site” OR “all sites” OR "Show more results" in the site  dropdown in the header
 *
 * @param {dashboardClickInSiteSelectorParams} params - The parameters for this event
 * @property {boolean} is_from_search - Did the user clicked on the cta when the dropdown shows search results?
 * @property {string} page_view - my-sites /dashboard / account settings
 * @property {string} view_type - view_type
 * @property {string} item_name - item clicked: all-sites/create-new-site /show-more-site-results
 * @property {string} platform - platform
 * @property {GUID} msid - metasite id
 * @return {LogObject<dashboardClickInSiteSelectorParams>} LogObject<dashboardClickInSiteSelectorParams>
 */
export function dashboardClickInSiteSelector(params) {
    return { evid: 1381, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'crmHomeInboxViewMessages' event (evid: 1383)
 *
 * Event description: CRM Home - inbox - view messages
 *
 * @param {crmHomeInboxViewMessagesParams} params - The parameters for this event
 * @property {number} countMessages - count_messages
 * @property {string} view_type - view_type
 * @property {string} platform - platform
 * @property {GUID} msid - msid
 * @return {LogObject<crmHomeInboxViewMessagesParams>} LogObject<crmHomeInboxViewMessagesParams>
 */
export function crmHomeInboxViewMessages(params) {
    return { evid: 1383, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'crmHomeTopCarouselClick' event (evid: 1384)
 *
 * Event description: CRM Home - Top carousel click
 *
 * @param {crmHomeTopCarouselClickParams} params - The parameters for this event
 * @property {string} view_type - view_type
 * @property {string} platform - platform
 * @property {GUID} msid - msid
 * @return {LogObject<crmHomeTopCarouselClickParams>} LogObject<crmHomeTopCarouselClickParams>
 */
export function crmHomeTopCarouselClick(params) {
    return { evid: 1384, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'crmHomeTopCarouselMainCtaClick' event (evid: 1385)
 *
 * Event description: CRM Home - Top carousel main CTA click
 *
 * @param {crmHomeTopCarouselMainCtaClickParams} params - The parameters for this event
 * @property {string} view_type - view_type
 * @property {string} platform - platform
 * @property {GUID} msid - msid
 * @property {string} bannerName - which banner was clicked
 * @return {LogObject<crmHomeTopCarouselMainCtaClickParams>} LogObject<crmHomeTopCarouselMainCtaClickParams>
 */
export function crmHomeTopCarouselMainCtaClick(params) {
    return { evid: 1385, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'crmHomeTopCarouselLoadStart' event (evid: 1386)
 *
 * Event description: CRM Home - Top carousel main CTA click
 *
 * @param {crmHomeTopCarouselLoadStartParams} params - The parameters for this event
 * @property {string} view_type - view_type
 * @property {string} platform - platform
 * @property {GUID} msid - msid
 * @return {LogObject<crmHomeTopCarouselLoadStartParams>} LogObject<crmHomeTopCarouselLoadStartParams>
 */
export function crmHomeTopCarouselLoadStart(params) {
    return { evid: 1386, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'crmHomeTopCarouselLoadEnd' event (evid: 1387)
 *
 * Event description: CRM Home - Top carousel main CTA click
 *
 * @param {crmHomeTopCarouselLoadEndParams} params - The parameters for this event
 * @property {string} view_type - view_type
 * @property {number} loadingTime - loading time in ms
 * @property {string} platform - platform
 * @property {GUID} msid - msid
 * @return {LogObject<crmHomeTopCarouselLoadEndParams>} LogObject<crmHomeTopCarouselLoadEndParams>
 */
export function crmHomeTopCarouselLoadEnd(params) {
    return { evid: 1387, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'notificationsBrowserStatus' event (evid: 1388)
 *
 * Event description: Notifications -> Browser status.
 *
 * @param {notificationsBrowserStatusParams} params - The parameters for this event
 * @property {GUID} app_instance_id - app_instance_id
 * @property {GUID} installation_id - installation_id
 * @property {string} state - state
 * @property {string} os_version - os_version
 * @property {string} app_version - app_version
 * @property {string} view_type - view_type
 * @property {string} notification_id - notification_id
 * @property {string} user_agent - user_agent
 * @property {string} bundle_version - bundle_version
 * @property {string} origin - origin
 * @property {boolean} status - Deprecated
 * @property {string} platform - platform
 * @property {GUID} bi_token - msid
 * @return {LogObject<notificationsBrowserStatusParams>} LogObject<notificationsBrowserStatusParams>
 */
export function notificationsBrowserStatus(params) {
    return { evid: 1388, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'ascendPpPurchasePageChangeCard' event (evid: 139)
 *
 * Event description: User click on credit card option
 *
 * @param {ascendPpPurchasePageChangeCardParams} params - The parameters for this event
 * @property {string} cycle_name - cycle name
 * @property {string} referralInfo - button name open PP
 * @property {string} view_type - view_type
 * @property {string} package_name - package name
 * @property {string} selection - saved card / another card
 * @property {string} origin - product name open PP
 * @property {GUID} app_id - app_id
 * @property {GUID} packageId - package id
 * @property {string} platform - platform
 * @property {number} cycleId - cycle id
 * @return {LogObject<ascendPpPurchasePageChangeCardParams>} LogObject<ascendPpPurchasePageChangeCardParams>
 */
export function ascendPpPurchasePageChangeCard(params) {
    return { evid: 139, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'ascendSelectCancelReason' event (evid: 1390)
 *
 * Event description: User click on cancel reason in cancelation screen
 *
 * @param {ascendSelectCancelReasonParams} params - The parameters for this event
 * @property {string} referralInfo - from where the screen was opened
 * @property {string} cancel_reason_text - cancel reason free text
 * @property {string} cancel_reason_name - cancel reason selection
 * @property {string} view_type - view_type
 * @property {string} premium - premium_id
 * @property {string} platform - native or web
 * @property {GUID} msid - msid
 * @return {LogObject<ascendSelectCancelReasonParams>} LogObject<ascendSelectCancelReasonParams>
 */
export function ascendSelectCancelReason(params) {
    return { evid: 1390, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'ascendCancelWindowApproveCancel' event (evid: 1391)
 *
 * Event description: User click on cancel plan or keep alive
 *
 * @param {ascendCancelWindowApproveCancelParams} params - The parameters for this event
 * @property {string} referralInfo - from where the screen was opened
 * @property {string} view_type - view_type
 * @property {string} selection - cancel plan / keep plan
 * @property {string} premium - premium_id
 * @property {string} platform - native or web
 * @property {GUID} msid - msid
 * @return {LogObject<ascendCancelWindowApproveCancelParams>} LogObject<ascendCancelWindowApproveCancelParams>
 */
export function ascendCancelWindowApproveCancel(params) {
    return { evid: 1391, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'automationsWebhookV2PayloadStructure' event (evid: 1393)
 *
 * Event description: Automations - webhook v2 - payload structure
 *
 * @param {automationsWebhookV2PayloadStructureParams} params - The parameters for this event
 * @property {string} view_type - view_type
 * @property {string} type - all keys or custom
 * @property {string} platform - platform
 * @property {GUID} msid - msid
 * @return {LogObject<automationsWebhookV2PayloadStructureParams>} LogObject<automationsWebhookV2PayloadStructureParams>
 */
export function automationsWebhookV2PayloadStructure(params) {
    return { evid: 1393, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'automationsWebhookV2ViewStructure' event (evid: 1394)
 *
 * Event description: Automations - webhook v2 - view structure
 *
 * @param {automationsWebhookV2ViewStructureParams} params - The parameters for this event
 * @property {string} view_type - view_type
 * @property {string} platform - platform
 * @property {GUID} msid - msid
 * @return {LogObject<automationsWebhookV2ViewStructureParams>} LogObject<automationsWebhookV2ViewStructureParams>
 */
export function automationsWebhookV2ViewStructure(params) {
    return { evid: 1394, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'automationsWebhookV2CustomizeStructure' event (evid: 1395)
 *
 * Event description: Automations - webhook v2 - customize structure
 *
 * @param {automationsWebhookV2CustomizeStructureParams} params - The parameters for this event
 * @property {string} view_type - view_type
 * @property {string} platform - platform
 * @property {GUID} msid - msid
 * @return {LogObject<automationsWebhookV2CustomizeStructureParams>} LogObject<automationsWebhookV2CustomizeStructureParams>
 */
export function automationsWebhookV2CustomizeStructure(params) {
    return { evid: 1395, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'automationsWebhookV2CustomizeStructureAddKeyValue' event (evid: 1396)
 *
 * Event description: Copy of Automations - webhook v2 - customize structure - add key-value
 *
 * @param {automationsWebhookV2CustomizeStructureAddKeyValueParams} params - The parameters for this event
 * @property {string} view_type - view_type
 * @property {string} platform - platform
 * @property {GUID} msid - msid
 * @return {LogObject<automationsWebhookV2CustomizeStructureAddKeyValueParams>} LogObject<automationsWebhookV2CustomizeStructureAddKeyValueParams>
 */
export function automationsWebhookV2CustomizeStructureAddKeyValue(params) {
    return { evid: 1396, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'automationsWebhookV2CustomizeStructureInsertVariable' event (evid: 1397)
 *
 * Event description: Automations - webhook v2 - customize structure - insert variable
 *
 * @param {automationsWebhookV2CustomizeStructureInsertVariableParams} params - The parameters for this event
 * @property {string} view_type - view_type
 * @property {string} platform - platform
 * @property {GUID} msid - msid
 * @return {LogObject<automationsWebhookV2CustomizeStructureInsertVariableParams>} LogObject<automationsWebhookV2CustomizeStructureInsertVariableParams>
 */
export function automationsWebhookV2CustomizeStructureInsertVariable(params) {
    return { evid: 1397, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'automationsWebhookV2CustomizeStructureSave' event (evid: 1398)
 *
 * Event description: Automations - webhook v2 - customize structure - save
 *
 * @param {automationsWebhookV2CustomizeStructureSaveParams} params - The parameters for this event
 * @property {string} view_type - view_type
 * @property {string} platform - platform
 * @property {GUID} msid - msid
 * @return {LogObject<automationsWebhookV2CustomizeStructureSaveParams>} LogObject<automationsWebhookV2CustomizeStructureSaveParams>
 */
export function automationsWebhookV2CustomizeStructureSave(params) {
    return { evid: 1398, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'dashboardBannerClick' event (evid: 14)
 *
 * Event description: dashboard > banner click.
 *
 * @param {dashboardBannerClickParams} params - The parameters for this event
 * @property {string} abTest - ab test group
 * @property {string} name - name
 * @property {string} click_type - click/close
 * @property {string} targetUrl - the banner link url
 * @property {string} view_type - view_type
 * @property {string} origin - origin
 * @property {string} bannerid - Banner id from dealer
 * @property {boolean} isPremium - is_premium
 * @property {string} platform - platform
 * @property {GUID} msid - msid
 * @property {string} bannerLocationOnPage - 'LIST_TOP' 'LIST_RIGHT' 'LIST_LEFT' ,the location of the banner
 * @return {LogObject<dashboardBannerClickParams>} LogObject<dashboardBannerClickParams>
 */
export function dashboardBannerClick(params) {
    return { evid: 14, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'ascendPpPurchasePageEnterPromo' event (evid: 140)
 *
 * Event description: User click on enter promo code or apply
 *
 * @param {ascendPpPurchasePageEnterPromoParams} params - The parameters for this event
 * @property {string} cycle_name - cycle name
 * @property {string} referralInfo - button name open PP
 * @property {string} view_type - view_type
 * @property {string} package_name - package name
 * @property {string} selection - enter click / apply
 * @property {string} origin - product name open PP
 * @property {GUID} app_id - app_id
 * @property {GUID} packageId - package id
 * @property {string} platform - platform
 * @property {number} cycleId - cycle id
 * @return {LogObject<ascendPpPurchasePageEnterPromoParams>} LogObject<ascendPpPurchasePageEnterPromoParams>
 */
export function ascendPpPurchasePageEnterPromo(params) {
    return { evid: 140, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'ascendPpPurchasePageSubmitPurchase' event (evid: 141)
 *
 * Event description: User click on Submit Purchase
 *
 * @param {ascendPpPurchasePageSubmitPurchaseParams} params - The parameters for this event
 * @property {string} cycle_name - cycle name
 * @property {string} referralInfo - button name open PP
 * @property {string} view_type - view_type
 * @property {string} package_name - package name
 * @property {string} origin - product name open PP
 * @property {GUID} app_id - app_id
 * @property {GUID} packageId - package id
 * @property {string} platform - platform
 * @property {number} cycleId - cycle id
 * @return {LogObject<ascendPpPurchasePageSubmitPurchaseParams>} LogObject<ascendPpPurchasePageSubmitPurchaseParams>
 */
export function ascendPpPurchasePageSubmitPurchase(params) {
    return { evid: 141, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'automationsBannerActivate' event (evid: 145)
 *
 * Event description: Automations > User click on banner CTA (only recipes)
 *
 * @param {automationsBannerActivateParams} params - The parameters for this event
 * @property {string} offerId - Dealer Offer id
 * @property {string} banner_name - banner_name
 * @property {string} view_type - view_type
 * @property {string} platform - platform
 * @property {GUID} msid - msid
 * @property {string} recipe_id - recipe_id
 * @return {LogObject<automationsBannerActivateParams>} LogObject<automationsBannerActivateParams>
 */
export function automationsBannerActivate(params) {
    return { evid: 145, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'headerLoaded' event (evid: 1452)
 *
 * Event description: when the header is shown to the user in my-sites/bizmgr/account manager/partner dashboard the event is sent
 *
 * @param {headerLoadedParams} params - The parameters for this event
 * @property {string} page_view - name of the page - my-sites/bizmgr/account manager/partner dashboard
 * @property {string} view_type - view_type
 * @property {string} platform - platform
 * @property {GUID} msid - in account level/my-sites send null
 * @return {LogObject<headerLoadedParams>} LogObject<headerLoadedParams>
 */
export function headerLoaded(params) {
    return { evid: 1452, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'customerNotificationsSettingsPreviewEditLoadingTime' event (evid: 1455)
 *
 * Event description: When the user come back from shoutout composer the event is send when the modal is fully loaded.
 *
 * @param {customerNotificationsSettingsPreviewEditLoadingTimeParams} params - The parameters for this event
 * @property {string} view_type - view_type
 * @property {number} loadingTime - The time between page was loaded and the modal was loaded
 * @property {string} platform - platform
 * @property {GUID} msid - msid
 * @return {LogObject<customerNotificationsSettingsPreviewEditLoadingTimeParams>} LogObject<customerNotificationsSettingsPreviewEditLoadingTimeParams>
 */
export function customerNotificationsSettingsPreviewEditLoadingTime(params) {
    return { evid: 1455, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'automationsMoreActionsChooseOption' event (evid: 1456)
 *
 * Event description: Automations - more actions (in automation home page BM) - choose option
 *
 * @param {automationsMoreActionsChooseOptionParams} params - The parameters for this event
 * @property {string} option - which option the user choose
 * @property {string} view_type - view_type
 * @property {string} origin - not relevant anymore
 * @property {string} platform - platform
 * @property {GUID} msid - msid
 * @return {LogObject<automationsMoreActionsChooseOptionParams>} LogObject<automationsMoreActionsChooseOptionParams>
 */
export function automationsMoreActionsChooseOption(params) {
    return { evid: 1456, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'settingsLobbyHoverOverAnItem' event (evid: 1457)
 *
 * Event description: When the user hovers over an item in the lobby
 *
 * @param {settingsLobbyHoverOverAnItemParams} params - The parameters for this event
 * @property {number} item_location_on_page - Item order (f.e. 0,1 etc.)
 * @property {string} section_name - general/ecommerce/..
 * @property {string} view_type - view_type
 * @property {string} cta_name - the cta value (if exists) - f.e. “Get a business number”
 * @property {string} page_id - the pageComppnentId of the item that was hovered on
 * @property {string} item_location - will be in this format {section,column,row}.  F.e. website settings will be {1,1,1}.  If there are no sections send 0.
 * @property {string} item_name - upgrade/connect_domain/.../website settings/business info/ roles and permissions/.../accept payments…
 * @property {string} platform - platform
 * @property {GUID} msid - msid
 * @return {LogObject<settingsLobbyHoverOverAnItemParams>} LogObject<settingsLobbyHoverOverAnItemParams>
 */
export function settingsLobbyHoverOverAnItem(params) {
    return { evid: 1457, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'bizmgrComponentRequestToLoad' event (evid: 1458)
 *
 * Event description: Generic component event - When the component is suppose to be loaded (before the loading starts)
 *
 * @param {bizmgrComponentRequestToLoadParams} params - The parameters for this event
 * @property {string} component_name - The component name
 * @property {string} state - The expected state of the component -  regular/empty_state/no_permission
 * @property {string} view_type - view_type
 * @property {string} sub_view - The sub_view of the hosted page in Bizmgr
 * @property {string} component_app_id - The app_id of the component
 * @property {string} app_id - The app_id of the page which hosts the component
 * @property {string} platform - platform
 * @property {string} component_id - the Id of the component
 * @property {string} hosting - MA/Editor/onboarding
 * @property {GUID} msid - msid
 * @property {string} view - The view of the hosted page in Bizmgr
 * @return {LogObject<bizmgrComponentRequestToLoadParams>} LogObject<bizmgrComponentRequestToLoadParams>
 */
export function bizmgrComponentRequestToLoad(params) {
    return { evid: 1458, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'bizmgrComponentLoadingStart' event (evid: 1459)
 *
 * Event description: Generic loading component event in the Bizmgr- When the component start loading
 *
 * @param {bizmgrComponentLoadingStartParams} params - The parameters for this event
 * @property {string} component_name - The component name
 * @property {string} hosting_platform - accountmanagr/bizmanagr/devcenter/etc.
 * @property {string} state - The expected state of the component -  regular/empty_state/no_permission
 * @property {string} view_type - view_type
 * @property {string} sub_view - The sub_view of the hosted page in Bizmgr
 * @property {string} page_id - the page id, please send always the page_id, no matter what is the type of the component
 * @property {string} host_id - the host id (meaningful string - f.e. ‘sidebar’,’settings-lobby’)
 * @property {string} component_app_id - The app_id of the component
 * @property {string} app_id - The app_id of the page which hosts the component
 * @property {string} platform - platform
 * @property {string} component_id - the Id of the component
 * @property {string} hosting_platform_context_id - context id: when the context is site - msid, when the context is app_id (like in devCenter f.e) - appDefId. In account manager is null
 * @property {string} hosting - MA/Editor/onboarding
 * @property {string} component_type - page/widget/modal/sidebar/header
 * @property {GUID} msid - msid
 * @property {string} view - The view of the hosted page in Bizmgr
 * @return {LogObject<bizmgrComponentLoadingStartParams>} LogObject<bizmgrComponentLoadingStartParams>
 */
export function bizmgrComponentLoadingStart(params) {
    return { evid: 1459, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'bizmgrComponentLoadingFinish' event (evid: 1460)
 *
 * Event description: Generic loading component event in the Bizmgr- When the component finishes loading
 *
 * @param {bizmgrComponentLoadingFinishParams} params - The parameters for this event
 * @property {string} component_name - The component name
 * @property {string} hosting_platform - accountmanagr/bizmanagr/devcenter/etc.
 * @property {string} state - The expected state of the component -  regular/empty_state/no_permission
 * @property {number} loading_time_from_start_loading_page - deprecated
 * @property {string} view_type - view_type
 * @property {string} prev_page_id - the previous page id
 * @property {number} loading_time_from_host_load - loading time from the start loading of the page
 * @property {string} sub_view - The sub_view of the hosted page in Bizmgr
 * @property {string} page_id - the page id
 * @property {boolean} is_first - True if the component loaded as part of the first page in session (before navigation). otherwise false
 * @property {string} host_id - the host id (meaningful string - f.e. ‘sidebar’,’settings-lobby’)
 * @property {string} component_app_id - The app_id of the component
 * @property {number} loading_time_from_host_platform_load - loading time from the start loading of the hosting platform
 * @property {string} app_id - The app_id of the page which hosts the component
 * @property {string} platform - platform
 * @property {string} component_id - the Id of the component
 * @property {string} hosting_platform_context_id - context id: when the context is site - msid, when the context is app_id (like in devCenter f.e) - appDefId. In account manager is null
 * @property {string} hosting - MA/Editor/onboarding
 * @property {string} component_type - page/widget/modal/sidebar/header
 * @property {GUID} msid - msid
 * @property {string} view - The view of the hosted page in Bizmgr
 * @property {number} loading_time - loading time from the start loading of the componen
 * @return {LogObject<bizmgrComponentLoadingFinishParams>} LogObject<bizmgrComponentLoadingFinishParams>
 */
export function bizmgrComponentLoadingFinish(params) {
    return { evid: 1460, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'bizmgrComponentLoadingWithAnError' event (evid: 1461)
 *
 * Event description: When component crashed for some reason
 *
 * @param {bizmgrComponentLoadingWithAnErrorParams} params - The parameters for this event
 * @property {string} component_name - The component name
 * @property {string} hosting_platform - accountmanagr/bizmanagr/devcenter/etc.
 * @property {string} state - error
 * @property {string} context - when the context is site - send msid, when the context is app for example (like in devCenter) send appDefId, etc.
 * @property {string} view_type - view_type
 * @property {number} loading_time_from_host_load - loading time from the start loading of the page which hosting the component until the component crashed (in ms)
 * @property {string} sub_view - The sub_view of the hosted page in Bizmgr
 * @property {string} error_type - the type of the error (f.e: permissions, system error, etc.)
 * @property {string} host_id - the host id (meaningful string - f.e. ‘sidebar’,’settings-lobby’)
 * @property {string} component_app_id - The app_id of the component
 * @property {number} loading_time_from_host_platform_load - loading time from the start loading of the hosting platform until the component crashed (in ms)
 * @property {string} app_id - The app_id of the page which hosts the component
 * @property {string} platform - platform
 * @property {string} component_id - the Id of the component
 * @property {string} hosting - MA/Editor/onboarding
 * @property {string} component_type - page/widget/sidebar/header
 * @property {GUID} msid - msid
 * @property {number} interval_load_time - load time of this component until it crashed in ms
 * @property {string} view - The view of the hosted page in Bizmgr
 * @return {LogObject<bizmgrComponentLoadingWithAnErrorParams>} LogObject<bizmgrComponentLoadingWithAnErrorParams>
 */
export function bizmgrComponentLoadingWithAnError(params) {
    return { evid: 1461, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'bizmgrComponentComponentWasShown' event (evid: 1462)
 *
 * Event description: Generic loading component event in the Bizmgr- When the component is shown (if it's below the fold it is sent only when the user scrolls down)
 *
 * @param {bizmgrComponentComponentWasShownParams} params - The parameters for this event
 * @property {string} component_name - The component name
 * @property {string} state - The expected state of the component -  regular/empty_state/no_permission
 * @property {string} view_type - view_type
 * @property {string} sub_view - The sub_view of the hosted page in Bizmgr
 * @property {string} host_id - the host id (meaningful string - f.e. ‘sidebar’,’settings-lobby’)
 * @property {string} component_app_id - The app_id of the component
 * @property {string} app_id - The app_id of the page which hosts the component
 * @property {string} platform - platform
 * @property {string} component_id - the Id of the component
 * @property {string} hosting - MA/Editor/onboarding
 * @property {GUID} msid - msid
 * @property {string} view - The view of the hosted page in Bizmgr
 * @return {LogObject<bizmgrComponentComponentWasShownParams>} LogObject<bizmgrComponentComponentWasShownParams>
 */
export function bizmgrComponentComponentWasShown(params) {
    return { evid: 1462, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'invoicesSetBusinessInfoModalClickOnAddContinue' event (evid: 1464)
 *
 * Event description: Set Business Info Modal - click on Add & Continue
 *
 * @param {invoicesSetBusinessInfoModalClickOnAddContinueParams} params - The parameters for this event
 * @property {string} view_type - view_type
 * @property {GUID} appDefId - application id
 * @property {string} origin - origin page - from which place this action was made (invoices, contacts full page, crm home...)
 * @property {string} platform - platform
 * @property {string} msid - msid
 * @return {LogObject<invoicesSetBusinessInfoModalClickOnAddContinueParams>} LogObject<invoicesSetBusinessInfoModalClickOnAddContinueParams>
 */
export function invoicesSetBusinessInfoModalClickOnAddContinue(params) {
    return { evid: 1464, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'invoicesSetBusinessInfoModalClickOnCancel' event (evid: 1465)
 *
 * Event description: Set Business Info Modal - click on cancel
 *
 * @param {invoicesSetBusinessInfoModalClickOnCancelParams} params - The parameters for this event
 * @property {string} view_type - view_type
 * @property {GUID} appDefId - application ID
 * @property {string} origin - origin page - from which place this action was made (invoices, contacts full page, crm home...)
 * @property {string} cancelType - cancel/ close
 * @property {string} platform - platform
 * @property {string} msid - msid
 * @return {LogObject<invoicesSetBusinessInfoModalClickOnCancelParams>} LogObject<invoicesSetBusinessInfoModalClickOnCancelParams>
 */
export function invoicesSetBusinessInfoModalClickOnCancel(params) {
    return { evid: 1465, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'automationsGlobalErrorForMissingRecipe' event (evid: 1466)
 *
 * Event description: Automations - global error for missing recipe
 *
 * @param {automationsGlobalErrorForMissingRecipeParams} params - The parameters for this event
 * @property {string} receipt_id - receipt_id
 * @property {string} view_type - view_type
 * @property {string} errorReason - errorReason
 * @property {string} origin - from where the automation error was made
 * @property {string} platform - platform
 * @property {GUID} msid - msid
 * @return {LogObject<automationsGlobalErrorForMissingRecipeParams>} LogObject<automationsGlobalErrorForMissingRecipeParams>
 */
export function automationsGlobalErrorForMissingRecipe(params) {
    return { evid: 1466, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'headerFullyLoaded' event (evid: 1467)
 *
 * Event description: when the header is fully loaded in my-sites/bizmgr/account manager/partner dashboard the event is sent
 *
 * @param {headerFullyLoadedParams} params - The parameters for this event
 * @property {string} page_view - name of the page - my-sites/bizmgr/account manager/partner dashboard
 * @property {boolean} is_partner - is_partner
 * @property {string} view_type - view_type
 * @property {string} platform - platform
 * @property {GUID} msid - in account level/my-sites send null
 * @return {LogObject<headerFullyLoadedParams>} LogObject<headerFullyLoadedParams>
 */
export function headerFullyLoaded(params) {
    return { evid: 1467, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'dashboardClickOnItemFromHeader' event (evid: 147)
 *
 * Event description: When a user clicks on an item in the header that redirects him to another page
 *
 * @param {dashboardClickOnItemFromHeaderParams} params - The parameters for this event
 * @property {string} name - the item clicked name (my-sites/partner dashors'
 * @property {string} page_view - my-sites /dashboard / account settings
 * @property {string} view_type - view_type
 * @property {string} platform - platform
 * @property {string} hosting - MA
 * @property {GUID} msid - --
 * @return {LogObject<dashboardClickOnItemFromHeaderParams>} LogObject<dashboardClickOnItemFromHeaderParams>
 */
export function dashboardClickOnItemFromHeader(params) {
    return { evid: 147, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'automationsGoogleSheetsConnectToGoogleAccountStart' event (evid: 1483)
 *
 * Event description: Automations - google sheets - connect to google account
 *
 * @param {automationsGoogleSheetsConnectToGoogleAccountStartParams} params - The parameters for this event
 * @property {string} view_type - view_type
 * @property {string} platform - platform
 * @property {GUID} msid - msid
 * @return {LogObject<automationsGoogleSheetsConnectToGoogleAccountStartParams>} LogObject<automationsGoogleSheetsConnectToGoogleAccountStartParams>
 */
export function automationsGoogleSheetsConnectToGoogleAccountStart(params) {
    return { evid: 1483, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'automationsGoogleSheetsConnectToGoogleAccountEnd' event (evid: 1484)
 *
 * Event description: Automations - google sheets - connect to google account - end
 *
 * @param {automationsGoogleSheetsConnectToGoogleAccountEndParams} params - The parameters for this event
 * @property {string} view_type - view_type
 * @property {string} platform - platform
 * @property {GUID} msid - msid
 * @return {LogObject<automationsGoogleSheetsConnectToGoogleAccountEndParams>} LogObject<automationsGoogleSheetsConnectToGoogleAccountEndParams>
 */
export function automationsGoogleSheetsConnectToGoogleAccountEnd(params) {
    return { evid: 1484, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'automationsGoogleSheetsChooseSpreadsheet' event (evid: 1485)
 *
 * Event description: Automations - google sheets - choose spreadsheet
 *
 * @param {automationsGoogleSheetsChooseSpreadsheetParams} params - The parameters for this event
 * @property {string} view_type - view_type
 * @property {string} platform - platform
 * @property {GUID} msid - msid
 * @return {LogObject<automationsGoogleSheetsChooseSpreadsheetParams>} LogObject<automationsGoogleSheetsChooseSpreadsheetParams>
 */
export function automationsGoogleSheetsChooseSpreadsheet(params) {
    return { evid: 1485, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'automationsGoogleSheetsMatchDataToSheet' event (evid: 1486)
 *
 * Event description: Automations - google sheets - match data to sheet
 *
 * @param {automationsGoogleSheetsMatchDataToSheetParams} params - The parameters for this event
 * @property {string} view_type - view_type
 * @property {string} platform - platform
 * @property {GUID} msid - msid
 * @return {LogObject<automationsGoogleSheetsMatchDataToSheetParams>} LogObject<automationsGoogleSheetsMatchDataToSheetParams>
 */
export function automationsGoogleSheetsMatchDataToSheet(params) {
    return { evid: 1486, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'automationsGoogleSheetsMatchDataToSheetSaveModal' event (evid: 1487)
 *
 * Event description: Automations - google sheets - match data to sheet - save modal
 *
 * @param {automationsGoogleSheetsMatchDataToSheetSaveModalParams} params - The parameters for this event
 * @property {number} matchedColumnsCount - matchedColumnsCount
 * @property {string} view_type - view_type
 * @property {string} platform - platform
 * @property {GUID} msid - msid
 * @return {LogObject<automationsGoogleSheetsMatchDataToSheetSaveModalParams>} LogObject<automationsGoogleSheetsMatchDataToSheetSaveModalParams>
 */
export function automationsGoogleSheetsMatchDataToSheetSaveModal(params) {
    return { evid: 1487, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'automationsGoogleSheetsChooseSheet' event (evid: 1488)
 *
 * Event description: Automations - google sheets - choose spreadsheet
 *
 * @param {automationsGoogleSheetsChooseSheetParams} params - The parameters for this event
 * @property {string} view_type - view_type
 * @property {string} platform - platform
 * @property {GUID} msid - msid
 * @return {LogObject<automationsGoogleSheetsChooseSheetParams>} LogObject<automationsGoogleSheetsChooseSheetParams>
 */
export function automationsGoogleSheetsChooseSheet(params) {
    return { evid: 1488, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'generalExposureEvent' event (evid: 149)
 *
 * Event description: general exposure event . can be used in several cases
 *
 * @param {generalExposureEventParams} params - The parameters for this event
 * @property {string} exposure_name - exposure_name
 * @property {string} label_name - A is spec=false , B is spec=true
 * @property {string} view_type - view_type
 * @property {string} platform - platform
 * @property {string} hosting - MA/editor
 * @property {GUID} msid - metasite id
 * @return {LogObject<generalExposureEventParams>} LogObject<generalExposureEventParams>
 */
export function generalExposureEvent(params) {
    return { evid: 149, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'dashboardSiteNavigation' event (evid: 15)
 *
 * Event description: dashboard > site -> navigation.
 *
 * @param {dashboardSiteNavigationParams} params - The parameters for this event
 * @property {string} view_type - view_type
 * @property {string} link - link
 * @property {string} platform - platform
 * @property {GUID} msid - msid
 * @return {LogObject<dashboardSiteNavigationParams>} LogObject<dashboardSiteNavigationParams>
 */
export function dashboardSiteNavigation(params) {
    return { evid: 15, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'dashboardMySitesActionSelectionPageView' event (evid: 150)
 *
 * Event description: my sites selection page
 *
 * @param {dashboardMySitesActionSelectionPageViewParams} params - The parameters for this event
 * @property {string} view_type - view_type
 * @property {number} no_of_html_sites - number of html sites
 * @property {string} origin - origin of page
 * @property {number} no_of_sites - number of sites user have
 * @property {string} platform - platform
 * @property {GUID} msid - msid
 * @return {LogObject<dashboardMySitesActionSelectionPageViewParams>} LogObject<dashboardMySitesActionSelectionPageViewParams>
 */
export function dashboardMySitesActionSelectionPageView(params) {
    return { evid: 150, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'dashboardMySitesSiteSelectionPageView' event (evid: 151)
 *
 * Event description: my sites selection page
 *
 * @param {dashboardMySitesSiteSelectionPageViewParams} params - The parameters for this event
 * @property {string} view_type - view_type
 * @property {number} no_of_html_sites - number of html sites
 * @property {string} origin - origin of page
 * @property {number} no_of_sites - number of sites user have
 * @property {string} platform - platform
 * @property {GUID} msid - msid
 * @return {LogObject<dashboardMySitesSiteSelectionPageViewParams>} LogObject<dashboardMySitesSiteSelectionPageViewParams>
 */
export function dashboardMySitesSiteSelectionPageView(params) {
    return { evid: 151, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'crmHomeSuggestionsCarouselClickCta' event (evid: 1511)
 *
 * Event description: CRM Home - Suggestions carousel click CTA
 *
 * @param {crmHomeSuggestionsCarouselClickCtaParams} params - The parameters for this event
 * @property {string} view_type - view_type
 * @property {string} platform - platform
 * @property {GUID} msid - msid
 * @property {string} bannerName - which banner was clicked
 * @return {LogObject<crmHomeSuggestionsCarouselClickCtaParams>} LogObject<crmHomeSuggestionsCarouselClickCtaParams>
 */
export function crmHomeSuggestionsCarouselClickCta(params) {
    return { evid: 1511, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'crmHomeSuggestionsCarouselCloseBanner' event (evid: 1512)
 *
 * Event description: CRM Home - Suggestions carousel close banner
 *
 * @param {crmHomeSuggestionsCarouselCloseBannerParams} params - The parameters for this event
 * @property {string} view_type - view_type
 * @property {string} platform - platform
 * @property {GUID} msid - msid
 * @property {string} bannerName - which banner was clicked
 * @return {LogObject<crmHomeSuggestionsCarouselCloseBannerParams>} LogObject<crmHomeSuggestionsCarouselCloseBannerParams>
 */
export function crmHomeSuggestionsCarouselCloseBanner(params) {
    return { evid: 1512, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'crmHomeSuggestionsCarouselClickOnCarousel' event (evid: 1513)
 *
 * Event description: CRM Home - Suggestions carousel click on carousel
 *
 * @param {crmHomeSuggestionsCarouselClickOnCarouselParams} params - The parameters for this event
 * @property {string} view_type - view_type
 * @property {string} platform - platform
 * @property {GUID} msid - msid
 * @return {LogObject<crmHomeSuggestionsCarouselClickOnCarouselParams>} LogObject<crmHomeSuggestionsCarouselClickOnCarouselParams>
 */
export function crmHomeSuggestionsCarouselClickOnCarousel(params) {
    return { evid: 1513, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'automationsChooseSpecificServiceOutOfTriggerDropdown' event (evid: 1514)
 *
 * Event description: Automations - Trigger filter - user open filter dropdown. for 'item selection' and input filter with selection
 *
 * @param {automationsChooseSpecificServiceOutOfTriggerDropdownParams} params - The parameters for this event
 * @property {string} filterType - input_filter / item_selection
 * @property {string} inputName - the key name of the dropdown
 * @property {string} view_type - view_type
 * @property {string} filterId - filter id
 * @property {string} triggerApp - trigger vertical / app / TPA
 * @property {string} conditionKeys - conditionKey
 * @property {string} platform - platform
 * @property {GUID} msid - msid
 * @property {string} inputType - input_type
 * @property {string} triggerName - triggerName
 * @property {number} inputLevel - how many dropdowns parents
 * @return {LogObject<automationsChooseSpecificServiceOutOfTriggerDropdownParams>} LogObject<automationsChooseSpecificServiceOutOfTriggerDropdownParams>
 */
export function automationsChooseSpecificServiceOutOfTriggerDropdown(params) {
    return { evid: 1514, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'automationsChooseSpecificServiceFromTriggerClick' event (evid: 1515)
 *
 * Event description: Automations - Trigger filter - user change value in filter
 *
 * @param {automationsChooseSpecificServiceFromTriggerClickParams} params - The parameters for this event
 * @property {string} selectedOption - selectedOption
 * @property {string} filterType - time_since_event / input_filter / selection_filter
 * @property {string} inputName - the key name of the dropdown
 * @property {string} view_type - view_type
 * @property {string} filterId - filter id
 * @property {string} triggerApp - trigger vertical / app / TPA
 * @property {string} conditionKeys - conditionKey
 * @property {string} platform - platform
 * @property {GUID} msid - msid
 * @property {string} inputType - multiselect / single select / number
 * @property {string} value - deprecated
 * @property {string} triggerName - triggerName
 * @property {number} inputLevel - how many dropdowns parents
 * @return {LogObject<automationsChooseSpecificServiceFromTriggerClickParams>} LogObject<automationsChooseSpecificServiceFromTriggerClickParams>
 */
export function automationsChooseSpecificServiceFromTriggerClick(params) {
    return { evid: 1515, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'dashboardMySitesSiteSelectionPageNumberView' event (evid: 152)
 *
 * Event description: my sites selection page
 *
 * @param {dashboardMySitesSiteSelectionPageNumberViewParams} params - The parameters for this event
 * @property {string} view_type - view_type
 * @property {number} no_of_html_sites - number of html sites
 * @property {number} no_of_sites - number of sites user have
 * @property {string} platform - platform
 * @property {GUID} msid - msid
 * @property {number} page_number - פשעק מוצנקר
 * @property {number} prev_page - previous page
 * @return {LogObject<dashboardMySitesSiteSelectionPageNumberViewParams>} LogObject<dashboardMySitesSiteSelectionPageNumberViewParams>
 */
export function dashboardMySitesSiteSelectionPageNumberView(params) {
    return { evid: 152, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'automationsGoogleSheetsMatchDataToSheetRefreshData' event (evid: 1529)
 *
 * Event description: Automations - google sheets - match data to sheet - refresh data
 *
 * @param {automationsGoogleSheetsMatchDataToSheetRefreshDataParams} params - The parameters for this event
 * @property {string} view_type - view_type
 * @property {string} platform - platform
 * @property {GUID} msid - msid
 * @return {LogObject<automationsGoogleSheetsMatchDataToSheetRefreshDataParams>} LogObject<automationsGoogleSheetsMatchDataToSheetRefreshDataParams>
 */
export function automationsGoogleSheetsMatchDataToSheetRefreshData(params) {
    return { evid: 1529, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'dashboardMySitesClickPromote' event (evid: 153)
 *
 * Event description: my sites selection page
 *
 * @param {dashboardMySitesClickPromoteParams} params - The parameters for this event
 * @property {string} view_type - view_type
 * @property {string} origin - original page
 * @property {string} place - place inside origin page
 * @property {string} platform - platform
 * @property {GUID} msid - msid
 * @return {LogObject<dashboardMySitesClickPromoteParams>} LogObject<dashboardMySitesClickPromoteParams>
 */
export function dashboardMySitesClickPromote(params) {
    return { evid: 153, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'automationsGoogleSheetsMatchDataToSheetSelectData' event (evid: 1530)
 *
 * Event description: Automations - google sheets - match data to sheet - refresh data
 *
 * @param {automationsGoogleSheetsMatchDataToSheetSelectDataParams} params - The parameters for this event
 * @property {string} view_type - view_type
 * @property {string} platform - platform
 * @property {GUID} msid - msid
 * @return {LogObject<automationsGoogleSheetsMatchDataToSheetSelectDataParams>} LogObject<automationsGoogleSheetsMatchDataToSheetSelectDataParams>
 */
export function automationsGoogleSheetsMatchDataToSheetSelectData(params) {
    return { evid: 1530, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'dashboardMySitesWelcomeMessageForProsDisplayed' event (evid: 154)
 *
 * Event description: welcome message of pro account is displayed
 *
 * @param {dashboardMySitesWelcomeMessageForProsDisplayedParams} params - The parameters for this event
 * @property {string} view_type - view_type
 * @property {string} platform - platform
 * @return {LogObject<dashboardMySitesWelcomeMessageForProsDisplayedParams>} LogObject<dashboardMySitesWelcomeMessageForProsDisplayedParams>
 */
export function dashboardMySitesWelcomeMessageForProsDisplayed(params) {
    return { evid: 154, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'quotesCreateInvoiceEnterItemDescription' event (evid: 1540)
 *
 * Event description: Create invoice - Enter Item Description
 *
 * @param {quotesCreateInvoiceEnterItemDescriptionParams} params - The parameters for this event
 * @property {string} view_type - view_type
 * @property {string} invoiceType - ’recurringAutoCharge’/ 'recurring'/ 'one time'
 * @property {string} origin - create invoice, edit invoice
 * @property {string} platform - platform
 * @property {string} msid - msid
 * @property {GUID} invoice_id - invoice guid
 * @return {LogObject<quotesCreateInvoiceEnterItemDescriptionParams>} LogObject<quotesCreateInvoiceEnterItemDescriptionParams>
 */
export function quotesCreateInvoiceEnterItemDescription(params) {
    return { evid: 1540, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'quotesCreateInvoiceClickOnSeeMoreItems' event (evid: 1541)
 *
 * Event description: Create invoice - Click on “See More Items”
 *
 * @param {quotesCreateInvoiceClickOnSeeMoreItemsParams} params - The parameters for this event
 * @property {string} view_type - view_type
 * @property {string} productSource - product source
 * @property {string} invoiceType - ’recurringAutoCharge’/ 'recurring'/ 'one time'
 * @property {string} origin - create invoice, edit invoice
 * @property {string} platform - platform
 * @property {string} msid - msid
 * @property {GUID} invoice_id - invoice guid
 * @return {LogObject<quotesCreateInvoiceClickOnSeeMoreItemsParams>} LogObject<quotesCreateInvoiceClickOnSeeMoreItemsParams>
 */
export function quotesCreateInvoiceClickOnSeeMoreItems(params) {
    return { evid: 1541, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'quotesCreateInvoiceRearrangeItems' event (evid: 1542)
 *
 * Event description: Quotes - Create invoice - Rearrange Items.
 *
 * @param {quotesCreateInvoiceRearrangeItemsParams} params - The parameters for this event
 * @property {string} view_type - view_type
 * @property {string} invoiceType - ’recurringAutoCharge’/ 'recurring'/ 'one time'
 * @property {string} origin - create invoice, edit invoice
 * @property {string} platform - platform
 * @property {string} msid - msid
 * @return {LogObject<quotesCreateInvoiceRearrangeItemsParams>} LogObject<quotesCreateInvoiceRearrangeItemsParams>
 */
export function quotesCreateInvoiceRearrangeItems(params) {
    return { evid: 1542, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'quotesCreateInvoiceClickOnAddTax' event (evid: 1543)
 *
 * Event description: Create invoice - user Clicks on Add Tax
 *
 * @param {quotesCreateInvoiceClickOnAddTaxParams} params - The parameters for this event
 * @property {string} source - deprecated
 * @property {string} view_type - view_type
 * @property {string} invoiceType - ’recurringAutoCharge’/ 'recurring'/ 'one time'
 * @property {string} origin - create invoice, edit invoice
 * @property {string} platform - deprecated
 * @property {string} msid - msid
 * @property {GUID} invoice_id - invoice guid
 * @return {LogObject<quotesCreateInvoiceClickOnAddTaxParams>} LogObject<quotesCreateInvoiceClickOnAddTaxParams>
 */
export function quotesCreateInvoiceClickOnAddTax(params) {
    return { evid: 1543, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'quotesCreateInvoiceTaxSelected' event (evid: 1544)
 *
 * Event description: Create invoice - user Clicks on Add Tax
 *
 * @param {quotesCreateInvoiceTaxSelectedParams} params - The parameters for this event
 * @property {string} source - deprecated
 * @property {string} view_type - view_type
 * @property {string} invoiceType - ’recurringAutoCharge’/ 'recurring'/ 'one time'
 * @property {string} origin - create invoice, edit invoice
 * @property {string} platform - deprecated
 * @property {string} msid - msid
 * @property {string} value - value of tax
 * @property {GUID} invoice_id - invoice guid
 * @return {LogObject<quotesCreateInvoiceTaxSelectedParams>} LogObject<quotesCreateInvoiceTaxSelectedParams>
 */
export function quotesCreateInvoiceTaxSelected(params) {
    return { evid: 1544, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'quotesCreateInvoiceClickOnInvoiceSettings' event (evid: 1545)
 *
 * Event description: Quotes - Create invoice - click on invoice settings.
 *
 * @param {quotesCreateInvoiceClickOnInvoiceSettingsParams} params - The parameters for this event
 * @property {string} source - source
 * @property {string} view_type - view_type
 * @property {string} invoiceType - ’recurringAutoCharge’/ 'recurring'/ 'one time'
 * @property {string} origin - origin
 * @property {string} platform - platform
 * @property {string} msid - msid
 * @property {GUID} invoice_id - invoice guid
 * @return {LogObject<quotesCreateInvoiceClickOnInvoiceSettingsParams>} LogObject<quotesCreateInvoiceClickOnInvoiceSettingsParams>
 */
export function quotesCreateInvoiceClickOnInvoiceSettings(params) {
    return { evid: 1545, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'quotesCreateInvoiceAddRemoveDiscount' event (evid: 1546)
 *
 * Event description: Create invoice - user adding or removing discounts
 *
 * @param {quotesCreateInvoiceAddRemoveDiscountParams} params - The parameters for this event
 * @property {string} source - source
 * @property {string} view_type - view_type
 * @property {string} invoiceType - ’recurringAutoCharge’/ 'recurring'/ 'one time'
 * @property {string} origin - create invoice, edit invoice
 * @property {string} platform - platform
 * @property {string} msid - msid
 * @property {string} value - add/remove
 * @property {GUID} invoice_id - invoice guid
 * @return {LogObject<quotesCreateInvoiceAddRemoveDiscountParams>} LogObject<quotesCreateInvoiceAddRemoveDiscountParams>
 */
export function quotesCreateInvoiceAddRemoveDiscount(params) {
    return { evid: 1546, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'quotesCreateInvoiceLeavingCreateInvoicePagePopUpAppears' event (evid: 1547)
 *
 * Event description: Create invoice - user leaving the create invoice page leading to a pop up appearance
 *
 * @param {quotesCreateInvoiceLeavingCreateInvoicePagePopUpAppearsParams} params - The parameters for this event
 * @property {string} source - source
 * @property {string} view_type - view_type
 * @property {string} origin - create invoice, edit invoice
 * @property {string} platform - platform
 * @property {string} msid - msid
 * @property {GUID} invoice_id - invoice guid
 * @return {LogObject<quotesCreateInvoiceLeavingCreateInvoicePagePopUpAppearsParams>} LogObject<quotesCreateInvoiceLeavingCreateInvoicePagePopUpAppearsParams>
 */
export function quotesCreateInvoiceLeavingCreateInvoicePagePopUpAppears(params) {
    return { evid: 1547, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'quotesCreateInvoiceLeavingCreateInvoicePagePopUpResolution' event (evid: 1548)
 *
 * Event description: Create invoice - user choose between saving and leaving w/o saving the invoice
 *
 * @param {quotesCreateInvoiceLeavingCreateInvoicePagePopUpResolutionParams} params - The parameters for this event
 * @property {string} source - source
 * @property {string} view_type - view_type
 * @property {string} origin - create invoice, edit invoice
 * @property {string} platform - platform
 * @property {string} msid - msid
 * @property {string} value - save / do not save / X
 * @property {GUID} invoice_id - invoice guid
 * @return {LogObject<quotesCreateInvoiceLeavingCreateInvoicePagePopUpResolutionParams>} LogObject<quotesCreateInvoiceLeavingCreateInvoicePagePopUpResolutionParams>
 */
export function quotesCreateInvoiceLeavingCreateInvoicePagePopUpResolution(params) {
    return { evid: 1548, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'quotesPreviewInvoiceClickInPreviewPageMenu' event (evid: 1549)
 *
 * Event description: Create invoice - user click in preview page menu
 *
 * @param {quotesPreviewInvoiceClickInPreviewPageMenuParams} params - The parameters for this event
 * @property {string} source - (invoices/ crm home/ os dashboard)
 * @property {GUID} externalId - external_id
 * @property {string} view_type - view_type
 * @property {string} invoiceType - ’recurringAutoCharge’/ 'recurring'/ 'one time'
 * @property {string} origin - create invoice, edit invoice
 * @property {GUID} invoiceSource - invoice_source
 * @property {string} platform - platform
 * @property {string} msid - msid
 * @property {string} value - share / print / edit / resend via email/ send via email
 * @property {GUID} invoice_id - invoice guid
 * @return {LogObject<quotesPreviewInvoiceClickInPreviewPageMenuParams>} LogObject<quotesPreviewInvoiceClickInPreviewPageMenuParams>
 */
export function quotesPreviewInvoiceClickInPreviewPageMenu(params) {
    return { evid: 1549, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'dashboardMySitesWelcomeMessageForProsClick' event (evid: 155)
 *
 * Event description: user clicked in welcome message of pro account, clicks":  close, disable, "check it out"
 *
 * @param {dashboardMySitesWelcomeMessageForProsClickParams} params - The parameters for this event
 * @property {string} view_type - view_type
 * @property {string} platform - platform
 * @property {string} action - check it out, close, disable
 * @return {LogObject<dashboardMySitesWelcomeMessageForProsClickParams>} LogObject<dashboardMySitesWelcomeMessageForProsClickParams>
 */
export function dashboardMySitesWelcomeMessageForProsClick(params) {
    return { evid: 155, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'quotesCreateInvoiceUserClickOnSendInvoice' event (evid: 1550)
 *
 * Event description: Create invoice -user click on send invoice
 *
 * @param {quotesCreateInvoiceUserClickOnSendInvoiceParams} params - The parameters for this event
 * @property {string} source - source
 * @property {string} view_type - view_type
 * @property {string} invoiceType - ’recurringAutoCharge’/ 'recurring'/ 'one time'
 * @property {string} origin - create invoice, edit invoice
 * @property {string} platform - platform
 * @property {string} msid - msid
 * @property {GUID} invoice_id - invoice guid
 * @return {LogObject<quotesCreateInvoiceUserClickOnSendInvoiceParams>} LogObject<quotesCreateInvoiceUserClickOnSendInvoiceParams>
 */
export function quotesCreateInvoiceUserClickOnSendInvoice(params) {
    return { evid: 1550, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'quotesCreateInvoiceSendInvoiceModalResolution' event (evid: 1551)
 *
 * Event description: Create invoice - user choose between Send or cancel in invoice final modal
 *
 * @param {quotesCreateInvoiceSendInvoiceModalResolutionParams} params - The parameters for this event
 * @property {string} source - source
 * @property {string} view_type - view_type
 * @property {string} invoiceType - ’recurringAutoCharge’/ 'recurring'/ 'one time'
 * @property {string} origin - create invoice, edit invoice
 * @property {string} platform - platform
 * @property {string} msid - msid
 * @property {string} value - send / cancel / X
 * @property {GUID} invoice_id - invoice guid
 * @return {LogObject<quotesCreateInvoiceSendInvoiceModalResolutionParams>} LogObject<quotesCreateInvoiceSendInvoiceModalResolutionParams>
 */
export function quotesCreateInvoiceSendInvoiceModalResolution(params) {
    return { evid: 1551, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'quotesCreateInvoiceSendInvoiceModalFieldChange' event (evid: 1552)
 *
 * Event description: Create invoice - user change message or subject line in the send invoice final modal
 *
 * @param {quotesCreateInvoiceSendInvoiceModalFieldChangeParams} params - The parameters for this event
 * @property {string} source - source
 * @property {string} view_type - view_type
 * @property {string} invoiceType - ’recurringAutoCharge’/ 'recurring'/ 'one time'
 * @property {string} fieldName - subject line /message
 * @property {string} origin - create invoice, edit invoice
 * @property {string} platform - platform
 * @property {string} msid - msid
 * @property {GUID} invoice_id - invoice guid
 * @return {LogObject<quotesCreateInvoiceSendInvoiceModalFieldChangeParams>} LogObject<quotesCreateInvoiceSendInvoiceModalFieldChangeParams>
 */
export function quotesCreateInvoiceSendInvoiceModalFieldChange(params) {
    return { evid: 1552, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'quotesCreateInvoiceAdditionalInfoFieldChange' event (evid: 1553)
 *
 * Event description: Create invoice - user change notes or legal terms fields in the Additional Info section
 *
 * @param {quotesCreateInvoiceAdditionalInfoFieldChangeParams} params - The parameters for this event
 * @property {string} source - source
 * @property {string} view_type - view_type
 * @property {string} invoiceType - ’recurringAutoCharge’/ 'recurring'/ 'one time'
 * @property {string} fieldName - notes  /legal terms
 * @property {string} origin - create invoice, edit invoice
 * @property {string} platform - platform
 * @property {string} msid - msid
 * @property {GUID} invoice_id - invoice guid
 * @return {LogObject<quotesCreateInvoiceAdditionalInfoFieldChangeParams>} LogObject<quotesCreateInvoiceAdditionalInfoFieldChangeParams>
 */
export function quotesCreateInvoiceAdditionalInfoFieldChange(params) {
    return { evid: 1553, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'quotesCreateInvoiceChangingEmailOfAContactForPaidInvoice' event (evid: 1554)
 *
 * Event description: Create invoice - user Changing email of a contact for paid invoice - pop up resolution
 *
 * @param {quotesCreateInvoiceChangingEmailOfAContactForPaidInvoiceParams} params - The parameters for this event
 * @property {string} source - source
 * @property {string} view_type - view_type
 * @property {string} origin - create invoice, edit invoice
 * @property {string} platform - platform
 * @property {string} msid - msid
 * @property {string} value - proceed / cancel / X
 * @property {GUID} invoice_id - invoice guid
 * @return {LogObject<quotesCreateInvoiceChangingEmailOfAContactForPaidInvoiceParams>} LogObject<quotesCreateInvoiceChangingEmailOfAContactForPaidInvoiceParams>
 */
export function quotesCreateInvoiceChangingEmailOfAContactForPaidInvoice(params) {
    return { evid: 1554, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'quotesCreateInvoiceAdditionalInfoHoverOnTooltipShown' event (evid: 1555)
 *
 * Event description: Create invoice - user hover over notes or legal terms fields in the Additional Info section, leading to tooltip appear
 *
 * @param {quotesCreateInvoiceAdditionalInfoHoverOnTooltipShownParams} params - The parameters for this event
 * @property {string} source - source
 * @property {string} view_type - view_type
 * @property {string} invoiceType - ’recurringAutoCharge’/ 'recurring'/ 'one time'
 * @property {string} fieldName - notes  /legal terms
 * @property {string} origin - create invoice, edit invoice
 * @property {string} platform - platform
 * @property {string} msid - msid
 * @property {GUID} invoice_id - invoice guid
 * @return {LogObject<quotesCreateInvoiceAdditionalInfoHoverOnTooltipShownParams>} LogObject<quotesCreateInvoiceAdditionalInfoHoverOnTooltipShownParams>
 */
export function quotesCreateInvoiceAdditionalInfoHoverOnTooltipShown(params) {
    return { evid: 1555, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'notificationClickOnAccountNotification' event (evid: 1556)
 *
 * Event description: user clicks on a account notification and opens app
 *
 * @param {notificationClickOnAccountNotificationParams} params - The parameters for this event
 * @property {string} feed_name - account notifications
 * @property {string} channel - Web / browser / mobile / SMS / email
 * @property {string} view_type - view_type
 * @property {string} grouped_sites - json {site:<msid> , badge:<num of unread notifications>}>
 * @property {string} contact_id - contact_id
 * @property {string} platform - -
 * @property {GUID} msid - msid of the notification
 * @return {LogObject<notificationClickOnAccountNotificationParams>} LogObject<notificationClickOnAccountNotificationParams>
 */
export function notificationClickOnAccountNotification(params) {
    return { evid: 1556, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'automationsSavingActivatingAnAutomation' event (evid: 1558)
 *
 * Event description: Automations > Saving/activating an automation
 *
 * @param {automationsSavingActivatingAnAutomationParams} params - The parameters for this event
 * @property {string} successFlow - where the success happen.
 * @property {string} triggerActivityType - trigger name
 * @property {boolean} isPartial - isPartial
 * @property {string} flowType - if it's create or update
 * @property {string} view_type - view_type
 * @property {GUID} rule_id - rule ID
 * @property {string} recipeName - IF not recipe put placeholder
 * @property {string} actionName - action name
 * @property {string} platform - platform
 * @property {GUID} msid - msid
 * @property {string} custom_name - automation name
 * @return {LogObject<automationsSavingActivatingAnAutomationParams>} LogObject<automationsSavingActivatingAnAutomationParams>
 */
export function automationsSavingActivatingAnAutomation(params) {
    return { evid: 1558, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'automationsErrorOnSavingActivatingAnAutomation' event (evid: 1559)
 *
 * Event description: Automations > Saving/activating an automation
 *
 * @param {automationsErrorOnSavingActivatingAnAutomationParams} params - The parameters for this event
 * @property {string} triggerActivityType - trigger name
 * @property {boolean} isPartial - isPartial
 * @property {string} flowType - if it's create or update
 * @property {string} recipe_name - IF not recipe put placeholder
 * @property {string} view_type - view_type
 * @property {string} errorReason - errorReason
 * @property {GUID} rule_id - rule ID
 * @property {string} actionName - action name
 * @property {string} platform - platform
 * @property {string} failedFlow - where the failed happen
 * @property {GUID} msid - msid
 * @property {string} custom_name - rule custom name
 * @return {LogObject<automationsErrorOnSavingActivatingAnAutomationParams>} LogObject<automationsErrorOnSavingActivatingAnAutomationParams>
 */
export function automationsErrorOnSavingActivatingAnAutomation(params) {
    return { evid: 1559, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'dashboardAccountSettingsRenderedWithShowProBoxValue' event (evid: 156)
 *
 * Event description: Account settings rendered with indicator if pro-account box is shown
 *
 * @param {dashboardAccountSettingsRenderedWithShowProBoxValueParams} params - The parameters for this event
 * @property {string} view_type - view_type
 * @property {boolean} show_pro_box - true if box is shown
 * @property {string} platform - platform
 * @return {LogObject<dashboardAccountSettingsRenderedWithShowProBoxValueParams>} LogObject<dashboardAccountSettingsRenderedWithShowProBoxValueParams>
 */
export function dashboardAccountSettingsRenderedWithShowProBoxValue(params) {
    return { evid: 156, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'invoicesNewRecurrentInvoiceClick' event (evid: 1564)
 *
 * Event description: Invoices - New Recurrent invoice click
 *
 * @param {invoicesNewRecurrentInvoiceClickParams} params - The parameters for this event
 * @property {string} view_type - view_type
 * @property {string} platform - platform
 * @property {string} msid - msid
 * @return {LogObject<invoicesNewRecurrentInvoiceClickParams>} LogObject<invoicesNewRecurrentInvoiceClickParams>
 */
export function invoicesNewRecurrentInvoiceClick(params) {
    return { evid: 1564, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'invoicesChooseADueDateRecurringInvoices' event (evid: 1565)
 *
 * Event description: Quotes - choose a due date - recurring invoices
 *
 * @param {invoicesChooseADueDateRecurringInvoicesParams} params - The parameters for this event
 * @property {string} view_type - view_type
 * @property {string} platform - platform
 * @property {string} msid - msid
 * @return {LogObject<invoicesChooseADueDateRecurringInvoicesParams>} LogObject<invoicesChooseADueDateRecurringInvoicesParams>
 */
export function invoicesChooseADueDateRecurringInvoices(params) {
    return { evid: 1565, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'invoicesRecurringSelectABillingCycle' event (evid: 1566)
 *
 * Event description: Quotes - recurring - select a billing cycle
 *
 * @param {invoicesRecurringSelectABillingCycleParams} params - The parameters for this event
 * @property {string} view_type - view_type
 * @property {string} platform - platform
 * @property {string} msid - msid
 * @property {string} value - selected value of billing cycle
 * @return {LogObject<invoicesRecurringSelectABillingCycleParams>} LogObject<invoicesRecurringSelectABillingCycleParams>
 */
export function invoicesRecurringSelectABillingCycle(params) {
    return { evid: 1566, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'invoicesRecurringSelectNumberOfOccurrences' event (evid: 1567)
 *
 * Event description: Quotes - recurring - select number of occurrences
 *
 * @param {invoicesRecurringSelectNumberOfOccurrencesParams} params - The parameters for this event
 * @property {string} view_type - view_type
 * @property {string} platform - platform
 * @property {string} msid - msid
 * @property {string} value - selected value of occurrences
 * @return {LogObject<invoicesRecurringSelectNumberOfOccurrencesParams>} LogObject<invoicesRecurringSelectNumberOfOccurrencesParams>
 */
export function invoicesRecurringSelectNumberOfOccurrences(params) {
    return { evid: 1567, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'invoicesRecurringSelectCustomNumberOfOccurrences' event (evid: 1568)
 *
 * Event description: Quotes - recurring - select custom number of occurrences
 *
 * @param {invoicesRecurringSelectCustomNumberOfOccurrencesParams} params - The parameters for this event
 * @property {string} view_type - view_type
 * @property {string} platform - platform
 * @property {string} msid - msid
 * @property {string} value - selected value of occurrences
 * @return {LogObject<invoicesRecurringSelectCustomNumberOfOccurrencesParams>} LogObject<invoicesRecurringSelectCustomNumberOfOccurrencesParams>
 */
export function invoicesRecurringSelectCustomNumberOfOccurrences(params) {
    return { evid: 1568, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'invoicesRecurringIsAutoCharge' event (evid: 1569)
 *
 * Event description: user selects if to charge the customer automatically or user will pay for each time
 *
 * @param {invoicesRecurringIsAutoChargeParams} params - The parameters for this event
 * @property {boolean} chargeAutomatically - true/ false
 * @property {string} view_type - view_type
 * @property {string} platform - platform
 * @property {string} msid - msid
 * @return {LogObject<invoicesRecurringIsAutoChargeParams>} LogObject<invoicesRecurringIsAutoChargeParams>
 */
export function invoicesRecurringIsAutoCharge(params) {
    return { evid: 1569, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'dashboardMySitesSiteHomeAlertMessageFromPremiumDisplay' event (evid: 157)
 *
 * Event description: when a user opens my-sites/site-home he receives a message based on notifications that transferred from premiums. This event collects  about what shown to user
 *
 * @param {dashboardMySitesSiteHomeAlertMessageFromPremiumDisplayParams} params - The parameters for this event
 * @property {GUID} alert_id - deprecated
 * @property {string} alert_type - alert_message
 * @property {string} view_type - view_type
 * @property {string} premium_alert_id - alert received from premium
 * @property {string} platform - platform
 * @property {string} hosting - MA/editor
 * @return {LogObject<dashboardMySitesSiteHomeAlertMessageFromPremiumDisplayParams>} LogObject<dashboardMySitesSiteHomeAlertMessageFromPremiumDisplayParams>
 */
export function dashboardMySitesSiteHomeAlertMessageFromPremiumDisplay(params) {
    return { evid: 157, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'invoicesRecurringClickOnGetStarted' event (evid: 1570)
 *
 * Event description: Quotes - recurring - click on Get Started
 *
 * @param {invoicesRecurringClickOnGetStartedParams} params - The parameters for this event
 * @property {string} view_type - view_type
 * @property {string} platform - platform
 * @property {string} msid - msid
 * @return {LogObject<invoicesRecurringClickOnGetStartedParams>} LogObject<invoicesRecurringClickOnGetStartedParams>
 */
export function invoicesRecurringClickOnGetStarted(params) {
    return { evid: 1570, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'invoicesRecurringClickOnHowDoRecurringInvoicesWork' event (evid: 1571)
 *
 * Event description: user clicks on 'How do recurring invoices work’
 *
 * @param {invoicesRecurringClickOnHowDoRecurringInvoicesWorkParams} params - The parameters for this event
 * @property {string} view_type - view_type
 * @property {string} platform - platform
 * @property {string} msid - msid
 * @return {LogObject<invoicesRecurringClickOnHowDoRecurringInvoicesWorkParams>} LogObject<invoicesRecurringClickOnHowDoRecurringInvoicesWorkParams>
 */
export function invoicesRecurringClickOnHowDoRecurringInvoicesWork(params) {
    return { evid: 1571, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'invoicesRecurringSetPaymentTermsPageClickOnNext' event (evid: 1572)
 *
 * Event description: Invoices - recurring - Set Payment Terms page - click on Next
 *
 * @param {invoicesRecurringSetPaymentTermsPageClickOnNextParams} params - The parameters for this event
 * @property {string} view_type - view_type
 * @property {string} platform - platform
 * @property {string} msid - msid
 * @return {LogObject<invoicesRecurringSetPaymentTermsPageClickOnNextParams>} LogObject<invoicesRecurringSetPaymentTermsPageClickOnNextParams>
 */
export function invoicesRecurringSetPaymentTermsPageClickOnNext(params) {
    return { evid: 1572, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'invoicesRecurringSetPaymentTermsPageClickOnCancel' event (evid: 1573)
 *
 * Event description: Invoices - recurring - Set Payment Terms page - click on Cancel
 *
 * @param {invoicesRecurringSetPaymentTermsPageClickOnCancelParams} params - The parameters for this event
 * @property {string} view_type - view_type
 * @property {string} platform - platform
 * @property {string} msid - msid
 * @return {LogObject<invoicesRecurringSetPaymentTermsPageClickOnCancelParams>} LogObject<invoicesRecurringSetPaymentTermsPageClickOnCancelParams>
 */
export function invoicesRecurringSetPaymentTermsPageClickOnCancel(params) {
    return { evid: 1573, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'invoicesRecurringClickOnBackToastInNewRecurringInvoicesCreationPage' event (evid: 1574)
 *
 * Event description: user clicks on back toast in the New Recurring Invoices creation page
 *
 * @param {invoicesRecurringClickOnBackToastInNewRecurringInvoicesCreationPageParams} params - The parameters for this event
 * @property {string} view_type - view_type
 * @property {string} platform - platform
 * @property {string} msid - msid
 * @return {LogObject<invoicesRecurringClickOnBackToastInNewRecurringInvoicesCreationPageParams>} LogObject<invoicesRecurringClickOnBackToastInNewRecurringInvoicesCreationPageParams>
 */
export function invoicesRecurringClickOnBackToastInNewRecurringInvoicesCreationPage(params) {
    return { evid: 1574, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'invoicesRecurringClickOnConnectNowForAutoCharging' event (evid: 1575)
 *
 * Event description: Invoices - recurring - click on connect now for auto charging
 *
 * @param {invoicesRecurringClickOnConnectNowForAutoChargingParams} params - The parameters for this event
 * @property {string} source - hover / page
 * @property {string} view_type - view_type
 * @property {string} platform - platform
 * @property {string} msid - msid
 * @return {LogObject<invoicesRecurringClickOnConnectNowForAutoChargingParams>} LogObject<invoicesRecurringClickOnConnectNowForAutoChargingParams>
 */
export function invoicesRecurringClickOnConnectNowForAutoCharging(params) {
    return { evid: 1575, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'invoicesRecurringClickOnLearnMoreAboutAutomaticCharging' event (evid: 1576)
 *
 * Event description: Invoices - recurring - click on Learn More about automatic charging
 *
 * @param {invoicesRecurringClickOnLearnMoreAboutAutomaticChargingParams} params - The parameters for this event
 * @property {string} view_type - view_type
 * @property {string} platform - platform
 * @property {string} msid - msid
 * @return {LogObject<invoicesRecurringClickOnLearnMoreAboutAutomaticChargingParams>} LogObject<invoicesRecurringClickOnLearnMoreAboutAutomaticChargingParams>
 */
export function invoicesRecurringClickOnLearnMoreAboutAutomaticCharging(params) {
    return { evid: 1576, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'invoicesRecurringFilterInvoices' event (evid: 1577)
 *
 * Event description: user filters the recurring invoices view
 *
 * @param {invoicesRecurringFilterInvoicesParams} params - The parameters for this event
 * @property {string} name - name of filter
 * @property {number} num_of_invoices - number of invoices the user has
 * @property {string} view_type - view_type
 * @property {string} origin_device - web,native
 * @property {string} platform - platform
 * @property {string} filter_type - period, currency, display
 * @property {string} msid - msid
 * @return {LogObject<invoicesRecurringFilterInvoicesParams>} LogObject<invoicesRecurringFilterInvoicesParams>
 */
export function invoicesRecurringFilterInvoices(params) {
    return { evid: 1577, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'invoicesRecurringTableActions' event (evid: 1578)
 *
 * Event description: user selecting an action in recurring invoices table for a specific invoice
 *
 * @param {invoicesRecurringTableActionsParams} params - The parameters for this event
 * @property {string} view_type - view_type
 * @property {GUID} invoiceId - instanceId
 * @property {string} platform - platform
 * @property {string} msid - msid
 * @property {string} action - edit/duplicate/view invoices/cancel
 * @return {LogObject<invoicesRecurringTableActionsParams>} LogObject<invoicesRecurringTableActionsParams>
 */
export function invoicesRecurringTableActions(params) {
    return { evid: 1578, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'invoicesRecurringSearchInvoices' event (evid: 1579)
 *
 * Event description: user searches in the invoices view
 *
 * @param {invoicesRecurringSearchInvoicesParams} params - The parameters for this event
 * @property {number} num_of_invoices - number of invoices the user has
 * @property {string} view_type - view_type
 * @property {string} text - text searched
 * @property {number} num_of_results - number of returned results
 * @property {string} origin_device - web,native
 * @property {string} platform - platform
 * @property {string} msid - msid
 * @return {LogObject<invoicesRecurringSearchInvoicesParams>} LogObject<invoicesRecurringSearchInvoicesParams>
 */
export function invoicesRecurringSearchInvoices(params) {
    return { evid: 1579, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'dashboardMySitesSiteHomeAlertMessageFromPremiumClick' event (evid: 158)
 *
 * Event description: when a user opens my-sites/site-home he receives a message based on notifications that transferred from premiums. This event collects data about what user choose
 *
 * @param {dashboardMySitesSiteHomeAlertMessageFromPremiumClickParams} params - The parameters for this event
 * @property {string} alert_type - alert_message
 * @property {string} view_type - view_type
 * @property {string} premium_alert_id - alert received from premium
 * @property {string} platform - platform
 * @property {string} hosting - hosting
 * @property {string} action - close (window), cancel , OK
 * @return {LogObject<dashboardMySitesSiteHomeAlertMessageFromPremiumClickParams>} LogObject<dashboardMySitesSiteHomeAlertMessageFromPremiumClickParams>
 */
export function dashboardMySitesSiteHomeAlertMessageFromPremiumClick(params) {
    return { evid: 158, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'invoicesRecurringCancelSubscription' event (evid: 1580)
 *
 * Event description: Invoices - recurring- cancel subscription
 *
 * @param {invoicesRecurringCancelSubscriptionParams} params - The parameters for this event
 * @property {string} view_type - view_type
 * @property {string} platform - platform
 * @property {string} msid - msid
 * @property {string} value - ’cancel subscription’ / ‘cancel’ / ‘X’
 * @return {LogObject<invoicesRecurringCancelSubscriptionParams>} LogObject<invoicesRecurringCancelSubscriptionParams>
 */
export function invoicesRecurringCancelSubscription(params) {
    return { evid: 1580, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'invoicesRecurringClickOnNewRecurringInvoiceSrc5Evid1581' event (evid: 1581)
 *
 * Event description: User clicks on New Recurring Invoice
 *
 * @param {invoicesRecurringClickOnNewRecurringInvoiceSrc5Evid1581Params} params - The parameters for this event
 * @property {string} view_type - view_type
 * @property {string} platform - platform
 * @property {string} msid - msid
 * @return {LogObject<invoicesRecurringClickOnNewRecurringInvoiceSrc5Evid1581Params>} LogObject<invoicesRecurringClickOnNewRecurringInvoiceSrc5Evid1581Params>
 */
export function invoicesRecurringClickOnNewRecurringInvoiceSrc5Evid1581(params) {
    return { evid: 1581, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'invoicesRecurringHoverOnNextWhenNotConnectedToPaymentMethod' event (evid: 1582)
 *
 * Event description: Hover on next when user is not connected to a supported payment method
 *
 * @param {invoicesRecurringHoverOnNextWhenNotConnectedToPaymentMethodParams} params - The parameters for this event
 * @property {string} view_type - view_type
 * @property {string} platform - platform
 * @property {string} msid - msid
 * @return {LogObject<invoicesRecurringHoverOnNextWhenNotConnectedToPaymentMethodParams>} LogObject<invoicesRecurringHoverOnNextWhenNotConnectedToPaymentMethodParams>
 */
export function invoicesRecurringHoverOnNextWhenNotConnectedToPaymentMethod(params) {
    return { evid: 1582, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'invoicesRecurringBackToRecurringInvoiceFromConnectPayment' event (evid: 1583)
 *
 * Event description: Invoices - recurring- back to recurring invoice from connect payment
 *
 * @param {invoicesRecurringBackToRecurringInvoiceFromConnectPaymentParams} params - The parameters for this event
 * @property {string} view_type - view_type
 * @property {string} platform - platform
 * @property {string} msid - msid
 * @return {LogObject<invoicesRecurringBackToRecurringInvoiceFromConnectPaymentParams>} LogObject<invoicesRecurringBackToRecurringInvoiceFromConnectPaymentParams>
 */
export function invoicesRecurringBackToRecurringInvoiceFromConnectPayment(params) {
    return { evid: 1583, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'invoicesRecurringClickOnNewRecurringInvoice' event (evid: 1587)
 *
 * Event description: Click on New Recurring Invoice
 *
 * @param {invoicesRecurringClickOnNewRecurringInvoiceParams} params - The parameters for this event
 * @property {string} view_type - view_type
 * @property {string} origin - [create new recurring invoice, create first recurring invoice]
 * @property {string} platform - platform
 * @property {string} msid - msid
 * @return {LogObject<invoicesRecurringClickOnNewRecurringInvoiceParams>} LogObject<invoicesRecurringClickOnNewRecurringInvoiceParams>
 */
export function invoicesRecurringClickOnNewRecurringInvoice(params) {
    return { evid: 1587, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'mySitesShowTooltip' event (evid: 159)
 *
 * Event description: select a site tooltip
 *
 * @param {mySitesShowTooltipParams} params - The parameters for this event
 * @property {string} name - tooltip name
 * @property {string} view_type - view_type
 * @property {string} num_of_sites - num of sites on screen
 * @property {string} platform - platform
 * @return {LogObject<mySitesShowTooltipParams>} LogObject<mySitesShowTooltipParams>
 */
export function mySitesShowTooltip(params) {
    return { evid: 159, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'invoicesOwnerappClickOnCreateNewInvoice' event (evid: 1592)
 *
 * Event description: In invoices widget click on new invoice empty state
 *
 * @param {invoicesOwnerappClickOnCreateNewInvoiceParams} params - The parameters for this event
 * @property {string} paymentType - one time, recurring
 * @property {string} view_type - view_type
 * @property {string} tabName - most recent / overdue
 * @property {string} invoiceType - ’recurringAutoCharge’/ 'recurring'/ 'one time'
 * @property {string} origin - my invoices, edit invoice, widget
 * @property {string} origin_device - web,native
 * @property {string} platform - platform
 * @property {string} msid - msid
 * @return {LogObject<invoicesOwnerappClickOnCreateNewInvoiceParams>} LogObject<invoicesOwnerappClickOnCreateNewInvoiceParams>
 */
export function invoicesOwnerappClickOnCreateNewInvoice(params) {
    return { evid: 1592, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'invoicesOwnerappClickOnInvoice' event (evid: 1593)
 *
 * Event description: Click on invoice in owner app widget
 *
 * @param {invoicesOwnerappClickOnInvoiceParams} params - The parameters for this event
 * @property {string} paymentType - one time, recurring
 * @property {string} view_type - view_type
 * @property {string} tabName - most recent / overdue
 * @property {string} invoiceType - ’recurringAutoCharge’/ 'recurring'/ 'one time'
 * @property {string} origin - my invoices, edit invoice, widget
 * @property {string} origin_device - web,native
 * @property {string} platform - platform
 * @property {string} msid - msid
 * @property {GUID} invoice_id - invoice guid
 * @return {LogObject<invoicesOwnerappClickOnInvoiceParams>} LogObject<invoicesOwnerappClickOnInvoiceParams>
 */
export function invoicesOwnerappClickOnInvoice(params) {
    return { evid: 1593, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'invoicesOwnerappClickOnViewAllInvoice' event (evid: 1594)
 *
 * Event description: Click on  view all invoice in owner app widget
 *
 * @param {invoicesOwnerappClickOnViewAllInvoiceParams} params - The parameters for this event
 * @property {string} view_type - view_type
 * @property {string} tabName - most recent / overdue
 * @property {string} origin - my invoices, edit invoice, widget
 * @property {string} origin_device - web,native
 * @property {string} platform - platform
 * @property {string} msid - msid
 * @return {LogObject<invoicesOwnerappClickOnViewAllInvoiceParams>} LogObject<invoicesOwnerappClickOnViewAllInvoiceParams>
 */
export function invoicesOwnerappClickOnViewAllInvoice(params) {
    return { evid: 1594, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'invoicesOwnerappClickOnTabs' event (evid: 1595)
 *
 * Event description: Click on  tabs in owner app widget
 *
 * @param {invoicesOwnerappClickOnTabsParams} params - The parameters for this event
 * @property {string} button_name - most recent / overdue / manage invoices
 * @property {string} view_type - view_type
 * @property {string} origin - my invoices, edit invoice, widget
 * @property {string} origin_device - web,native
 * @property {string} platform - platform
 * @property {string} msid - msid
 * @return {LogObject<invoicesOwnerappClickOnTabsParams>} LogObject<invoicesOwnerappClickOnTabsParams>
 */
export function invoicesOwnerappClickOnTabs(params) {
    return { evid: 1595, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'dashboardSiteSelectorStartLoading' event (evid: 1596)
 *
 * Event description: send when site selector start loading
 *
 * @param {dashboardSiteSelectorStartLoadingParams} params - The parameters for this event
 * @property {string} filtered - premium/published/adi / none
 * @property {string} selectionType - single / multi
 * @property {string} view_type - view_type
 * @property {Url} action_url - action_url
 * @property {Url} referral - from where the screen was open
 * @property {string} status - no thumbnails / empty state / success
 * @property {string} siteType - htmlWeb / modal
 * @property {string} version_experienced - which experience the user is getting in Site Selector (old/new)
 * @property {number} site_type_enriched - site_type
 * @property {string} platform - platform
 * @property {Url} page_url - page url
 * @property {string} device - mobile / desktop
 * @return {LogObject<dashboardSiteSelectorStartLoadingParams>} LogObject<dashboardSiteSelectorStartLoadingParams>
 */
export function dashboardSiteSelectorStartLoading(params) {
    return { evid: 1596, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'dashboardSiteSelectorSearch' event (evid: 1597)
 *
 * Event description: when users searches in site selector
 *
 * @param {dashboardSiteSelectorSearchParams} params - The parameters for this event
 * @property {string} filtered_by - premium/published/adi / none
 * @property {string} selectionType - single / multi
 * @property {string} view_type - view_type
 * @property {string} site_type - HtmlWeb / modal
 * @property {string} siteType - HtmlWeb / modal
 * @property {number} site_type_enriched - site_type
 * @property {string} platform - platform
 * @property {string} device - mobile / desktop
 * @return {LogObject<dashboardSiteSelectorSearchParams>} LogObject<dashboardSiteSelectorSearchParams>
 */
export function dashboardSiteSelectorSearch(params) {
    return { evid: 1597, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'dashboardSiteSelectorSearchResults' event (evid: 1598)
 *
 * Event description: dashboard > site selector search results.
 *
 * @param {dashboardSiteSelectorSearchResultsParams} params - The parameters for this event
 * @property {string} filtered_by - premium/published/adi / none
 * @property {string} selectionType - single / multi
 * @property {string} view_type - view_type
 * @property {string} site_type - HtmlWeb / modal
 * @property {string} status - success / no match
 * @property {number} site_type_enriched - site_type
 * @property {string} type - HtmlWeb /modal
 * @property {string} platform - platform
 * @property {string} device - mobile / desktop
 * @return {LogObject<dashboardSiteSelectorSearchResultsParams>} LogObject<dashboardSiteSelectorSearchResultsParams>
 */
export function dashboardSiteSelectorSearchResults(params) {
    return { evid: 1598, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'dashboardSiteSelectorUserNotification' event (evid: 1599)
 *
 * Event description: when users got any notification in site selector
 *
 * @param {dashboardSiteSelectorUserNotificationParams} params - The parameters for this event
 * @property {string} filtered_by - premium/published/adi / none
 * @property {string} selectionType - single / multi
 * @property {string} view_type - view_type
 * @property {string} notificationType - unsupported editor / no permissions / selection limit
 * @property {string} siteType - HtmlWeb / modal
 * @property {number} site_type_enriched - site_type
 * @property {string} platform - platform
 * @property {string} device - mobile / desktop
 * @return {LogObject<dashboardSiteSelectorUserNotificationParams>} LogObject<dashboardSiteSelectorUserNotificationParams>
 */
export function dashboardSiteSelectorUserNotification(params) {
    return { evid: 1599, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'dashboardSiteQuickActionClick' event (evid: 16)
 *
 * Event description: dashboard > quick action click.
 *
 * @param {dashboardSiteQuickActionClickParams} params - The parameters for this event
 * @property {string} name - The quick action name (quick_actions.rename_site, quick_actions.move_to_trash, etc.)
 * @property {string} site_class - site_class
 * @property {string} view_type - view_type
 * @property {string} sub_view - sub_view
 * @property {string} referral - --
 * @property {string} origin - sites-list-enterprise\site-list
 * @property {string} cta - ‘sidepanel’ \ ‘menu’
 * @property {GUID} esi - editing session id -  is generated when clicking edit site, it will remain until the url is changed, by navigating to another page or closing the tab
 * @property {string} platform - deprecated
 * @property {string} hosting - editor/ma
 * @property {GUID} msid - The site guid the user opened the menu for
 * @return {LogObject<dashboardSiteQuickActionClickParams>} LogObject<dashboardSiteQuickActionClickParams>
 */
export function dashboardSiteQuickActionClick(params) {
    return { evid: 16, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'mySitesTooltipClose' event (evid: 160)
 *
 * Event description: close the tooltip
 *
 * @param {mySitesTooltipCloseParams} params - The parameters for this event
 * @property {string} name - tooltip name
 * @property {string} view_type - view_type
 * @property {string} num_of_sites - num of sites on screen
 * @property {string} platform - platform
 * @return {LogObject<mySitesTooltipCloseParams>} LogObject<mySitesTooltipCloseParams>
 */
export function mySitesTooltipClose(params) {
    return { evid: 160, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'headerStartLoading' event (evid: 1601)
 *
 * Event description: when the header started loading in my-sites/bizmgr/account manager/partner dashboard the event is sent
 *
 * @param {headerStartLoadingParams} params - The parameters for this event
 * @property {string} page_view - name of the page - my-sites/bizmgr/account manager/partner dashboard
 * @property {boolean} is_partner - true/false
 * @property {string} view_type - view_type
 * @property {string} platform - platform
 * @property {GUID} msid - in account level/my-sites send null
 * @return {LogObject<headerStartLoadingParams>} LogObject<headerStartLoadingParams>
 */
export function headerStartLoading(params) {
    return { evid: 1601, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'invoicesRecurringMessagePresentedWhenUserReachesMaxNumberOfRecurringInvoices' event (evid: 1602)
 *
 * Event description: Invoices - recurring- message presented when user reaches max number of recurring invoices.
 *
 * @param {invoicesRecurringMessagePresentedWhenUserReachesMaxNumberOfRecurringInvoicesParams} params - The parameters for this event
 * @property {string} view_type - view_type
 * @property {string} platform - platform
 * @property {string} msid - msid
 * @return {LogObject<invoicesRecurringMessagePresentedWhenUserReachesMaxNumberOfRecurringInvoicesParams>} LogObject<invoicesRecurringMessagePresentedWhenUserReachesMaxNumberOfRecurringInvoicesParams>
 */
export function invoicesRecurringMessagePresentedWhenUserReachesMaxNumberOfRecurringInvoices(params) {
    return { evid: 1602, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'dashboardSiteSelectorMoreSitesLoadedSuccessfully' event (evid: 1608)
 *
 * Event description: when user scrolls and loads more sites
 *
 * @param {dashboardSiteSelectorMoreSitesLoadedSuccessfullyParams} params - The parameters for this event
 * @property {string} filtered - premium/published/adi / none
 * @property {string} selectionType - single / multi
 * @property {string} view_type - view_type
 * @property {string} site_type - HtmlWeb / modal
 * @property {Url} referral - referral
 * @property {number} loadingTime - in ms
 * @property {string} status - no thumbnails / empty state / success
 * @property {string} siteType - HtmlWeb / modal
 * @property {number} site_type_enriched - id
 * @property {string} platform - relevant for mobile only
 * @property {number} sites_count - # sites loaded
 * @property {string} device - mobile / desktop
 * @return {LogObject<dashboardSiteSelectorMoreSitesLoadedSuccessfullyParams>} LogObject<dashboardSiteSelectorMoreSitesLoadedSuccessfullyParams>
 */
export function dashboardSiteSelectorMoreSitesLoadedSuccessfully(params) {
    return { evid: 1608, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'mySitesHoverSite' event (evid: 161)
 *
 * Event description: send when a users hover site
 *
 * @param {mySitesHoverSiteParams} params - The parameters for this event
 * @property {string} view_type - view_type
 * @property {string} sub_view - sub_view
 * @property {string} ds_origin - editor/ adi / editorX
 * @property {string} origin - origin
 * @property {string} view_level - view_level
 * @property {boolean} is_premium - is_premium
 * @property {string} platform - platform
 * @property {GUID} msid - msid
 * @property {boolean} is_published - is_published
 * @return {LogObject<mySitesHoverSiteParams>} LogObject<mySitesHoverSiteParams>
 */
export function mySitesHoverSite(params) {
    return { evid: 161, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'automationsSendCouponSetCoupon' event (evid: 1613)
 *
 * Event description: choose coupon type: unique single use OR same coupon
 *
 * @param {automationsSendCouponSetCouponParams} params - The parameters for this event
 * @property {string} view_type - view_type
 * @property {string} toggle_status - toggle_status
 * @property {string} platform - platform
 * @property {GUID} msid - msid
 * @return {LogObject<automationsSendCouponSetCouponParams>} LogObject<automationsSendCouponSetCouponParams>
 */
export function automationsSendCouponSetCoupon(params) {
    return { evid: 1613, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'automationsSendCouponChooseUniqueCoupon' event (evid: 1614)
 *
 * Event description: Automations - send coupon - choose unique coupon
 *
 * @param {automationsSendCouponChooseUniqueCouponParams} params - The parameters for this event
 * @property {string} view_type - view_type
 * @property {string} platform - platform
 * @property {GUID} msid - msid
 * @return {LogObject<automationsSendCouponChooseUniqueCouponParams>} LogObject<automationsSendCouponChooseUniqueCouponParams>
 */
export function automationsSendCouponChooseUniqueCoupon(params) {
    return { evid: 1614, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'automationsSendCouponCreateNewCoupon' event (evid: 1615)
 *
 * Event description: Automations - send coupon - create new coupon
 *
 * @param {automationsSendCouponCreateNewCouponParams} params - The parameters for this event
 * @property {string} view_type - view_type
 * @property {string} platform - platform
 * @property {GUID} msid - msid
 * @return {LogObject<automationsSendCouponCreateNewCouponParams>} LogObject<automationsSendCouponCreateNewCouponParams>
 */
export function automationsSendCouponCreateNewCoupon(params) {
    return { evid: 1615, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'automationsSendCouponEditCouponDetails' event (evid: 1616)
 *
 * Event description: Automations - send coupon - edit coupon details
 *
 * @param {automationsSendCouponEditCouponDetailsParams} params - The parameters for this event
 * @property {string} view_type - view_type
 * @property {string} platform - platform
 * @property {GUID} msid - msid
 * @return {LogObject<automationsSendCouponEditCouponDetailsParams>} LogObject<automationsSendCouponEditCouponDetailsParams>
 */
export function automationsSendCouponEditCouponDetails(params) {
    return { evid: 1616, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'automationsWidgetSeenWidget' event (evid: 1619)
 *
 * Event description: NEED TO DELETE Automations > widget > seen widget
 *
 * @param {automationsWidgetSeenWidgetParams} params - The parameters for this event
 * @property {string} asset_campaign_guid - asset_campaign_guid
 * @property {string} widget_name - dashboard/rows/recommendations
 * @property {string} referral_info - indicate which vertical is the dacomponent triggered from
 * @property {string} view_type - view_type
 * @property {string} item_list - item_list
 * @property {string} origin - button, link, header, success creation dialog
 * @property {string} platform - platform
 * @property {GUID} msid - msid
 * @return {LogObject<automationsWidgetSeenWidgetParams>} LogObject<automationsWidgetSeenWidgetParams>
 */
export function automationsWidgetSeenWidget(params) {
    return { evid: 1619, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'searchSearchInDialog' event (evid: 162)
 *
 * Event description: when a user is searching in search dialog send event at the end of the results
 *
 * @param {searchSearchInDialogParams} params - The parameters for this event
 * @property {string} query - the users's query search
 * @property {string} view_type - view_type
 * @property {string} triggred_from - search/show_all
 * @property {string} sub_view - page in app
 * @property {string} results - send all results who return on time in the following way -> section: number of results: time to load
 * @property {string} origin - settings lobby / bizmgr
 * @property {string} seen_results - send only results who were seen in search -> section: number of results: time to load
 * @property {string} platform - platform
 * @property {string} view - requested view
 * @property {string} hosting_platform_context_id - context id: when the context is site - msid, when the context is app_id (like in devCenter f.e) - appDefId. In account manager is null
 * @return {LogObject<searchSearchInDialogParams>} LogObject<searchSearchInDialogParams>
 */
export function searchSearchInDialog(params) {
    return { evid: 162, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'dashboardDuplicateSiteActionWindowNavigationClick' event (evid: 1627)
 *
 * Event description: when user click on quick action, and then approve the duplication options from the popped window
 *
 * @param {dashboardDuplicateSiteActionWindowNavigationClickParams} params - The parameters for this event
 * @property {string} view_type - view_type
 * @property {string} origin - my sites / dashboard
 * @property {string} cta - duplicate / cancel
 * @property {string} platform - relevant only for mobile view
 * @property {string} hosting - ma/editor
 * @property {GUID} msid - --
 * @return {LogObject<dashboardDuplicateSiteActionWindowNavigationClickParams>} LogObject<dashboardDuplicateSiteActionWindowNavigationClickParams>
 */
export function dashboardDuplicateSiteActionWindowNavigationClick(params) {
    return { evid: 1627, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'searchScrollingInResultView' event (evid: 163)
 *
 * Event description: send an event when a user's scroll in search's results
 *
 * @param {searchScrollingInResultViewParams} params - The parameters for this event
 * @property {string} view_type - view_type
 * @property {string} sub_view - page in app
 * @property {string} origin - settings lobby / bizmgr
 * @property {string} platform - platform
 * @property {string} view - requested view
 * @property {string} hosting_platform_context_id - context id: when the context is site - msid, when the context is app_id (like in devCenter f.e) - appDefId. In account manager is null
 * @return {LogObject<searchScrollingInResultViewParams>} LogObject<searchScrollingInResultViewParams>
 */
export function searchScrollingInResultView(params) {
    return { evid: 163, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'invoicesRecurringSelectPremiumPlanIncludedOnlyServices' event (evid: 1632)
 *
 * Event description: Quotes - recurring - select Premium Plan included/only services
 *
 * @param {invoicesRecurringSelectPremiumPlanIncludedOnlyServicesParams} params - The parameters for this event
 * @property {GUID} uuid - uuid
 * @property {string} view_type - view_type
 * @property {string} platform - BM/ client billing
 * @property {string} msid - msid
 * @property {string} value - value
 * @return {LogObject<invoicesRecurringSelectPremiumPlanIncludedOnlyServicesParams>} LogObject<invoicesRecurringSelectPremiumPlanIncludedOnlyServicesParams>
 */
export function invoicesRecurringSelectPremiumPlanIncludedOnlyServices(params) {
    return { evid: 1632, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'invoicesRecurringAddPremiumPlanClick' event (evid: 1633)
 *
 * Event description: Quotes - recurring - Add Premium Plan click
 *
 * @param {invoicesRecurringAddPremiumPlanClickParams} params - The parameters for this event
 * @property {GUID} uuid - uuid
 * @property {string} view_type - view_type
 * @property {string} platform - BM/ client billing
 * @property {string} msid - msid
 * @return {LogObject<invoicesRecurringAddPremiumPlanClickParams>} LogObject<invoicesRecurringAddPremiumPlanClickParams>
 */
export function invoicesRecurringAddPremiumPlanClick(params) {
    return { evid: 1633, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'invoicesRecurringPremiumPlanSelected' event (evid: 1634)
 *
 * Event description: Quotes - recurring - Premium Plan selected
 *
 * @param {invoicesRecurringPremiumPlanSelectedParams} params - The parameters for this event
 * @property {string} package_id - id of package
 * @property {GUID} uuid - uuid
 * @property {string} view_type - view_type
 * @property {string} platform - platform
 * @property {string} msid - msid
 * @return {LogObject<invoicesRecurringPremiumPlanSelectedParams>} LogObject<invoicesRecurringPremiumPlanSelectedParams>
 */
export function invoicesRecurringPremiumPlanSelected(params) {
    return { evid: 1634, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'invoicesRecurringErrorMessageForInvoiceAmountLowerThenPremium' event (evid: 1635)
 *
 * Event description: When a partner try to send an recurring invoice contains premium plan, and the amount of the invoice is lower the premium plan price
 *
 * @param {invoicesRecurringErrorMessageForInvoiceAmountLowerThenPremiumParams} params - The parameters for this event
 * @property {GUID} uuid - uuid
 * @property {string} view_type - view_type
 * @property {string} errorReason - reason of error
 * @property {string} platform - platform
 * @property {string} msid - msid
 * @return {LogObject<invoicesRecurringErrorMessageForInvoiceAmountLowerThenPremiumParams>} LogObject<invoicesRecurringErrorMessageForInvoiceAmountLowerThenPremiumParams>
 */
export function invoicesRecurringErrorMessageForInvoiceAmountLowerThenPremium(params) {
    return { evid: 1635, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'invoicesRecurringTableActionsCancelModalClick' event (evid: 1636)
 *
 * Event description: Cancel modal click by user
 *
 * @param {invoicesRecurringTableActionsCancelModalClickParams} params - The parameters for this event
 * @property {string} view_type - view_type
 * @property {GUID} invoiceId - instanceId
 * @property {string} platform - BM/client billing
 * @property {string} msid - msid
 * @property {string} action - keep/cancel
 * @return {LogObject<invoicesRecurringTableActionsCancelModalClickParams>} LogObject<invoicesRecurringTableActionsCancelModalClickParams>
 */
export function invoicesRecurringTableActionsCancelModalClick(params) {
    return { evid: 1636, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'searchFocusedOnASearchResult' event (evid: 164)
 *
 * Event description: when a user is focused on a result
 *
 * @param {searchFocusedOnASearchResultParams} params - The parameters for this event
 * @property {string} title_id - result's title id
 * @property {string} result - send all results who return on time in the following way -> section: number of results: time to load
 * @property {number} section_index - the index of the section in results
 * @property {string} query - query
 * @property {string} view_type - view_type
 * @property {string} sub_view - page in app
 * @property {string} section - result's section
 * @property {number} item_index_in_section - the item's index in it's section
 * @property {string} origin - settings lobby / bizmgr
 * @property {boolean} is_first_hover - 1- first item that was hovered (without the default) , 0 - not the first
 * @property {string} title - result's title
 * @property {string} platform - platform
 * @property {number} item_index - item's index in all results
 * @property {string} view - requested view
 * @property {string} hosting_platform_context_id - context id: when the context is site - msid, when the context is app_id (like in devCenter f.e) - appDefId. In account manager is null
 * @return {LogObject<searchFocusedOnASearchResultParams>} LogObject<searchFocusedOnASearchResultParams>
 */
export function searchFocusedOnASearchResult(params) {
    return { evid: 164, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'automationsMissingEmailOrPhoneLearnMore' event (evid: 1647)
 *
 * Event description: Automations > missing email/phone - learn more
 *
 * @param {automationsMissingEmailOrPhoneLearnMoreParams} params - The parameters for this event
 * @property {string} triggerActivityType - triggerActivityType
 * @property {string} view_type - view_type
 * @property {string} recipeName - recipeName
 * @property {string} actionName - actionName
 * @property {string} platform - platform
 * @property {GUID} msid - msid
 * @property {GUID} ruleId - ruleId
 * @return {LogObject<automationsMissingEmailOrPhoneLearnMoreParams>} LogObject<automationsMissingEmailOrPhoneLearnMoreParams>
 */
export function automationsMissingEmailOrPhoneLearnMore(params) {
    return { evid: 1647, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'bizManagerSidebarItemSelectedHighlighted' event (evid: 1649)
 *
 * Event description: User has some BM Sidebar item selected (highlighted - user is on a page)
 *
 * @param {bizManagerSidebarItemSelectedHighlightedParams} params - The parameters for this event
 * @property {string} name - unique name that doesn't change when changing the name on the side bar
 * @property {string} sidebar_name - the name that appears in the sidebar - can be changed
 * @property {string} view_type - view_type
 * @property {number} counter - The value inside the counter clicked (if counter exists)
 * @property {string} app_id - app_id of the item
 * @property {string} platform - platform
 * @property {string} hosting - MA/editor
 * @property {GUID} msid - metasite id
 * @return {LogObject<bizManagerSidebarItemSelectedHighlightedParams>} LogObject<bizManagerSidebarItemSelectedHighlightedParams>
 */
export function bizManagerSidebarItemSelectedHighlighted(params) {
    return { evid: 1649, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'searchClickOnSearchResult' event (evid: 165)
 *
 * Event description: when a user is focused on a result
 *
 * @param {searchClickOnSearchResultParams} params - The parameters for this event
 * @property {string} title_id - result's title id
 * @property {number} section_index - the index of the section in results
 * @property {string} query - query
 * @property {string} view_type - view_type
 * @property {string} sub_view - page in app
 * @property {string} section - result's section
 * @property {number} item_index_in_section - the item's index in it's section
 * @property {string} origin - settings lobby / bizmgr
 * @property {string} title - result's title
 * @property {string} platform - platform
 * @property {number} item_index - item's index in all results
 * @property {string} view - requested view
 * @property {string} category - the category the result belongs to (Help Articles, Apps For Your Site,  Contacts, Tools & Settings)
 * @property {string} hosting_platform_context_id - context id: when the context is site - msid, when the context is app_id (like in devCenter f.e) - appDefId. In account manager is null
 * @return {LogObject<searchClickOnSearchResultParams>} LogObject<searchClickOnSearchResultParams>
 */
export function searchClickOnSearchResult(params) {
    return { evid: 165, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'invoicesRecurringClientSelected' event (evid: 1651)
 *
 * Event description: Quotes - recurring -  Client selected
 *
 * @param {invoicesRecurringClientSelectedParams} params - The parameters for this event
 * @property {GUID} uuid - uuid
 * @property {string} view_type - view_type
 * @property {string} contact_id - contact_id selected
 * @property {string} platform - platform
 * @property {string} msid - msid
 * @return {LogObject<invoicesRecurringClientSelectedParams>} LogObject<invoicesRecurringClientSelectedParams>
 */
export function invoicesRecurringClientSelected(params) {
    return { evid: 1651, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'invoicesRecurringSiteOfClientSelected' event (evid: 1652)
 *
 * Event description: Quotes - recurring -  Client selected
 *
 * @param {invoicesRecurringSiteOfClientSelectedParams} params - The parameters for this event
 * @property {GUID} uuid - uuid
 * @property {string} view_type - view_type
 * @property {string} clientBillingMsids - Comma separated, the msids of the site associated to a client billing subscription included in the recurring invoice, if exist.
 * @property {string} platform - platform
 * @property {string} msid - msid
 * @return {LogObject<invoicesRecurringSiteOfClientSelectedParams>} LogObject<invoicesRecurringSiteOfClientSelectedParams>
 */
export function invoicesRecurringSiteOfClientSelected(params) {
    return { evid: 1652, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'searchCloseSearchDialog' event (evid: 166)
 *
 * Event description: send an event when a user's scroll in search's results
 *
 * @param {searchCloseSearchDialogParams} params - The parameters for this event
 * @property {string} result - send all results who return on time in the following way -> section: number of results: time to load
 * @property {string} query - query
 * @property {string} view_type - view_type
 * @property {string} sub_view - page in app
 * @property {string} reason - click on result/ click somewhere else/ click on x
 * @property {number} time_in_dialog - show in seconds the time spent in the dialog
 * @property {string} origin - settings lobby / bizmgr
 * @property {string} platform - platform
 * @property {string} view - requested view
 * @property {string} hosting_platform_context_id - context id: when the context is site - msid, when the context is app_id (like in devCenter f.e) - appDefId. In account manager is null
 * @return {LogObject<searchCloseSearchDialogParams>} LogObject<searchCloseSearchDialogParams>
 */
export function searchCloseSearchDialog(params) {
    return { evid: 166, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'siteActionsDropDownListShown' event (evid: 1662)
 *
 * Event description: Site actions > drop down list shown.
 *
 * @param {siteActionsDropDownListShownParams} params - The parameters for this event
 * @property {string} view_mode - list/grid
 * @property {string} site_class - client/organization, not mendatory
 * @property {GUID} sub_account_id - sub_account_id
 * @property {string} view_type - view_type
 * @property {string} sub_view - sub_view
 * @property {string} origin - my-sites/dashboard/sites-list-enterprise
 * @property {string} cta - ‘sidepanel’ \ ‘menu’
 * @property {string} platform - deprecated
 * @property {GUID} msid - site guid
 * @property {string} permitted_items - list of all the items the user can click on (unblocked items)
 * @property {string} itemsList - list of all the shown items when drop down menu is shown
 * @return {LogObject<siteActionsDropDownListShownParams>} LogObject<siteActionsDropDownListShownParams>
 */
export function siteActionsDropDownListShown(params) {
    return { evid: 1662, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'clickOnSeeMoreButton' event (evid: 167)
 *
 * Event description: When a user clicks on expand results button
 *
 * @param {clickOnSeeMoreButtonParams} params - The parameters for this event
 * @property {string} title_id - result's title id
 * @property {string} result - send all results who return on time in the following way -> section: number of results: time to load
 * @property {number} section_index - the index of the section in results
 * @property {string} query - query
 * @property {string} view_type - view_type
 * @property {string} sub_view - page in app
 * @property {string} section - result's section
 * @property {string} origin - settings lobby / bizmgr
 * @property {string} title - result's title
 * @property {string} platform - platform
 * @property {string} view - requested view
 * @property {string} hosting_platform_context_id - context id: when the context is site - msid, when the context is app_id (like in devCenter f.e) - appDefId. In account manager is null
 * @return {LogObject<clickOnSeeMoreButtonParams>} LogObject<clickOnSeeMoreButtonParams>
 */
export function clickOnSeeMoreButton(params) {
    return { evid: 167, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'email2FaSetupEnableClick' event (evid: 1672)
 *
 * Event description: The user click on 'enable' to enable Email 2FA
 *
 * @param {email2FaSetupEnableClickParams} params - The parameters for this event
 * @property {string} view_type - view_type
 * @property {string} origin - account settings page/phone modal/app modal/second best
 * @property {string} platform - platform
 * @return {LogObject<email2FaSetupEnableClickParams>} LogObject<email2FaSetupEnableClickParams>
 */
export function email2FaSetupEnableClick(params) {
    return { evid: 1672, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'email2FaSetupSendCode' event (evid: 1673)
 *
 * Event description: The user clicks on 'send code' or 'resend code' in the email 2fa setup modal
 *
 * @param {email2FaSetupSendCodeParams} params - The parameters for this event
 * @property {string} view_type - view_type
 * @property {string} platform - platform
 * @property {string} action - send/resend
 * @property {string} origin - The origin of the page (Account settings\ 2fa enforcement)
 * @return {LogObject<email2FaSetupSendCodeParams>} LogObject<email2FaSetupSendCodeParams>
 */
export function email2FaSetupSendCode(params) {
    return { evid: 1673, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'email2FaSetupSendCodeSuccess' event (evid: 1674)
 *
 * Event description: The code was successfully sent to the user's email after he clicked on send code
 *
 * @param {email2FaSetupSendCodeSuccessParams} params - The parameters for this event
 * @property {string} view_type - view_type
 * @property {string} platform - platform
 * @property {string} action - send/resend
 * @property {string} origin - The origin of the page (Account settings\ 2fa enforcement)
 * @return {LogObject<email2FaSetupSendCodeSuccessParams>} LogObject<email2FaSetupSendCodeSuccessParams>
 */
export function email2FaSetupSendCodeSuccess(params) {
    return { evid: 1674, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'email2FaSetupSendCodeFail' event (evid: 1675)
 *
 * Event description: The code was not sent to the user's email after he clicked on send code
 *
 * @param {email2FaSetupSendCodeFailParams} params - The parameters for this event
 * @property {string} view_type - view_type
 * @property {string} platform - platform
 * @property {string} action - send/resend
 * @property {string} origin - The origin of the page (Account settings\ 2fa enforcement)
 * @return {LogObject<email2FaSetupSendCodeFailParams>} LogObject<email2FaSetupSendCodeFailParams>
 */
export function email2FaSetupSendCodeFail(params) {
    return { evid: 1675, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'email2FaSetupChangeAccountEmail' event (evid: 1676)
 *
 * Event description: The user clicks on 'change account email' in the email 2fa setup modal
 *
 * @param {email2FaSetupChangeAccountEmailParams} params - The parameters for this event
 * @property {string} view_type - view_type
 * @property {string} platform - platform
 * @return {LogObject<email2FaSetupChangeAccountEmailParams>} LogObject<email2FaSetupChangeAccountEmailParams>
 */
export function email2FaSetupChangeAccountEmail(params) {
    return { evid: 1676, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'email2FaSetupEnterCode' event (evid: 1677)
 *
 * Event description: The user clicks on 'ok' in the email 2fa setup modal after entering the 6-digit code he received by email
 *
 * @param {email2FaSetupEnterCodeParams} params - The parameters for this event
 * @property {string} view_type - view_type
 * @property {boolean} is_valid - did the user enter the correct code sent to his email
 * @property {string} platform - platform
 * @property {string} origin - The origin of the page (Account settings\ 2fa enforcement)
 * @return {LogObject<email2FaSetupEnterCodeParams>} LogObject<email2FaSetupEnterCodeParams>
 */
export function email2FaSetupEnterCode(params) {
    return { evid: 1677, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'email2FaSetupCodeErrorMessage' event (evid: 1678)
 *
 * Event description: The user sees an error message after entering a code in the email 2fa setup modal
 *
 * @param {email2FaSetupCodeErrorMessageParams} params - The parameters for this event
 * @property {string} view_type - view_type
 * @property {string} error_reason - reason for error message
 * @property {string} platform - platform
 * @property {number} error_code - error numeric code
 * @property {string} origin - The origin of the page (Account settings\ 2fa enforcement)
 * @return {LogObject<email2FaSetupCodeErrorMessageParams>} LogObject<email2FaSetupCodeErrorMessageParams>
 */
export function email2FaSetupCodeErrorMessage(params) {
    return { evid: 1678, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'email2FaSetupEnableSuccessClient' event (evid: 1679)
 *
 * Event description: The user successfully enabled 2FA by Email
 *
 * @param {email2FaSetupEnableSuccessClientParams} params - The parameters for this event
 * @property {string} view_type - view_type
 * @property {string} platform - platform
 * @return {LogObject<email2FaSetupEnableSuccessClientParams>} LogObject<email2FaSetupEnableSuccessClientParams>
 */
export function email2FaSetupEnableSuccessClient(params) {
    return { evid: 1679, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'clickOnShowAllButton' event (evid: 168)
 *
 * Event description: When a user clicks on 'Go To ' relevant page button
 *
 * @param {clickOnShowAllButtonParams} params - The parameters for this event
 * @property {string} title_id - result's title id
 * @property {string} result - send all results who return on time in the following way -> section: number of results: time to load
 * @property {number} section_index - the index of the section in results
 * @property {string} query - query
 * @property {string} view_type - view_type
 * @property {string} sub_view - page in app
 * @property {string} section - result's section
 * @property {string} origin - bizmgr / settings lobby
 * @property {string} title - result's title
 * @property {string} platform - platform
 * @property {string} view - requested view
 * @property {string} hosting_platform_context_id - context id: when the context is site - msid, when the context is app_id (like in devCenter f.e) - appDefId. In account manager is null
 * @return {LogObject<clickOnShowAllButtonParams>} LogObject<clickOnShowAllButtonParams>
 */
export function clickOnShowAllButton(params) {
    return { evid: 168, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'email2FaSetupDisableClick' event (evid: 1680)
 *
 * Event description: The user clicked on 'disable' to disable Email 2FA
 *
 * @param {email2FaSetupDisableClickParams} params - The parameters for this event
 * @property {string} view_type - view_type
 * @property {string} platform - platform
 * @return {LogObject<email2FaSetupDisableClickParams>} LogObject<email2FaSetupDisableClickParams>
 */
export function email2FaSetupDisableClick(params) {
    return { evid: 1680, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'email2FaSetupDisableConfirm' event (evid: 1681)
 *
 * Event description: The user clicks on "disable" in the disable modal for email 2FA
 * (confirms disable)
 *
 * @param {email2FaSetupDisableConfirmParams} params - The parameters for this event
 * @property {string} view_type - view_type
 * @property {string} platform - platform
 * @return {LogObject<email2FaSetupDisableConfirmParams>} LogObject<email2FaSetupDisableConfirmParams>
 */
export function email2FaSetupDisableConfirm(params) {
    return { evid: 1681, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'accountSettingsChangeEmailAddressClickOnSure' event (evid: 1682)
 *
 * Event description: The user tries to change email address while email 2FA is enabled, sees the email 2FA modal warning him it will be disabled and clicks on 'sure'
 *
 * @param {accountSettingsChangeEmailAddressClickOnSureParams} params - The parameters for this event
 * @property {string} view_type - view_type
 * @property {string} platform - platform
 * @return {LogObject<accountSettingsChangeEmailAddressClickOnSureParams>} LogObject<accountSettingsChangeEmailAddressClickOnSureParams>
 */
export function accountSettingsChangeEmailAddressClickOnSure(params) {
    return { evid: 1682, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'ssoSettingsUpdateSsoSettings' event (evid: 1683)
 *
 * Event description: The user updated the SSO settings page
 *
 * @param {ssoSettingsUpdateSsoSettingsParams} params - The parameters for this event
 * @property {GUID} sso_id - sso_id
 * @property {string} view_type - view_type
 * @property {boolean} is_first_update - Is it the first time the user updates SSO settings. The first time will not have sso_id.
 * @property {string} sso_user_type - DIFM/DIY (is the SSO of type Do It For Me/ Do It Yourself)
 * @property {string} platform - platform
 * @return {LogObject<ssoSettingsUpdateSsoSettingsParams>} LogObject<ssoSettingsUpdateSsoSettingsParams>
 */
export function ssoSettingsUpdateSsoSettings(params) {
    return { evid: 1683, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'ssoSettingsChangeActivationStatus' event (evid: 1684)
 *
 * Event description: The user enabled or disabled SSO settings
 *
 * @param {ssoSettingsChangeActivationStatusParams} params - The parameters for this event
 * @property {GUID} sso_id - sso_id
 * @property {string} view_type - view_type
 * @property {boolean} is_mandatory - is SSO mandatory for team member login
 * @property {string} sso_user_type - DIFM/DIY (is the SSO of type Do It For Me/ Do It Yourself)
 * @property {string} platform - platform
 * @property {string} action - enable/disable
 * @return {LogObject<ssoSettingsChangeActivationStatusParams>} LogObject<ssoSettingsChangeActivationStatusParams>
 */
export function ssoSettingsChangeActivationStatus(params) {
    return { evid: 1684, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'ssoSettingsIsMandatoryToggleStatus' event (evid: 1685)
 *
 * Event description: SSO Settings - Is Mandatory Toggle Status.
 *
 * @param {ssoSettingsIsMandatoryToggleStatusParams} params - The parameters for this event
 * @property {GUID} sso_id - sso_id
 * @property {string} view_type - view_type
 * @property {string} status - status_name
 * @property {string} platform - platform
 * @return {LogObject<ssoSettingsIsMandatoryToggleStatusParams>} LogObject<ssoSettingsIsMandatoryToggleStatusParams>
 */
export function ssoSettingsIsMandatoryToggleStatus(params) {
    return { evid: 1685, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'mySitesUnableToMoveSiteToTrashMessageShown' event (evid: 1686)
 *
 * Event description: when Unable to Move Site to Trash message shown
 *
 * @param {mySitesUnableToMoveSiteToTrashMessageShownParams} params - The parameters for this event
 * @property {string} view_type - view_type
 * @property {string} reason - the reason the site can't be deleted, for example: pending subscription/active subscription/not permitted/unknown
 * @property {string} origin - my-sites/dashboard
 * @property {string} messageTitle - the title of the message
 * @property {string} platform - deprecated
 * @property {GUID} msid - site guid
 * @return {LogObject<mySitesUnableToMoveSiteToTrashMessageShownParams>} LogObject<mySitesUnableToMoveSiteToTrashMessageShownParams>
 */
export function mySitesUnableToMoveSiteToTrashMessageShown(params) {
    return { evid: 1686, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'financialSettingsGoToInvoicesPriceQuotes' event (evid: 1688)
 *
 * Event description: financial settings - go to invoices/price quotes
 *
 * @param {financialSettingsGoToInvoicesPriceQuotesParams} params - The parameters for this event
 * @property {string} view_type - view_type
 * @property {string} type - if it's price quotes or invoices
 * @property {string} platform - platform
 * @property {string} msid - msid
 * @return {LogObject<financialSettingsGoToInvoicesPriceQuotesParams>} LogObject<financialSettingsGoToInvoicesPriceQuotesParams>
 */
export function financialSettingsGoToInvoicesPriceQuotes(params) {
    return { evid: 1688, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'invoicesFirstTimeExpirienceGetStarted' event (evid: 1689)
 *
 * Event description: Invoices - First time expirience - get started
 *
 * @param {invoicesFirstTimeExpirienceGetStartedParams} params - The parameters for this event
 * @property {string} name - ‘Get started’ or ‘Watch Tutorial’
 * @property {string} view_type - view_type
 * @property {string} platform - platform
 * @property {string} msid - msid
 * @return {LogObject<invoicesFirstTimeExpirienceGetStartedParams>} LogObject<invoicesFirstTimeExpirienceGetStartedParams>
 */
export function invoicesFirstTimeExpirienceGetStarted(params) {
    return { evid: 1689, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'bizManagerSetupWidgetPhaseCompleted' event (evid: 169)
 *
 * Event description: When a phase is completed in the OMNI Widget
 *
 * @param {bizManagerSetupWidgetPhaseCompletedParams} params - The parameters for this event
 * @property {string} asset_campaign_guid - omni setup phase id
 * @property {string} view_type - view_type
 * @property {string} platform - platform
 * @property {string} hosting - ADI/Editor/MA
 * @property {GUID} msid - msid
 * @return {LogObject<bizManagerSetupWidgetPhaseCompletedParams>} LogObject<bizManagerSetupWidgetPhaseCompletedParams>
 */
export function bizManagerSetupWidgetPhaseCompleted(params) {
    return { evid: 169, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'invoicesFirstTimeExpirienceLearnMore' event (evid: 1690)
 *
 * Event description: Invoices - First time expirience - learn more
 *
 * @param {invoicesFirstTimeExpirienceLearnMoreParams} params - The parameters for this event
 * @property {string} view_type - view_type
 * @property {string} platform - platform
 * @property {string} msid - msid
 * @return {LogObject<invoicesFirstTimeExpirienceLearnMoreParams>} LogObject<invoicesFirstTimeExpirienceLearnMoreParams>
 */
export function invoicesFirstTimeExpirienceLearnMore(params) {
    return { evid: 1690, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'invoicesDepositRequestDeposit' event (evid: 1692)
 *
 * Event description: Invoices - Deposit - Request Deposit
 *
 * @param {invoicesDepositRequestDepositParams} params - The parameters for this event
 * @property {string} view_type - view_type
 * @property {string} platform - platform
 * @property {string} msid - msid
 * @return {LogObject<invoicesDepositRequestDepositParams>} LogObject<invoicesDepositRequestDepositParams>
 */
export function invoicesDepositRequestDeposit(params) {
    return { evid: 1692, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'invoicesDepositChooseFlatOrPercentageDeposit' event (evid: 1693)
 *
 * Event description: Invoices - Deposit - choose flat or percentage deposit.
 *
 * @param {invoicesDepositChooseFlatOrPercentageDepositParams} params - The parameters for this event
 * @property {boolean} toggle - true if it's flat, false if it's percentage
 * @property {string} view_type - view_type
 * @property {string} platform - platform
 * @property {string} msid - msid
 * @return {LogObject<invoicesDepositChooseFlatOrPercentageDepositParams>} LogObject<invoicesDepositChooseFlatOrPercentageDepositParams>
 */
export function invoicesDepositChooseFlatOrPercentageDeposit(params) {
    return { evid: 1693, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'invoicesDepositLearnMore' event (evid: 1694)
 *
 * Event description: Invoices - Deposit - learn more
 *
 * @param {invoicesDepositLearnMoreParams} params - The parameters for this event
 * @property {string} view_type - view_type
 * @property {string} platform - platform
 * @property {string} msid - msid
 * @return {LogObject<invoicesDepositLearnMoreParams>} LogObject<invoicesDepositLearnMoreParams>
 */
export function invoicesDepositLearnMore(params) {
    return { evid: 1694, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'invoicesConnectPaymentLearnMore' event (evid: 1695)
 *
 * Event description: when a user click on 'learn more' about payment provider from invoices app
 *
 * @param {invoicesConnectPaymentLearnMoreParams} params - The parameters for this event
 * @property {string} view_type - view_type
 * @property {string} origin - origin
 * @property {string} platform - platform
 * @property {string} msid - msid
 * @return {LogObject<invoicesConnectPaymentLearnMoreParams>} LogObject<invoicesConnectPaymentLearnMoreParams>
 */
export function invoicesConnectPaymentLearnMore(params) {
    return { evid: 1695, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'invoicesDepositDropDeposit' event (evid: 1697)
 *
 * Event description: Copy of Invoices - Deposit - drop deposit
 *
 * @param {invoicesDepositDropDepositParams} params - The parameters for this event
 * @property {string} view_type - view_type
 * @property {string} platform - platform
 * @property {string} msid - msid
 * @return {LogObject<invoicesDepositDropDepositParams>} LogObject<invoicesDepositDropDepositParams>
 */
export function invoicesDepositDropDeposit(params) {
    return { evid: 1697, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'pingPingWidgetLoadedInEditNotificationDialog' event (evid: 1698)
 *
 * Event description: Apes - Ping widget loaded in Edit Notification dialog after Automations opened that dialog when user click on Preview & Edit. this Event is for debugging purposes
 *
 * @param {pingPingWidgetLoadedInEditNotificationDialogParams} params - The parameters for this event
 * @property {string} view_type - view_type
 * @property {string} config - JSON field of the configuration, contains ape details
 * @property {boolean} isPMFlow - is pm flow
 * @property {string} platform - platform
 * @property {GUID} msid - site guid
 * @property {string} ruleId - the rule id
 * @return {LogObject<pingPingWidgetLoadedInEditNotificationDialogParams>} LogObject<pingPingWidgetLoadedInEditNotificationDialogParams>
 */
export function pingPingWidgetLoadedInEditNotificationDialog(params) {
    return { evid: 1698, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'pingSaveInEditNotificationDialog' event (evid: 1699)
 *
 * Event description: Apes - save in Edit Notification dialog. in order to get save in the dialog itself we should filter isWidgetless=false, otherwise this event will report also deactivate/activate ape action from outside the dialog.
 *
 * @param {pingSaveInEditNotificationDialogParams} params - The parameters for this event
 * @property {string} eventInfo - JSON field of schema parametrs and action recommendations - debugging purposes.
 * @property {string} previousStatus - JSON field of the previous status of muted/unmuted channels and audience
 * @property {string} pingTemplateId - pingTemplateId
 * @property {string} view_type - view_type
 * @property {string} config - JSON field of the configuration, contains ape details. only for debugging usage
 * @property {boolean} isWidgetless - True - when user activates/deactivates the ape from apes list, False - when user clicks save in the widget
 * @property {string} componentChanged - JSON field of the components that were changed
 * @property {boolean} isPMFlow - is pm flow
 * @property {string} platform - deprecated
 * @property {GUID} msid - site guid
 * @property {string} ruleId - the rule id
 * @property {string} currentStatus - JSON field of the current status of muted/unmuted channels and audience
 * @return {LogObject<pingSaveInEditNotificationDialogParams>} LogObject<pingSaveInEditNotificationDialogParams>
 */
export function pingSaveInEditNotificationDialog(params) {
    return { evid: 1699, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'dashboardSiteAppPromo' event (evid: 17)
 *
 * Event description: dashboard > site -> app promo.
 *
 * @param {dashboardSiteAppPromoParams} params - The parameters for this event
 * @property {string} name - name
 * @property {string} view_type - view_type
 * @property {string} platform - platform
 * @return {LogObject<dashboardSiteAppPromoParams>} LogObject<dashboardSiteAppPromoParams>
 */
export function dashboardSiteAppPromo(params) {
    return { evid: 17, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'teamManagementClickToLearnMore' event (evid: 170)
 *
 * Event description: User clicks on 'Learn More'
 *
 * @param {teamManagementClickToLearnMoreParams} params - The parameters for this event
 * @property {string} view_type - view_type
 * @property {string} origin - team_onboarding/team_management_page/team profile dialog/MA/invite_members_dialog
 * @property {string} platform - platform
 * @return {LogObject<teamManagementClickToLearnMoreParams>} LogObject<teamManagementClickToLearnMoreParams>
 */
export function teamManagementClickToLearnMore(params) {
    return { evid: 170, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'apesUpdateTooltip' event (evid: 1701)
 *
 * Event description: APeS - update tooltip
 *
 * @param {apesUpdateTooltipParams} params - The parameters for this event
 * @property {boolean} isPreinstalled - if the automation is pre installed
 * @property {string} pingTemplateId - pingTemplateId
 * @property {string} view_type - view_type
 * @property {string} origin - app id
 * @property {string} platform - platform
 * @property {GUID} msid - msid
 * @property {GUID} ruleId - ruleId
 * @return {LogObject<apesUpdateTooltipParams>} LogObject<apesUpdateTooltipParams>
 */
export function apesUpdateTooltip(params) {
    return { evid: 1701, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'apesVersioningPreviewNewEmail' event (evid: 1702)
 *
 * Event description: APeS - versioning - preview new email
 *
 * @param {apesVersioningPreviewNewEmailParams} params - The parameters for this event
 * @property {boolean} isPreinstalled - if the automation is pre installed
 * @property {string} pingTemplateId - pingTemplateId
 * @property {string} view_type - view_type
 * @property {string} origin - app id
 * @property {string} platform - platform
 * @property {GUID} msid - msid
 * @property {GUID} ruleId - ruleId
 * @return {LogObject<apesVersioningPreviewNewEmailParams>} LogObject<apesVersioningPreviewNewEmailParams>
 */
export function apesVersioningPreviewNewEmail(params) {
    return { evid: 1702, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'apesVersioningUpdateNewVersion' event (evid: 1703)
 *
 * Event description: APeS - versioning - update new version
 *
 * @param {apesVersioningUpdateNewVersionParams} params - The parameters for this event
 * @property {boolean} isPreinstalled - if the automation is pre installed
 * @property {string} pingTemplateId - pingTemplateId
 * @property {string} view_type - view_type
 * @property {string} origin - app id
 * @property {string} platform - platform
 * @property {GUID} msid - msid
 * @property {GUID} ruleId - ruleId
 * @return {LogObject<apesVersioningUpdateNewVersionParams>} LogObject<apesVersioningUpdateNewVersionParams>
 */
export function apesVersioningUpdateNewVersion(params) {
    return { evid: 1703, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'apesVersioningUpdateNewVersionError' event (evid: 1704)
 *
 * Event description: APeS - versioning - update new version
 *
 * @param {apesVersioningUpdateNewVersionErrorParams} params - The parameters for this event
 * @property {boolean} isPreinstalled - if the automation is pre installed
 * @property {string} pingTemplateId - pingTemplateId
 * @property {string} view_type - view_type
 * @property {string} errorReason - errorReason
 * @property {string} origin - app id
 * @property {string} platform - platform
 * @property {GUID} msid - msid
 * @property {GUID} ruleId - ruleId
 * @return {LogObject<apesVersioningUpdateNewVersionErrorParams>} LogObject<apesVersioningUpdateNewVersionErrorParams>
 */
export function apesVersioningUpdateNewVersionError(params) {
    return { evid: 1704, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'apesVersioningSaveAnUpdateError' event (evid: 1705)
 *
 * Event description: APeS - versioning - save an update - error
 *
 * @param {apesVersioningSaveAnUpdateErrorParams} params - The parameters for this event
 * @property {boolean} isPreinstalled - if the automation is pre installed
 * @property {string} pingTemplateId - pingTemplateId
 * @property {string} view_type - view_type
 * @property {string} errorReason - errorReason
 * @property {string} origin - app id
 * @property {string} platform - platform
 * @property {GUID} msid - msid
 * @property {GUID} ruleId - ruleId
 * @return {LogObject<apesVersioningSaveAnUpdateErrorParams>} LogObject<apesVersioningSaveAnUpdateErrorParams>
 */
export function apesVersioningSaveAnUpdateError(params) {
    return { evid: 1705, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'dashboardAfterSiteSelectorStartedLoadingAndBeforeFinished' event (evid: 1706)
 *
 * Event description: send after site selector started loading and before site selector loaded successfully. this event is for debugging purposes.
 *
 * @param {dashboardAfterSiteSelectorStartedLoadingAndBeforeFinishedParams} params - The parameters for this event
 * @property {string} filtered - premium/published/adi / none
 * @property {string} selectionType - single / multi
 * @property {string} view_type - view_type
 * @property {string} place_description - The place in the code the event being sent from
 * @property {string} referral - from where the screen was open
 * @property {string} status - no thumbnails / empty state / success
 * @property {string} siteType - htmlWeb / modal
 * @property {number} site_type_enriched - site_type
 * @property {string} platform - platform
 * @property {Url} page_url - the full URL of the page
 * @property {string} device - mobile / desktop
 * @return {LogObject<dashboardAfterSiteSelectorStartedLoadingAndBeforeFinishedParams>} LogObject<dashboardAfterSiteSelectorStartedLoadingAndBeforeFinishedParams>
 */
export function dashboardAfterSiteSelectorStartedLoadingAndBeforeFinished(params) {
    return { evid: 1706, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'siteSelectorSiteChosen' event (evid: 1709)
 *
 * Event description: Site is chosen within the site selector (button is highlighted, but the selection isn't applied yet)
 *
 * @param {siteSelectorSiteChosenParams} params - The parameters for this event
 * @property {string} filtered - premium/published/adi / none
 * @property {number} positionIndex - the index of the selected site position in the site selector
 * @property {boolean} is_partner_dashboard - true - if partner dashboard chosen
 * @property {string} result - json of all chosen msid separated with comma
 * @property {string} selectionType - single / multi
 * @property {string} view_type - view_type
 * @property {number} sites_available - the number of sites available in site selector (not necessarily equal to number of sites owned)
 * @property {Url} action_url - action_url
 * @property {string} siteType - HtmlWeb / modal
 * @property {number} previous_position_index - index of previous (before change) selected site
 * @property {Url} referer - Referral url
 * @property {GUID} esi - esi
 * @property {string} platform - deprecated
 * @property {boolean} is_default_selection - Is current selection selected by default or actively
 * @property {number} sites_count - how many sites were chosen
 * @property {string} device - mobile / desktop
 * @return {LogObject<siteSelectorSiteChosenParams>} LogObject<siteSelectorSiteChosenParams>
 */
export function siteSelectorSiteChosen(params) {
    return { evid: 1709, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'teamManagementEditTeamProfileOpenDialog' event (evid: 171)
 *
 * Event description: When a user clicks to edit team profile please send this event with the next fields:
 *
 * @param {teamManagementEditTeamProfileOpenDialogParams} params - The parameters for this event
 * @property {boolean} onboarding - the dialog was opened from the onboarding page - true, from team management - false
 * @property {string} view_type - view_type
 * @property {string} platform - platform
 * @return {LogObject<teamManagementEditTeamProfileOpenDialogParams>} LogObject<teamManagementEditTeamProfileOpenDialogParams>
 */
export function teamManagementEditTeamProfileOpenDialog(params) {
    return { evid: 171, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'dashboardSiteCategoryShown' event (evid: 1714)
 *
 * Event description: When site category is shown.
 *
 * @param {dashboardSiteCategoryShownParams} params - The parameters for this event
 * @property {boolean} has_category - true/false
 * @property {string} site_category - site category/null
 * @property {string} view_type - view_type
 * @property {string} platform - platform
 * @property {string} hosting - hosting
 * @property {GUID} msid - msid
 * @return {LogObject<dashboardSiteCategoryShownParams>} LogObject<dashboardSiteCategoryShownParams>
 */
export function dashboardSiteCategoryShown(params) {
    return { evid: 1714, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'dashboardSiteSelectorClickForDebuggingPurposes' event (evid: 1715)
 *
 * Event description: when user clicks on the select in site selector, this event is for debugging purposes and will be sent via native reporting approach
 *
 * @param {dashboardSiteSelectorClickForDebuggingPurposesParams} params - The parameters for this event
 * @property {string} filtered - premium/published/adi / none
 * @property {number} positionIndex - the index of the selected site position in the site selector
 * @property {GUID} site_id
 * @property {boolean} is_partner_dashboard - true - if partner dashboard chosen
 * @property {string} result - json of all chosen msid separated with comma
 * @property {string} selectionType - single / multi
 * @property {string} view_type - view_type
 * @property {string} siteTypeName - ADI/Editor
 * @property {Url} action_url - action_url
 * @property {string} siteType - HtmlWeb / modal
 * @property {number} sites_number - the number of sites available in site selector (not necessarily equal to number of sites owned)
 * @property {string} cta - x / cancel / continue
 * @property {number} position - The position of the selected site in the page. 1 is the highest site.
 * @property {number} site_type_enriched
 * @property {Url} referer - Referral url
 * @property {GUID} esi
 * @property {string} platform - deprecated
 * @property {GUID} msid - the site guid
 * @property {number} sites_count - how many sites were chosen
 * @property {string} device - mobile / desktop
 * @return {LogObject<dashboardSiteSelectorClickForDebuggingPurposesParams>} LogObject<dashboardSiteSelectorClickForDebuggingPurposesParams>
 */
export function dashboardSiteSelectorClickForDebuggingPurposes(params) {
    return { evid: 1715, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'dashboardSiteSelectorLoadedSuccessfullyForDebuggingPurposes' event (evid: 1716)
 *
 * Event description: when Site Selector loaded successfully, this event is for debugging purposes and will be sent via native reporting approach
 *
 * @param {dashboardSiteSelectorLoadedSuccessfullyForDebuggingPurposesParams} params - The parameters for this event
 * @property {string} filtered - premium/published/adi / none
 * @property {boolean} is_partner_dashboard - true - if partner dashboard displayed
 * @property {string} sitePublished - -
 * @property {string} selectionType - single / multi
 * @property {string} view_type - view_type
 * @property {number} account_sites_number - absolute account sites number
 * @property {string} referral - -
 * @property {number} loadingTime - in ms
 * @property {string} status - no thumbnails / empty state / success
 * @property {string} siteType - HtmlWeb / modal
 * @property {number} site_type_enriched - -
 * @property {string} platform - -
 * @property {number} sites_count - # sites returned to site selector
 * @property {string} device - mobile / desktop
 * @return {LogObject<dashboardSiteSelectorLoadedSuccessfullyForDebuggingPurposesParams>} LogObject<dashboardSiteSelectorLoadedSuccessfullyForDebuggingPurposesParams>
 */
export function dashboardSiteSelectorLoadedSuccessfullyForDebuggingPurposes(params) {
    return { evid: 1716, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'teamManagementPickLogo' event (evid: 172)
 *
 * Event description: when a user clicks to add/remove/replace/upload logo in edit team dialog
 *
 * @param {teamManagementPickLogoParams} params - The parameters for this event
 * @property {string} view_type - view_type
 * @property {string} platform - platform
 * @property {string} action_type - replace/remove/add/upload/purchase
 * @return {LogObject<teamManagementPickLogoParams>} LogObject<teamManagementPickLogoParams>
 */
export function teamManagementPickLogo(params) {
    return { evid: 172, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'bmACallForTokenRefreshIsFailing' event (evid: 1722)
 *
 * Event description: when a call for token refresh is failing
 *
 * @param {bmACallForTokenRefreshIsFailingParams} params - The parameters for this event
 * @property {string} view_type - view_type
 * @property {string} platform - depreceted
 * @property {GUID} msid - site guid
 * @return {LogObject<bmACallForTokenRefreshIsFailingParams>} LogObject<bmACallForTokenRefreshIsFailingParams>
 */
export function bmACallForTokenRefreshIsFailing(params) {
    return { evid: 1722, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'transferSiteSiteCanTBeTransferredPopUpView' event (evid: 1725)
 *
 * Event description: pop-up shown that the site cannot be transferred
 *
 * @param {transferSiteSiteCanTBeTransferredPopUpViewParams} params - The parameters for this event
 * @property {string} view_type - view_type
 * @property {string} origin - origin
 * @property {string} platform - platform
 * @property {string} hosting - MA /Editor
 * @property {string} block_from_transfer_reason - is_block_from_transfer_reason
 * @property {GUID} msid - msid
 * @return {LogObject<transferSiteSiteCanTBeTransferredPopUpViewParams>} LogObject<transferSiteSiteCanTBeTransferredPopUpViewParams>
 */
export function transferSiteSiteCanTBeTransferredPopUpView(params) {
    return { evid: 1725, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'teamManagementSave' event (evid: 173)
 *
 * Event description: User clicks to save his edit team dialog
 *
 * @param {teamManagementSaveParams} params - The parameters for this event
 * @property {boolean} is_logo_shown - true/false
 * @property {string} view_type - view_type
 * @property {string} platform - platform
 * @property {boolean} is_valid_team_name - true/false (false if error shows)
 * @return {LogObject<teamManagementSaveParams>} LogObject<teamManagementSaveParams>
 */
export function teamManagementSave(params) {
    return { evid: 173, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'mySitesWhenDialogPopsUp' event (evid: 1732)
 *
 * Event description: when user triggers a dialog to open
 *
 * @param {mySitesWhenDialogPopsUpParams} params - The parameters for this event
 * @property {string} name - dialog's name: move to trash etc...
 * @property {string} view_mode - grid/list
 * @property {string} view_type - view_type
 * @property {number} num_selected_sites - number of sites selected
 * @property {string} origin - sites-list/ sites-list-enterprise
 * @property {string} view_level - view_level
 * @property {string} platform - deprecated
 * @property {string} hosting - MA
 * @return {LogObject<mySitesWhenDialogPopsUpParams>} LogObject<mySitesWhenDialogPopsUpParams>
 */
export function mySitesWhenDialogPopsUp(params) {
    return { evid: 1732, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'automationsQuickGoogleSpreadsheetsRecipeActivationErrorActivateClickedWhileDetailsEmpty' event (evid: 1734)
 *
 * Event description: Triggered when the user click's the activate while the fields are empty
 *
 * @param {automationsQuickGoogleSpreadsheetsRecipeActivationErrorActivateClickedWhileDetailsEmptyParams} params - The parameters for this event
 * @property {string} view_type - view_type
 * @property {string} platform - platform
 * @property {GUID} msid - msid
 * @return {LogObject<automationsQuickGoogleSpreadsheetsRecipeActivationErrorActivateClickedWhileDetailsEmptyParams>} LogObject<automationsQuickGoogleSpreadsheetsRecipeActivationErrorActivateClickedWhileDetailsEmptyParams>
 */
export function automationsQuickGoogleSpreadsheetsRecipeActivationErrorActivateClickedWhileDetailsEmpty(params) {
    return { evid: 1734, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'mySitesClickOnButtonInDialog' event (evid: 1735)
 *
 * Event description: when user click on any button in dialog in My-Sites page. currently this BI reported from move to trash/move to folder dialogs.
 *
 * @param {mySitesClickOnButtonInDialogParams} params - The parameters for this event
 * @property {string} name - dialog name
 * @property {string} view_mode - list/grid
 * @property {string} to_level - to where the user moved the site. In case it’s sites-list main page report: ROOT, in case it’s folder report: folder_name_of_folder, ic case it’s trash folder report: folder_trash
 * @property {string} view_type - view_type
 * @property {number} num_selected_sites - number of sites move to the folder
 * @property {string} origin - sites-list-enterprise
 * @property {string} cta - X / cancel / move to trash / move to folder etc...
 * @property {string} from_level - from where the user moved the sites. In case it’s sites-list main page report: ROOT, in case it’s folder report: folder_name_of_folder, in case it’s search report search_search_term, in case it’s filter report filter
 * @property {string} platform - platform
 * @property {string} action - approve / cancel
 * @return {LogObject<mySitesClickOnButtonInDialogParams>} LogObject<mySitesClickOnButtonInDialogParams>
 */
export function mySitesClickOnButtonInDialog(params) {
    return { evid: 1735, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'dashboardFinishLoadingAllWidgets' event (evid: 1736)
 *
 * Event description: The event is sent at the first time all components that started loading have been fully loaded
 *
 * @param {dashboardFinishLoadingAllWidgetsParams} params - The parameters for this event
 * @property {string} view_type - view_type
 * @property {boolean} is_account_mgr - true/ false
 * @property {number} loading_time_from_host_load - Loading time from module start loading
 * @property {string} sub_view - --
 * @property {string} host_id - host
 * @property {number} loading_time_from_performance_now - loading_time_from_performance_now  when server start to load. the real beginning
 * @property {string} app_id - application id
 * @property {string} platform - platform
 * @property {string} hosting - dashboard/editor/onboarding
 * @property {GUID} msid - msid
 * @property {string} view - requested view
 * @property {number} loading_time - loading time of page
 * @return {LogObject<dashboardFinishLoadingAllWidgetsParams>} LogObject<dashboardFinishLoadingAllWidgetsParams>
 */
export function dashboardFinishLoadingAllWidgets(params) {
    return { evid: 1736, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'app2FaSetupEnableClick' event (evid: 1738)
 *
 * Event description: The user clicked on 'enable' in the account settings page, or clicked on 'Add app verification' in the phone/email 2FA setup modals.
 *
 * @param {app2FaSetupEnableClickParams} params - The parameters for this event
 * @property {string} view_type - view_type
 * @property {string} origin - account settings page/phone modal/email modal/second best
 * @property {string} platform - platform
 * @return {LogObject<app2FaSetupEnableClickParams>} LogObject<app2FaSetupEnableClickParams>
 */
export function app2FaSetupEnableClick(params) {
    return { evid: 1738, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'app2FaSetupClickOnNextAfterScanningQrCode' event (evid: 1739)
 *
 * Event description: The user scanned the QR code, or entered the code manually in the authentication app, and clicked on next.
 *
 * @param {app2FaSetupClickOnNextAfterScanningQrCodeParams} params - The parameters for this event
 * @property {string} view_type - view_type
 * @property {string} origin - account settings page/phone modal/email modal
 * @property {string} mode - change app/enable
 * @property {string} platform - platform
 * @return {LogObject<app2FaSetupClickOnNextAfterScanningQrCodeParams>} LogObject<app2FaSetupClickOnNextAfterScanningQrCodeParams>
 */
export function app2FaSetupClickOnNextAfterScanningQrCode(params) {
    return { evid: 1739, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'teamManagementAddMembersOpenDialog' event (evid: 174)
 *
 * Event description: When a user clicks to Invite/add People on account level - Team Management page
 *
 * @param {teamManagementAddMembersOpenDialogParams} params - The parameters for this event
 * @property {string} view_type - view_type
 * @property {string} roles_displayed - list of roles displayed to the user
 * @property {string} origin - where the dialog is opened from
 * @property {string} platform - platform
 * @return {LogObject<teamManagementAddMembersOpenDialogParams>} LogObject<teamManagementAddMembersOpenDialogParams>
 */
export function teamManagementAddMembersOpenDialog(params) {
    return { evid: 174, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'app2FaSetupClickOnCopyCode' event (evid: 1740)
 *
 * Event description: The user clicked on 'copy code' in the QR scan step of the app 2FA enable modal.
 *
 * @param {app2FaSetupClickOnCopyCodeParams} params - The parameters for this event
 * @property {string} view_type - view_type
 * @property {string} mode - change app/enable
 * @property {string} platform - platform
 * @property {string} origin - The screen origin (Account settings \ 2fa enforcement)
 * @return {LogObject<app2FaSetupClickOnCopyCodeParams>} LogObject<app2FaSetupClickOnCopyCodeParams>
 */
export function app2FaSetupClickOnCopyCode(params) {
    return { evid: 1740, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'app2FaSetupSubmitCode' event (evid: 1741)
 *
 * Event description: The user clicks on 'submit' in the app 2fa setup modal after entering the 6-digit code from the authenticator app
 *
 * @param {app2FaSetupSubmitCodeParams} params - The parameters for this event
 * @property {string} view_type - view_type
 * @property {string} mode - change app/enable
 * @property {string} platform - platform
 * @property {string} origin - The screen origin (Account settings \ 2fa enforcement)
 * @return {LogObject<app2FaSetupSubmitCodeParams>} LogObject<app2FaSetupSubmitCodeParams>
 */
export function app2FaSetupSubmitCode(params) {
    return { evid: 1741, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'app2FaSetupDisableClick' event (evid: 1742)
 *
 * Event description: App 2FA Setup - Disable Click.
 *
 * @param {app2FaSetupDisableClickParams} params - The parameters for this event
 * @property {string} view_type - view_type
 * @property {string} platform - platform
 * @return {LogObject<app2FaSetupDisableClickParams>} LogObject<app2FaSetupDisableClickParams>
 */
export function app2FaSetupDisableClick(params) {
    return { evid: 1742, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'app2FaSetupDisableConfirm' event (evid: 1743)
 *
 * Event description: The user clicks on disable in the disable modal, to confirm the action
 *
 * @param {app2FaSetupDisableConfirmParams} params - The parameters for this event
 * @property {string} view_type - view_type
 * @property {string} platform - platform
 * @return {LogObject<app2FaSetupDisableConfirmParams>} LogObject<app2FaSetupDisableConfirmParams>
 */
export function app2FaSetupDisableConfirm(params) {
    return { evid: 1743, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'app2FaSetupClickOnChangeApp' event (evid: 1744)
 *
 * Event description: The user clicks on 'Change App' to change the authenticator app
 *
 * @param {app2FaSetupClickOnChangeAppParams} params - The parameters for this event
 * @property {string} view_type - view_type
 * @property {string} platform - platform
 * @return {LogObject<app2FaSetupClickOnChangeAppParams>} LogObject<app2FaSetupClickOnChangeAppParams>
 */
export function app2FaSetupClickOnChangeApp(params) {
    return { evid: 1744, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'app2FaSetupConfirmChangeApp' event (evid: 1745)
 *
 * Event description: The user clicks on 'Change' in the change app modal, to confirm the action
 *
 * @param {app2FaSetupConfirmChangeAppParams} params - The parameters for this event
 * @property {string} view_type - view_type
 * @property {string} platform - platform
 * @return {LogObject<app2FaSetupConfirmChangeAppParams>} LogObject<app2FaSetupConfirmChangeAppParams>
 */
export function app2FaSetupConfirmChangeApp(params) {
    return { evid: 1745, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'app2FaSetupCodeErrorMessage' event (evid: 1746)
 *
 * Event description: An error message shown to a user who entered an invalid 6-digit code in the 2FA app setup
 *
 * @param {app2FaSetupCodeErrorMessageParams} params - The parameters for this event
 * @property {string} view_type - view_type
 * @property {string} error_reason - reason for error
 * @property {string} mode - change app/enable
 * @property {string} platform - platform
 * @property {number} error_code - error_code
 * @property {string} origin - The origin page of the click
 * @return {LogObject<app2FaSetupCodeErrorMessageParams>} LogObject<app2FaSetupCodeErrorMessageParams>
 */
export function app2FaSetupCodeErrorMessage(params) {
    return { evid: 1746, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'app2FaSetupClickOnBack' event (evid: 1747)
 *
 * Event description: The user clicked on 'back' in the enter code step, when enabling app 2fa
 *
 * @param {app2FaSetupClickOnBackParams} params - The parameters for this event
 * @property {string} view_type - view_type
 * @property {string} mode - change app/enable
 * @property {string} platform - platform
 * @property {string} origin - The page origin (Account settings\ 2fa enforcement)
 * @return {LogObject<app2FaSetupClickOnBackParams>} LogObject<app2FaSetupClickOnBackParams>
 */
export function app2FaSetupClickOnBack(params) {
    return { evid: 1747, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'sapir1' event (evid: 1748)
 *
 * Event description: When error message is shown in Site Selector
 *
 * @param {sapir1Params} params - The parameters for this event
 * @property {string} view_type - view_type
 * @property {string} errorType - the error type. f.e: Sites failed to load/Site screenshots failed to load
 * @property {string} referral - refferral
 * @property {number} loadingTime - in ms
 * @property {string} siteType - HtmlWeb / modal
 * @property {string} platform - deprecated
 * @property {string} device - mobile / desktop
 * @return {LogObject<sapir1Params>} LogObject<sapir1Params>
 */
export function sapir1(params) {
    return { evid: 1748, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'teamManagementAddMembersSendInvite' event (evid: 175)
 *
 * Event description: When a user clicks on 'send invites' in the add member window
 *
 * @param {teamManagementAddMembersSendInviteParams} params - The parameters for this event
 * @property {number} number_of_invalid_emails - number of invalid numbers (error for not typing correctly - exclude errors for existing emails)
 * @property {string} view_type - view_type
 * @property {string} roles_displayed - list of roles displayed to the user
 * @property {number} number_of_existing_emails - emails that already exist in the team
 * @property {string} origin - where the user opened the dialog from
 * @property {string} invite_role - (please note that using the toggle changes role desc) the role the user sends to the invitees
 * @property {string} platform - platform
 * @property {number} number_of_valid_emails - number of valid emails
 * @return {LogObject<teamManagementAddMembersSendInviteParams>} LogObject<teamManagementAddMembersSendInviteParams>
 */
export function teamManagementAddMembersSendInvite(params) {
    return { evid: 175, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'teamManagementAddMembersInviteClickSuccess' event (evid: 176)
 *
 * Event description: When a user clicks on 'send invites' in the add member window - success response
 *
 * @param {teamManagementAddMembersInviteClickSuccessParams} params - The parameters for this event
 * @property {string} view_type - view_type
 * @property {string} origin - where the dialog is opened from
 * @property {string} invite_role - (please note that using the toggle changes role desc) the role the user sends to the invitees
 * @property {string} platform - platform
 * @return {LogObject<teamManagementAddMembersInviteClickSuccessParams>} LogObject<teamManagementAddMembersInviteClickSuccessParams>
 */
export function teamManagementAddMembersInviteClickSuccess(params) {
    return { evid: 176, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'headerClickOnItemInOneOfTheHeaderDialogsDropDownMenus' event (evid: 1768)
 *
 * Event description: click on item in one of the header dialogs which are drop down menus, it can be click on item in explore menu, help menu, etc.
 *
 * @param {headerClickOnItemInOneOfTheHeaderDialogsDropDownMenusParams} params - The parameters for this event
 * @property {string} view_type - view_type
 * @property {string} pageView - my-sites /dashboard / account settings
 * @property {string} itemName - the item name, f.e: courses and lessons, updates and releases, etc.
 * @property {string} platform - deprecated
 * @property {GUID} msid - site guid (when the click is in site level)
 * @property {string} view - the dropdown menu name, f.e: explore, priority support, site-dropdown, notifications, etc.
 * @return {LogObject<headerClickOnItemInOneOfTheHeaderDialogsDropDownMenusParams>} LogObject<headerClickOnItemInOneOfTheHeaderDialogsDropDownMenusParams>
 */
export function headerClickOnItemInOneOfTheHeaderDialogsDropDownMenus(params) {
    return { evid: 1768, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'teamManagementAddMembersInviteClickFail' event (evid: 177)
 *
 * Event description: When a user clicks on 'send invites' in the add member window - fail response
 *
 * @param {teamManagementAddMembersInviteClickFailParams} params - The parameters for this event
 * @property {string} error_desc - error description
 * @property {string} view_type - view_type
 * @property {string} origin - where the dialog was opened
 * @property {string} invite_role - (please note that using the toggle changes role desc) the role the user sends to the invitees
 * @property {string} platform - platform
 * @return {LogObject<teamManagementAddMembersInviteClickFailParams>} LogObject<teamManagementAddMembersInviteClickFailParams>
 */
export function teamManagementAddMembersInviteClickFail(params) {
    return { evid: 177, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'mySitesUnableToMoveSitesToTrashModalIsShownOnBulkMoveToTrashOrSingleSiteMoveToTrash' event (evid: 1771)
 *
 * Event description: when Unable to Move Sites to Trash modal is shown after user tried to move to trash (the modal will appear in single site moving to trash or in bulk moving to trash)
 *
 * @param {mySitesUnableToMoveSitesToTrashModalIsShownOnBulkMoveToTrashOrSingleSiteMoveToTrashParams} params - The parameters for this event
 * @property {string} view_mode - view_mode
 * @property {string} view_type - view_type
 * @property {string} sub_view - sub_view
 * @property {string} origin - my sites / dashboard / sites-list-enterprise
 * @property {number} num_untrashed_sites - number of sites can't be moved to trash
 * @property {string} platform - deprecated
 * @property {string} hosting - MA/editor
 * @property {string} reasons - a JSON of the reasons the sites can't be moved to trash when the key is the reason and the value is a list of the sites msid's which can't be moved to trash, the keys: pending subscription/active subscription/unpermitted/tech error
 * @return {LogObject<mySitesUnableToMoveSitesToTrashModalIsShownOnBulkMoveToTrashOrSingleSiteMoveToTrashParams>} LogObject<mySitesUnableToMoveSitesToTrashModalIsShownOnBulkMoveToTrashOrSingleSiteMoveToTrashParams>
 */
export function mySitesUnableToMoveSitesToTrashModalIsShownOnBulkMoveToTrashOrSingleSiteMoveToTrash(params) {
    return { evid: 1771, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'teamManagementDeleteTeamMemberOpenDialog' event (evid: 178)
 *
 * Event description: When a user clicks on delete member
 *
 * @param {teamManagementDeleteTeamMemberOpenDialogParams} params - The parameters for this event
 * @property {string} invite_status - pending/expired/leave team
 * @property {string} role - the deleted user’s role
 * @property {string} view_type - view_type
 * @property {string} origin - where the user opened the dialog from
 * @property {GUID} member_id - the uuid of the deleted member (if status is pending then invite_id)
 * @property {string} platform - platform
 * @return {LogObject<teamManagementDeleteTeamMemberOpenDialogParams>} LogObject<teamManagementDeleteTeamMemberOpenDialogParams>
 */
export function teamManagementDeleteTeamMemberOpenDialog(params) {
    return { evid: 178, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'accountSettingsChangeEmailAddressModalClickOnNext' event (evid: 1784)
 *
 * Event description: The user clicks on next in the modal that opens when he wants to change email address
 *
 * @param {accountSettingsChangeEmailAddressModalClickOnNextParams} params - The parameters for this event
 * @property {string} view_type - view_type
 * @property {string} platform - platform
 * @return {LogObject<accountSettingsChangeEmailAddressModalClickOnNextParams>} LogObject<accountSettingsChangeEmailAddressModalClickOnNextParams>
 */
export function accountSettingsChangeEmailAddressModalClickOnNext(params) {
    return { evid: 1784, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'accountSettingsChangeEmailAddressModalSubmit' event (evid: 1785)
 *
 * Event description: The user clicks on submit after entering the code in the change email address modal
 *
 * @param {accountSettingsChangeEmailAddressModalSubmitParams} params - The parameters for this event
 * @property {string} view_type - view_type
 * @property {string} platform - platform
 * @return {LogObject<accountSettingsChangeEmailAddressModalSubmitParams>} LogObject<accountSettingsChangeEmailAddressModalSubmitParams>
 */
export function accountSettingsChangeEmailAddressModalSubmit(params) {
    return { evid: 1785, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'accountSettingsChangeEmailAddressModalResendCode' event (evid: 1786)
 *
 * Event description: The user clicks on resend code in the change email address modal
 *
 * @param {accountSettingsChangeEmailAddressModalResendCodeParams} params - The parameters for this event
 * @property {string} view_type - view_type
 * @property {string} platform - platform
 * @return {LogObject<accountSettingsChangeEmailAddressModalResendCodeParams>} LogObject<accountSettingsChangeEmailAddressModalResendCodeParams>
 */
export function accountSettingsChangeEmailAddressModalResendCode(params) {
    return { evid: 1786, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'accountSettingsChangeEmailAddressModalCancelChanges' event (evid: 1787)
 *
 * Event description: The user clicked on 'cancel' to confirm that the change email address action was canceled
 *
 * @param {accountSettingsChangeEmailAddressModalCancelChangesParams} params - The parameters for this event
 * @property {string} view_type - view_type
 * @property {string} platform - platform
 * @return {LogObject<accountSettingsChangeEmailAddressModalCancelChangesParams>} LogObject<accountSettingsChangeEmailAddressModalCancelChangesParams>
 */
export function accountSettingsChangeEmailAddressModalCancelChanges(params) {
    return { evid: 1787, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'teamManagementDeleteTeamMemberDeleteClick' event (evid: 179)
 *
 * Event description: When a user clicks on 'delete' in the delete team member window
 *
 * @param {teamManagementDeleteTeamMemberDeleteClickParams} params - The parameters for this event
 * @property {string} invite_status - pending/expired/leave team
 * @property {string} role - the deleted user’s role
 * @property {string} view_type - view_type
 * @property {string} origin - where the dialog was opened from
 * @property {GUID} member_id - the uuid of the deleted member (if status is pending then invite_id)
 * @property {string} platform - platform
 * @return {LogObject<teamManagementDeleteTeamMemberDeleteClickParams>} LogObject<teamManagementDeleteTeamMemberDeleteClickParams>
 */
export function teamManagementDeleteTeamMemberDeleteClick(params) {
    return { evid: 179, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'dashboardSiteNewsViewAll' event (evid: 18)
 *
 * Event description: dashboard > site -> news -> view all.
 *
 * @param {dashboardSiteNewsViewAllParams} params - The parameters for this event
 * @property {string} view_type - view_type
 * @property {string} platform - platform
 * @return {LogObject<dashboardSiteNewsViewAllParams>} LogObject<dashboardSiteNewsViewAllParams>
 */
export function dashboardSiteNewsViewAll(params) {
    return { evid: 18, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'teamManagementDeleteTeamMemberDeleteClickSuccess' event (evid: 180)
 *
 * Event description: When a user clicks on 'delete' in the delete team member window - success response
 *
 * @param {teamManagementDeleteTeamMemberDeleteClickSuccessParams} params - The parameters for this event
 * @property {string} invite_status - pending/expired/leave team
 * @property {string} role - the deleted user’s role
 * @property {string} view_type - view_type
 * @property {string} origin - where the dialog was opened from
 * @property {GUID} member_id - the uuid of the deleted member (if status is pending then invite_id)
 * @property {string} platform - platform
 * @return {LogObject<teamManagementDeleteTeamMemberDeleteClickSuccessParams>} LogObject<teamManagementDeleteTeamMemberDeleteClickSuccessParams>
 */
export function teamManagementDeleteTeamMemberDeleteClickSuccess(params) {
    return { evid: 180, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'teamManagementDeleteTeamMemberDeleteClickFail' event (evid: 181)
 *
 * Event description: When a user clicks on 'delete' in the delete team member window - fail response
 *
 * @param {teamManagementDeleteTeamMemberDeleteClickFailParams} params - The parameters for this event
 * @property {string} invite_status - pending/expired/leave team
 * @property {string} role - the deleted user’s role
 * @property {string} view_type - view_type
 * @property {string} origin - where the dialog was opened from
 * @property {GUID} member_id - the uuid of the deleted member (if status is pending then invite_id)
 * @property {string} platform - platform
 * @return {LogObject<teamManagementDeleteTeamMemberDeleteClickFailParams>} LogObject<teamManagementDeleteTeamMemberDeleteClickFailParams>
 */
export function teamManagementDeleteTeamMemberDeleteClickFail(params) {
    return { evid: 181, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'teamManagementGetInviteLink' event (evid: 182)
 *
 * Event description: When a user clicks on get invitation link
 *
 * @param {teamManagementGetInviteLinkParams} params - The parameters for this event
 * @property {string} invite_status - pending/expired/leave team
 * @property {string} role - the deleted user’s role
 * @property {string} view_type - view_type
 * @property {string} origin - where the dialog was opened from
 * @property {string} platform - platform
 * @return {LogObject<teamManagementGetInviteLinkParams>} LogObject<teamManagementGetInviteLinkParams>
 */
export function teamManagementGetInviteLink(params) {
    return { evid: 182, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'teamManagementEditRoleOpenDialog' event (evid: 183)
 *
 * Event description: When the user clicks on edit role
 *
 * @param {teamManagementEditRoleOpenDialogParams} params - The parameters for this event
 * @property {string} invite_status - pending/expired
 * @property {string} view_type - view_type
 * @property {string} roles_displayed - list of roles displayed to the user
 * @property {string} origin - where the dialog is opened from
 * @property {GUID} member_id - the uuid of the member which we edit the role for
 * @property {string} platform - platform
 * @return {LogObject<teamManagementEditRoleOpenDialogParams>} LogObject<teamManagementEditRoleOpenDialogParams>
 */
export function teamManagementEditRoleOpenDialog(params) {
    return { evid: 183, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'teamManagementEditRoleUpdateClick' event (evid: 184)
 *
 * Event description: When the user clicks on 'update' in the edit role window - success response
 *
 * @param {teamManagementEditRoleUpdateClickParams} params - The parameters for this event
 * @property {string} new_role - new role
 * @property {boolean} is_accepted - true if invite was accepted
 * @property {string} view_type - view_type
 * @property {string} roles_displayed - list of roles displayed to the user
 * @property {string} prev_role - previous role
 * @property {string} origin - where the dialog is opened from
 * @property {string} platform - platform
 * @return {LogObject<teamManagementEditRoleUpdateClickParams>} LogObject<teamManagementEditRoleUpdateClickParams>
 */
export function teamManagementEditRoleUpdateClick(params) {
    return { evid: 184, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'teamManagementResendInviteClick' event (evid: 185)
 *
 * Event description: When a user clicks on resend invite
 *
 * @param {teamManagementResendInviteClickParams} params - The parameters for this event
 * @property {string} invite_status - pending/expired
 * @property {string} view_type - view_type
 * @property {string} origin - where the user opened the dialog from
 * @property {GUID} invite_id - the invite id
 * @property {string} invite_role - the role on the invite
 * @property {string} platform - platform
 * @return {LogObject<teamManagementResendInviteClickParams>} LogObject<teamManagementResendInviteClickParams>
 */
export function teamManagementResendInviteClick(params) {
    return { evid: 185, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'dashboardContributorsClickOnMangeRolesAndPermissions' event (evid: 187)
 *
 * Event description: When a user clicks on 'manage roles and permissions' from contributors pic
 *
 * @param {dashboardContributorsClickOnMangeRolesAndPermissionsParams} params - The parameters for this event
 * @property {string} view_type - view_type
 * @property {string} platform - platform
 * @property {string} hosting - MA
 * @property {GUID} msid - --
 * @return {LogObject<dashboardContributorsClickOnMangeRolesAndPermissionsParams>} LogObject<dashboardContributorsClickOnMangeRolesAndPermissionsParams>
 */
export function dashboardContributorsClickOnMangeRolesAndPermissions(params) {
    return { evid: 187, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'ascendHoverOnUpgradeAscend' event (evid: 188)
 *
 * Event description: Hover on Upgrade Ascend
 *
 * @param {ascendHoverOnUpgradeAscendParams} params - The parameters for this event
 * @property {string} appName - BM App
 * @property {GUID} uuid - uuid
 * @property {string} button_name - upgrade button / ascend title
 * @property {string} view_type - view_type
 * @property {string} platform - platform
 * @property {GUID} msid - msid
 * @return {LogObject<ascendHoverOnUpgradeAscendParams>} LogObject<ascendHoverOnUpgradeAscendParams>
 */
export function ascendHoverOnUpgradeAscend(params) {
    return { evid: 188, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'ascendClickOnUpgradeAscend' event (evid: 189)
 *
 * Event description: Click on Upgrade Ascend
 *
 * @param {ascendClickOnUpgradeAscendParams} params - The parameters for this event
 * @property {string} appName - BM App
 * @property {GUID} uuid - uuid
 * @property {string} button_name - upgrade/upgrade business tools / ascend info / learn more
 * @property {string} view_type - view_type
 * @property {string} origin - web/native
 * @property {string} platform - platform
 * @property {GUID} msid - msid
 * @return {LogObject<ascendClickOnUpgradeAscendParams>} LogObject<ascendClickOnUpgradeAscendParams>
 */
export function ascendClickOnUpgradeAscend(params) {
    return { evid: 189, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'dashboardSiteNewsClickItem' event (evid: 19)
 *
 * Event description: dashboard > site -> news -> click item.
 *
 * @param {dashboardSiteNewsClickItemParams} params - The parameters for this event
 * @property {string} feed_type - type
 * @property {string} msg_origin - origin
 * @property {string} name - name
 * @property {GUID} item_id - item_id
 * @property {string} source - source
 * @property {string} url - url
 * @property {boolean} is_deleted - is_deleted
 * @property {string} view_type - view_type
 * @property {string} origin - origin
 * @property {GUID} campaignId - unique identifier of CMS items
 * @property {string} title - title of tip
 * @property {string} lang - item_lng
 * @property {string} type - type
 * @property {string} platform - platform
 * @property {GUID} msid - msid
 * @property {boolean} is_archived - is_archived
 * @property {GUID} feed_id - feed_id
 * @return {LogObject<dashboardSiteNewsClickItemParams>} LogObject<dashboardSiteNewsClickItemParams>
 */
export function dashboardSiteNewsClickItem(params) {
    return { evid: 19, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'ascendPpClickOnMoveToWixPremiumPp' event (evid: 190)
 *
 * Event description: User clicks on buttons in Ascend PP
 *
 * @param {ascendPpClickOnMoveToWixPremiumPpParams} params - The parameters for this event
 * @property {number} timeInPage - in milisec
 * @property {string} referralInfo - button name open PP
 * @property {string} button_name - premium / compare
 * @property {string} view_type - view_type
 * @property {string} origin - product name open PP
 * @property {string} platform - web/mobile
 * @return {LogObject<ascendPpClickOnMoveToWixPremiumPpParams>} LogObject<ascendPpClickOnMoveToWixPremiumPpParams>
 */
export function ascendPpClickOnMoveToWixPremiumPp(params) {
    return { evid: 190, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'ascendPpThankYouPage' event (evid: 191)
 *
 * Event description: Thank you page after purchasing Ascend PP
 *
 * @param {ascendPpThankYouPageParams} params - The parameters for this event
 * @property {string} package_id - package bought
 * @property {string} cycle_name - Cycle bought
 * @property {string} view_type - view_type
 * @property {string} package_name - package bought
 * @property {GUID} app_id - app_id
 * @property {string} type - Page View / Click go to Dashboard
 * @property {GUID} packageId - package id
 * @property {string} platform - web/native
 * @property {number} cycleId - cycle id
 * @return {LogObject<ascendPpThankYouPageParams>} LogObject<ascendPpThankYouPageParams>
 */
export function ascendPpThankYouPage(params) {
    return { evid: 191, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'invoicesMoreActionsClick' event (evid: 193)
 *
 * Event description: Invoices - More Actions - Click
 *
 * @param {invoicesMoreActionsClickParams} params - The parameters for this event
 * @property {string} view_type - view_type
 * @property {string} origin - origin page
 * @property {string} platform - platform
 * @property {string} msid - msid
 * @return {LogObject<invoicesMoreActionsClickParams>} LogObject<invoicesMoreActionsClickParams>
 */
export function invoicesMoreActionsClick(params) {
    return { evid: 193, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'invoicesMoreActionsChooseOption' event (evid: 194)
 *
 * Event description: Invoices - More Actions - Choose option
 *
 * @param {invoicesMoreActionsChooseOptionParams} params - The parameters for this event
 * @property {string} option - 'Products', 'Reports','Accept Payments', 'Invoice Settings','Feedback'
 * @property {string} view_type - view_type
 * @property {string} origin - originPage
 * @property {string} platform - platform
 * @property {string} msid - msid
 * @return {LogObject<invoicesMoreActionsChooseOptionParams>} LogObject<invoicesMoreActionsChooseOptionParams>
 */
export function invoicesMoreActionsChooseOption(params) {
    return { evid: 194, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'clickInDashboard' event (evid: 195)
 *
 * Event description: Click on the action in dashboard widgets. (in the beginning this event was only for site details and in the new dashboard we added other clicks in different widgets.)
 *
 * @param {clickInDashboardParams} params - The parameters for this event
 * @property {string} name - the site details' item: Connect Domain, Manage Plan...
 * @property {string} widget_name - the widget name in dashboard (this field added only in new dashboard)
 * @property {string} permissions - permissions
 * @property {string} view_type - view_type
 * @property {string} tagList - tag_list
 * @property {string} widgetState - widget_state
 * @property {string} place - place
 * @property {string} type - Type of widget
 * @property {string} platform - platform
 * @property {string} item_status_desc - item_status_desc
 * @property {string} hosting - ma
 * @property {GUID} msid - --
 * @property {string} page_name - page_name
 * @return {LogObject<clickInDashboardParams>} LogObject<clickInDashboardParams>
 */
export function clickInDashboard(params) {
    return { evid: 195, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'dashboardFetchDealerLayoutFailed' event (evid: 1999)
 *
 * Event description: when fetching from dealer layout is failed
 *
 * @param {dashboardFetchDealerLayoutFailedParams} params - The parameters for this event
 * @property {string} view_type - view_type
 * @property {string} type - fallback/cached
 * @property {string} platform - platform
 * @property {GUID} msid - msid
 * @property {string} dashboard_type - old/new
 * @return {LogObject<dashboardFetchDealerLayoutFailedParams>} LogObject<dashboardFetchDealerLayoutFailedParams>
 */
export function dashboardFetchDealerLayoutFailed(params) {
    return { evid: 1999, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'dashboardUserSeeFeed' event (evid: 20)
 *
 * Event description: whenever a news item is a fully displayed in the newsfeed send a bi-feed so I will be able to know that a user saw the feed
 *
 * @param {dashboardUserSeeFeedParams} params - The parameters for this event
 * @property {GUID} feedId - feed id
 * @property {string} source - the application/CMS that sent the feed. send the application ID.
 * @property {string} url - the link of the action
 * @property {string} view_type - view_type
 * @property {boolean} more3sec - if the item was full displayed for 3 sec or more
 * @property {string} origin - origin
 * @property {GUID} campaignId - unique identifier of CMS items
 * @property {string} title - title of feed
 * @property {string} type - type
 * @property {string} platform - platform
 * @property {GUID} msid - msid
 * @property {boolean} aboveTheFold - was the item full viewed above the fold
 * @property {GUID} feed_id - feed id
 * @return {LogObject<dashboardUserSeeFeedParams>} LogObject<dashboardUserSeeFeedParams>
 */
export function dashboardUserSeeFeed(params) {
    return { evid: 20, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'dashboardTriggersBrowseTriggers' event (evid: 200)
 *
 * Event description: User enter automation bulider (wizard) from scratch
 *
 * @param {dashboardTriggersBrowseTriggersParams} params - The parameters for this event
 * @property {string} page - FT/ browse triggers
 * @property {string} referral_info - indicate which vertical is the dacomponent triggered from
 * @property {string} view_type - view_type
 * @property {string} origin - button, link, header, success creation dialog
 * @property {string} platform - platform
 * @property {GUID} msid - msid
 * @return {LogObject<dashboardTriggersBrowseTriggersParams>} LogObject<dashboardTriggersBrowseTriggersParams>
 */
export function dashboardTriggersBrowseTriggers(params) {
    return { evid: 200, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'mySitesClickInUnableToMoveSitesToTrashDialog' event (evid: 2000)
 *
 * Event description: My Sites - click in Unable to Move Sites to Trash dialog.
 *
 * @param {mySitesClickInUnableToMoveSitesToTrashDialogParams} params - The parameters for this event
 * @property {string} view_type - view_type
 * @property {string} origin - my-sites/dashboard
 * @property {string} cta - the button actual text/ the url actual title (only in english)
 * @property {string} platform - deprecated
 * @property {GUID} msid - the selected site guid, when the action is generic and not related to specific site (exit f.e) send null
 * @property {string} action - cancel/cta
 * @return {LogObject<mySitesClickInUnableToMoveSitesToTrashDialogParams>} LogObject<mySitesClickInUnableToMoveSitesToTrashDialogParams>
 */
export function mySitesClickInUnableToMoveSitesToTrashDialog(params) {
    return { evid: 2000, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'clickingOnQuickActionButtonThreeDots' event (evid: 2001)
 *
 * Event description: Clicking on three dots for more actions
 *
 * @param {clickingOnQuickActionButtonThreeDotsParams} params - The parameters for this event
 * @property {string} view_type - view_type
 * @property {string} origin - origin page ( Invoices Dashboard, Recurring Invoices,Pricing Quotes, Invoice Interface
 * @property {string} platform - OneApp/ Web
 * @property {string} msid - msid
 * @property {GUID} invoice_id - invoice guid
 * @return {LogObject<clickingOnQuickActionButtonThreeDotsParams>} LogObject<clickingOnQuickActionButtonThreeDotsParams>
 */
export function clickingOnQuickActionButtonThreeDots(params) {
    return { evid: 2001, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'tooltipForOwnerApp' event (evid: 2002)
 *
 * Event description: when Tooltip for owner app shown
 *
 * @param {tooltipForOwnerAppParams} params - The parameters for this event
 * @property {string} view_type - view_type
 * @property {string} origin - entry points -analytics/blog
 * @property {string} platform - platform
 * @property {string} hosting - Dashboard/editor/ADI
 * @property {GUID} msid - msid
 * @return {LogObject<tooltipForOwnerAppParams>} LogObject<tooltipForOwnerAppParams>
 */
export function tooltipForOwnerApp(params) {
    return { evid: 2002, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'tooltipForOwnerAppClick' event (evid: 2003)
 *
 * Event description: when click onTooltip for owner app
 *
 * @param {tooltipForOwnerAppClickParams} params - The parameters for this event
 * @property {string} name - cta/close
 * @property {string} view_type - view_type
 * @property {string} platform - platform
 * @property {string} hosting - Dashboard/editor/ADI
 * @property {GUID} msid - msid
 * @return {LogObject<tooltipForOwnerAppClickParams>} LogObject<tooltipForOwnerAppClickParams>
 */
export function tooltipForOwnerAppClick(params) {
    return { evid: 2003, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'downloadModal' event (evid: 2004)
 *
 * Event description: whendownload modal shown
 *
 * @param {downloadModalParams} params - The parameters for this event
 * @property {string} view_type - view_type
 * @property {string} origin - activity tab/mobile app dashboard
 * @property {string} platform - platform
 * @property {string} hosting - Dashboard/editor/ADI
 * @property {GUID} msid - msid
 * @return {LogObject<downloadModalParams>} LogObject<downloadModalParams>
 */
export function downloadModal(params) {
    return { evid: 2004, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'downloadModalClick' event (evid: 2005)
 *
 * Event description: download modal click
 *
 * @param {downloadModalClickParams} params - The parameters for this event
 * @property {string} view_type - view_type
 * @property {string} origin - activity tab/mobile app dashboard
 * @property {string} platform - platform
 * @property {string} hosting - Dashboard/editor/ADI
 * @property {GUID} msid - msid
 * @property {string} action - send_link/learn_how/close
 * @return {LogObject<downloadModalClickParams>} LogObject<downloadModalClickParams>
 */
export function downloadModalClick(params) {
    return { evid: 2005, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'downloadModalSuccessMessage' event (evid: 2006)
 *
 * Event description: download modal success message sent
 *
 * @param {downloadModalSuccessMessageParams} params - The parameters for this event
 * @property {string} view_type - view_type
 * @property {string} origin - origin
 * @property {string} platform - platform
 * @property {string} hosting - Dashboard/editor/ADI
 * @property {GUID} msid - msid
 * @return {LogObject<downloadModalSuccessMessageParams>} LogObject<downloadModalSuccessMessageParams>
 */
export function downloadModalSuccessMessage(params) {
    return { evid: 2006, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'downloadModalErrorMessage' event (evid: 2007)
 *
 * Event description: download modal error message sent
 *
 * @param {downloadModalErrorMessageParams} params - The parameters for this event
 * @property {string} view_type - view_type
 * @property {string} origin - origin
 * @property {string} platform - platform
 * @property {string} hosting - Dashboard/editor/ADI
 * @property {GUID} msid - msid
 * @return {LogObject<downloadModalErrorMessageParams>} LogObject<downloadModalErrorMessageParams>
 */
export function downloadModalErrorMessage(params) {
    return { evid: 2007, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'automationMainTableUserSearchFocusOut' event (evid: 2008)
 *
 * Event description: main table > user search focus out
 *
 * @param {automationMainTableUserSearchFocusOutParams} params - The parameters for this event
 * @property {string} view_type - view_type
 * @property {string} searchText - the text the user search for
 * @property {string} platform - platform
 * @property {number} numOfResults - number of results the user get
 * @property {GUID} msid - msid
 * @return {LogObject<automationMainTableUserSearchFocusOutParams>} LogObject<automationMainTableUserSearchFocusOutParams>
 */
export function automationMainTableUserSearchFocusOut(params) {
    return { evid: 2008, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'automationHomePageAutomationTablePreviewAutomation' event (evid: 2009)
 *
 * Event description: Automation > home page - automation table - preview automation
 * the user clicked on the 'preview' button to clicked on item in the automation table
 *
 * @param {automationHomePageAutomationTablePreviewAutomationParams} params - The parameters for this event
 * @property {string} view_type - view_type
 * @property {boolean} preinstalled - true or false
 * @property {string} origin - where from the user clicked
 * @property {string} status - automation current status
 * @property {string} type - where the user clicked: ‘button’ / ‘click on row’
 * @property {string} platform - platform
 * @property {GUID} msid - msid
 * @property {GUID} ruleId - rule_id
 * @return {LogObject<automationHomePageAutomationTablePreviewAutomationParams>} LogObject<automationHomePageAutomationTablePreviewAutomationParams>
 */
export function automationHomePageAutomationTablePreviewAutomation(params) {
    return { evid: 2009, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'dashboardTriggersUseThisTriggerClick' event (evid: 201)
 *
 * Event description: User enter automation bulider (wizard) from automation recipe
 *
 * @param {dashboardTriggersUseThisTriggerClickParams} params - The parameters for this event
 * @property {string} section_name - section_name
 * @property {string} multistep - multistep if it's multistep, null if not
 * @property {string} recipe_name - recipe name
 * @property {string} originUrl - originUrl
 * @property {string} referral_info - indicate which vertical is the dacomponent triggered from
 * @property {string} view_type - view_type
 * @property {string} group_name - group name of recommended triggers
 * @property {string} origin - origin page
 * @property {string} platform - platform
 * @property {GUID} msid - msid
 * @return {LogObject<dashboardTriggersUseThisTriggerClickParams>} LogObject<dashboardTriggersUseThisTriggerClickParams>
 */
export function dashboardTriggersUseThisTriggerClick(params) {
    return { evid: 201, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'automationsOpenGoogleSheetFromAutomation' event (evid: 2010)
 *
 * Event description: Automations > open google sheet from automation
 *
 * @param {automationsOpenGoogleSheetFromAutomationParams} params - The parameters for this event
 * @property {string} recipe_name - recipe name
 * @property {string} view_type - view_type
 * @property {GUID} rule_id - if this trigger all ready customized, null if it first time customization
 * @property {string} origin - from where this action was called
 * @property {string} platform - platform
 * @property {GUID} msid - msid
 * @return {LogObject<automationsOpenGoogleSheetFromAutomationParams>} LogObject<automationsOpenGoogleSheetFromAutomationParams>
 */
export function automationsOpenGoogleSheetFromAutomation(params) {
    return { evid: 2010, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'automationAnAutomationErrorMessageIsDisplayed' event (evid: 2012)
 *
 * Event description: an automation error message is displayed (example: automation disconnect, on hold etc.)
 *
 * @param {automationAnAutomationErrorMessageIsDisplayedParams} params - The parameters for this event
 * @property {string} view_type - view_type
 * @property {GUID} rule_id - if this trigger all ready customized, null if it first time customization
 * @property {string} errorType - which error the user see
 * @property {string} origin - origin which this action was made
 * @property {string} status - 'active’ / ‘suspended’
 * @property {string} platform - platform
 * @property {GUID} msid - msid
 * @return {LogObject<automationAnAutomationErrorMessageIsDisplayedParams>} LogObject<automationAnAutomationErrorMessageIsDisplayedParams>
 */
export function automationAnAutomationErrorMessageIsDisplayed(params) {
    return { evid: 2012, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'automationUserClickOnAutomationErrorMessage' event (evid: 2013)
 *
 * Event description: User click on the automation error  (example: 'fix automation', 'learn more' etc.)
 *
 * @param {automationUserClickOnAutomationErrorMessageParams} params - The parameters for this event
 * @property {string} buttonType - button_type
 * @property {string} view_type - view_type
 * @property {GUID} rule_id - if this trigger all ready customized, null if it first time customization
 * @property {string} errorType - which error the user see
 * @property {string} origin - origin which this action was made
 * @property {string} status - 'active’ / ‘suspended’
 * @property {string} platform - platform
 * @property {GUID} msid - msid
 * @return {LogObject<automationUserClickOnAutomationErrorMessageParams>} LogObject<automationUserClickOnAutomationErrorMessageParams>
 */
export function automationUserClickOnAutomationErrorMessage(params) {
    return { evid: 2013, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'automationUserCloseSidebarPanel' event (evid: 2014)
 *
 * Event description: Automation > user close sidebar panel
 *
 * @param {automationUserCloseSidebarPanelParams} params - The parameters for this event
 * @property {string} view_type - view_type
 * @property {string} origin - page
 * @property {string} platform - platform
 * @property {GUID} msid - msid
 * @property {string} sidebar - sidebar
 * @return {LogObject<automationUserCloseSidebarPanelParams>} LogObject<automationUserCloseSidebarPanelParams>
 */
export function automationUserCloseSidebarPanel(params) {
    return { evid: 2014, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'dashboardTriggersCustomizeTheTriggerValueChangeValueChange' event (evid: 205)
 *
 * Event description: customize the timing value (scheduled field and frequency field)
 *
 * @param {dashboardTriggersCustomizeTheTriggerValueChangeValueChangeParams} params - The parameters for this event
 * @property {number} delay - timing
 * @property {string} flowType - flow in which the save happens: {create, edit}
 * @property {string} recipe_name - recipe name
 * @property {string} view_type - view_type
 * @property {GUID} rule_id - if this trigger all ready customized, null if it first time customization
 * @property {string} section - which section the user changed
 * @property {string} units - units
 * @property {string} platform - platform
 * @property {GUID} msid - msid
 * @property {string} value - value of rule
 * @property {number} index - index for drip campaign
 * @return {LogObject<dashboardTriggersCustomizeTheTriggerValueChangeValueChangeParams>} LogObject<dashboardTriggersCustomizeTheTriggerValueChangeValueChangeParams>
 */
export function dashboardTriggersCustomizeTheTriggerValueChangeValueChange(params) {
    return { evid: 205, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'dashboardTriggersReachStepCustomizeTheTrigger' event (evid: 206)
 *
 * Event description: open/close choose a trigger section in automation wizard.  some scenario opens it automatically (is_auto=true)
 *
 * @param {dashboardTriggersReachStepCustomizeTheTriggerParams} params - The parameters for this event
 * @property {string} flowType - edit or create
 * @property {string} recipe_name - recipe name
 * @property {string} view_type - view_type
 * @property {GUID} rule_id - if this trigger all ready customized, null if it first time customization
 * @property {boolean} is_auto - window opens automatically/manually
 * @property {string} origin - deprecated
 * @property {string} platform - platform
 * @property {GUID} msid - msid
 * @property {string} action - open/close - which action the user did
 * @property {number} index - index for drip campaign
 * @return {LogObject<dashboardTriggersReachStepCustomizeTheTriggerParams>} LogObject<dashboardTriggersReachStepCustomizeTheTriggerParams>
 */
export function dashboardTriggersReachStepCustomizeTheTrigger(params) {
    return { evid: 206, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'dashboardTriggersReachStepCustomizeTheAction' event (evid: 207)
 *
 * Event description: open/close choose action section in automation wizard. some scenario opens it automatically (is_auto=true)
 *
 * @param {dashboardTriggersReachStepCustomizeTheActionParams} params - The parameters for this event
 * @property {string} flowType - flow in which the save happens: {create, edit}
 * @property {string} recipe_name - recipe name
 * @property {string} view_type - view_type
 * @property {GUID} rule_id - if this trigger already customized, null if it first time customization
 * @property {boolean} is_auto - window opens automatically/manually
 * @property {string} origin - deprecated
 * @property {string} platform - platform
 * @property {GUID} msid - msid
 * @property {string} action - open/close - which action the user did
 * @property {number} index - the action number when multi action
 * @return {LogObject<dashboardTriggersReachStepCustomizeTheActionParams>} LogObject<dashboardTriggersReachStepCustomizeTheActionParams>
 */
export function dashboardTriggersReachStepCustomizeTheAction(params) {
    return { evid: 207, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'dashboardTriggersReachStepSaveAndActivates' event (evid: 208)
 *
 * Event description: open/close timming section in automation wizard
 *
 * @param {dashboardTriggersReachStepSaveAndActivatesParams} params - The parameters for this event
 * @property {string} flowType - flow in which the save happens: {create, edit}
 * @property {string} recipe_name - recipe name
 * @property {string} view_type - view_type
 * @property {GUID} rule_id - if this trigger all ready customized, null if it first time customization
 * @property {boolean} is_auto - window opens automatically/manually
 * @property {string} origin - deprecated
 * @property {string} triggerApp - trigger vertical / app / TPA
 * @property {string} platform - platform
 * @property {GUID} msid - msid
 * @property {string} action - open/close - which action the user did
 * @property {string} triggerName - triggerName
 * @property {number} index - the action number when multi action
 * @return {LogObject<dashboardTriggersReachStepSaveAndActivatesParams>} LogObject<dashboardTriggersReachStepSaveAndActivatesParams>
 */
export function dashboardTriggersReachStepSaveAndActivates(params) {
    return { evid: 208, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'dashboardTriggersSaveOrUpdateTrigger' event (evid: 209)
 *
 * Event description: Name your recipe click
 *
 * @param {dashboardTriggersSaveOrUpdateTriggerParams} params - The parameters for this event
 * @property {string} flowType - flow in which the save happens: {create, edit}
 * @property {string} trigger_activity_type - 'Members Area' / 'Contact Form' / 'Price Quotes' / 'Wix Forms' / ...
 * @property {string} recipe_name - recipe name
 * @property {string} referral_info - indicate which vertical is the dacomponent triggered from
 * @property {string} view_type - view_type
 * @property {GUID} rule_id - if this trigger already customized, null if it first time customization
 * @property {boolean} is_suspended - will be suspended if user don't has Ascend and already has 3 active rules
 * @property {string} action_service_name - 'Send email to visitors' / 'Send a chat message' / 'Create a task' / ....
 * @property {string} condition - condition
 * @property {string} units - units of rule
 * @property {string} platform - platform
 * @property {GUID} msid - msid
 * @property {string} value - value of rule
 * @property {string} custom_name - automation name
 * @return {LogObject<dashboardTriggersSaveOrUpdateTriggerParams>} LogObject<dashboardTriggersSaveOrUpdateTriggerParams>
 */
export function dashboardTriggersSaveOrUpdateTrigger(params) {
    return { evid: 209, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'dashboardSiteNewsFilter' event (evid: 21)
 *
 * Event description: dashboard > site -> news -> filter.
 *
 * @param {dashboardSiteNewsFilterParams} params - The parameters for this event
 * @property {string} name - name
 * @property {string} location - location
 * @property {string} view_type - view_type
 * @property {string} origin - origin
 * @property {string} type - type
 * @property {string} platform - platform
 * @property {string} filter_type - filter_type
 * @property {GUID} msid - msid
 * @return {LogObject<dashboardSiteNewsFilterParams>} LogObject<dashboardSiteNewsFilterParams>
 */
export function dashboardSiteNewsFilter(params) {
    return { evid: 21, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'dashboardTriggersInactivateActivateTrigger' event (evid: 211)
 *
 * Event description: Inactivate /Activate trigger
 *
 * @param {dashboardTriggersInactivateActivateTriggerParams} params - The parameters for this event
 * @property {boolean} isPreinstalled - if the automation was pre installed, null = false
 * @property {string} recipe_name - recipe name
 * @property {string} view_type - view_type
 * @property {GUID} rule_id - if this trigger all ready customized, null if it first time customization
 * @property {string} origin - origin which this action was made
 * @property {string} status - new status
 * @property {string} platform - platform
 * @property {GUID} msid - msid
 * @return {LogObject<dashboardTriggersInactivateActivateTriggerParams>} LogObject<dashboardTriggersInactivateActivateTriggerParams>
 */
export function dashboardTriggersInactivateActivateTrigger(params) {
    return { evid: 211, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'dashboardTriggersStep1TriggerSelected' event (evid: 212)
 *
 * Event description: selecting visitor action trigger
 *
 * @param {dashboardTriggersStep1TriggerSelectedParams} params - The parameters for this event
 * @property {string} flowType - flow in which the save happens: {create, edit}
 * @property {string} recipe_name - recipe name
 * @property {string} event_name - trigger key
 * @property {string} view_type - view_type
 * @property {GUID} rule_id - if this trigger all ready customized, null if it first time customization
 * @property {string} platform - platform
 * @property {GUID} msid - msid
 * @return {LogObject<dashboardTriggersStep1TriggerSelectedParams>} LogObject<dashboardTriggersStep1TriggerSelectedParams>
 */
export function dashboardTriggersStep1TriggerSelected(params) {
    return { evid: 212, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'dashboardTriggersEditTriggerClick' event (evid: 213)
 *
 * Event description: Edit Automation rule Click
 *
 * @param {dashboardTriggersEditTriggerClickParams} params - The parameters for this event
 * @property {boolean} isPreinstalled - isPreinstalled
 * @property {string} ruleName - ruleName
 * @property {GUID} configurationId - configurationId
 * @property {string} recipe_name - recipe name
 * @property {string} view_type - view_type
 * @property {GUID} rule_id - if this trigger all ready customized, null if it first time customization
 * @property {string} origin - from where this action was called
 * @property {string} platform - platform
 * @property {boolean} isMultiStep - isMultiStep
 * @property {GUID} msid - msid
 * @property {GUID} automationId - automation_id
 * @property {string} automationName - automation name
 * @return {LogObject<dashboardTriggersEditTriggerClickParams>} LogObject<dashboardTriggersEditTriggerClickParams>
 */
export function dashboardTriggersEditTriggerClick(params) {
    return { evid: 213, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'dashboardTriggersAlertDeleteOpen' event (evid: 214)
 *
 * Event description:  Alert delete open
 *
 * @param {dashboardTriggersAlertDeleteOpenParams} params - The parameters for this event
 * @property {string} recipe_name - recipe name
 * @property {string} view_type - view_type
 * @property {GUID} rule_id - if this trigger all ready customized, null if it first time customization
 * @property {string} origin - (e.g: 'Forms') from where this action was called
 * @property {string} platform - platform
 * @property {GUID} msid - msid
 * @return {LogObject<dashboardTriggersAlertDeleteOpenParams>} LogObject<dashboardTriggersAlertDeleteOpenParams>
 */
export function dashboardTriggersAlertDeleteOpen(params) {
    return { evid: 214, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'dashboardTriggersDelete' event (evid: 216)
 *
 * Event description: Delete
 *
 * @param {dashboardTriggersDeleteParams} params - The parameters for this event
 * @property {string} recipe_name - recipe name
 * @property {string} view_type - view_type
 * @property {GUID} rule_id - rule_id
 * @property {string} origin - all triggers / create trigger
 * @property {string} platform - platform
 * @property {GUID} msid - msid
 * @return {LogObject<dashboardTriggersDeleteParams>} LogObject<dashboardTriggersDeleteParams>
 */
export function dashboardTriggersDelete(params) {
    return { evid: 216, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'dashboardSettingsUpdate' event (evid: 22)
 *
 * Event description: dashboard > settings -> update.
 *
 * @param {dashboardSettingsUpdateParams} params - The parameters for this event
 * @property {string} name - settings section name
 * @property {string} view_type - view_type
 * @property {string} providerId - social provider for enable/disable social actions (facebook/google)
 * @property {string} click_from - security box/main page
 * @property {string} origin - button/description (only for 'edit password' - where did the user click)
 * @property {string} platform - platform
 * @property {GUID} msid - msid
 * @property {string} value - deprecated
 * @return {LogObject<dashboardSettingsUpdateParams>} LogObject<dashboardSettingsUpdateParams>
 */
export function dashboardSettingsUpdate(params) {
    return { evid: 22, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'dashboardTriggersStep2ActionSelected' event (evid: 224)
 *
 * Event description: selecting an action for trigger
 *
 * @param {dashboardTriggersStep2ActionSelectedParams} params - The parameters for this event
 * @property {string} flowType - flow in which the save happens: {create, edit}
 * @property {string} recipe_name - recipe name
 * @property {string} event_name - name of event (action)
 * @property {string} view_type - view_type
 * @property {GUID} rule_id - if this trigger all ready customized, null if it first time customization
 * @property {string} platform - platform
 * @property {GUID} msid - msid
 * @property {number} index - number of action
 * @return {LogObject<dashboardTriggersStep2ActionSelectedParams>} LogObject<dashboardTriggersStep2ActionSelectedParams>
 */
export function dashboardTriggersStep2ActionSelected(params) {
    return { evid: 224, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'automationsDialogShowClick' event (evid: 226)
 *
 * Event description: showing/clicking a dialog (alert popup) under Automations
 *
 * @param {automationsDialogShowClickParams} params - The parameters for this event
 * @property {string} name - name of dialog: {leave, creation success}
 * @property {string} flowType - flow in which the dialog is shown: {create, edit}
 * @property {string} recipe_name - recipe name
 * @property {string} view_type - view_type
 * @property {GUID} rule_id - the rule_id that the user started/edited
 * @property {string} platform - platform
 * @property {GUID} msid - msid
 * @property {string} action - name of action: {show, approve, cancel ; create new, all automations}
 * @return {LogObject<automationsDialogShowClickParams>} LogObject<automationsDialogShowClickParams>
 */
export function automationsDialogShowClick(params) {
    return { evid: 226, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'automationsClientError' event (evid: 227)
 *
 * Event description: error in automations in creation flow (and created by the user). errors: in trigger in action etc
 *
 * @param {automationsClientErrorParams} params - The parameters for this event
 * @property {string} desc - more details about the error (e.g. which fields are causing the error)
 * @property {string} name - name of error: {missingInfo}
 * @property {boolean} withTriggersCatalog - withTriggersCatalog
 * @property {string} action_name - in case the step is "action", in which action the error is: {email to visitors, email to owner, chat message}
 * @property {string} flowType - flow in which the dialog is shown: {create, edit}
 * @property {string} phase_name - which step in the automation flow: {trigger type, action, timing}
 * @property {string} recipe_name - recipe name
 * @property {string} view_type - view_type
 * @property {GUID} rule_id - the rule_id that the user started/edited
 * @property {string} platform - platform
 * @property {GUID} msid - msid
 * @property {number} index - index for drip campaign
 * @return {LogObject<automationsClientErrorParams>} LogObject<automationsClientErrorParams>
 */
export function automationsClientError(params) {
    return { evid: 227, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'automationsEditAutomationSTitle' event (evid: 228)
 *
 * Event description: editing the title of the automation
 *
 * @param {automationsEditAutomationSTitleParams} params - The parameters for this event
 * @property {string} flowType - flow in which the dialog is shown: {create, edit}
 * @property {string} recipe_name - recipe name
 * @property {string} view_type - view_type
 * @property {GUID} rule_id - the rule_id that the user started/edited
 * @property {string} platform - platform
 * @property {GUID} msid - msid
 * @return {LogObject<automationsEditAutomationSTitleParams>} LogObject<automationsEditAutomationSTitleParams>
 */
export function automationsEditAutomationSTitle(params) {
    return { evid: 228, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'automationsChooseTimePhaseToggle' event (evid: 229)
 *
 * Event description: change the "send one per contact" toggle
 *
 * @param {automationsChooseTimePhaseToggleParams} params - The parameters for this event
 * @property {string} name - {sendOncePerContact}
 * @property {string} flowType - flow {create, edit}
 * @property {string} recipe_name - recipe name
 * @property {string} view_type - view_type
 * @property {GUID} rule_id - the rule_id that the user started/edited
 * @property {string} platform - platform
 * @property {GUID} msid - msid
 * @return {LogObject<automationsChooseTimePhaseToggleParams>} LogObject<automationsChooseTimePhaseToggleParams>
 */
export function automationsChooseTimePhaseToggle(params) {
    return { evid: 229, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'dashboardTpaUpgradeClick' event (evid: 23)
 *
 * Event description: dashboard > tpa upgrade click.
 *
 * @param {dashboardTpaUpgradeClickParams} params - The parameters for this event
 * @property {string} view_type - view_type
 * @property {string} origin - origin
 * @property {GUID} app_id - app_id
 * @property {string} platform - platform
 * @property {GUID} msid - msid
 * @return {LogObject<dashboardTpaUpgradeClickParams>} LogObject<dashboardTpaUpgradeClickParams>
 */
export function dashboardTpaUpgradeClick(params) {
    return { evid: 23, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'automationsClickOnAutomationsTabs' event (evid: 230)
 *
 * Event description: User click on Automations tabs
 *
 * @param {automationsClickOnAutomationsTabsParams} params - The parameters for this event
 * @property {string} tab_name - {my_automations,recommended}
 * @property {string} view_type - view_type
 * @property {string} previous_tab - {my_automations,recommended}
 * @property {string} platform - platform
 * @property {GUID} msid - msid
 * @return {LogObject<automationsClickOnAutomationsTabsParams>} LogObject<automationsClickOnAutomationsTabsParams>
 */
export function automationsClickOnAutomationsTabs(params) {
    return { evid: 230, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'automationsPriceQuotesInvoicesSendFeedbackForm' event (evid: 232)
 *
 * Event description: user click on Send Feedback
 *
 * @param {automationsPriceQuotesInvoicesSendFeedbackFormParams} params - The parameters for this event
 * @property {string} view_type - view_type
 * @property {string} origin - {automations, price quotes, invoices}
 * @property {string} platform - platform
 * @property {GUID} msid - msid
 * @return {LogObject<automationsPriceQuotesInvoicesSendFeedbackFormParams>} LogObject<automationsPriceQuotesInvoicesSendFeedbackFormParams>
 */
export function automationsPriceQuotesInvoicesSendFeedbackForm(params) {
    return { evid: 232, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'automationsPriceQuotesInvoicesSubmitFeedbackForm' event (evid: 233)
 *
 * Event description: user click Submit Feedback Form
 *
 * @param {automationsPriceQuotesInvoicesSubmitFeedbackFormParams} params - The parameters for this event
 * @property {string} view_type - view_type
 * @property {string} origin - {automations, price quotes, invoices}
 * @property {string} platform - platform
 * @property {GUID} msid - msid
 * @return {LogObject<automationsPriceQuotesInvoicesSubmitFeedbackFormParams>} LogObject<automationsPriceQuotesInvoicesSubmitFeedbackFormParams>
 */
export function automationsPriceQuotesInvoicesSubmitFeedbackForm(params) {
    return { evid: 233, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'dashboardSiteSelectorLoaded' event (evid: 24)
 *
 * Event description: dashboard > site selector loaded successfully.
 *
 * @param {dashboardSiteSelectorLoadedParams} params - The parameters for this event
 * @property {string} filtered - premium/published/adi / none
 * @property {boolean} is_partner_dashboard - true - if partner dashboard displayed
 * @property {string} sitePublished - publish_status
 * @property {string} selectionType - single / multi
 * @property {string} view_type - view_type
 * @property {number} account_sites_number - absolute account sites number
 * @property {string} referral - referral
 * @property {number} loadingTime - in ms
 * @property {string} status - no thumbnails / empty state / success
 * @property {string} siteType - HtmlWeb / modal
 * @property {number} site_type_enriched - site_type
 * @property {string} platform - platform
 * @property {number} sites_count - # sites returned to site selector
 * @property {string} device - mobile / desktop
 * @return {LogObject<dashboardSiteSelectorLoadedParams>} LogObject<dashboardSiteSelectorLoadedParams>
 */
export function dashboardSiteSelectorLoaded(params) {
    return { evid: 24, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'automationsNewHomeBannerLoadingEnd' event (evid: 242)
 *
 * Event description: All data when opening automation after banner
 *
 * @param {automationsNewHomeBannerLoadingEndParams} params - The parameters for this event
 * @property {string} view_type - view_type
 * @property {string} jsonData - json
 * @property {string} platform - platform
 * @property {GUID} msid - msid
 * @return {LogObject<automationsNewHomeBannerLoadingEndParams>} LogObject<automationsNewHomeBannerLoadingEndParams>
 */
export function automationsNewHomeBannerLoadingEnd(params) {
    return { evid: 242, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'quotesPrintInvoice' event (evid: 245)
 *
 * Event description: Quotes - Print Invoice
 *
 * @param {quotesPrintInvoiceParams} params - The parameters for this event
 * @property {string} paymentType - 'Recurring','One Time'
 * @property {string} view_type - view_type
 * @property {string} origin - customer for UoU, my invoices for users
 * @property {string} platform - platform
 * @property {string} msid - msid
 * @property {GUID} invoice_id - invoice guid
 * @return {LogObject<quotesPrintInvoiceParams>} LogObject<quotesPrintInvoiceParams>
 */
export function quotesPrintInvoice(params) {
    return { evid: 245, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'quotesPayInvoiceClickSrc5Evid246' event (evid: 246)
 *
 * Event description: Quotes - Pay Invoice Click
 *
 * @param {quotesPayInvoiceClickSrc5Evid246Params} params - The parameters for this event
 * @property {string} paymentType - 'Recurring','One Time'
 * @property {string} view_type - view_type
 * @property {string} origin - customer for UoU, my invoices for users
 * @property {string} platform - platform
 * @property {string} msid - msid
 * @property {GUID} invoice_id - invoice guid
 * @return {LogObject<quotesPayInvoiceClickSrc5Evid246Params>} LogObject<quotesPayInvoiceClickSrc5Evid246Params>
 */
export function quotesPayInvoiceClickSrc5Evid246(params) {
    return { evid: 246, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'automationsShowStatisticsClick' event (evid: 247)
 *
 * Event description: Automations > Show Statistics Click
 *
 * @param {automationsShowStatisticsClickParams} params - The parameters for this event
 * @property {string} ruleName - ruleName
 * @property {string} view_type - view_type
 * @property {GUID} rule_id - if this trigger all ready customized, null if it first time customization
 * @property {string} origin - (e.g: 'Forms') from where this action was called
 * @property {string} platform - platform
 * @property {GUID} msid - msid
 * @return {LogObject<automationsShowStatisticsClickParams>} LogObject<automationsShowStatisticsClickParams>
 */
export function automationsShowStatisticsClick(params) {
    return { evid: 247, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'automationsRenameTriggerClick' event (evid: 249)
 *
 * Event description: User clicked on rename automation (before the actual rename)
 *
 * @param {automationsRenameTriggerClickParams} params - The parameters for this event
 * @property {string} view_type - view_type
 * @property {GUID} rule_id - if this trigger all ready customized, null if it first time customization
 * @property {string} origin - (e.g: 'Forms') from where this action was called
 * @property {string} platform - platform
 * @property {GUID} msid - msid
 * @return {LogObject<automationsRenameTriggerClickParams>} LogObject<automationsRenameTriggerClickParams>
 */
export function automationsRenameTriggerClick(params) {
    return { evid: 249, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'dashboardSiteSelectorButton' event (evid: 25)
 *
 * Event description: dashboard > site selector click.
 *
 * @param {dashboardSiteSelectorButtonParams} params - The parameters for this event
 * @property {string} filtered - premium/published/adi / none
 * @property {number} positionIndex - the index of the selected site position in the site selector
 * @property {GUID} site_id - site_id
 * @property {boolean} is_partner_dashboard - true - if partner dashboard chosen
 * @property {string} result - json of all chosen msid separated with comma
 * @property {string} selectionType - single / multi
 * @property {string} view_type - view_type
 * @property {string} siteTypeName - ADI/Editor
 * @property {Url} action_url - action_url
 * @property {string} referral - referral URL
 * @property {string} siteType - HtmlWeb / modal
 * @property {number} sites_number - the number of sites available in site selector (not necessarily equal to number of sites owned)
 * @property {string} cta - x / cancel / continue
 * @property {number} position - The position of the selected site in the page. 1 is the highest site.
 * @property {number} site_type_enriched - site_type
 * @property {GUID} esi - esi
 * @property {string} platform - deprecated
 * @property {GUID} msid - msid
 * @property {number} sites_count - how many sites were chosen
 * @property {string} device - mobile / desktop
 * @return {LogObject<dashboardSiteSelectorButtonParams>} LogObject<dashboardSiteSelectorButtonParams>
 */
export function dashboardSiteSelectorButton(params) {
    return { evid: 25, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'homeClickNotificationCta' event (evid: 250)
 *
 * Event description: user clicks on a notification and opens app (test)
 *
 * @param {homeClickNotificationCtaParams} params - The parameters for this event
 * @property {GUID} app_id - app that sent the notification
 * @property {string} app_def_id - app that sent the notification
 * @property {string} view_type - view_type
 * @property {string} activity_type - the notification / activity type
 * @property {GUID} notification_id - notification id
 * @property {number} num_of_new - number of new notifications - number in badge
 * @property {string} platform - platform
 * @property {GUID} msid - msid
 * @return {LogObject<homeClickNotificationCtaParams>} LogObject<homeClickNotificationCtaParams>
 */
export function homeClickNotificationCta(params) {
    return { evid: 250, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'homeMarkNotificationUnread' event (evid: 251)
 *
 * Event description: user clicks on mark as unread
 *
 * @param {homeMarkNotificationUnreadParams} params - The parameters for this event
 * @property {string} view_type - view_type
 * @property {GUID} notification_id - notification id
 * @property {string} app_id - app that sent the notification
 * @property {string} platform - platform
 * @property {GUID} msid - msid
 * @return {LogObject<homeMarkNotificationUnreadParams>} LogObject<homeMarkNotificationUnreadParams>
 */
export function homeMarkNotificationUnread(params) {
    return { evid: 251, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'homeMarkNotificationRead' event (evid: 252)
 *
 * Event description: user clicks on mark as read
 *
 * @param {homeMarkNotificationReadParams} params - The parameters for this event
 * @property {string} view_type - view_type
 * @property {string} activity_type - activity type - not sent
 * @property {string} notification_id - notification id
 * @property {string} app_id - app that sent the notification
 * @property {string} platform - platform
 * @property {string} msid - msid
 * @return {LogObject<homeMarkNotificationReadParams>} LogObject<homeMarkNotificationReadParams>
 */
export function homeMarkNotificationRead(params) {
    return { evid: 252, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'homeMarkAllUnreadNotifications' event (evid: 253)
 *
 * Event description: user clicks mark all unread
 *
 * @param {homeMarkAllUnreadNotificationsParams} params - The parameters for this event
 * @property {string} channel - Web / browser / mobile / SMS / email
 * @property {string} view_type - view_type
 * @property {string} notification_ids - all notifications that were marked as read in the page ( separated with a comma)
 * @property {string} origin - MSID of the site the user is on, my-sites if on Site List. Later on, also account-settings, and other account-level pages.
 * @property {number} num_of_unread - number of unread messages
 * @property {string} platform - platform
 * @property {string} msid - deprecated
 * @return {LogObject<homeMarkAllUnreadNotificationsParams>} LogObject<homeMarkAllUnreadNotificationsParams>
 */
export function homeMarkAllUnreadNotifications(params) {
    return { evid: 253, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'homeNotificationBadgeShown' event (evid: 254)
 *
 * Event description: a badge with new notifications/ urgent notifications is shown to the user
 *
 * @param {homeNotificationBadgeShownParams} params - The parameters for this event
 * @property {string} view_type - view_type
 * @property {boolean} on_page_load - true if sent on page load
 * @property {string} origin - MSID of the site the user is on, my-sites if on Site List. Later on, also account-settings, and other account-level pages.
 * @property {number} num_of_new - number of new notifications - number in badge
 * @property {string} platform - platform
 * @property {string} msid - deprecated
 * @return {LogObject<homeNotificationBadgeShownParams>} LogObject<homeNotificationBadgeShownParams>
 */
export function homeNotificationBadgeShown(params) {
    return { evid: 254, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'homeAllowBlockBrowserNotificationClick' event (evid: 255)
 *
 * Event description: User clicks on Allow/Block browser notification setting
 *
 * @param {homeAllowBlockBrowserNotificationClickParams} params - The parameters for this event
 * @property {string} view_type - view_type
 * @property {string} user_reply - allow/block/dismiss
 * @property {string} platform - platform
 * @property {string} msid - msid
 * @return {LogObject<homeAllowBlockBrowserNotificationClickParams>} LogObject<homeAllowBlockBrowserNotificationClickParams>
 */
export function homeAllowBlockBrowserNotificationClick(params) {
    return { evid: 255, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'notificationsClickOnAllSitesTab' event (evid: 256)
 *
 * Event description: User clicks navigated between all site / this site tabs
 *
 * @param {notificationsClickOnAllSitesTabParams} params - The parameters for this event
 * @property {string} feed_name - on which tab did he clicked
 * @property {string} tab_name - deprecated
 * @property {string} view_type - view_type
 * @property {string} origin - MSID of the site the user is on, my-sites if on Site List. Later on, also account-settings, and other account-level pages.
 * @property {string} platform - platform
 * @property {string} msid - deprecated
 * @property {string} view - deprecated
 * @return {LogObject<notificationsClickOnAllSitesTabParams>} LogObject<notificationsClickOnAllSitesTabParams>
 */
export function notificationsClickOnAllSitesTab(params) {
    return { evid: 256, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'dashboardEnterEditorx' event (evid: 257)
 *
 * Event description: user enters EditorX from different origins (site_list_top, site_list_bottom, top_bar, account_templates)
 *
 * @param {dashboardEnterEditorxParams} params - The parameters for this event
 * @property {string} view_type - view_type
 * @property {string} origin - the location of the button e.g. my-sites top button
 * @property {string} platform - platform
 * @return {LogObject<dashboardEnterEditorxParams>} LogObject<dashboardEnterEditorxParams>
 */
export function dashboardEnterEditorx(params) {
    return { evid: 257, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'automationsMoreActionsClick' event (evid: 258)
 *
 * Event description: user click on the 3 dots icon in automation home page (BM)
 *
 * @param {automationsMoreActionsClickParams} params - The parameters for this event
 * @property {string} page - not relevant anymore
 * @property {string} view_type - view_type
 * @property {string} platform - platform
 * @property {GUID} msid - msid
 * @return {LogObject<automationsMoreActionsClickParams>} LogObject<automationsMoreActionsClickParams>
 */
export function automationsMoreActionsClick(params) {
    return { evid: 258, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'dashboardQuickActionsDragNDrop' event (evid: 26)
 *
 * Event description: dashboard > quick actions drag'N'drop.
 *
 * @param {dashboardQuickActionsDragNDropParams} params - The parameters for this event
 * @property {number} duration - ts
 * @property {string} name - name
 * @property {string} view_type - view_type
 * @property {string} direction - direction
 * @property {boolean} isToTopSix - is_to_top_six
 * @property {number} to - to
 * @property {boolean} isFromTopSix - is_from_top_six
 * @property {number} from - from
 * @property {string} platform - platform
 * @property {GUID} msid - msid
 * @return {LogObject<dashboardQuickActionsDragNDropParams>} LogObject<dashboardQuickActionsDragNDropParams>
 */
export function dashboardQuickActionsDragNDrop(params) {
    return { evid: 26, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'notificationNotificationAutomationCreated' event (evid: 269)
 *
 * Event description: Notification that was created by Automations
 *
 * @param {notificationNotificationAutomationCreatedParams} params - The parameters for this event
 * @property {string} channels - Web / browser / mobile / SMS / email- multiple channels
 * @property {string} channel - deprecated
 * @property {string} recipients_type - all contributors / owner
 * @property {string} view_type - view_type
 * @property {string} platform - platform
 * @property {GUID} msid - msid
 * @return {LogObject<notificationNotificationAutomationCreatedParams>} LogObject<notificationNotificationAutomationCreatedParams>
 */
export function notificationNotificationAutomationCreated(params) {
    return { evid: 269, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'dashboardClickOnSideBar' event (evid: 27)
 *
 * Event description: dashboard > click on side bar.
 *
 * @param {dashboardClickOnSideBarParams} params - The parameters for this event
 * @property {string} name - origin
 * @property {string} view_type - view_type
 * @property {string} platform - platform
 * @property {GUID} msid - msid
 * @return {LogObject<dashboardClickOnSideBarParams>} LogObject<dashboardClickOnSideBarParams>
 */
export function dashboardClickOnSideBar(params) {
    return { evid: 27, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'invoicesClickOnSendInvoiceButton' event (evid: 270)
 *
 * Event description: Click on the 'send invoice' button (before the actual sending), the event is triggered also when the invoice form is not valid, please use is_valid field
 *
 * @param {invoicesClickOnSendInvoiceButtonParams} params - The parameters for this event
 * @property {GUID} instanceId - instance_id
 * @property {number} totalAmountLong - Total amount of the invoice, INTEGER multiplied by 100,000
 * @property {boolean} createOrder - create order?
 * @property {boolean} isValid - is the invoice form valid
 * @property {GUID} uuid - uuid
 * @property {string} paymentType - 'one time','recurring'
 * @property {string} view_type - view_type
 * @property {GUID} invoiceId - invoice_guid
 * @property {string} origin - create invoice, edit invoice
 * @property {string} status - Creation form/Draft/Sent/Paid
 * @property {string} currency - currency
 * @property {string} platform - platform
 * @property {GUID} msid - msid
 * @return {LogObject<invoicesClickOnSendInvoiceButtonParams>} LogObject<invoicesClickOnSendInvoiceButtonParams>
 */
export function invoicesClickOnSendInvoiceButton(params) {
    return { evid: 270, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'notificationShowNotification' event (evid: 271)
 *
 * Event description: user opens the dialog and X notifications are being displayed , after scrolling another event will be sent with a new page number
 *
 * @param {notificationShowNotificationParams} params - The parameters for this event
 * @property {boolean} is_high_priority - true / false
 * @property {string} feed_name - All sites/This site /float
 * @property {string} channel - Web / browser / mobile / SMS / email
 * @property {string} source - where the display was triggered from: site_level / account_level / home_site_level
 * @property {GUID} correlation_id - correlation_id
 * @property {string} view_type - view_type
 * @property {string} notification_ids - all notifications that were shown in the page ( separated with a comma)
 * @property {string} origin - MSID of the site the user is on, my-sites if on Site List. Later on, also account-settings, and other account-level pages.
 * @property {string} mode - online / cashed (in case of no internet)
 * @property {string} correlationId - correlation_id
 * @property {string} contact_id - contact_id guid
 * @property {string} platform - platform
 * @property {string} notificationid - deprecated
 * @property {GUID} msid - msid
 * @property {number} page_number - page number - each page is limited to 30 notifications
 * @return {LogObject<notificationShowNotificationParams>} LogObject<notificationShowNotificationParams>
 */
export function notificationShowNotification(params) {
    return { evid: 271, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'notificationClickOnNotification' event (evid: 272)
 *
 * Event description: user clicks on a notification and opens app (test)
 *
 * @param {notificationClickOnNotificationParams} params - The parameters for this event
 * @property {boolean} is_high_priority - true / false
 * @property {string} feed_name - Sub category of the channel (All Sites/This Site /Float/Oneapp notification center/ mobile os)
 * @property {string} clickOrigin - deprecated
 * @property {string} channel - Web / browser / mobile / SMS / email
 * @property {GUID} correlation_id - correlation_id
 * @property {string} click_type - mark read/mark unread/click/delete
 * @property {string} view_type - view_type
 * @property {string} notification_id - deprecated
 * @property {string} origin - (Msid/my-site) MSID of the site the user is on, my-sites if on Site List. Later on, also account-settings, and other account-level pages.
 * @property {string} correlationId - correlation_id
 * @property {string} contact_id - contact_id
 * @property {string} platform - platform
 * @property {string} notificationid - notificationid
 * @property {GUID} msid - msid of the notification
 * @property {string} deep_link - deep_link
 * @property {string} grouped_notifications - list of notification ids contain in this notification. if the notification is not grouped this field will be null
 * @return {LogObject<notificationClickOnNotificationParams>} LogObject<notificationClickOnNotificationParams>
 */
export function notificationClickOnNotification(params) {
    return { evid: 272, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'notificationsEnableDesktopNotificationsFirstTime' event (evid: 273)
 *
 * Event description: User turned on his desktop notification for the first time for all his sites (actually browser turned on)
 *
 * @param {notificationsEnableDesktopNotificationsFirstTimeParams} params - The parameters for this event
 * @property {string} feed_name - All Sites/This Site / settings
 * @property {string} view_type - view_type
 * @property {string} origin - (Msid/my-site) MSID of the site the user is on, my-sites if on Site List. Later on, also account-settings, and other account-level pages.
 * @property {string} platform - platform
 * @property {string} msid - deprecated
 * @return {LogObject<notificationsEnableDesktopNotificationsFirstTimeParams>} LogObject<notificationsEnableDesktopNotificationsFirstTimeParams>
 */
export function notificationsEnableDesktopNotificationsFirstTime(params) {
    return { evid: 273, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'notificationsPushNotificationToggleIsDisplayed' event (evid: 274)
 *
 * Event description: user clicks the "Allow/ Block " and toggle is displayed
 *
 * @param {notificationsPushNotificationToggleIsDisplayedParams} params - The parameters for this event
 * @property {string} feed_name - All Sites/This Site/ Settings
 * @property {string} view_type - view_type
 * @property {string} origin - (Msid/my-site) MSID of the site the user is on, my-sites if on Site List. Later on, also account-settings, and other account-level pages.
 * @property {string} permission_type - permission
 * @property {string} platform - platform
 * @property {string} msid - deprecated
 * @return {LogObject<notificationsPushNotificationToggleIsDisplayedParams>} LogObject<notificationsPushNotificationToggleIsDisplayedParams>
 */
export function notificationsPushNotificationToggleIsDisplayed(params) {
    return { evid: 274, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'notificationsEnableToTurnOnOffAllSiteNotificationsExperts' event (evid: 275)
 *
 * Event description: expert can enable  / disable all notifications for a specific site
 *
 * @param {notificationsEnableToTurnOnOffAllSiteNotificationsExpertsParams} params - The parameters for this event
 * @property {boolean} toggle - 1- on , 0- off
 * @property {string} view_type - view_type
 * @property {string} platform - platform
 * @property {string} msid - msid
 * @return {LogObject<notificationsEnableToTurnOnOffAllSiteNotificationsExpertsParams>} LogObject<notificationsEnableToTurnOnOffAllSiteNotificationsExpertsParams>
 */
export function notificationsEnableToTurnOnOffAllSiteNotificationsExperts(params) {
    return { evid: 275, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'notificationsEnableToTurnOnOffNotificationsPerChannel' event (evid: 276)
 *
 * Event description: User turned on his desktop notification for the first time for all his sites (actually browser turned on)
 *
 * @param {notificationsEnableToTurnOnOffNotificationsPerChannelParams} params - The parameters for this event
 * @property {string} channel - desktop/email/ sms/ mobile
 * @property {boolean} toggle - 1 - on , 0- off
 * @property {string} view_type - view_type
 * @property {string} section - desktop/general/ wix chat/bookings/...
 * @property {string} platform - platform
 * @property {string} msid - msid
 * @property {string} group - desktop/ contact form/  subscriber/  becomes a member/requests to be a member
 * @return {LogObject<notificationsEnableToTurnOnOffNotificationsPerChannelParams>} LogObject<notificationsEnableToTurnOnOffNotificationsPerChannelParams>
 */
export function notificationsEnableToTurnOnOffNotificationsPerChannel(params) {
    return { evid: 276, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'notificationsShowMobileDialog' event (evid: 277)
 *
 * Event description: allow to enable desktop notifications after clicking on "turn on"
 *
 * @param {notificationsShowMobileDialogParams} params - The parameters for this event
 * @property {string} view_type - view_type
 * @property {boolean} is_installed_oneapp - true , false
 * @property {string} platform - platform
 * @property {string} msid - msid
 * @return {LogObject<notificationsShowMobileDialogParams>} LogObject<notificationsShowMobileDialogParams>
 */
export function notificationsShowMobileDialog(params) {
    return { evid: 277, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'notificationsDisplayPopupForUserBlockedDesktopNotifications' event (evid: 278)
 *
 * Event description: When the user clicks the link, show a popup window telling the user they need to unblock notifications at their browser level.
 *
 * @param {notificationsDisplayPopupForUserBlockedDesktopNotificationsParams} params - The parameters for this event
 * @property {string} view_type - view_type
 * @property {string} platform - platform
 * @property {string} msid - msid
 * @return {LogObject<notificationsDisplayPopupForUserBlockedDesktopNotificationsParams>} LogObject<notificationsDisplayPopupForUserBlockedDesktopNotificationsParams>
 */
export function notificationsDisplayPopupForUserBlockedDesktopNotifications(params) {
    return { evid: 278, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'notificationCloseAHighPriorityNotifications' event (evid: 279)
 *
 * Event description: Close a High priority Notifications- not in the dialog
 *
 * @param {notificationCloseAHighPriorityNotificationsParams} params - The parameters for this event
 * @property {string} feed_name - All Sites/This Site /Float
 * @property {string} channel - Web / browser / mobile / SMS / email
 * @property {string} view_type - view_type
 * @property {string} notification_ids - deprecated
 * @property {string} origin - MSID of the site the user is on, my-sites if on Site List. Later on, also account-settings, and other account-level pages.
 * @property {string} platform - platform
 * @property {string} notificationid - notificationid
 * @property {GUID} msid - msid of the notification
 * @return {LogObject<notificationCloseAHighPriorityNotificationsParams>} LogObject<notificationCloseAHighPriorityNotificationsParams>
 */
export function notificationCloseAHighPriorityNotifications(params) {
    return { evid: 279, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'dashboardShowMorePopularShortcutsClick' event (evid: 28)
 *
 * Event description: each time user clicks the 'show more' link
 *
 * @param {dashboardShowMorePopularShortcutsClickParams} params - The parameters for this event
 * @property {string} view_type - view_type
 * @property {string} platform - platform
 * @property {GUID} msid - msid
 * @return {LogObject<dashboardShowMorePopularShortcutsClickParams>} LogObject<dashboardShowMorePopularShortcutsClickParams>
 */
export function dashboardShowMorePopularShortcutsClick(params) {
    return { evid: 28, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'notificationsDisplayDesktopNotificationsBanner' event (evid: 280)
 *
 * Event description: display desktop notifications banner
 *
 * @param {notificationsDisplayDesktopNotificationsBannerParams} params - The parameters for this event
 * @property {string} feed_name - All Sites/This Site /Float
 * @property {string} view_type - view_type
 * @property {string} origin - (Msid/my-site) MSID of the site the user is on, my-sites if on Site List. Later on, also account-settings, and other account-level pages.
 * @property {string} platform - platform
 * @return {LogObject<notificationsDisplayDesktopNotificationsBannerParams>} LogObject<notificationsDisplayDesktopNotificationsBannerParams>
 */
export function notificationsDisplayDesktopNotificationsBanner(params) {
    return { evid: 280, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'notificationsClickOnDesktopNotificationsBanner' event (evid: 281)
 *
 * Event description: display desktop notifications banner
 *
 * @param {notificationsClickOnDesktopNotificationsBannerParams} params - The parameters for this event
 * @property {string} feed_name - All Sites/This Site /Float
 * @property {string} view_type - view_type
 * @property {string} origin - (Msid/my-site) MSID of the site the user is on, my-sites if on Site List. Later on, also account-settings, and other account-level pages.
 * @property {string} platform - platform
 * @return {LogObject<notificationsClickOnDesktopNotificationsBannerParams>} LogObject<notificationsClickOnDesktopNotificationsBannerParams>
 */
export function notificationsClickOnDesktopNotificationsBanner(params) {
    return { evid: 281, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'notificationsResolveAlertNotification' event (evid: 282)
 *
 * Event description: display desktop notifications banner
 *
 * @param {notificationsResolveAlertNotificationParams} params - The parameters for this event
 * @property {string} channel - deprecated
 * @property {string} resolve_type - resolve/ revoke
 * @property {string} view_type - view_type
 * @property {string} platform - platform
 * @property {string} notificationid - notificationid
 * @property {string} msid - deprecated
 * @property {string} template_id - template_id
 * @return {LogObject<notificationsResolveAlertNotificationParams>} LogObject<notificationsResolveAlertNotificationParams>
 */
export function notificationsResolveAlertNotification(params) {
    return { evid: 282, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'invoicesUserSendInvoice' event (evid: 283)
 *
 * Event description: user send invoice
 *
 * @param {invoicesUserSendInvoiceParams} params - The parameters for this event
 * @property {GUID} instanceId - instance_id
 * @property {number} totalAmountLong - Total amount of the invoice, INTEGER multiplied by 100,000
 * @property {boolean} createOrder - create order?
 * @property {GUID} uuid - uuid
 * @property {string} depositType - The optional type of the invoice deposit. Possible values: "FLAT"/"PERCENTAGE".
 * @property {string} paymentType - 'one time','recurring'
 * @property {string} view_type - view_type
 * @property {GUID} invoiceId - invoice_guid
 * @property {string} origin - create invoice, edit invoice
 * @property {string} status - Creation form/Draft/Sent/Paid
 * @property {string} invoiceTitle - invoiceTitle
 * @property {string} invoiceSource - by app_def_id
 * @property {string} currency - currency
 * @property {string} platform - platform
 * @property {GUID} msid - msid
 * @property {number} discountPercentage - discountPercentage
 * @return {LogObject<invoicesUserSendInvoiceParams>} LogObject<invoicesUserSendInvoiceParams>
 */
export function invoicesUserSendInvoice(params) {
    return { evid: 283, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'bizManagerSetupWidgetOmniPhaseCompletedInDashboard' event (evid: 284)
 *
 * Event description: When a user doesn't see an open phase in the dashboard (since they completed all tasks in the OMNI widget or the phase is collapsed - since they skipped all items in the phase), sent each time the user enters the dashboard - home
 *
 * @param {bizManagerSetupWidgetOmniPhaseCompletedInDashboardParams} params - The parameters for this event
 * @property {string} skipped_items - a list of asset campaign IDs that were skipped in the phase
 * @property {string} resolved_items - a list of asset campaign IDs that were resolved in the phase
 * @property {string} asset_campaign_guid - omni setup phase id, sent the event for each "done" phase
 * @property {number} number_of_resolved_items - deprecate
 * @property {string} view_type - view_type
 * @property {number} number_of_skipped_items - deprecate
 * @property {string} platform - platform
 * @property {string} hosting - ADI/Editor/MA
 * @property {GUID} msid - msid
 * @return {LogObject<bizManagerSetupWidgetOmniPhaseCompletedInDashboardParams>} LogObject<bizManagerSetupWidgetOmniPhaseCompletedInDashboardParams>
 */
export function bizManagerSetupWidgetOmniPhaseCompletedInDashboard(params) {
    return { evid: 284, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'automationsDaComponentShowPageSrc5Evid285' event (evid: 285)
 *
 * Event description: Quotes - Invoice Table  - Download PDF
 *
 * @param {automationsDaComponentShowPageSrc5Evid285Params} params - The parameters for this event
 * @property {string} paymentType - 'Recurring','One Time'
 * @property {string} view_type - view_type
 * @property {string} origin - customer for UoU, my invoices for users
 * @property {string} platform - platform
 * @property {string} msid - msid
 * @property {GUID} invoice_id - invoice guid
 * @return {LogObject<automationsDaComponentShowPageSrc5Evid285Params>} LogObject<automationsDaComponentShowPageSrc5Evid285Params>
 */
export function automationsDaComponentShowPageSrc5Evid285(params) {
    return { evid: 285, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'automationsDaComponentManageAutomationsSrc5Evid286' event (evid: 286)
 *
 * Event description: Quotes - partial payment success/failure page
 *
 * @param {automationsDaComponentManageAutomationsSrc5Evid286Params} params - The parameters for this event
 * @property {string} view_type - view_type
 * @property {boolean} status - success,failure
 * @property {string} platform - platform
 * @property {string} msid - msid
 * @property {GUID} invoice_id - invoice guid
 * @return {LogObject<automationsDaComponentManageAutomationsSrc5Evid286Params>} LogObject<automationsDaComponentManageAutomationsSrc5Evid286Params>
 */
export function automationsDaComponentManageAutomationsSrc5Evid286(params) {
    return { evid: 286, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'automationsDaComponentCreateYourOwn' event (evid: 287)
 *
 * Event description: Quotes - Invoice paid - Thank you page shown
 *
 * @param {automationsDaComponentCreateYourOwnParams} params - The parameters for this event
 * @property {string} paymentType - 'recurring','one time'
 * @property {string} view_type - view_type
 * @property {string} invoiceSource - by app_def_id
 * @property {string} platform - platform
 * @property {string} msid - msid
 * @property {GUID} invoice_id - invoice guid
 * @return {LogObject<automationsDaComponentCreateYourOwnParams>} LogObject<automationsDaComponentCreateYourOwnParams>
 */
export function automationsDaComponentCreateYourOwn(params) {
    return { evid: 287, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'automationsDaComponentRecommendationClickSrc5Evid288' event (evid: 288)
 *
 * Event description: Quotes - Invoice Table - Manage Plan
 *
 * @param {automationsDaComponentRecommendationClickSrc5Evid288Params} params - The parameters for this event
 * @property {string} view_type - view_type
 * @property {string} platform - platform
 * @property {string} msid - msid
 * @property {GUID} invoice_id - invoice guid
 * @return {LogObject<automationsDaComponentRecommendationClickSrc5Evid288Params>} LogObject<automationsDaComponentRecommendationClickSrc5Evid288Params>
 */
export function automationsDaComponentRecommendationClickSrc5Evid288(params) {
    return { evid: 288, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'automationsDaComponentExploreMoreClick' event (evid: 289)
 *
 * Event description: General - Exposure Analytics from Dealer
 *
 * @param {automationsDaComponentExploreMoreClickParams} params - The parameters for this event
 * @property {string} exposure_name - exposure_name
 * @property {string} view_type - view_type
 * @property {number} value_from_was - The value we get from the WAS
 * @property {number} value_from_dealer - The value we get from the Dealer
 * @property {string} platform - platform
 * @property {string} hosting - MA/editor
 * @property {GUID} msid - metasite id
 * @return {LogObject<automationsDaComponentExploreMoreClickParams>} LogObject<automationsDaComponentExploreMoreClickParams>
 */
export function automationsDaComponentExploreMoreClick(params) {
    return { evid: 289, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'dashboardLessPopularShortcutsClick' event (evid: 29)
 *
 * Event description: each time user clicks the 'less' link
 *
 * @param {dashboardLessPopularShortcutsClickParams} params - The parameters for this event
 * @property {string} view_type - view_type
 * @property {string} platform - platform
 * @property {GUID} msid - msid
 * @return {LogObject<dashboardLessPopularShortcutsClickParams>} LogObject<dashboardLessPopularShortcutsClickParams>
 */
export function dashboardLessPopularShortcutsClick(params) {
    return { evid: 29, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'automationsDaComponentManageAutomations' event (evid: 291)
 *
 * Event description: Automation - Automation widget - Click on "Manage Automations"
 *
 * @param {automationsDaComponentManageAutomationsParams} params - The parameters for this event
 * @property {string} asset_campaign_guid - asset_campaign_guid
 * @property {string} referral_info - indicate which vertical is the dacomponent triggered from
 * @property {string} view_type - view_type
 * @property {string} origin - button, link, header, success creation dialog
 * @property {number} offer_location - offer_location
 * @property {string} platform - platform
 * @property {GUID} msid - msid
 * @return {LogObject<automationsDaComponentManageAutomationsParams>} LogObject<automationsDaComponentManageAutomationsParams>
 */
export function automationsDaComponentManageAutomations(params) {
    return { evid: 291, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'automationsDaComponentRecommendationClick' event (evid: 293)
 *
 * Event description: Automations Widget > click on recommended recipe
 *
 * @param {automationsDaComponentRecommendationClickParams} params - The parameters for this event
 * @property {string} name - Name of the recommendation
 * @property {string} asset_campaign_guid - asset_campaign_guid
 * @property {string} referral_info - indicate which vertical is the dacomponent triggered from
 * @property {string} view_type - view_type
 * @property {number} countAutomations - how many automations was presented in the widget
 * @property {string} origin - button, link, header, success creation dialog
 * @property {number} offer_location - offer_location
 * @property {string} platform - platform
 * @property {GUID} msid - msid
 * @property {string} action - which action was presented
 * @return {LogObject<automationsDaComponentRecommendationClickParams>} LogObject<automationsDaComponentRecommendationClickParams>
 */
export function automationsDaComponentRecommendationClick(params) {
    return { evid: 293, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'automationsDaComponentExploreMoreClick294' event (evid: 294)
 *
 * Event description: Automations > DaComponent > Explore More Click
 *
 * @param {automationsDaComponentExploreMoreClick294Params} params - The parameters for this event
 * @property {string} asset_campaign_guid - asset_campaign_guid
 * @property {string} referral_info - indicate which vertical is the dacomponent triggered from
 * @property {string} view_type - view_type
 * @property {number} countAutomations - count how many automations was presented in the widget
 * @property {string} origin - button, link, header, success creation dialog
 * @property {number} offer_location - offer_location
 * @property {string} platform - platform
 * @property {GUID} msid - msid
 * @return {LogObject<automationsDaComponentExploreMoreClick294Params>} LogObject<automationsDaComponentExploreMoreClick294Params>
 */
export function automationsDaComponentExploreMoreClick294(params) {
    return { evid: 294, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'errorPageClick295' event (evid: 295)
 *
 * Event description: When a user clicks on the CTA in the error page
 *
 * @param {errorPageClick295Params} params - The parameters for this event
 * @property {string} component_name - component_name
 * @property {string} hosting_platform - hosting_platform
 * @property {string} error_location - specifies the location in page: header/sidebar/app/sidepanel etc. includes error type. different for refresh/load types of actions
 * @property {string} view_type - view_type
 * @property {string} host_id - host_id
 * @property {string} component_app_id - component_app_id
 * @property {string} platform - platform
 * @property {string} component_id - component_id
 * @property {string} hosting_platform_context_id - hosting_platform_context_id
 * @property {string} hosting - --
 * @property {string} component_type - component_type
 * @property {GUID} msid - msid
 * @property {string} error_name - null when it's a system error, permissions when the error is permission related (user has no permission for the page)
 * @return {LogObject<errorPageClick295Params>} LogObject<errorPageClick295Params>
 */
export function errorPageClick295(params) {
    return { evid: 295, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'accountDialogClickItem' event (evid: 296)
 *
 * Event description: When a user/anonymous clicks on a dialog item in the account dialog
 *
 * @param {accountDialogClickItemParams} params - The parameters for this event
 * @property {string} item_id - the page name the item leads to (e.g. account-settings)
 * @property {number} item_index_ex_separators - item's index in the entire dialog excluding separators (only for main display, index starts from 1, logout (or any side location)=0)
 * @property {string} page_view - my-sites /dashboard / account settings
 * @property {string} view_type - view_type
 * @property {string} items_displayed - items list including section separators as 'delimiter'
 * @property {string} item_name - the display name in the dialog
 * @property {string} origin - main-menu/sub-menu (e.g. languages)
 * @property {string} platform - platform
 * @property {GUID} msid - only for dashboard dialog
 * @property {number} item_index - item's index in the entire dialog (only for main display, index starts from 1, logout (or any side location)=0)
 * @return {LogObject<accountDialogClickItemParams>} LogObject<accountDialogClickItemParams>
 */
export function accountDialogClickItem(params) {
    return { evid: 296, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'errorPage297' event (evid: 297)
 *
 * Event description: an error page is displayed in one of Giza's hosting platforms (Business Manager/Account Manager/Dev Center/etc.)  in case of BizMgr it's not reported from Giza yet - to get all errors from BizMgr you should filter 'host' field is not null.
 *
 * @param {errorPage297Params} params - The parameters for this event
 * @property {string} component_name - component_name
 * @property {string} hosting_platform - hosting_platform
 * @property {string} error_location - specifies the location in page: header/sidebar/app/sidepanel etc. includes error type
 * @property {string} view_type - view_type
 * @property {string} error_type - error_type
 * @property {string} host_id - host_id
 * @property {string} component_app_id - component_app_id
 * @property {string} app_id - app_id
 * @property {string} platform - platform
 * @property {string} component_id - component_id
 * @property {string} hosting_platform_context_id - hosting_platform_context_id
 * @property {string} hosting - --
 * @property {string} component_type - component_type
 * @property {GUID} msid - msid
 * @property {string} page_url - page_url
 * @property {string} error_name - null when it's a system error, permission when the error is permission related (user has no permission for the page)
 * @return {LogObject<errorPage297Params>} LogObject<errorPage297Params>
 */
export function errorPage297(params) {
    return { evid: 297, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'dashboardWidgetSeen' event (evid: 298)
 *
 * Event description: widget is shown in the dashboard - the event is being sent only when the user sees the widget
 *
 * @param {dashboardWidgetSeenParams} params - The parameters for this event
 * @property {string} widget_name - widget name
 * @property {string} view_type - view_type
 * @property {string} order - order
 * @property {string} platform - platform
 * @property {string} hosting - hosting
 * @property {GUID} msid - msid
 * @return {LogObject<dashboardWidgetSeenParams>} LogObject<dashboardWidgetSeenParams>
 */
export function dashboardWidgetSeen(params) {
    return { evid: 298, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'widgetLoaded' event (evid: 299)
 *
 * Event description: widget is shown in dashboard
 *
 * @param {widgetLoadedParams} params - The parameters for this event
 * @property {number} loading_time_from_start_loading_home - loading time from start loading the home
 * @property {string} widget_name - widget name
 * @property {string} view_type - view_type
 * @property {string} platform - platform
 * @property {string} hosting - --
 * @property {GUID} msid - msid
 * @property {boolean} is_shown - 1- shown 0 hidden
 * @property {number} loading_time - loading time from start loading the widget
 * @return {LogObject<widgetLoadedParams>} LogObject<widgetLoadedParams>
 */
export function widgetLoaded(params) {
    return { evid: 299, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'dashboardTourUserSeesTourBanner' event (evid: 30)
 *
 * Event description: dashboard tour > user sees tour banner.
 *
 * @param {dashboardTourUserSeesTourBannerParams} params - The parameters for this event
 * @property {string} experiment_name - experiment_id
 * @property {string} view_type - view_type
 * @property {string} platform - platform
 * @property {GUID} msid - msid
 * @return {LogObject<dashboardTourUserSeesTourBannerParams>} LogObject<dashboardTourUserSeesTourBannerParams>
 */
export function dashboardTourUserSeesTourBanner(params) {
    return { evid: 30, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'dashboardStartLoading' event (evid: 300)
 *
 * Event description: dashboard > start loading.
 *
 * @param {dashboardStartLoadingParams} params - The parameters for this event
 * @property {string} prev_module_id - deprecated
 * @property {string} __cookies_prefix__wixsession - authentication token. if the session exists, then the user is logged in.
 * @property {string} referral_additional_info - referral_additional_info
 * @property {string} referral_info - specific button triggered the the view loading
 * @property {string} view_type - view_type
 * @property {boolean} is_account_mgr - true / false
 * @property {string} sub_view - page in app/module
 * @property {number} screen_width - screen_width
 * @property {boolean} initial_load - deprecated
 * @property {string} app_ids - all application ids installed on Biz Mgr
 * @property {number} window_width - window_width
 * @property {string} origin - specific button triggered the the view loading (== referral info from editor)
 * @property {boolean} is_biz_mgr - true if page is loaded when Biz mgr is active
 * @property {number} screen_height - screen_height
 * @property {string} prev_view - origin view / module / app
 * @property {string} prevPageComponentId - the previous page component id, will be reliable only when page has an entry point from sidebar.
 * @property {string} app_id - application id
 * @property {string} prev_sub_view - previous page in app/module
 * @property {number} window_height - window_height
 * @property {string} platform - platform
 * @property {string} origin_app_id - origin_app_id (what app opened the bizmgr)
 * @property {string} hosting - MA/editor
 * @property {GUID} msid - msid
 * @property {string} pageComponentId - the page component id, will be reliable only when page has an entry point from sidebar. was added on 22/08/22
 * @property {string} module_id - deprecated
 * @property {string} view - requested view/ module/ app
 * @return {LogObject<dashboardStartLoadingParams>} LogObject<dashboardStartLoadingParams>
 */
export function dashboardStartLoading(params) {
    return { evid: 300, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'homeCloseDialog' event (evid: 301)
 *
 * Event description: closing a dialog from home my apps, my sites, account menu
 *
 * @param {homeCloseDialogParams} params - The parameters for this event
 * @property {string} wixsession - deprecated
 * @property {string} page_view - Dashboard / my sites
 * @property {string} referral_info - -
 * @property {string} view_type - view_type
 * @property {string} origin - place of clicking my sites ( Header, top left bar). Relevant only for site list
 * @property {string} prev_view - -
 * @property {GUID} app_id - -
 * @property {string} platform - platform
 * @property {GUID} msid - -
 * @property {string} action - the action made to close the dialog: click/hover (until 05/23 dialog close only on click)
 * @property {string} view - name of dialog: my-apps, site-list, account. 'account'- regular full menu
 * ‘partner-account’- full menu with entry point to wix studio
 *  ‘WixStudio-account-menu’- lean menu
 * @return {LogObject<homeCloseDialogParams>} LogObject<homeCloseDialogParams>
 */
export function homeCloseDialog(params) {
    return { evid: 301, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'dashboardFinishLoading' event (evid: 302)
 *
 * Event description: dashboard > finish loading.
 *
 * @param {dashboardFinishLoadingParams} params - The parameters for this event
 * @property {string} __cookies_prefix__wixsession - authentication token. if the session exists, then the user is logged in.
 * @property {string} view_mode - grid/list-view
 * @property {string} referral_additional_info - referral_additional_info
 * @property {number} loading_time_from_start - loading time from start loading Bizmgr (from 561) - deprecated
 * @property {string} referral_info - specific button triggered the the view loading
 * @property {string} view_type - view_type
 * @property {boolean} is_account_mgr - true/ false
 * @property {string} sub_view - --
 * @property {number} screen_width - screen width
 * @property {boolean} initial_load - intial load
 * @property {number} loading_time_from_module - Loading time from module start loading (from 564)
 * @property {string} app_ids - all applications installed on Biz Mgr
 * @property {number} window_width - --
 * @property {number} loading_time_from_first_interaction - loading_time_from_first_interaction (309)
 * @property {string} origin - origin
 * @property {number} loading_time_from_performance_now - loading_time_from_performance_now  when server start to load. the real beginning
 * @property {boolean} is_biz_mgr - true if page is loaded when Biz mgr is active
 * @property {number} screen_height - screen height
 * @property {string} prev_view - origin view
 * @property {string} prevPageComponentId - the previous page component id, will be reliable only when page has an entry point from sidebar.
 * @property {string} app_id - application id
 * @property {string} prev_sub_view - previous sub view
 * @property {number} window_height - --
 * @property {boolean} is_pro - not in use
 * @property {string} platform - platform
 * @property {string} origin_app_id - origin_app_id (what app opened the bizmgr)
 * @property {string} hosting - dashboard/editor/onboarding
 * @property {GUID} msid - msid
 * @property {string} pageComponentId - the page component id, will be reliable only when page has an entry point from sidebar. was added on 22/08/22
 * @property {string} module_id - *not in use*
 * @property {string} view - requested view
 * @property {number} loading_time - loading time of page (from 300 )
 * @return {LogObject<dashboardFinishLoadingParams>} LogObject<dashboardFinishLoadingParams>
 */
export function dashboardFinishLoading(params) {
    return { evid: 302, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'homeOpenDialogClick' event (evid: 303)
 *
 * Event description: opening a dialog from home: my apps, my sites, account menu,notifications,priority support
 *
 * @param {homeOpenDialogClickParams} params - The parameters for this event
 * @property {string} wixsession - authentication token. if the session exists, then the user is logged in.
 * @property {string} page_view - my-sites /dashboard / account settings
 * @property {string} referral_info - -
 * @property {string} view_type - view_type
 * @property {string} origin - place of clicking my sites ( Header, top left bar). Relevant only for site list
 * @property {string} prev_view - -
 * @property {GUID} app_id - -
 * @property {string} platform - platform
 * @property {GUID} msid - -
 * @property {string} action - the action made to open the dialog: click/hover (was sent between 05/23 to 08/23)
 * @property {string} view - my-apps, site-list, account,notifications,priority support
 * @return {LogObject<homeOpenDialogClickParams>} LogObject<homeOpenDialogClickParams>
 */
export function homeOpenDialogClick(params) {
    return { evid: 303, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'dialogFirstLoad' event (evid: 304)
 *
 * Event description: opening a dialog from home (sent only in the first click within the same session) {my apps, my sites}
 *
 * @param {dialogFirstLoadParams} params - The parameters for this event
 * @property {string} wixsession - authentication token. if the session exists, then the user is logged in.
 * @property {string} referral_info - -
 * @property {string} view_type - view_type
 * @property {string} origin - place of clicking my sites ( Header, top left bar). Relevant only for site list
 * @property {string} prev_view - -
 * @property {GUID} app_id - -
 * @property {string} platform - platform
 * @property {GUID} msid - -
 * @property {string} view - my-apps, site-list
 * @property {number} loading_time - loading time of page
 * @return {LogObject<dialogFirstLoadParams>} LogObject<dialogFirstLoadParams>
 */
export function dialogFirstLoad(params) {
    return { evid: 304, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'homeMultipleSitesCheck' event (evid: 305)
 *
 * Event description: checked if a user has one site or more (including sites that he is a contributor.)
 *
 * @param {homeMultipleSitesCheckParams} params - The parameters for this event
 * @property {string} view_type - view_type
 * @property {string} origin - dashboard / my-sites
 * @property {number} num_displayed_sites - num sites that are displayed on page
 * @property {boolean} has_two_sites - deprecated
 * @property {string} prev_view - search/dashboard/wix.com
 * @property {string} platform - platform
 * @property {GUID} msid - deorecated
 * @property {number} sites_count - total number of sites
 * @return {LogObject<homeMultipleSitesCheckParams>} LogObject<homeMultipleSitesCheckParams>
 */
export function homeMultipleSitesCheck(params) {
    return { evid: 305, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'homeBizMgrEligible' event (evid: 306)
 *
 * Event description: checked if a user is eligible for biz mgr, phase=4 is for main funnel sites
 *
 * @param {homeBizMgrEligibleParams} params - The parameters for this event
 * @property {string} view_type - view_type
 * @property {number} phase_number - phase number
 * @property {string} platform - platform
 * @property {GUID} msid - metasite id
 * @property {boolean} is_eligible - deprecated
 * @return {LogObject<homeBizMgrEligibleParams>} LogObject<homeBizMgrEligibleParams>
 */
export function homeBizMgrEligible(params) {
    return { evid: 306, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'homeClickOnCreateAnythingItem' event (evid: 307)
 *
 * Event description: click on create anything item
 *
 * @param {homeClickOnCreateAnythingItemParams} params - The parameters for this event
 * @property {string} name - item name
 * @property {string} page_view - from where the users opened the dialog
 * @property {string} view_type - view_type
 * @property {string} add_app_id - add_app_id
 * @property {GUID} app_id - deprecated
 * @property {string} platform - platform
 * @property {GUID} msid - -
 * @property {string} view - dialog name
 * @return {LogObject<homeClickOnCreateAnythingItemParams>} LogObject<homeClickOnCreateAnythingItemParams>
 */
export function homeClickOnCreateAnythingItem(params) {
    return { evid: 307, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'myAccountClickOnExpertDashboard' event (evid: 308)
 *
 * Event description: User clicks on Expert Dashboard
 *
 * @param {myAccountClickOnExpertDashboardParams} params - The parameters for this event
 * @property {string} page_view - my-sites / dashboard / account settings
 * @property {string} view_type - view_type
 * @property {string} origin - header
 * @property {string} platform - platform
 * @return {LogObject<myAccountClickOnExpertDashboardParams>} LogObject<myAccountClickOnExpertDashboardParams>
 */
export function myAccountClickOnExpertDashboard(params) {
    return { evid: 308, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'dashboardDashboardHomeIsFullyLoaded' event (evid: 309)
 *
 * Event description: dashboard (home) is fully loaded
 *
 * @param {dashboardDashboardHomeIsFullyLoadedParams} params - The parameters for this event
 * @property {number} loading_time_from_start - loading time from start loading Bizmgr (from 561)
 * @property {string} referral_info - specific button triggered the the view loading
 * @property {string} view_type - view_type
 * @property {string} sub_view - page in app
 * @property {number} screen_width - screen_width
 * @property {number} loading_time_from_module - Loading time from module start loading (from 564)
 * @property {number} window_width - window_width
 * @property {number} loading_time_from_first_interaction - deprecated
 * @property {number} loading_time_from_performance_now - loading_time_from_performance_now  when server start to load. the real beginning
 * @property {number} screen_height - screen_height
 * @property {string} prev_view - origin view
 * @property {string} prev_sub_view - prev page in app
 * @property {number} window_height - window_height
 * @property {string} platform - platform
 * @property {string} hosting - MA/editor
 * @property {GUID} msid - msid
 * @property {string} view - requested view
 * @property {number} loading_time - loading time of page (from 300 )
 * @return {LogObject<dashboardDashboardHomeIsFullyLoadedParams>} LogObject<dashboardDashboardHomeIsFullyLoadedParams>
 */
export function dashboardDashboardHomeIsFullyLoaded(params) {
    return { evid: 309, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'dashboardTourCloseTour' event (evid: 31)
 *
 * Event description: dashboard tour > close tour.
 *
 * @param {dashboardTourCloseTourParams} params - The parameters for this event
 * @property {string} experiment_name - experiment_id
 * @property {string} stage_process - phase_name
 * @property {string} view_type - view_type
 * @property {number} stage_number - phase_number
 * @property {string} platform - platform
 * @property {GUID} msid - msid
 * @return {LogObject<dashboardTourCloseTourParams>} LogObject<dashboardTourCloseTourParams>
 */
export function dashboardTourCloseTour(params) {
    return { evid: 31, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'dashboardSiteSettingsPageView' event (evid: 310)
 *
 * Event description: site settings page view
 *
 * @param {dashboardSiteSettingsPageViewParams} params - The parameters for this event
 * @property {string} available_sections - json of sections and sub-items that were loaded to settings. For example:  { ‘Site-details’: ‘connect-domain,compare-plans,get a business email’, ’General’: ‘website settings, business info, language and region’, ‘Ecommerce’: ‘accept payments, store shipping...’ ‘Bookings’:... ‘Communication’:... ... }
 * @property {string} name - name of tab
 * @property {string} focus_section - section name of the automatic scrolling if null then the page wasn't automated scrolled
 * @property {string} view_type - view_type
 * @property {string} unseen_sections - list of sections that loaded in settings lobby but the user is not seeing in the page loading separated by comma
 * @property {string} seen_sections - list of sections the user sees above the fold
 * @property {string} origin - name of previous tab
 * @property {string} alertStatus - If the red badge is shown in the sidebar then "true", if not "false"
 * @property {string} place - deprecated
 * @property {string} platform - platform
 * @property {string} hosting - from where user arrived to sitesettings (Editor/MA/...)
 * @property {GUID} msid - msid
 * @property {string} alert_sections - json of sections and sub-items that were loaded to settings with the red badge. For example: { ‘Site-details’: ‘connect-domain,compare-plans,get a business email’, ’General’: ‘website settings, business info, language and region’, ‘Ecommerce’: ‘accept payments, store shipping...’ ‘Bookings’:... ‘Communication’:... ... }
 * @property {string} subscriptions - json of sections and sub-items that were loaded to settings in the premium bar
 * @return {LogObject<dashboardSiteSettingsPageViewParams>} LogObject<dashboardSiteSettingsPageViewParams>
 */
export function dashboardSiteSettingsPageView(params) {
    return { evid: 310, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'dashboardSiteSettingsExperienceDisplayed' event (evid: 311)
 *
 * Event description: what is the experience of the user when he sees the page
 *
 * @param {dashboardSiteSettingsExperienceDisplayedParams} params - The parameters for this event
 * @property {string} view_type - view_type
 * @property {string} experience - user's experience
 * @property {string} origin - name of previous tab
 * @property {string} platform - platform
 * @property {string} hosting - from where user arrived to sitesettings (Editor/MA/...)
 * @property {GUID} msid - msid
 * @return {LogObject<dashboardSiteSettingsExperienceDisplayedParams>} LogObject<dashboardSiteSettingsExperienceDisplayedParams>
 */
export function dashboardSiteSettingsExperienceDisplayed(params) {
    return { evid: 311, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'dashboardSiteSettingsChangeValue' event (evid: 312)
 *
 * Event description: user changed a value in the site settings
 *
 * @param {dashboardSiteSettingsChangeValueParams} params - The parameters for this event
 * @property {string} name - name of the field that was changed
 * @property {string} create_method - save(pop-up),create new
 * @property {string} view_type - view_type
 * @property {string} experience - user's experience
 * @property {string} origin - name of current tab
 * @property {string} platform - platform
 * @property {string} hosting - from where user arrived to sitesettings (Editor/MA/...)
 * @property {GUID} msid - msid
 * @property {string} value - field's value
 * @return {LogObject<dashboardSiteSettingsChangeValueParams>} LogObject<dashboardSiteSettingsChangeValueParams>
 */
export function dashboardSiteSettingsChangeValue(params) {
    return { evid: 312, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'dashboardSiteSettingsChangeValueSuccess' event (evid: 313)
 *
 * Event description: user changed a value in the site settings successfully
 *
 * @param {dashboardSiteSettingsChangeValueSuccessParams} params - The parameters for this event
 * @property {string} name - name of the field that was changed
 * @property {string} create_method - save(pop-up),create new
 * @property {string} view_type - view_type
 * @property {string} experience - user's experience
 * @property {string} origin - name of current tab
 * @property {string} platform - platform
 * @property {string} hosting - from where user arrived to sitesettings (Editor/MA/...)
 * @property {GUID} msid - msid
 * @property {string} value - field's value
 * @return {LogObject<dashboardSiteSettingsChangeValueSuccessParams>} LogObject<dashboardSiteSettingsChangeValueSuccessParams>
 */
export function dashboardSiteSettingsChangeValueSuccess(params) {
    return { evid: 313, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'dashboardSiteSettingsChangeValueFailure' event (evid: 314)
 *
 * Event description: user changed a value in the dashboard > site settings > failed
 *
 * @param {dashboardSiteSettingsChangeValueFailureParams} params - The parameters for this event
 * @property {string} name - name of the field that was changed
 * @property {string} view_type - view_type
 * @property {string} experience - user's experience
 * @property {string} origin - name of current tab
 * @property {string} platform - platform
 * @property {string} hosting - from where user arrived to sitesettings (Editor/MA/...)
 * @property {GUID} msid - msid
 * @property {string} value - field's value
 * @return {LogObject<dashboardSiteSettingsChangeValueFailureParams>} LogObject<dashboardSiteSettingsChangeValueFailureParams>
 */
export function dashboardSiteSettingsChangeValueFailure(params) {
    return { evid: 314, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'dashboardSiteSettingsClickLink' event (evid: 315)
 *
 * Event description: user clicked on a link
 *
 * @param {dashboardSiteSettingsClickLinkParams} params - The parameters for this event
 * @property {string} name - link name
 * @property {string} view_type - view_type
 * @property {string} experience - user's experience
 * @property {string} origin - name of current tab
 * @property {string} platform - platform
 * @property {string} hosting - from where user arrived to sitesettings (Editor/MA/...)
 * @property {GUID} msid - msid
 * @property {string} value - Link URL
 * @return {LogObject<dashboardSiteSettingsClickLinkParams>} LogObject<dashboardSiteSettingsClickLinkParams>
 */
export function dashboardSiteSettingsClickLink(params) {
    return { evid: 315, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'dashboardSiteSettingsDeleteValue' event (evid: 316)
 *
 * Event description: user deleted/cleared a value from field
 *
 * @param {dashboardSiteSettingsDeleteValueParams} params - The parameters for this event
 * @property {string} name - name of the field that was changed
 * @property {string} view_type - view_type
 * @property {string} experience - user's experience
 * @property {string} origin - name of current tab
 * @property {string} platform - platform
 * @property {string} hosting - from where user arrived to sitesettings (Editor/MA/...)
 * @property {GUID} msid - msid
 * @property {string} value - delete/clear value
 * @return {LogObject<dashboardSiteSettingsDeleteValueParams>} LogObject<dashboardSiteSettingsDeleteValueParams>
 */
export function dashboardSiteSettingsDeleteValue(params) {
    return { evid: 316, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'dashboardSiteSettingsDeleteValueSuccess' event (evid: 317)
 *
 * Event description: user deleted/cleared a value from field - success
 *
 * @param {dashboardSiteSettingsDeleteValueSuccessParams} params - The parameters for this event
 * @property {string} name - name of the field that was changed
 * @property {string} view_type - view_type
 * @property {string} experience - user's experience
 * @property {string} origin - name of current tab
 * @property {string} platform - platform
 * @property {string} hosting - from where user arrived to sitesettings (Editor/MA/...)
 * @property {GUID} msid - msid
 * @property {string} value - delete/clear value
 * @return {LogObject<dashboardSiteSettingsDeleteValueSuccessParams>} LogObject<dashboardSiteSettingsDeleteValueSuccessParams>
 */
export function dashboardSiteSettingsDeleteValueSuccess(params) {
    return { evid: 317, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'dashboardSiteSettingsDeleteValueFailure' event (evid: 318)
 *
 * Event description: user deleted/cleared a value from field - failure
 *
 * @param {dashboardSiteSettingsDeleteValueFailureParams} params - The parameters for this event
 * @property {string} name - name of the field that was changed
 * @property {string} view_type - view_type
 * @property {string} experience - user's experience
 * @property {string} origin - name of current tab
 * @property {string} platform - platform
 * @property {string} hosting - from where user arrived to sitesettings (Editor/MA/...)
 * @property {GUID} msid - msid
 * @property {string} value - delete/clear value
 * @return {LogObject<dashboardSiteSettingsDeleteValueFailureParams>} LogObject<dashboardSiteSettingsDeleteValueFailureParams>
 */
export function dashboardSiteSettingsDeleteValueFailure(params) {
    return { evid: 318, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'dashboardSiteSettingsSelectValue' event (evid: 319)
 *
 * Event description: user selected a value and didn't change it (drop down and select image)
 *
 * @param {dashboardSiteSettingsSelectValueParams} params - The parameters for this event
 * @property {string} name - name of the field that was selected
 * @property {string} adding_method - manually(pop-up),drop-down
 * @property {string} view_type - view_type
 * @property {string} experience - user's experience
 * @property {string} origin - name of current tab
 * @property {string} place - UI type (picture/button/select/input...)
 * @property {string} platform - platform
 * @property {string} hosting - from where user arrived to sitesettings (Editor/MA/...)
 * @property {GUID} msid - msid
 * @property {string} value - user's selection
 * @return {LogObject<dashboardSiteSettingsSelectValueParams>} LogObject<dashboardSiteSettingsSelectValueParams>
 */
export function dashboardSiteSettingsSelectValue(params) {
    return { evid: 319, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'dashboardTourNextStep' event (evid: 32)
 *
 * Event description: dashboard tour > next step.
 *
 * @param {dashboardTourNextStepParams} params - The parameters for this event
 * @property {string} experiment_name - experiment_id
 * @property {string} stage_process - phase_name
 * @property {string} view_type - view_type
 * @property {string} platform - platform
 * @property {GUID} msid - msid
 * @return {LogObject<dashboardTourNextStepParams>} LogObject<dashboardTourNextStepParams>
 */
export function dashboardTourNextStep(params) {
    return { evid: 32, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'dashboardSiteSettingsClosingComponent' event (evid: 320)
 *
 * Event description: user closed site settings' component
 *
 * @param {dashboardSiteSettingsClosingComponentParams} params - The parameters for this event
 * @property {string} name - name of the field that was selected
 * @property {string} view_type - view_type
 * @property {string} origin - name of current tab
 * @property {string} place - close type (x/cancel...)
 * @property {string} platform - platform
 * @property {string} hosting - from where user arrived to sitesettings (Editor/MA/...)
 * @property {GUID} msid - msid
 * @return {LogObject<dashboardSiteSettingsClosingComponentParams>} LogObject<dashboardSiteSettingsClosingComponentParams>
 */
export function dashboardSiteSettingsClosingComponent(params) {
    return { evid: 320, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'dashboardSiteSettingsDomainSslOption' event (evid: 321)
 *
 * Event description: User choose to Activate/ Deactivate the  HTTPS option
 *
 * @param {dashboardSiteSettingsDomainSslOptionParams} params - The parameters for this event
 * @property {string} name - name of the field that was changed
 * @property {string} view_type - view_type
 * @property {string} experience - user's experience
 * @property {string} origin - name of current tab
 * @property {string} mode - {Turn on SSL,Remove SSL}
 * @property {string} platform - platform
 * @property {string} hosting - from where user arrived to sitesettings (Editor/MA/...)
 * @property {GUID} msid - msid
 * @return {LogObject<dashboardSiteSettingsDomainSslOptionParams>} LogObject<dashboardSiteSettingsDomainSslOptionParams>
 */
export function dashboardSiteSettingsDomainSslOption(params) {
    return { evid: 321, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'dashboardSiteSettingsDomainSslPopupCancel' event (evid: 322)
 *
 * Event description: close Pop-up window either with 'cancel' option or 'X' .
 *
 * @param {dashboardSiteSettingsDomainSslPopupCancelParams} params - The parameters for this event
 * @property {string} name - name of the field that was changed
 * @property {string} view_type - view_type
 * @property {string} experience - user's experience
 * @property {string} origin - name of current tab
 * @property {string} mode - {Turn on SSL,Remove SSL}
 * @property {string} platform - platform
 * @property {string} hosting - from where user arrived to sitesettings (Editor/MA/...)
 * @property {GUID} msid - msid
 * @return {LogObject<dashboardSiteSettingsDomainSslPopupCancelParams>} LogObject<dashboardSiteSettingsDomainSslPopupCancelParams>
 */
export function dashboardSiteSettingsDomainSslPopupCancel(params) {
    return { evid: 322, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'dashboardSiteSettingsSeoClickEnterAddressManually' event (evid: 323)
 *
 * Event description: user clicked on a link 'Enter address manually' in SEO section
 *
 * @param {dashboardSiteSettingsSeoClickEnterAddressManuallyParams} params - The parameters for this event
 * @property {string} view_type - view_type
 * @property {string} experience - user's experience
 * @property {string} origin - name of current tab
 * @property {string} platform - platform
 * @property {string} hosting - from where user arrived to sitesettings (Editor/MA/...)
 * @property {GUID} msid - msid
 * @property {string} value - Link URL
 * @return {LogObject<dashboardSiteSettingsSeoClickEnterAddressManuallyParams>} LogObject<dashboardSiteSettingsSeoClickEnterAddressManuallyParams>
 */
export function dashboardSiteSettingsSeoClickEnterAddressManually(params) {
    return { evid: 323, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'dashboardSiteSettingsSeoCloseEnterAddressManuallyPopUp' event (evid: 324)
 *
 * Event description: user closed  pop up 'Enter address manually' in SEO section
 *
 * @param {dashboardSiteSettingsSeoCloseEnterAddressManuallyPopUpParams} params - The parameters for this event
 * @property {string} view_type - view_type
 * @property {string} experience - user's experience
 * @property {string} origin - name of current tab
 * @property {string} platform - platform
 * @property {string} hosting - from where user arrived to sitesettings (Editor/MA/...)
 * @property {GUID} msid - msid
 * @property {string} value - Link URL
 * @return {LogObject<dashboardSiteSettingsSeoCloseEnterAddressManuallyPopUpParams>} LogObject<dashboardSiteSettingsSeoCloseEnterAddressManuallyPopUpParams>
 */
export function dashboardSiteSettingsSeoCloseEnterAddressManuallyPopUp(params) {
    return { evid: 324, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'dashboardSiteSettingsSeoClickOnGetStarted' event (evid: 325)
 *
 * Event description: user clicked on get started button
 *
 * @param {dashboardSiteSettingsSeoClickOnGetStartedParams} params - The parameters for this event
 * @property {string} view_type - view_type
 * @property {string} origin - name of current tab
 * @property {string} platform - platform
 * @property {string} hosting - from where user arrived to sitesettings (Editor/MA/...)
 * @return {LogObject<dashboardSiteSettingsSeoClickOnGetStartedParams>} LogObject<dashboardSiteSettingsSeoClickOnGetStartedParams>
 */
export function dashboardSiteSettingsSeoClickOnGetStarted(params) {
    return { evid: 325, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'dashboardSiteSettingsOverviewUnpublishSite' event (evid: 326)
 *
 * Event description: User choose to unpublish site in pop up window
 *
 * @param {dashboardSiteSettingsOverviewUnpublishSiteParams} params - The parameters for this event
 * @property {string} name - name of the field that was changed
 * @property {string} view_type - view_type
 * @property {string} experience - user's experience
 * @property {string} origin - name of current tab
 * @property {string} platform - platform
 * @property {string} hosting - from where user arrived to sitesettings (Editor/MA/...)
 * @property {GUID} msid - msid
 * @return {LogObject<dashboardSiteSettingsOverviewUnpublishSiteParams>} LogObject<dashboardSiteSettingsOverviewUnpublishSiteParams>
 */
export function dashboardSiteSettingsOverviewUnpublishSite(params) {
    return { evid: 326, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'dashboardSiteSettingsOverviewUnpublishPopupCancel' event (evid: 327)
 *
 * Event description: close Pop-up window either with 'cancel' option or 'X' .
 *
 * @param {dashboardSiteSettingsOverviewUnpublishPopupCancelParams} params - The parameters for this event
 * @property {string} name - name of the field that was changed
 * @property {string} view_type - view_type
 * @property {string} experience - user's experience
 * @property {string} origin - name of current tab
 * @property {string} platform - platform
 * @property {string} hosting - from where user arrived to sitesettings (Editor/MA/...)
 * @property {GUID} msid - msid
 * @return {LogObject<dashboardSiteSettingsOverviewUnpublishPopupCancelParams>} LogObject<dashboardSiteSettingsOverviewUnpublishPopupCancelParams>
 */
export function dashboardSiteSettingsOverviewUnpublishPopupCancel(params) {
    return { evid: 327, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'renameSiteOpenRenameDialog' event (evid: 328)
 *
 * Event description: rename dialog is opened
 *
 * @param {renameSiteOpenRenameDialogParams} params - The parameters for this event
 * @property {string} view_type - view_type
 * @property {string} origin - site-list \ site-list-enterprise
 * @property {string} cta - ‘sidepanel’ / ‘menu’
 * @property {string} platform - platform
 * @property {GUID} msid - msid
 * @return {LogObject<renameSiteOpenRenameDialogParams>} LogObject<renameSiteOpenRenameDialogParams>
 */
export function renameSiteOpenRenameDialog(params) {
    return { evid: 328, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'dashboardChangeSiteDisplayNameSave' event (evid: 329)
 *
 * Event description: user changed site display name and clicked on save in rename dialog
 *
 * @param {dashboardChangeSiteDisplayNameSaveParams} params - The parameters for this event
 * @property {string} view_type - view_type
 * @property {string} platform - platform
 * @property {GUID} msid - site guid
 * @return {LogObject<dashboardChangeSiteDisplayNameSaveParams>} LogObject<dashboardChangeSiteDisplayNameSaveParams>
 */
export function dashboardChangeSiteDisplayNameSave(params) {
    return { evid: 329, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'dashboardUserSeeFeedMoreThen3Sec' event (evid: 33)
 *
 * Event description: whenever a news item is a fully displayed in the newsfeed more then 3 sec send a bi-feed so I will be able to know that a user saw the feed
 *
 * @param {dashboardUserSeeFeedMoreThen3SecParams} params - The parameters for this event
 * @property {GUID} feedId - feed id
 * @property {string} source - source
 * @property {string} url - url
 * @property {string} view_type - view_type
 * @property {string} origin - origin
 * @property {GUID} campaignId - unique identifier of CMS items
 * @property {string} title - title
 * @property {string} type - type
 * @property {string} platform - platform
 * @property {GUID} msid - msid
 * @property {boolean} aboveTheFold - aboveTheFold
 * @property {GUID} feed_id - feed id
 * @return {LogObject<dashboardUserSeeFeedMoreThen3SecParams>} LogObject<dashboardUserSeeFeedMoreThen3SecParams>
 */
export function dashboardUserSeeFeedMoreThen3Sec(params) {
    return { evid: 33, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'dashboardChangeUrlSave' event (evid: 330)
 *
 * Event description: user changed the url and clicked on save  in rename dialog
 *
 * @param {dashboardChangeUrlSaveParams} params - The parameters for this event
 * @property {string} view_type - view_type
 * @property {string} platform - platform
 * @property {GUID} msid - site guid
 * @return {LogObject<dashboardChangeUrlSaveParams>} LogObject<dashboardChangeUrlSaveParams>
 */
export function dashboardChangeUrlSave(params) {
    return { evid: 330, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'needsYourActionNyaWidgetShown' event (evid: 331)
 *
 * Event description: When a user entered into the dashboard and has at least 1 NYA item
 *
 * @param {needsYourActionNyaWidgetShownParams} params - The parameters for this event
 * @property {string} view_type - view_type
 * @property {number} num_of_items - num of NYA items appears to users
 * @property {string} platform - platform
 * @property {string} hosting - MA/editor/ADI
 * @property {GUID} msid - msid
 * @return {LogObject<needsYourActionNyaWidgetShownParams>} LogObject<needsYourActionNyaWidgetShownParams>
 */
export function needsYourActionNyaWidgetShown(params) {
    return { evid: 331, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'needsYourActionItemIsShown' event (evid: 332)
 *
 * Event description: show 1 Needs Your Action item
 *
 * @param {needsYourActionItemIsShownParams} params - The parameters for this event
 * @property {string} item_id - id of the specific item
 * @property {number} item_location_on_page - item location appear on page
 * @property {string} view_type - view_type
 * @property {number} num_of_items - num of NYA items appears to users
 * @property {string} platform - platform
 * @property {string} hosting - MA/editor/ADI
 * @property {GUID} msid - msid
 * @property {string} template_id - template id of the action
 * @return {LogObject<needsYourActionItemIsShownParams>} LogObject<needsYourActionItemIsShownParams>
 */
export function needsYourActionItemIsShown(params) {
    return { evid: 332, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'needsYourActionClickOnItem' event (evid: 333)
 *
 * Event description: Click on 'Needs Your Action' item
 *
 * @param {needsYourActionClickOnItemParams} params - The parameters for this event
 * @property {string} item_id - item id
 * @property {number} item_location_on_page - item location num onpage
 * @property {string} click_type - click/close/hide
 * @property {string} view_type - view_type
 * @property {string} item_name - item name appear
 * @property {string} platform - platform
 * @property {string} hosting - MA/editor/ADI
 * @property {GUID} msid - msid
 * @property {string} template_id - template id
 * @return {LogObject<needsYourActionClickOnItemParams>} LogObject<needsYourActionClickOnItemParams>
 */
export function needsYourActionClickOnItem(params) {
    return { evid: 333, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'needsYourActionClickOnUndoHidingAnItem' event (evid: 334)
 *
 * Event description: Click on hide after hiding an item
 *
 * @param {needsYourActionClickOnUndoHidingAnItemParams} params - The parameters for this event
 * @property {string} item_id - item id
 * @property {string} view_type - view_type
 * @property {string} platform - platform
 * @property {string} hosting - MA/editor/ADI
 * @property {GUID} msid - msid
 * @property {string} template_id - template id of the action
 * @return {LogObject<needsYourActionClickOnUndoHidingAnItemParams>} LogObject<needsYourActionClickOnUndoHidingAnItemParams>
 */
export function needsYourActionClickOnUndoHidingAnItem(params) {
    return { evid: 334, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'hooverNewReleasesIcon' event (evid: 336)
 *
 * Event description: The user hoovers the new releases icon in the top bar of the BM.
 * The event tracks the first time per load page.
 *
 * @param {hooverNewReleasesIconParams} params - The parameters for this event
 * @property {string} view_type - view_type
 * @property {string} platform - platform
 * @property {GUID} msid - msid
 * @return {LogObject<hooverNewReleasesIconParams>} LogObject<hooverNewReleasesIconParams>
 */
export function hooverNewReleasesIcon(params) {
    return { evid: 336, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'tooltipNotificationPopsUp' event (evid: 337)
 *
 * Event description: Tooltip pops up. It happens only once when the site gets his first  "new release" notification.
 *
 * @param {tooltipNotificationPopsUpParams} params - The parameters for this event
 * @property {string} name - New released feature's name
 * @property {string} view_type - view_type
 * @property {string} origin - web/mobile
 * @property {string} platform - platform
 * @property {GUID} msid - msid
 * @return {LogObject<tooltipNotificationPopsUpParams>} LogObject<tooltipNotificationPopsUpParams>
 */
export function tooltipNotificationPopsUp(params) {
    return { evid: 337, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'newReleasesApiRequest' event (evid: 338)
 *
 * Event description: This event fires every time there is a new request from the API. It means that the dealer sent a new release update to a site.
 * The event is unique by announcement_id and metasite_id.
 *
 * @param {newReleasesApiRequestParams} params - The parameters for this event
 * @property {string} lng - language
 * @property {GUID} announcement_id - announcement_id
 * @property {string} view_type - view_type
 * @property {string} platform - platform
 * @property {GUID} msid - msid
 * @return {LogObject<newReleasesApiRequestParams>} LogObject<newReleasesApiRequestParams>
 */
export function newReleasesApiRequest(params) {
    return { evid: 338, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'closeTooltipPopUp' event (evid: 339)
 *
 * Event description: Event fires when users closes the tooltip.
 *
 * @param {closeTooltipPopUpParams} params - The parameters for this event
 * @property {string} name - New released feature's name
 * @property {string} view_type - view_type
 * @property {string} origin - web, mobile
 * @property {string} platform - platform
 * @property {GUID} msid - msid
 * @return {LogObject<closeTooltipPopUpParams>} LogObject<closeTooltipPopUpParams>
 */
export function closeTooltipPopUp(params) {
    return { evid: 339, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'dashboardSeeBanner' event (evid: 34)
 *
 * Event description: send each time user see banner
 *
 * @param {dashboardSeeBannerParams} params - The parameters for this event
 * @property {string} abTest - ab test group
 * @property {string} name - name of the banner
 * @property {string} targetUrl - the banner link url
 * @property {string} view_type - view_type
 * @property {string} origin - the page it displays in
 * @property {string} bannerid - Banner id from dealer
 * @property {boolean} isPremium - is_premium
 * @property {string} platform - platform
 * @property {GUID} msid - msid
 * @property {string} bannerLocationOnPage - 'LIST_TOP' 'LIST_RIGHT' 'LIST_LEFT' ,the location of the banner
 * @property {boolean} aboveTheFold - was the item full viewed above the fold
 * @return {LogObject<dashboardSeeBannerParams>} LogObject<dashboardSeeBannerParams>
 */
export function dashboardSeeBanner(params) {
    return { evid: 34, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'badgeNotification' event (evid: 340)
 *
 * Event description: a badge with new notifications is shown to the user
 *
 * @param {badgeNotificationParams} params - The parameters for this event
 * @property {string} view_type - view_type
 * @property {number} new_notifications - number in the badge
 * @property {string} platform - platform
 * @property {GUID} msid - msid
 * @return {LogObject<badgeNotificationParams>} LogObject<badgeNotificationParams>
 */
export function badgeNotification(params) {
    return { evid: 340, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'viewFeatureCard' event (evid: 341)
 *
 * Event description: View is more than 75% of the card and at least 3 seconds. In 3 second I managed to read the header of the announcement.
 * The event should be fired only once per announcement per sidebar opened (if sidebar is opened again, an announcement that was already viewed can have another view event).
 *
 * @param {viewFeatureCardParams} params - The parameters for this event
 * @property {GUID} announcement_id - announcement_id
 * @property {string} view_type - view_type
 * @property {number} card_position - position of the announcement
 * @property {string} platform - platform
 * @property {GUID} msid - msid
 * @return {LogObject<viewFeatureCardParams>} LogObject<viewFeatureCardParams>
 */
export function viewFeatureCard(params) {
    return { evid: 341, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'cardCta' event (evid: 342)
 *
 * Event description: CTA button
 *
 * @param {cardCtaParams} params - The parameters for this event
 * @property {string} button_type - main/secondary
 * @property {GUID} announcement_id - announcement_id
 * @property {string} button_name - cta name
 * @property {string} view_type - view_type
 * @property {number} card_position - position of the announcement
 * @property {string} platform - platform
 * @property {GUID} msid - msid
 * @return {LogObject<cardCtaParams>} LogObject<cardCtaParams>
 */
export function cardCta(params) {
    return { evid: 342, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'viewedAllUpdates' event (evid: 343)
 *
 * Event description: Users gets to the bottom of the feed
 *
 * @param {viewedAllUpdatesParams} params - The parameters for this event
 * @property {string} view_type - view_type
 * @property {string} platform - platform
 * @property {GUID} msid - msid
 * @return {LogObject<viewedAllUpdatesParams>} LogObject<viewedAllUpdatesParams>
 */
export function viewedAllUpdates(params) {
    return { evid: 343, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'settingsOverviewPageClickOnItem' event (evid: 345)
 *
 * Event description: when a user clicks on item in one of the OS Settings page
 *
 * @param {settingsOverviewPageClickOnItemParams} params - The parameters for this event
 * @property {string} click_name - deprecated
 * @property {string} hosting_platform - in case it's Wix studio Business info (account level business info page) then the value is 'my-account-2-dashboard' otherwise the value is null and it means it's BizMgr business info (site level business info)
 * @property {string} page_view - The page of the click (website settings/business info/language and region)
 * @property {string} view_type - view_type
 * @property {string} item_name - the name of the item
 * @property {string} status_text - deprecated
 * @property {string} fold_name - card name
 * @property {string} platform - platform
 * @property {string} hosting - MA/editor/ADI
 * @property {GUID} msid - --
 * @return {LogObject<settingsOverviewPageClickOnItemParams>} LogObject<settingsOverviewPageClickOnItemParams>
 */
export function settingsOverviewPageClickOnItem(params) {
    return { evid: 345, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'automationsClicksOnTips' event (evid: 346)
 *
 * Event description: User click on a Automation tip from the banner or other places
 *
 * @param {automationsClicksOnTipsParams} params - The parameters for this event
 * @property {string} offerId - Dealer Offer id
 * @property {string} view_type - view_type
 * @property {string} origin - origin
 * @property {string} tipType - video / kb / external
 * @property {string} platform - platform
 * @property {string} tipTitle - tip name
 * @property {GUID} msid - msid
 * @return {LogObject<automationsClicksOnTipsParams>} LogObject<automationsClicksOnTipsParams>
 */
export function automationsClicksOnTips(params) {
    return { evid: 346, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'quotesBulkActionsPrint' event (evid: 348)
 *
 * Event description: Quotes - Create invoice - Toggle Recurring
 *
 * @param {quotesBulkActionsPrintParams} params - The parameters for this event
 * @property {string} number - number of invoices choose or all
 * @property {string} view_type - view_type
 * @property {string} filter - type of filter
 * @property {string} platform - platform
 * @property {string} msid - msid
 * @return {LogObject<quotesBulkActionsPrintParams>} LogObject<quotesBulkActionsPrintParams>
 */
export function quotesBulkActionsPrint(params) {
    return { evid: 348, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'setupWidgetItems' event (evid: 349)
 *
 * Event description: When a user has an open phase in the dashboard (since they did not complete all tasks in the phase (it is not collapsed), sent each time the user enters the dashboard - home. Following a bug fix, the data is accurate since 25.5.20
 *
 * @param {setupWidgetItemsParams} params - The parameters for this event
 * @property {string} skipped_items - a list of offering guids that were skipped in the phase
 * @property {string} resolved_items - a list of offering guids that were resolved in the phase
 * @property {string} asset_campaign_guid - dealer placement id
 * @property {string} location - dashboard/sidebar
 * @property {number} number_of_available_items - number_of_open_items
 * @property {string} available_items - a list of offering guids that are available in the phase
 * @property {number} number_of_resolved_items - number_of_resolved_items
 * @property {string} view_type - view_type
 * @property {number} number_of_skipped_items - number_of_skipped_items
 * @property {string} setup_location - dashboard/sidebar/popover
 * @property {string} platform - platform
 * @property {string} hosting - ADI/Editor/MA
 * @property {GUID} msid - msid
 * @property {string} trigger - normal/hover/click/step-completed
 * @return {LogObject<setupWidgetItemsParams>} LogObject<setupWidgetItemsParams>
 */
export function setupWidgetItems(params) {
    return { evid: 349, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'dashboardShowSideBar' event (evid: 35)
 *
 * Event description: send event each time the side bar is being shown ( repurposed for mobile web sidebar)
 *
 * @param {dashboardShowSideBarParams} params - The parameters for this event
 * @property {string} page_view - my sites/site home
 * @property {string} view_type - view_type
 * @property {boolean} alwaysOpen - if the side bar always open at application (not relevant anymore)
 * @property {string} selectedItem - name of application ('mobile sidebar' in case of mobile web)
 * @property {string} platform - platform
 * @property {GUID} msid - msid
 * @property {string} action - open/close
 * @return {LogObject<dashboardShowSideBarParams>} LogObject<dashboardShowSideBarParams>
 */
export function dashboardShowSideBar(params) {
    return { evid: 35, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'rolesAddNewRoleClick' event (evid: 350)
 *
 * Event description: click on add new from authorization tab in site settings
 *
 * @param {rolesAddNewRoleClickParams} params - The parameters for this event
 * @property {boolean} is_blog_shown - true if shown (blog manager appears only for sites with blog)
 * @property {string} view_type - view_type
 * @property {string} roles_displayed - list of roles displayed to the user
 * @property {string} origin - name of tab dashboard/authorization/my sites
 * @property {string} platform - platform
 * @property {string} hosting - MA/Editor
 * @property {boolean} is_events_shown - true if shown (event manager appears only for sites with events )
 * @property {GUID} msid - msid
 * @return {LogObject<rolesAddNewRoleClickParams>} LogObject<rolesAddNewRoleClickParams>
 */
export function rolesAddNewRoleClick(params) {
    return { evid: 350, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'rolesAddRoleCloseWindow' event (evid: 351)
 *
 * Event description: user closed add role window
 *
 * @param {rolesAddRoleCloseWindowParams} params - The parameters for this event
 * @property {string} view_type - view_type
 * @property {string} origin - name of tab dashboard/authorization/my sites
 * @property {string} platform - platform
 * @property {string} hosting - Editor / MA
 * @property {GUID} msid - msid
 * @return {LogObject<rolesAddRoleCloseWindowParams>} LogObject<rolesAddRoleCloseWindowParams>
 */
export function rolesAddRoleCloseWindow(params) {
    return { evid: 351, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'rolesAddRoleInviteClick' event (evid: 352)
 *
 * Event description: user clicked on 'invite' in the add role window
 *
 * @param {rolesAddRoleInviteClickParams} params - The parameters for this event
 * @property {string} view_type - view_type
 * @property {string} roles_displayed - list of roles displayed to the user
 * @property {string} origin - name of tab dashboard/authorization/my sites
 * @property {string} invite_role - invited role
 * @property {boolean} is_valid_email - email validation
 * @property {string} platform - platform
 * @property {string} hosting - MA / Editor
 * @property {string} invite_email - not reported (PII)
 * @property {GUID} msid - msid
 * @return {LogObject<rolesAddRoleInviteClickParams>} LogObject<rolesAddRoleInviteClickParams>
 */
export function rolesAddRoleInviteClick(params) {
    return { evid: 352, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'rolesAddRoleInviteClickSuccess' event (evid: 353)
 *
 * Event description: user clicked on 'invite' in the add role window - success response
 *
 * @param {rolesAddRoleInviteClickSuccessParams} params - The parameters for this event
 * @property {boolean} is_blog_shown - deprecated from 2/6/19 and replaced by roles_displayed field
 * @property {string} view_type - view_type
 * @property {string} roles_displayed - list of roles displayed to the user
 * @property {string} origin - name of tab dashboard/authorization/my sites
 * @property {string} invite_role - invited role
 * @property {string} platform - platform
 * @property {string} hosting - Editor / MA
 * @property {string} invite_email - invited email
 * @property {GUID} msid - msid
 * @return {LogObject<rolesAddRoleInviteClickSuccessParams>} LogObject<rolesAddRoleInviteClickSuccessParams>
 */
export function rolesAddRoleInviteClickSuccess(params) {
    return { evid: 353, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'crmHomeButtonClicked' event (evid: 354)
 *
 * Event description: CRM Home - Button Clicked
 *
 * @param {crmHomeButtonClickedParams} params - The parameters for this event
 * @property {GUID} uuid - uuid
 * @property {string} button_name - button name
 * @property {string} view_type - view_type
 * @property {string} section - i.e create automation , manage finance , all crm tabs
 * @property {string} platform - platform
 * @property {GUID} msid - msid
 * @return {LogObject<crmHomeButtonClickedParams>} LogObject<crmHomeButtonClickedParams>
 */
export function crmHomeButtonClicked(params) {
    return { evid: 354, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'rolesAddRoleInviteClickFail' event (evid: 355)
 *
 * Event description: user clicked on 'invite' in the add role window - fail response
 *
 * @param {rolesAddRoleInviteClickFailParams} params - The parameters for this event
 * @property {string} error_desc - error description
 * @property {string} view_type - view_type
 * @property {string} roles_displayed - list of roles displayed to the user
 * @property {string} origin - name of tab dashboard/authorization/my sites
 * @property {string} invite_role - invited role
 * @property {string} platform - platform
 * @property {string} hosting - MA / Editor
 * @property {string} invite_email - invited email, empty if email isn't valid
 * @property {GUID} msid - msid
 * @return {LogObject<rolesAddRoleInviteClickFailParams>} LogObject<rolesAddRoleInviteClickFailParams>
 */
export function rolesAddRoleInviteClickFail(params) {
    return { evid: 355, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'rolesLoginPageLoadStart' event (evid: 356)
 *
 * Event description: before login component is loaded - page load start
 *
 * @param {rolesLoginPageLoadStartParams} params - The parameters for this event
 * @property {string} view_type - view_type
 * @property {string} invite_id - invite_id
 * @property {string} platform - platform
 * @property {string} invite_email - invited email
 * @property {GUID} msid - msid
 * @return {LogObject<rolesLoginPageLoadStartParams>} LogObject<rolesLoginPageLoadStartParams>
 */
export function rolesLoginPageLoadStart(params) {
    return { evid: 356, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'rolesLoginPageLoadComplete' event (evid: 357)
 *
 * Event description: before login component is loaded - page load complete
 *
 * @param {rolesLoginPageLoadCompleteParams} params - The parameters for this event
 * @property {string} view_type - view_type
 * @property {string} invite_id - invite_id
 * @property {string} platform - platform
 * @property {string} invite_email - invited email
 * @property {GUID} msid - msid
 * @return {LogObject<rolesLoginPageLoadCompleteParams>} LogObject<rolesLoginPageLoadCompleteParams>
 */
export function rolesLoginPageLoadComplete(params) {
    return { evid: 357, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'rolesAcceptFail' event (evid: 358)
 *
 * Event description: post login signup accept response fail
 *
 * @param {rolesAcceptFailParams} params - The parameters for this event
 * @property {string} view_type - view_type
 * @property {string} invite_id - invite id
 * @property {string} platform - platform
 * @property {string} invite_email - invited email
 * @property {GUID} msid - msid
 * @return {LogObject<rolesAcceptFailParams>} LogObject<rolesAcceptFailParams>
 */
export function rolesAcceptFail(params) {
    return { evid: 358, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'rolesResendInviteClick' event (evid: 359)
 *
 * Event description: user clicked on resend invite
 *
 * @param {rolesResendInviteClickParams} params - The parameters for this event
 * @property {string} view_type - view_type
 * @property {string} origin - name of tab
 * @property {string} invite_role - invited role
 * @property {string} platform - platform
 * @property {string} hosting - MA /Editor
 * @property {string} invite_email - invited email
 * @property {GUID} msid - msid
 * @return {LogObject<rolesResendInviteClickParams>} LogObject<rolesResendInviteClickParams>
 */
export function rolesResendInviteClick(params) {
    return { evid: 359, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'dashboardCloseBanner' event (evid: 36)
 *
 * Event description: send each time user see banner
 *
 * @param {dashboardCloseBannerParams} params - The parameters for this event
 * @property {string} name - of banner
 * @property {string} view_type - view_type
 * @property {string} origin - where is the banner displayed
 * @property {string} platform - platform
 * @property {GUID} msid - msid
 * @return {LogObject<dashboardCloseBannerParams>} LogObject<dashboardCloseBannerParams>
 */
export function dashboardCloseBanner(params) {
    return { evid: 36, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'rolesDeleteRoleClick' event (evid: 360)
 *
 * Event description: user clicked on delete role
 *
 * @param {rolesDeleteRoleClickParams} params - The parameters for this event
 * @property {string} view_type - view_type
 * @property {string} accept_email - accepted email
 * @property {string} origin - name of tab
 * @property {string} platform - platform
 * @property {string} hosting - MA / Editor
 * @property {GUID} msid - msid
 * @return {LogObject<rolesDeleteRoleClickParams>} LogObject<rolesDeleteRoleClickParams>
 */
export function rolesDeleteRoleClick(params) {
    return { evid: 360, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'rolesDeleteRoleCloseWindow' event (evid: 361)
 *
 * Event description: user closed delete role window
 *
 * @param {rolesDeleteRoleCloseWindowParams} params - The parameters for this event
 * @property {string} view_type - view_type
 * @property {string} accept_email - accepted email
 * @property {string} origin - name of tab
 * @property {string} platform - platform
 * @property {string} hosting - MA /Editor
 * @property {GUID} msid - msid
 * @return {LogObject<rolesDeleteRoleCloseWindowParams>} LogObject<rolesDeleteRoleCloseWindowParams>
 */
export function rolesDeleteRoleCloseWindow(params) {
    return { evid: 361, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'rolesDeleteRoleDeleteClick' event (evid: 362)
 *
 * Event description: user clicked on 'delete' in the delete role window
 *
 * @param {rolesDeleteRoleDeleteClickParams} params - The parameters for this event
 * @property {string} view_type - view_type
 * @property {string} accept_email - accepted email
 * @property {string} origin - name of tab
 * @property {string} platform - platform
 * @property {string} hosting - MA / Editor
 * @property {GUID} msid - msid
 * @return {LogObject<rolesDeleteRoleDeleteClickParams>} LogObject<rolesDeleteRoleDeleteClickParams>
 */
export function rolesDeleteRoleDeleteClick(params) {
    return { evid: 362, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'rolesDeleteRoleDeleteClickSuccess' event (evid: 363)
 *
 * Event description: user clicked on 'delete' in the delete role window - success response
 *
 * @param {rolesDeleteRoleDeleteClickSuccessParams} params - The parameters for this event
 * @property {string} view_type - view_type
 * @property {string} accept_email - accepted email
 * @property {string} origin - name of tab
 * @property {string} platform - platform
 * @property {string} hosting - MA / Editor
 * @property {GUID} msid - msid
 * @return {LogObject<rolesDeleteRoleDeleteClickSuccessParams>} LogObject<rolesDeleteRoleDeleteClickSuccessParams>
 */
export function rolesDeleteRoleDeleteClickSuccess(params) {
    return { evid: 363, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'rolesDeleteRoleDeleteClickFail' event (evid: 364)
 *
 * Event description: user clicked on 'delete' in the delete role window - fail response
 *
 * @param {rolesDeleteRoleDeleteClickFailParams} params - The parameters for this event
 * @property {string} view_type - view_type
 * @property {string} accept_email - accepted email
 * @property {string} origin - name of tab
 * @property {string} platform - platform
 * @property {string} hosting - MA / Editor
 * @property {GUID} msid - msid
 * @return {LogObject<rolesDeleteRoleDeleteClickFailParams>} LogObject<rolesDeleteRoleDeleteClickFailParams>
 */
export function rolesDeleteRoleDeleteClickFail(params) {
    return { evid: 364, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'rolesAcceptInviteFromMobilePageView' event (evid: 365)
 *
 * Event description: user accepted invite from mobile page view
 *
 * @param {rolesAcceptInviteFromMobilePageViewParams} params - The parameters for this event
 * @property {string} view_type - view_type
 * @property {string} inviteToken - token
 * @property {string} invite_id - invite_id
 * @property {string} platform - platform
 * @property {GUID} msid - msid
 * @return {LogObject<rolesAcceptInviteFromMobilePageViewParams>} LogObject<rolesAcceptInviteFromMobilePageViewParams>
 */
export function rolesAcceptInviteFromMobilePageView(params) {
    return { evid: 365, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'rolesEditRoleClick' event (evid: 366)
 *
 * Event description: click on edit role
 *
 * @param {rolesEditRoleClickParams} params - The parameters for this event
 * @property {boolean} is_blog_shown - true if shown (blog manager appears only for sites with blog)
 * @property {boolean} is_accepted - true if invite was accepted
 * @property {string} view_type - view_type
 * @property {string} roles_displayed - list of roles displayed to the user
 * @property {string} origin - origin page
 * @property {string} platform - platform
 * @property {string} hosting - MA/Editor
 * @property {boolean} is_events_shown - is_events_shown
 * @property {GUID} msid - msid
 * @return {LogObject<rolesEditRoleClickParams>} LogObject<rolesEditRoleClickParams>
 */
export function rolesEditRoleClick(params) {
    return { evid: 366, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'rolesEditRoleUpdateClick' event (evid: 367)
 *
 * Event description: user clicked on 'update' in the edit role window - success response
 *
 * @param {rolesEditRoleUpdateClickParams} params - The parameters for this event
 * @property {boolean} is_blog_shown - true if shown (blog manager appears only for sites with blog)
 * @property {string} new_role - new role
 * @property {boolean} is_accepted - true if edit is after invite was accepted
 * @property {string} view_type - view_type
 * @property {string} roles_displayed - list of roles displayed to the user
 * @property {string} prev_role - previous role
 * @property {string} origin - origin page
 * @property {string} platform - platform
 * @property {string} hosting - Editor / MA
 * @property {GUID} msid - msid
 * @return {LogObject<rolesEditRoleUpdateClickParams>} LogObject<rolesEditRoleUpdateClickParams>
 */
export function rolesEditRoleUpdateClick(params) {
    return { evid: 367, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'rolesGetInviteLink' event (evid: 368)
 *
 * Event description: user clicked on get invite link
 *
 * @param {rolesGetInviteLinkParams} params - The parameters for this event
 * @property {string} view_type - view_type
 * @property {string} invite_role - invited role
 * @property {string} platform - platform
 * @property {string} hosting - MA /Editor
 * @property {GUID} msid - msid
 * @property {string} action - not in use
 * @return {LogObject<rolesGetInviteLinkParams>} LogObject<rolesGetInviteLinkParams>
 */
export function rolesGetInviteLink(params) {
    return { evid: 368, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'analyticsKpiIsShownInAnalyticsWidget' event (evid: 369)
 *
 * Event description: For each kpi shown in the analytics widget
 *
 * @param {analyticsKpiIsShownInAnalyticsWidgetParams} params - The parameters for this event
 * @property {string} kpi_period - the kpis period chosen for all seen kpis when the kpi is shown
 * @property {number} kpi_location - 0-left 1-middle 2-right
 * @property {string} view_type - view_type
 * @property {string} kpi_name - kpi's name
 * @property {string} app_id - app id of the vertical that displays the widget.
 * @property {string} platform - platform
 * @property {string} hosting - MA/editor/ADI
 * @property {GUID} msid - msid
 * @property {string} value - the value that WAS returns as the kpi value
 * @return {LogObject<analyticsKpiIsShownInAnalyticsWidgetParams>} LogObject<analyticsKpiIsShownInAnalyticsWidgetParams>
 */
export function analyticsKpiIsShownInAnalyticsWidget(params) {
    return { evid: 369, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'dashboardNewsUserClickReadMore' event (evid: 37)
 *
 * Event description: each time user clicks reed more send. in the Dashboard, the news link can lead only to the News Feed
 *
 * @param {dashboardNewsUserClickReadMoreParams} params - The parameters for this event
 * @property {string} source - the app that sent the feed
 * @property {GUID} feedId - unique identifier of the feed
 * @property {string} view_type - view_type
 * @property {string} origin - of read more
 * @property {string} title - of the feed
 * @property {string} type - of activity
 * @property {string} platform - platform
 * @property {GUID} msid - unique identifier of the site
 * @return {LogObject<dashboardNewsUserClickReadMoreParams>} LogObject<dashboardNewsUserClickReadMoreParams>
 */
export function dashboardNewsUserClickReadMore(params) {
    return { evid: 37, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'analyticsErrorMessage' event (evid: 370)
 *
 * Event description: When the user sees an error message on the widgets in the dashboard
 *
 * @param {analyticsErrorMessageParams} params - The parameters for this event
 * @property {string} widget_name - widget name
 * @property {string} view_type - view_type
 * @property {string} error_type - type of the error
 * @property {string} platform - platform
 * @property {string} hosting - MA/editor/ADI
 * @property {GUID} msid - msid
 * @return {LogObject<analyticsErrorMessageParams>} LogObject<analyticsErrorMessageParams>
 */
export function analyticsErrorMessage(params) {
    return { evid: 370, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'analyticsTooltip' event (evid: 371)
 *
 * Event description: Tooltip for Analytics
 *
 * @param {analyticsTooltipParams} params - The parameters for this event
 * @property {string} name - The tooltip name. Till July 2020 was not populated  (only "info" was reported).
 * @property {string} view_type - view_type
 * @property {string} platform - platform
 * @property {string} hosting - Dashboard/editor/ADI
 * @property {GUID} msid - msid
 * @return {LogObject<analyticsTooltipParams>} LogObject<analyticsTooltipParams>
 */
export function analyticsTooltip(params) {
    return { evid: 371, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'analyticsClickOnWidgetButtons' event (evid: 372)
 *
 * Event description: Click on Widget Buttons
 *
 * @param {analyticsClickOnWidgetButtonsParams} params - The parameters for this event
 * @property {string} click_name - collapse/expand/customize
 * @property {string} view_type - view_type
 * @property {string} platform - platform
 * @property {string} hosting - MA/editor/ADI
 * @property {GUID} msid - msid
 * @return {LogObject<analyticsClickOnWidgetButtonsParams>} LogObject<analyticsClickOnWidgetButtonsParams>
 */
export function analyticsClickOnWidgetButtons(params) {
    return { evid: 372, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'analyticsClickOnKpi' event (evid: 373)
 *
 * Event description: click on KPI from Analytics Widget
 *
 * @param {analyticsClickOnKpiParams} params - The parameters for this event
 * @property {number} kpi_location - 0-left 1-middle 2-right
 * @property {string} view_type - view_type
 * @property {string} kpi_name - kpi's name
 * @property {string} platform - platform
 * @property {string} hosting - MA/editor/ADI
 * @property {GUID} msid - msid
 * @return {LogObject<analyticsClickOnKpiParams>} LogObject<analyticsClickOnKpiParams>
 */
export function analyticsClickOnKpi(params) {
    return { evid: 373, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'analyticsChooseKpiFromCustomizationList' event (evid: 374)
 *
 * Event description: When a user gets an error in the dialog (e.g. picks a 4th item)
 *
 * @param {analyticsChooseKpiFromCustomizationListParams} params - The parameters for this event
 * @property {string} selected_kpis - the chosen kpis in the following way -> kpi: location: (json)
 * @property {string} added_kpi_location - the location of the kpi the user tried to add when they got the error
 * @property {string} error_desc - the error the user received
 * @property {string} view_type - view_type
 * @property {string} added_kpi - the kpi the user tried to add when they got the error
 * @property {string} platform - platform
 * @property {string} hosting - MA/editor/ADI
 * @property {GUID} msid - msid
 * @return {LogObject<analyticsChooseKpiFromCustomizationListParams>} LogObject<analyticsChooseKpiFromCustomizationListParams>
 */
export function analyticsChooseKpiFromCustomizationList(params) {
    return { evid: 374, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'analyticsClickOnButtonFromCustomizationList' event (evid: 375)
 *
 * Event description: Click on apply button from customization list
 *
 * @param {analyticsClickOnButtonFromCustomizationListParams} params - The parameters for this event
 * @property {string} selected_kpis - the chosen kpis in the following way -> kpi: location: (json)
 * @property {string} view_type - view_type
 * @property {string} platform - platform
 * @property {string} hosting - MA/editor/ADI
 * @property {GUID} msid - msid
 * @return {LogObject<analyticsClickOnButtonFromCustomizationListParams>} LogObject<analyticsClickOnButtonFromCustomizationListParams>
 */
export function analyticsClickOnButtonFromCustomizationList(params) {
    return { evid: 375, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'analyticsChangeKpisTimePeriod' event (evid: 376)
 *
 * Event description: When a user chooses to change the time period of the kpis shown to him in analytics widget (the click that actually changes the period - not the period selection menu)
 *
 * @param {analyticsChangeKpisTimePeriodParams} params - The parameters for this event
 * @property {string} kpi_period - the kpis period chosen for all seen kpis when the kpi is shown
 * @property {string} view_type - view_type
 * @property {string} app_id - app id of the vertical that displays the widget.
 * @property {string} platform - platform
 * @property {string} hosting - MA/Editor
 * @property {GUID} msid - msid
 * @return {LogObject<analyticsChangeKpisTimePeriodParams>} LogObject<analyticsChangeKpisTimePeriodParams>
 */
export function analyticsChangeKpisTimePeriod(params) {
    return { evid: 376, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'analyticsHoverAKpi' event (evid: 377)
 *
 * Event description: Hover a KPI from Analytics Widget
 *
 * @param {analyticsHoverAKpiParams} params - The parameters for this event
 * @property {number} kpi_location - 0-left 1-middle 2-right
 * @property {string} view_type - view_type
 * @property {string} kpi_name - kpi's name
 * @property {string} platform - platform
 * @property {string} hosting - MA/editor/ADI
 * @property {GUID} msid - msid
 * @return {LogObject<analyticsHoverAKpiParams>} LogObject<analyticsHoverAKpiParams>
 */
export function analyticsHoverAKpi(params) {
    return { evid: 377, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'notificationsClickOnAChannelSettings' event (evid: 379)
 *
 * Event description: On the Notification Setting page,  "Set Notifications by Channel" section, click on collapse/expand.
 *
 * @param {notificationsClickOnAChannelSettingsParams} params - The parameters for this event
 * @property {string} click_name - collapse/expand
 * @property {string} channel - channel section the user clicked on
 * @property {string} view_type - view_type
 * @property {string} platform - platform
 * @property {string} hosting - MA/editor/ADI
 * @property {GUID} msid - msid
 * @return {LogObject<notificationsClickOnAChannelSettingsParams>} LogObject<notificationsClickOnAChannelSettingsParams>
 */
export function notificationsClickOnAChannelSettings(params) {
    return { evid: 379, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'dashboardNewsClickViewAll' event (evid: 38)
 *
 * Event description: clicking view all. leads to the News Feed
 *
 * @param {dashboardNewsClickViewAllParams} params - The parameters for this event
 * @property {string} view_type - view_type
 * @property {string} platform - platform
 * @property {GUID} msid - msid
 * @return {LogObject<dashboardNewsClickViewAllParams>} LogObject<dashboardNewsClickViewAllParams>
 */
export function dashboardNewsClickViewAll(params) {
    return { evid: 38, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'notificationsClickOnChannelLink' event (evid: 380)
 *
 * Event description: Click on a Channel link via "Set Notifications by Channel" section
 *
 * @param {notificationsClickOnChannelLinkParams} params - The parameters for this event
 * @property {string} channel - channel section channel section the user clicked on
 * @property {string} url - the url the user is transferred to
 * @property {string} view_type - view_type
 * @property {string} platform - platform
 * @property {boolean} has_settings - Indication if there are settings options for the channel
 * @property {string} hosting - MA/editor/ADI
 * @property {GUID} msid - msid
 * @return {LogObject<notificationsClickOnChannelLinkParams>} LogObject<notificationsClickOnChannelLinkParams>
 */
export function notificationsClickOnChannelLink(params) {
    return { evid: 380, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'quotesClickDueDate' event (evid: 383)
 *
 * Event description: Quotes - click due date
 *
 * @param {quotesClickDueDateParams} params - The parameters for this event
 * @property {string} view_type - view_type
 * @property {string} platform - platform
 * @property {string} msid - msid
 * @return {LogObject<quotesClickDueDateParams>} LogObject<quotesClickDueDateParams>
 */
export function quotesClickDueDate(params) {
    return { evid: 383, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'quotesChooseDueDate' event (evid: 384)
 *
 * Event description: Quotes - choose due date
 *
 * @param {quotesChooseDueDateParams} params - The parameters for this event
 * @property {string} view_type - view_type
 * @property {DateTime} dueDate - Due date added
 * @property {string} platform - platform
 * @property {string} msid - msid
 * @return {LogObject<quotesChooseDueDateParams>} LogObject<quotesChooseDueDateParams>
 */
export function quotesChooseDueDate(params) {
    return { evid: 384, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'quotesClickIssueDate' event (evid: 385)
 *
 * Event description: Quotes - click issue date
 *
 * @param {quotesClickIssueDateParams} params - The parameters for this event
 * @property {string} view_type - view_type
 * @property {string} platform - platform
 * @property {string} msid - msid
 * @return {LogObject<quotesClickIssueDateParams>} LogObject<quotesClickIssueDateParams>
 */
export function quotesClickIssueDate(params) {
    return { evid: 385, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'quotesChooseIssueDate' event (evid: 386)
 *
 * Event description: Quotes - choose issue date
 *
 * @param {quotesChooseIssueDateParams} params - The parameters for this event
 * @property {string} view_type - view_type
 * @property {string} invoiceType - invoice_type
 * @property {string} platform - platform
 * @property {string} msid - msid
 * @return {LogObject<quotesChooseIssueDateParams>} LogObject<quotesChooseIssueDateParams>
 */
export function quotesChooseIssueDate(params) {
    return { evid: 386, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'notificationGroupNotificationIsDisplayed' event (evid: 387)
 *
 * Event description: user opens the dialog and group notification is seen.
 *
 * @param {notificationGroupNotificationIsDisplayedParams} params - The parameters for this event
 * @property {string} feed_name - All sites/This site /float
 * @property {string} channel - channel
 * @property {string} view_type - view_type
 * @property {string} notification_id_shown - the shown notification id
 * @property {string} notification_ids - list of the notification ids
 * @property {string} origin - MSID of the site the user is on, my-sites if on Site List. Later on, also account-settings, and other account-level pages.
 * @property {string} contact_id - contact_id guid
 * @property {string} platform - --
 * @property {number} page_number - page number - each page is limited to 30 notifications
 * @return {LogObject<notificationGroupNotificationIsDisplayedParams>} LogObject<notificationGroupNotificationIsDisplayedParams>
 */
export function notificationGroupNotificationIsDisplayed(params) {
    return { evid: 387, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'quotesViewPayments' event (evid: 388)
 *
 * Event description: Quotes - view payments
 *
 * @param {quotesViewPaymentsParams} params - The parameters for this event
 * @property {string} view_type - view_type
 * @property {string} platform - platform
 * @property {string} msid - msid
 * @return {LogObject<quotesViewPaymentsParams>} LogObject<quotesViewPaymentsParams>
 */
export function quotesViewPayments(params) {
    return { evid: 388, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'quotesSubscriptionViewPayments' event (evid: 389)
 *
 * Event description: Quotes - Subscription - view payments
 *
 * @param {quotesSubscriptionViewPaymentsParams} params - The parameters for this event
 * @property {string} view_type - view_type
 * @property {string} platform - platform
 * @property {string} msid - msid
 * @return {LogObject<quotesSubscriptionViewPaymentsParams>} LogObject<quotesSubscriptionViewPaymentsParams>
 */
export function quotesSubscriptionViewPayments(params) {
    return { evid: 389, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'dashboardProsSiteActionsOpened' event (evid: 39)
 *
 * Event description: user opens site actions  dialog in pro-my-sites
 *
 * @param {dashboardProsSiteActionsOpenedParams} params - The parameters for this event
 * @property {string} view_type - view_type
 * @property {string} platform - platform
 * @property {GUID} msid - -
 * @return {LogObject<dashboardProsSiteActionsOpenedParams>} LogObject<dashboardProsSiteActionsOpenedParams>
 */
export function dashboardProsSiteActionsOpened(params) {
    return { evid: 39, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'quotesBulkActionsDownloadPdf' event (evid: 397)
 *
 * Event description: Quotes - Create invoice - Toggle Recurring
 *
 * @param {quotesBulkActionsDownloadPdfParams} params - The parameters for this event
 * @property {string} number - number of invoices choose or all
 * @property {string} view_type - view_type
 * @property {string} filter - type of filter
 * @property {string} platform - platform
 * @property {string} msid - msid
 * @return {LogObject<quotesBulkActionsDownloadPdfParams>} LogObject<quotesBulkActionsDownloadPdfParams>
 */
export function quotesBulkActionsDownloadPdf(params) {
    return { evid: 397, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'quotesBulkActionsExportCsv' event (evid: 398)
 *
 * Event description: Quotes - Create invoice - Toggle Recurring
 *
 * @param {quotesBulkActionsExportCsvParams} params - The parameters for this event
 * @property {string} number - number of invoices choose or all
 * @property {string} view_type - view_type
 * @property {string} filter - type of filter
 * @property {string} platform - platform
 * @property {string} msid - msid
 * @return {LogObject<quotesBulkActionsExportCsvParams>} LogObject<quotesBulkActionsExportCsvParams>
 */
export function quotesBulkActionsExportCsv(params) {
    return { evid: 398, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'quotesDuplicateInvoice' event (evid: 399)
 *
 * Event description: Quotes - Duplicate Invoice
 *
 * @param {quotesDuplicateInvoiceParams} params - The parameters for this event
 * @property {string} view_type - view_type
 * @property {string} platform - platform
 * @property {string} msid - msid
 * @property {GUID} invoice_id - invoice guid
 * @return {LogObject<quotesDuplicateInvoiceParams>} LogObject<quotesDuplicateInvoiceParams>
 */
export function quotesDuplicateInvoice(params) {
    return { evid: 399, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'dashboardClickOnMySites' event (evid: 40)
 *
 * Event description: dashboard > click on my sites.
 *
 * @param {dashboardClickOnMySitesParams} params - The parameters for this event
 * @property {string} view_type - view_type
 * @property {string} origin - origin
 * @property {string} platform - platform
 * @property {GUID} msid - msid
 * @return {LogObject<dashboardClickOnMySitesParams>} LogObject<dashboardClickOnMySitesParams>
 */
export function dashboardClickOnMySites(params) {
    return { evid: 40, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'quotesTabPageView' event (evid: 400)
 *
 * Event description: wix invoices/ quotes tab page view
 *
 * @param {quotesTabPageViewParams} params - The parameters for this event
 * @property {string} name - tab name
 * @property {string} view_type - view_type
 * @property {string} experience - deprecated
 * @property {string} origin - web,native
 * @property {string} place - how the user arrived to the tab
 * @property {string} platform - platform
 * @property {string} msid - msid
 * @return {LogObject<quotesTabPageViewParams>} LogObject<quotesTabPageViewParams>
 */
export function quotesTabPageView(params) {
    return { evid: 400, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'quotesInvoicesOnboardingPageView' event (evid: 401)
 *
 * Event description: wix invoices onboarding flow - page view
 *
 * @param {quotesInvoicesOnboardingPageViewParams} params - The parameters for this event
 * @property {string} name - phase name
 * @property {string} view_type - view_type
 * @property {string} platform - platform
 * @property {string} msid - msid
 * @return {LogObject<quotesInvoicesOnboardingPageViewParams>} LogObject<quotesInvoicesOnboardingPageViewParams>
 */
export function quotesInvoicesOnboardingPageView(params) {
    return { evid: 401, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'quotesGetPaymentClick' event (evid: 402)
 *
 * Event description: site owner payment funnel - get payment click
 *
 * @param {quotesGetPaymentClickParams} params - The parameters for this event
 * @property {string} name - name of payment
 * @property {string} view_type - view_type
 * @property {string} origin - how user arrived to the flow
 * @property {string} type - connect/disconnect
 * @property {string} platform - platform
 * @property {string} msid - msid
 * @return {LogObject<quotesGetPaymentClickParams>} LogObject<quotesGetPaymentClickParams>
 */
export function quotesGetPaymentClick(params) {
    return { evid: 402, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'quotesNewInvoiceClick' event (evid: 403)
 *
 * Event description: Quotes - New invoice click
 *
 * @param {quotesNewInvoiceClickParams} params - The parameters for this event
 * @property {GUID} originalInvoiceId - in case of duplicate: original invoice guid
 * @property {string} view_type - view_type
 * @property {string} origin - origin page, my invoices ( on mobile, when creating from list), create invoice - on web, when creating for the first time, widget (mobile), quick actions (mobile)
 * @property {string} status - Creation form/Draft/Sent/Paid
 * @property {boolean} create_order - true / false -  indicates the type of the flow (in case of type= duplicate it will indicate the type of invoice)
 * @property {string} type - [invoice / invoice&order/ duplicate / get started / without menu]
 * @property {string} platform - platform
 * @property {string} msid - msid
 * @property {GUID} invoice_id - invoice guid
 * @return {LogObject<quotesNewInvoiceClickParams>} LogObject<quotesNewInvoiceClickParams>
 */
export function quotesNewInvoiceClick(params) {
    return { evid: 403, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'quotesEmailInvoicePage' event (evid: 404)
 *
 * Event description: email invoice pop up
 *
 * @param {quotesEmailInvoicePageParams} params - The parameters for this event
 * @property {string} paymentType - 'one time', 'recurring'
 * @property {string} view_type - view_type
 * @property {string} origin - origin page
 * @property {string} status - Creation form/Draft/Sent/Paid
 * @property {string} origin_device - web,native
 * @property {string} invoiceSource - by app_def_id
 * @property {boolean} resend - resend mode?
 * @property {string} platform - platform
 * @property {string} msid - msid
 * @property {GUID} invoice_id - invoice guid
 * @return {LogObject<quotesEmailInvoicePageParams>} LogObject<quotesEmailInvoicePageParams>
 */
export function quotesEmailInvoicePage(params) {
    return { evid: 404, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'quotesEmailInvoicePageCancelClick' event (evid: 405)
 *
 * Event description: email invoice - clicked on cancel
 *
 * @param {quotesEmailInvoicePageCancelClickParams} params - The parameters for this event
 * @property {string} view_type - view_type
 * @property {string} origin - origin page
 * @property {string} origin_device - web,native
 * @property {boolean} resend - resend mode?
 * @property {string} platform - platform
 * @property {string} msid - msid
 * @property {GUID} invoice_id - invoice guid
 * @return {LogObject<quotesEmailInvoicePageCancelClickParams>} LogObject<quotesEmailInvoicePageCancelClickParams>
 */
export function quotesEmailInvoicePageCancelClick(params) {
    return { evid: 405, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'quotesViewInvoicePageView' event (evid: 406)
 *
 * Event description: view invoice page view
 *
 * @param {quotesViewInvoicePageViewParams} params - The parameters for this event
 * @property {string} source - source
 * @property {string} no_of_payments - number of online payments available for this invoice
 * @property {string} paymentType - payment_type
 * @property {string} view_type - view_type
 * @property {boolean} is_visible - true if the pay invoice button is shown
 * @property {boolean} paid - true if invoice was paid
 * @property {string} origin - origin page
 * @property {string} invoiceSource - by app_def_id
 * @property {string} platform - platform
 * @property {string} msid - msid
 * @property {GUID} invoice_id - invoice guid
 * @property {string} view - other/desktop/tablet/smartphone
 * @return {LogObject<quotesViewInvoicePageViewParams>} LogObject<quotesViewInvoicePageViewParams>
 */
export function quotesViewInvoicePageView(params) {
    return { evid: 406, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'quotesChangeValue' event (evid: 407)
 *
 * Event description: change value
 *
 * @param {quotesChangeValueParams} params - The parameters for this event
 * @property {string} name - field name key (customer, email, subject, message, ..)
 * @property {string} view_type - view_type
 * @property {string} origin - name of page: create invoice, email invoice, settings
 * @property {string} platform - platform
 * @property {string} msid - msid
 * @property {string} value - value of field
 * @property {GUID} invoice_id - invoice guid
 * @return {LogObject<quotesChangeValueParams>} LogObject<quotesChangeValueParams>
 */
export function quotesChangeValue(params) {
    return { evid: 407, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'quotesCreateInvoiceSaveDraftClick' event (evid: 408)
 *
 * Event description: Create invoice - Save draft button click
 *
 * @param {quotesCreateInvoiceSaveDraftClickParams} params - The parameters for this event
 * @property {string} paymentType - 'one time','recurring'
 * @property {string} view_type - view_type
 * @property {string} invoiceType - ’recurringAutoCharge’/ 'recurring'/ 'one time'
 * @property {string} origin - create invoice, edit invoice,premium banner
 * @property {string} status - Creation form/Draft/Sent/Paid
 * @property {string} platform - platform
 * @property {string} msid - msid
 * @property {GUID} invoice_id - invoice guid
 * @return {LogObject<quotesCreateInvoiceSaveDraftClickParams>} LogObject<quotesCreateInvoiceSaveDraftClickParams>
 */
export function quotesCreateInvoiceSaveDraftClick(params) {
    return { evid: 408, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'quotesCreateInvoiceSaveDraftComplete' event (evid: 409)
 *
 * Event description: Create invoice - Save draft completed
 *
 * @param {quotesCreateInvoiceSaveDraftCompleteParams} params - The parameters for this event
 * @property {string} paymentType - 'one time','recurring'
 * @property {string} view_type - view_type
 * @property {string} origin - create invoice, edit invoice
 * @property {string} invoiceSource - by app_def_id
 * @property {string} platform - platform
 * @property {string} msid - msid
 * @property {GUID} invoice_id - invoice guid
 * @return {LogObject<quotesCreateInvoiceSaveDraftCompleteParams>} LogObject<quotesCreateInvoiceSaveDraftCompleteParams>
 */
export function quotesCreateInvoiceSaveDraftComplete(params) {
    return { evid: 409, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'dashboardClickToggleSitesListInNavbar' event (evid: 41)
 *
 * Event description: dashboard > click toggle sites list in navbar.
 *
 * @param {dashboardClickToggleSitesListInNavbarParams} params - The parameters for this event
 * @property {string} view_type - view_type
 * @property {string} platform - platform
 * @property {GUID} msid - msid
 * @property {string} action - action
 * @return {LogObject<dashboardClickToggleSitesListInNavbarParams>} LogObject<dashboardClickToggleSitesListInNavbarParams>
 */
export function dashboardClickToggleSitesListInNavbar(params) {
    return { evid: 41, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'quotesCreateInvoiceSaveDraftFailed' event (evid: 410)
 *
 * Event description: Create invoice - Save draft failed
 *
 * @param {quotesCreateInvoiceSaveDraftFailedParams} params - The parameters for this event
 * @property {string} view_type - view_type
 * @property {string} reason - failure reason
 * @property {string} origin - create invoice, edit invoice
 * @property {string} platform - platform
 * @property {string} msid - msid
 * @property {GUID} invoice_id - invoice guid
 * @return {LogObject<quotesCreateInvoiceSaveDraftFailedParams>} LogObject<quotesCreateInvoiceSaveDraftFailedParams>
 */
export function quotesCreateInvoiceSaveDraftFailed(params) {
    return { evid: 410, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'quotesCreateInvoiceCancelClick' event (evid: 411)
 *
 * Event description: Create invoice - cancel click
 *
 * @param {quotesCreateInvoiceCancelClickParams} params - The parameters for this event
 * @property {string} view_type - view_type
 * @property {string} origin - button, navigation
 * @property {string} platform - platform
 * @property {string} msid - msid
 * @property {GUID} invoice_id - invoice guid
 * @return {LogObject<quotesCreateInvoiceCancelClickParams>} LogObject<quotesCreateInvoiceCancelClickParams>
 */
export function quotesCreateInvoiceCancelClick(params) {
    return { evid: 411, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'quotesCreateInvoiceAddLine' event (evid: 412)
 *
 * Event description: Create invoice - add line
 *
 * @param {quotesCreateInvoiceAddLineParams} params - The parameters for this event
 * @property {string} source - productSource
 * @property {string} view_type - view_type
 * @property {GUID} appDefId - appDefId
 * @property {string} invoiceType - ’recurringAutoCharge’/ 'recurring'/ 'one time'
 * @property {string} origin - create invoice, edit invoice
 * @property {string} platform - platform
 * @property {string} msid - msid
 * @property {GUID} invoice_id - invoice guid
 * @return {LogObject<quotesCreateInvoiceAddLineParams>} LogObject<quotesCreateInvoiceAddLineParams>
 */
export function quotesCreateInvoiceAddLine(params) {
    return { evid: 412, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'quotesCreateInvoiceDeleteLine' event (evid: 413)
 *
 * Event description: Create invoice - delete line
 *
 * @param {quotesCreateInvoiceDeleteLineParams} params - The parameters for this event
 * @property {string} source - source
 * @property {string} view_type - view_type
 * @property {string} invoiceType - ’recurringAutoCharge’/ 'recurring'/ 'one time'
 * @property {string} origin - create invoice, edit invoice
 * @property {string} platform - platform
 * @property {string} msid - msid
 * @property {GUID} invoice_id - invoice guid
 * @return {LogObject<quotesCreateInvoiceDeleteLineParams>} LogObject<quotesCreateInvoiceDeleteLineParams>
 */
export function quotesCreateInvoiceDeleteLine(params) {
    return { evid: 413, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'quotesNewProductClick' event (evid: 414)
 *
 * Event description: new product
 *
 * @param {quotesNewProductClickParams} params - The parameters for this event
 * @property {string} view_type - view_type
 * @property {string} invoiceType - ’recurringAutoCharge’/ 'recurring'/ 'one time'
 * @property {string} origin - product page, create invoice form
 * @property {string} platform - platform
 * @property {string} msid - msid
 * @return {LogObject<quotesNewProductClickParams>} LogObject<quotesNewProductClickParams>
 */
export function quotesNewProductClick(params) {
    return { evid: 414, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'quotesNewProductSave' event (evid: 415)
 *
 * Event description: new product -save successful
 *
 * @param {quotesNewProductSaveParams} params - The parameters for this event
 * @property {number} price_long - product price
 * @property {string} description - description of the product
 * @property {string} view_type - view_type
 * @property {string} invoiceType - ’recurringAutoCharge’/ 'recurring'/ 'one time'
 * @property {string} product_name - name of the product
 * @property {string} origin - create,edit,select
 * @property {string} platform - platform
 * @property {string} msid - msid
 * @return {LogObject<quotesNewProductSaveParams>} LogObject<quotesNewProductSaveParams>
 */
export function quotesNewProductSave(params) {
    return { evid: 415, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'quotesNewProductCancel' event (evid: 416)
 *
 * Event description: new product -cancel (for every close (cancel, x, background click))
 *
 * @param {quotesNewProductCancelParams} params - The parameters for this event
 * @property {string} view_type - view_type
 * @property {string} invoiceType - ’recurringAutoCharge’/ 'recurring'/ 'one time'
 * @property {string} origin - create,edit
 * @property {string} platform - platform
 * @property {string} msid - msid
 * @return {LogObject<quotesNewProductCancelParams>} LogObject<quotesNewProductCancelParams>
 */
export function quotesNewProductCancel(params) {
    return { evid: 416, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'quotesEditProductClick' event (evid: 417)
 *
 * Event description: edit product
 *
 * @param {quotesEditProductClickParams} params - The parameters for this event
 * @property {string} view_type - view_type
 * @property {string} platform - platform
 * @property {string} msid - msid
 * @return {LogObject<quotesEditProductClickParams>} LogObject<quotesEditProductClickParams>
 */
export function quotesEditProductClick(params) {
    return { evid: 417, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'quotesDeleteProductClick' event (evid: 418)
 *
 * Event description: Delete product click
 *
 * @param {quotesDeleteProductClickParams} params - The parameters for this event
 * @property {string} view_type - view_type
 * @property {string} platform - platform
 * @property {string} msid - msid
 * @return {LogObject<quotesDeleteProductClickParams>} LogObject<quotesDeleteProductClickParams>
 */
export function quotesDeleteProductClick(params) {
    return { evid: 418, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'quotesDeleteProductPageOk' event (evid: 419)
 *
 * Event description: OK click in delete product page
 *
 * @param {quotesDeleteProductPageOkParams} params - The parameters for this event
 * @property {string} view_type - view_type
 * @property {string} platform - platform
 * @property {string} msid - msid
 * @return {LogObject<quotesDeleteProductPageOkParams>} LogObject<quotesDeleteProductPageOkParams>
 */
export function quotesDeleteProductPageOk(params) {
    return { evid: 419, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'dashboardSiteQuickActionDialogApprove' event (evid: 42)
 *
 * Event description: user clicks approve in dialog of a quick action (e.g approve rename)
 *
 * @param {dashboardSiteQuickActionDialogApproveParams} params - The parameters for this event
 * @property {string} name - quick action name
 * @property {string} view_type - view_type
 * @property {string} origin - site-settings, my-sites
 * @property {string} platform - platform
 * @property {GUID} msid - -
 * @return {LogObject<dashboardSiteQuickActionDialogApproveParams>} LogObject<dashboardSiteQuickActionDialogApproveParams>
 */
export function dashboardSiteQuickActionDialogApprove(params) {
    return { evid: 42, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'quotesDeleteProductPageCancel' event (evid: 420)
 *
 * Event description: cancel in delete product page (for every close (cancel, x, background click))
 *
 * @param {quotesDeleteProductPageCancelParams} params - The parameters for this event
 * @property {string} view_type - view_type
 * @property {string} platform - platform
 * @property {string} msid - msid
 * @return {LogObject<quotesDeleteProductPageCancelParams>} LogObject<quotesDeleteProductPageCancelParams>
 */
export function quotesDeleteProductPageCancel(params) {
    return { evid: 420, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'quotesEditInvoice' event (evid: 421)
 *
 * Event description: edit invoice
 *
 * @param {quotesEditInvoiceParams} params - The parameters for this event
 * @property {GUID} externalId - An external id of an entity, relevant to the invoiceSource application
 * @property {string} view_type - view_type
 * @property {GUID} appDefId - appDefId of the source
 * @property {string} origin - my invoices, preview, deposit paid
 * @property {string} status - Creation form/Draft/Sent/Paid
 * @property {string} platform - platform
 * @property {string} msid - msid
 * @property {GUID} invoice_id - invoice guid
 * @return {LogObject<quotesEditInvoiceParams>} LogObject<quotesEditInvoiceParams>
 */
export function quotesEditInvoice(params) {
    return { evid: 421, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'quotesPreviewInvoice' event (evid: 422)
 *
 * Event description: preview invoice
 *
 * @param {quotesPreviewInvoiceParams} params - The parameters for this event
 * @property {string} source - from where the invoice open {feed, more-->invoices}
 * @property {string} paymentType - one time, recurring
 * @property {string} view_type - view_type
 * @property {string} invoiceType - ’recurringAutoCharge’/ 'recurring'/ 'one time'
 * @property {string} origin - my invoices, edit invoice, widget
 * @property {string} status - Creation form/Draft/Sent/Paid
 * @property {string} origin_device - web,native
 * @property {string} invoiceSource - by app_def_id
 * @property {string} platform - platform
 * @property {string} msid - msid
 * @property {GUID} invoice_id - invoice guid
 * @return {LogObject<quotesPreviewInvoiceParams>} LogObject<quotesPreviewInvoiceParams>
 */
export function quotesPreviewInvoice(params) {
    return { evid: 422, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'quotesPrintInvoiceSrc5Evid423' event (evid: 423)
 *
 * Event description: print invoice
 *
 * @param {quotesPrintInvoiceSrc5Evid423Params} params - The parameters for this event
 * @property {GUID} externalId - An external id of an entity, relevant to the oridapplication
 * @property {string} paymentType - 'recurring','one time'
 * @property {string} view_type - view_type
 * @property {GUID} appDefId - appDefId (application ID)
 * @property {string} originPage - origin page - from which place this action was made (invoices, contacts full page, crm home...)
 * @property {string} origin - my invoices, preview
 * @property {string} platform - platform
 * @property {string} msid - msid
 * @property {GUID} invoice_id - invoice guid
 * @return {LogObject<quotesPrintInvoiceSrc5Evid423Params>} LogObject<quotesPrintInvoiceSrc5Evid423Params>
 */
export function quotesPrintInvoiceSrc5Evid423(params) {
    return { evid: 423, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'quotesAddPaymentClick' event (evid: 424)
 *
 * Event description: add payment for an invoice click
 *
 * @param {quotesAddPaymentClickParams} params - The parameters for this event
 * @property {GUID} externalId - An external id of an entity, relevant to the invoiceSource application
 * @property {string} view_type - view_type
 * @property {GUID} appDefId - appDefId of the source
 * @property {string} origin - my invoices,preview
 * @property {string} status - Creation form/Draft/Sent/Paid
 * @property {string} origin_device - web,native
 * @property {string} platform - platform
 * @property {string} msid - msid
 * @property {GUID} invoice_id - invoice guid
 * @property {boolean} fully_paid - true for fully paid selected, false for partial payment selected
 * @return {LogObject<quotesAddPaymentClickParams>} LogObject<quotesAddPaymentClickParams>
 */
export function quotesAddPaymentClick(params) {
    return { evid: 424, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'quotesAddPaymentPageOk' event (evid: 425)
 *
 * Event description: OK clicked in add payment page, fully_paid is true when the full amount is paid in one payment
 *
 * @param {quotesAddPaymentPageOkParams} params - The parameters for this event
 * @property {string} paymentMethod - payment method chosen
 * @property {string} view_type - view_type
 * @property {string} origin - my invoices,preview
 * @property {string} origin_device - web,native
 * @property {string} platform - platform
 * @property {string} msid - msid
 * @property {GUID} invoice_id - invoice guid
 * @property {boolean} fully_paid - true for fully paid selected, false for partial payment selected
 * @return {LogObject<quotesAddPaymentPageOkParams>} LogObject<quotesAddPaymentPageOkParams>
 */
export function quotesAddPaymentPageOk(params) {
    return { evid: 425, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'quotesAddPaymentPageCancel' event (evid: 426)
 *
 * Event description: cancel in add payment page (for every close (cancel, x, background click))
 *
 * @param {quotesAddPaymentPageCancelParams} params - The parameters for this event
 * @property {string} view_type - view_type
 * @property {string} origin - my invoices,preview
 * @property {string} origin_device - web,native
 * @property {string} platform - platform
 * @property {string} msid - msid
 * @property {GUID} invoice_id - invoice guid
 * @return {LogObject<quotesAddPaymentPageCancelParams>} LogObject<quotesAddPaymentPageCancelParams>
 */
export function quotesAddPaymentPageCancel(params) {
    return { evid: 426, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'quotesVoidClick' event (evid: 427)
 *
 * Event description: make invoice Void click
 *
 * @param {quotesVoidClickParams} params - The parameters for this event
 * @property {GUID} app_instance_id - app_instance_id
 * @property {GUID} installation_id - installation_id
 * @property {string} os_version - os_version
 * @property {string} app_version - app_version
 * @property {string} view_type - view_type
 * @property {string} user_agent - user_agent
 * @property {string} bundle_version - bundle_version
 * @property {string} origin - origin
 * @property {string} origin_device - web,native
 * @property {string} platform - platform
 * @property {string} msid - msid
 * @property {GUID} invoice_id - invoice guid
 * @property {GUID} bi_token - msid
 * @return {LogObject<quotesVoidClickParams>} LogObject<quotesVoidClickParams>
 */
export function quotesVoidClick(params) {
    return { evid: 427, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'quotesVoidPageOk' event (evid: 428)
 *
 * Event description: OK clicked in Void page
 *
 * @param {quotesVoidPageOkParams} params - The parameters for this event
 * @property {string} view_type - view_type
 * @property {string} origin_device - web,native
 * @property {string} platform - platform
 * @property {string} msid - msid
 * @property {GUID} invoice_id - invoice guid
 * @return {LogObject<quotesVoidPageOkParams>} LogObject<quotesVoidPageOkParams>
 */
export function quotesVoidPageOk(params) {
    return { evid: 428, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'quotesVoidPageCancel' event (evid: 429)
 *
 * Event description: cancel in Void page (for every close (cancel, x, background click))
 *
 * @param {quotesVoidPageCancelParams} params - The parameters for this event
 * @property {string} view_type - view_type
 * @property {string} origin_device - web,native
 * @property {string} platform - platform
 * @property {string} msid - msid
 * @property {GUID} invoice_id - invoice guid
 * @return {LogObject<quotesVoidPageCancelParams>} LogObject<quotesVoidPageCancelParams>
 */
export function quotesVoidPageCancel(params) {
    return { evid: 429, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'dashboardSiteQuickActionDialogClose' event (evid: 43)
 *
 * Event description: user clicks cancel or X in dialog of a quick action (e.g cancel rename)
 *
 * @param {dashboardSiteQuickActionDialogCloseParams} params - The parameters for this event
 * @property {string} name - quick action name
 * @property {string} view_type - view_type
 * @property {string} origin - site-settings, my-sites
 * @property {string} platform - platform
 * @property {GUID} msid - -
 * @return {LogObject<dashboardSiteQuickActionDialogCloseParams>} LogObject<dashboardSiteQuickActionDialogCloseParams>
 */
export function dashboardSiteQuickActionDialogClose(params) {
    return { evid: 43, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'quotesDeleteInvoiceClick' event (evid: 430)
 *
 * Event description: delete invoice click
 *
 * @param {quotesDeleteInvoiceClickParams} params - The parameters for this event
 * @property {string} view_type - view_type
 * @property {string} origin - Preview/my invoices
 * @property {string} status - Creation form/Draft/Sent/Paid
 * @property {string} origin_device - web,native
 * @property {string} platform - platform
 * @property {string} msid - msid
 * @property {GUID} invoice_id - invoice guid
 * @return {LogObject<quotesDeleteInvoiceClickParams>} LogObject<quotesDeleteInvoiceClickParams>
 */
export function quotesDeleteInvoiceClick(params) {
    return { evid: 430, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'quotesDeleteInvoicePageOk' event (evid: 431)
 *
 * Event description: OK clicked in delete page
 *
 * @param {quotesDeleteInvoicePageOkParams} params - The parameters for this event
 * @property {string} view_type - view_type
 * @property {string} origin_device - web,native
 * @property {string} platform - platform
 * @property {string} msid - msid
 * @property {GUID} invoice_id - invoice guid
 * @return {LogObject<quotesDeleteInvoicePageOkParams>} LogObject<quotesDeleteInvoicePageOkParams>
 */
export function quotesDeleteInvoicePageOk(params) {
    return { evid: 431, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'quotesDeleteInvoicePageCancel' event (evid: 432)
 *
 * Event description: cancel in delete page (for every close (cancel, x, background click))
 *
 * @param {quotesDeleteInvoicePageCancelParams} params - The parameters for this event
 * @property {string} view_type - view_type
 * @property {string} origin_device - web,native
 * @property {string} platform - platform
 * @property {string} msid - msid
 * @property {GUID} invoice_id - invoice guid
 * @return {LogObject<quotesDeleteInvoicePageCancelParams>} LogObject<quotesDeleteInvoicePageCancelParams>
 */
export function quotesDeleteInvoicePageCancel(params) {
    return { evid: 432, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'quotesSettingsNewTaxClick' event (evid: 433)
 *
 * Event description: Settings - New tax click
 *
 * @param {quotesSettingsNewTaxClickParams} params - The parameters for this event
 * @property {string} source - source
 * @property {string} view_type - view_type
 * @property {string} invoiceType - ’recurringAutoCharge’/ 'recurring'/ 'one time'
 * @property {string} origin - settings , create invoice, empty experience
 * @property {string} platform - platform
 * @property {string} msid - msid
 * @property {GUID} invoice_id - invoice guid
 * @return {LogObject<quotesSettingsNewTaxClickParams>} LogObject<quotesSettingsNewTaxClickParams>
 */
export function quotesSettingsNewTaxClick(params) {
    return { evid: 433, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'quotesSettingsNewTaxPageSave' event (evid: 434)
 *
 * Event description: Settings - New tax page - Save successful
 *
 * @param {quotesSettingsNewTaxPageSaveParams} params - The parameters for this event
 * @property {string} source - source
 * @property {string} view_type - view_type
 * @property {string} invoiceType - ’recurringAutoCharge’/ 'recurring'/ 'one time'
 * @property {string} origin - create,edit
 * @property {string} platform - platform
 * @property {string} msid - msid
 * @property {GUID} invoice_id - invoice guid
 * @return {LogObject<quotesSettingsNewTaxPageSaveParams>} LogObject<quotesSettingsNewTaxPageSaveParams>
 */
export function quotesSettingsNewTaxPageSave(params) {
    return { evid: 434, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'quotesSettingsNewTaxPageCancel' event (evid: 435)
 *
 * Event description: Settings - New tax page - Cancel (for every close (cancel, x, background click))
 *
 * @param {quotesSettingsNewTaxPageCancelParams} params - The parameters for this event
 * @property {string} source - source
 * @property {string} view_type - view_type
 * @property {string} invoiceType - ’recurringAutoCharge’/ 'recurring'/ 'one time'
 * @property {string} origin - create,edit
 * @property {string} platform - platform
 * @property {string} msid - msid
 * @property {GUID} invoice_id - invoice guid
 * @return {LogObject<quotesSettingsNewTaxPageCancelParams>} LogObject<quotesSettingsNewTaxPageCancelParams>
 */
export function quotesSettingsNewTaxPageCancel(params) {
    return { evid: 435, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'quotesEditTaxClick' event (evid: 436)
 *
 * Event description: edit tax click
 *
 * @param {quotesEditTaxClickParams} params - The parameters for this event
 * @property {string} view_type - view_type
 * @property {string} platform - platform
 * @property {string} msid - msid
 * @return {LogObject<quotesEditTaxClickParams>} LogObject<quotesEditTaxClickParams>
 */
export function quotesEditTaxClick(params) {
    return { evid: 436, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'quotesDeleteTaxClick' event (evid: 437)
 *
 * Event description: Delete tax click
 *
 * @param {quotesDeleteTaxClickParams} params - The parameters for this event
 * @property {string} view_type - view_type
 * @property {string} platform - platform
 * @property {string} msid - msid
 * @return {LogObject<quotesDeleteTaxClickParams>} LogObject<quotesDeleteTaxClickParams>
 */
export function quotesDeleteTaxClick(params) {
    return { evid: 437, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'quotesDeleteTaxPageOk' event (evid: 438)
 *
 * Event description: OK click in delete tax page
 *
 * @param {quotesDeleteTaxPageOkParams} params - The parameters for this event
 * @property {string} view_type - view_type
 * @property {string} platform - platform
 * @property {string} msid - msid
 * @return {LogObject<quotesDeleteTaxPageOkParams>} LogObject<quotesDeleteTaxPageOkParams>
 */
export function quotesDeleteTaxPageOk(params) {
    return { evid: 438, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'quotesDeleteTaxPageCancel' event (evid: 439)
 *
 * Event description: cancel in delete tax page (for every close (cancel, x, background click))
 *
 * @param {quotesDeleteTaxPageCancelParams} params - The parameters for this event
 * @property {string} view_type - view_type
 * @property {string} platform - platform
 * @property {string} msid - msid
 * @return {LogObject<quotesDeleteTaxPageCancelParams>} LogObject<quotesDeleteTaxPageCancelParams>
 */
export function quotesDeleteTaxPageCancel(params) {
    return { evid: 439, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'myAccountClickOnHelp' event (evid: 44)
 *
 * Event description: User click on help center (Can be either from '?' button or account -->help center)
 *
 * @param {myAccountClickOnHelpParams} params - The parameters for this event
 * @property {string} page_view - my-sites /dashboard / account settings
 * @property {string} view_type - view_type
 * @property {string} origin_app - if dashboard then 'MAD'
 * @property {string} origin - origin
 * @property {string} app_id - app_id
 * @property {string} platform - platform
 * @return {LogObject<myAccountClickOnHelpParams>} LogObject<myAccountClickOnHelpParams>
 */
export function myAccountClickOnHelp(params) {
    return { evid: 44, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'quotesShowPaymentPopupPage' event (evid: 440)
 *
 * Event description: Stripe popup is shown
 *
 * @param {quotesShowPaymentPopupPageParams} params - The parameters for this event
 * @property {string} name - name of payment
 * @property {string} view_type - view_type
 * @property {string} origin - how user arrived to the flow onboarding/payments
 * @property {string} platform - platform
 * @property {string} msid - msid
 * @return {LogObject<quotesShowPaymentPopupPageParams>} LogObject<quotesShowPaymentPopupPageParams>
 */
export function quotesShowPaymentPopupPage(params) {
    return { evid: 440, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'quotesConnectPaymentClick' event (evid: 441)
 *
 * Event description: user clicks on 'connect' from the payment popup page
 *
 * @param {quotesConnectPaymentClickParams} params - The parameters for this event
 * @property {string} name - name of payment
 * @property {string} view_type - view_type
 * @property {string} origin - how user arrived to the flow onboarding/payments
 * @property {string} platform - platform
 * @property {string} msid - msid
 * @return {LogObject<quotesConnectPaymentClickParams>} LogObject<quotesConnectPaymentClickParams>
 */
export function quotesConnectPaymentClick(params) {
    return { evid: 441, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'quotesCreateAnAccountOfPaymentProvider' event (evid: 442)
 *
 * Event description: user clicks on 'create an account' from the payment popup page
 *
 * @param {quotesCreateAnAccountOfPaymentProviderParams} params - The parameters for this event
 * @property {string} name - name of payment
 * @property {string} view_type - view_type
 * @property {string} origin - how user arrived to the flow onboarding/payments
 * @property {string} platform - platform
 * @property {string} msid - msid
 * @return {LogObject<quotesCreateAnAccountOfPaymentProviderParams>} LogObject<quotesCreateAnAccountOfPaymentProviderParams>
 */
export function quotesCreateAnAccountOfPaymentProvider(params) {
    return { evid: 442, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'quotesNonValidPaypalAccountPopup' event (evid: 443)
 *
 * Event description: when a user has an old / non business paypal account and connection to paypal is not possible
 *
 * @param {quotesNonValidPaypalAccountPopupParams} params - The parameters for this event
 * @property {string} name - name of payment
 * @property {string} view_type - view_type
 * @property {string} origin - how user arrived to the flow
 * @property {string} platform - platform
 * @property {string} msid - msid
 * @return {LogObject<quotesNonValidPaypalAccountPopupParams>} LogObject<quotesNonValidPaypalAccountPopupParams>
 */
export function quotesNonValidPaypalAccountPopup(params) {
    return { evid: 443, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'quotesNonValidPaypalAccountPopupClose' event (evid: 444)
 *
 * Event description: when a user closes the popup
 *
 * @param {quotesNonValidPaypalAccountPopupCloseParams} params - The parameters for this event
 * @property {string} name - name of payment
 * @property {string} view_type - view_type
 * @property {string} origin - how user arrived to the flow
 * @property {string} platform - platform
 * @property {string} msid - msid
 * @return {LogObject<quotesNonValidPaypalAccountPopupCloseParams>} LogObject<quotesNonValidPaypalAccountPopupCloseParams>
 */
export function quotesNonValidPaypalAccountPopupClose(params) {
    return { evid: 444, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'quotesNonValidPaypalAccountPopupClickLink' event (evid: 445)
 *
 * Event description: when a user closes the popup
 *
 * @param {quotesNonValidPaypalAccountPopupClickLinkParams} params - The parameters for this event
 * @property {string} name - name of payment
 * @property {string} view_type - view_type
 * @property {string} origin - how user arrived to the flow
 * @property {string} link_type - create, upgrade, support
 * @property {string} platform - platform
 * @property {string} msid - msid
 * @return {LogObject<quotesNonValidPaypalAccountPopupClickLinkParams>} LogObject<quotesNonValidPaypalAccountPopupClickLinkParams>
 */
export function quotesNonValidPaypalAccountPopupClickLink(params) {
    return { evid: 445, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'quotesSortInvoices' event (evid: 446)
 *
 * Event description: user clicks on a column to sort by it
 *
 * @param {quotesSortInvoicesParams} params - The parameters for this event
 * @property {string} name - name of field sorted by
 * @property {number} num_of_invoices - number of invoices the user has
 * @property {string} view_type - view_type
 * @property {string} order - desc/asc
 * @property {string} platform - platform
 * @property {string} msid - msid
 * @return {LogObject<quotesSortInvoicesParams>} LogObject<quotesSortInvoicesParams>
 */
export function quotesSortInvoices(params) {
    return { evid: 446, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'quotesFilterInvoices' event (evid: 447)
 *
 * Event description: user filters the invoices view
 *
 * @param {quotesFilterInvoicesParams} params - The parameters for this event
 * @property {string} name - name of filter
 * @property {number} num_of_invoices - number of invoices the user has
 * @property {string} view_type - view_type
 * @property {string} origin_device - web,native
 * @property {string} platform - platform
 * @property {string} filter_type - period, currency, display
 * @property {string} msid - msid
 * @return {LogObject<quotesFilterInvoicesParams>} LogObject<quotesFilterInvoicesParams>
 */
export function quotesFilterInvoices(params) {
    return { evid: 447, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'quotesSearchInvoices' event (evid: 448)
 *
 * Event description: user searches  in the invoices view
 *
 * @param {quotesSearchInvoicesParams} params - The parameters for this event
 * @property {number} num_of_invoices - number of invoices the user has
 * @property {string} view_type - view_type
 * @property {string} text - text searched
 * @property {number} num_of_results - number of returned results
 * @property {string} origin_device - web,native
 * @property {string} platform - platform
 * @property {string} msid - msid
 * @return {LogObject<quotesSearchInvoicesParams>} LogObject<quotesSearchInvoicesParams>
 */
export function quotesSearchInvoices(params) {
    return { evid: 448, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'quotesDownloadPdf' event (evid: 449)
 *
 * Event description: click on save as PDF
 *
 * @param {quotesDownloadPdfParams} params - The parameters for this event
 * @property {string} paymentType - 'Recurring','One Time'
 * @property {string} view_type - view_type
 * @property {string} origin - customer for UoU, my invoices for users
 * @property {string} invoiceSource - by def_app_id
 * @property {string} platform - platform
 * @property {string} msid - msid
 * @property {GUID} invoice_id - invoice guid
 * @return {LogObject<quotesDownloadPdfParams>} LogObject<quotesDownloadPdfParams>
 */
export function quotesDownloadPdf(params) {
    return { evid: 449, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'dashboardAccountSettingsImageAction' event (evid: 45)
 *
 * Event description: user changes profile image in account settings - can choose upload / remove image
 *
 * @param {dashboardAccountSettingsImageActionParams} params - The parameters for this event
 * @property {string} view_type - view_type
 * @property {string} platform - platform
 * @property {string} action - {upload, remove}
 * @return {LogObject<dashboardAccountSettingsImageActionParams>} LogObject<dashboardAccountSettingsImageActionParams>
 */
export function dashboardAccountSettingsImageAction(params) {
    return { evid: 45, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'quotesResendFromPreviewPage' event (evid: 450)
 *
 * Event description: Quotes - Resend from preview page
 *
 * @param {quotesResendFromPreviewPageParams} params - The parameters for this event
 * @property {GUID} externalId - An external id of an entity, relevant to the invoiceSource application
 * @property {string} view_type - view_type
 * @property {GUID} appDefId - appDefId (application ID)
 * @property {string} origin - origin page - from which place this action was made (invoices, contacts full page, crm home...)
 * @property {string} platform - platform
 * @property {string} msid - msid
 * @property {GUID} invoice_id - invoice_guid
 * @return {LogObject<quotesResendFromPreviewPageParams>} LogObject<quotesResendFromPreviewPageParams>
 */
export function quotesResendFromPreviewPage(params) {
    return { evid: 450, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'quotesRunReportClickGenerateReportClick' event (evid: 451)
 *
 * Event description: user clicks on run report in tax/revenue summary, this initiates the creation of a report. use 'name'  to choose tax or revenue.
 *
 * @param {quotesRunReportClickGenerateReportClickParams} params - The parameters for this event
 * @property {string} name - tax, revenue
 * @property {string} view_type - view_type
 * @property {string} platform - platform
 * @property {string} basis - accural, cash
 * @property {string} msid - msid
 * @return {LogObject<quotesRunReportClickGenerateReportClickParams>} LogObject<quotesRunReportClickGenerateReportClickParams>
 */
export function quotesRunReportClickGenerateReportClick(params) {
    return { evid: 451, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'quotesPrintReportClick' event (evid: 452)
 *
 * Event description: user clicks on print report in tax/revenue summary. use 'name'  to choose tax or revenue.
 *
 * @param {quotesPrintReportClickParams} params - The parameters for this event
 * @property {string} name - tax, revenue
 * @property {string} view_type - view_type
 * @property {string} platform - platform
 * @property {string} basis - accural, cash
 * @property {string} msid - msid
 * @return {LogObject<quotesPrintReportClickParams>} LogObject<quotesPrintReportClickParams>
 */
export function quotesPrintReportClick(params) {
    return { evid: 452, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'quotesExportReportClick' event (evid: 453)
 *
 * Event description: user clicks on export report in tax/revenue summary. use 'name'  to choose tax or revenue.
 *
 * @param {quotesExportReportClickParams} params - The parameters for this event
 * @property {string} name - tax, revenue
 * @property {string} view_type - view_type
 * @property {string} file_type - csv,pdf,excel
 * @property {string} platform - platform
 * @property {string} basis - accural, cash
 * @property {string} msid - msid
 * @return {LogObject<quotesExportReportClickParams>} LogObject<quotesExportReportClickParams>
 */
export function quotesExportReportClick(params) {
    return { evid: 453, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'quotesPageView' event (evid: 454)
 *
 * Event description: viewing invoices page in Oneapp
 *
 * @param {quotesPageViewParams} params - The parameters for this event
 * @property {number} num_of_invoices - num_of_invoices
 * @property {string} view_type - view_type
 * @property {string} referral - the origin of navigation to this page {invoice card preview,direct}
 * @property {string} origin - deprecated
 * @property {number} num_of_contacts - num_of_contacts
 * @property {string} platform - platform
 * @property {GUID} msid - msid
 * @return {LogObject<quotesPageViewParams>} LogObject<quotesPageViewParams>
 */
export function quotesPageView(params) {
    return { evid: 454, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'quotesManagePaymentsBannerDisplayed' event (evid: 455)
 *
 * Event description: manage payments banner is displayed in invoices app
 *
 * @param {quotesManagePaymentsBannerDisplayedParams} params - The parameters for this event
 * @property {string} name - banner name {manage payments}
 * @property {string} view_type - view_type
 * @property {string} platform - platform
 * @property {GUID} msid - msid
 * @return {LogObject<quotesManagePaymentsBannerDisplayedParams>} LogObject<quotesManagePaymentsBannerDisplayedParams>
 */
export function quotesManagePaymentsBannerDisplayed(params) {
    return { evid: 455, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'quotesDismissManagePaymentsBanner' event (evid: 456)
 *
 * Event description: dismiss manage payments banner
 *
 * @param {quotesDismissManagePaymentsBannerParams} params - The parameters for this event
 * @property {string} name - banner name {manage payments}
 * @property {string} view_type - view_type
 * @property {string} platform - platform
 * @property {GUID} msid - msid
 * @return {LogObject<quotesDismissManagePaymentsBannerParams>} LogObject<quotesDismissManagePaymentsBannerParams>
 */
export function quotesDismissManagePaymentsBanner(params) {
    return { evid: 456, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'quotesClickCtaInManagePaymentsBanner' event (evid: 457)
 *
 * Event description: User clicks on CTA (Payments) in manage payments banner
 *
 * @param {quotesClickCtaInManagePaymentsBannerParams} params - The parameters for this event
 * @property {string} name - banner name {manage payments}
 * @property {string} view_type - view_type
 * @property {string} platform - platform
 * @property {GUID} msid - msid
 * @return {LogObject<quotesClickCtaInManagePaymentsBannerParams>} LogObject<quotesClickCtaInManagePaymentsBannerParams>
 */
export function quotesClickCtaInManagePaymentsBanner(params) {
    return { evid: 457, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'quotesClickViewOrderBooking' event (evid: 458)
 *
 * Event description: click on view order/booking, when invoice was created from a stores order/booking
 *
 * @param {quotesClickViewOrderBookingParams} params - The parameters for this event
 * @property {string} view_type - view_type
 * @property {string} app_name - app name (stores/booking)
 * @property {string} platform - platform
 * @property {string} msid - msid
 * @property {GUID} invoice_id - invoice guid
 * @return {LogObject<quotesClickViewOrderBookingParams>} LogObject<quotesClickViewOrderBookingParams>
 */
export function quotesClickViewOrderBooking(params) {
    return { evid: 458, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'quotesInvoicesAutomaticallyCreateAndSendInvoices' event (evid: 459)
 *
 * Event description: User Clicked on 'Automatically create and send invoices for accepted price quotes' checkbox in Price Quotes/Invoices settings
 *
 * @param {quotesInvoicesAutomaticallyCreateAndSendInvoicesParams} params - The parameters for this event
 * @property {GUID} uuid - uuid
 * @property {string} view_type - view_type
 * @property {boolean} is_auto - {true/false}
 * @property {string} platform - platform
 * @property {string} msid - msid
 * @return {LogObject<quotesInvoicesAutomaticallyCreateAndSendInvoicesParams>} LogObject<quotesInvoicesAutomaticallyCreateAndSendInvoicesParams>
 */
export function quotesInvoicesAutomaticallyCreateAndSendInvoices(params) {
    return { evid: 459, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'dashboardAccountSettingsImageActionSuccess' event (evid: 46)
 *
 * Event description: image upload / remove success after user chooses action
 *
 * @param {dashboardAccountSettingsImageActionSuccessParams} params - The parameters for this event
 * @property {string} view_type - view_type
 * @property {string} platform - platform
 * @property {string} action - {upload, remove}
 * @return {LogObject<dashboardAccountSettingsImageActionSuccessParams>} LogObject<dashboardAccountSettingsImageActionSuccessParams>
 */
export function dashboardAccountSettingsImageActionSuccess(params) {
    return { evid: 46, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'quotesAddCustomerClick' event (evid: 460)
 *
 * Event description: Add Customer - Click
 *
 * @param {quotesAddCustomerClickParams} params - The parameters for this event
 * @property {GUID} uuid - uuid
 * @property {string} view_type - view_type
 * @property {string} platform - platform
 * @property {string} msid - msid
 * @property {GUID} invoice_id - invoice guid
 * @return {LogObject<quotesAddCustomerClickParams>} LogObject<quotesAddCustomerClickParams>
 */
export function quotesAddCustomerClick(params) {
    return { evid: 460, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'quotesChooseACustomer' event (evid: 461)
 *
 * Event description: User Choose a Customer
 *
 * @param {quotesChooseACustomerParams} params - The parameters for this event
 * @property {GUID} uuid - uuid
 * @property {string} view_type - view_type
 * @property {string} platform - platform
 * @property {boolean} is_new_contact - is_new_contact
 * @property {string} msid - msid
 * @property {GUID} invoice_id - invoice guid
 * @return {LogObject<quotesChooseACustomerParams>} LogObject<quotesChooseACustomerParams>
 */
export function quotesChooseACustomer(params) {
    return { evid: 461, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'quotesRemoveCustomer' event (evid: 462)
 *
 * Event description: User remove customer from the invoice
 *
 * @param {quotesRemoveCustomerParams} params - The parameters for this event
 * @property {GUID} uuid - uuid
 * @property {string} view_type - view_type
 * @property {string} platform - platform
 * @property {string} msid - msid
 * @property {GUID} invoice_id - invoice guid
 * @return {LogObject<quotesRemoveCustomerParams>} LogObject<quotesRemoveCustomerParams>
 */
export function quotesRemoveCustomer(params) {
    return { evid: 462, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'quotesDueDateUpdating' event (evid: 463)
 *
 * Event description: Invoice Due Date Updating
 *
 * @param {quotesDueDateUpdatingParams} params - The parameters for this event
 * @property {GUID} uuid - uuid
 * @property {string} view_type - view_type
 * @property {DateTime} due_date - due_date
 * @property {string} platform - platform
 * @property {string} msid - msid
 * @property {GUID} invoice_id - invoice guid
 * @return {LogObject<quotesDueDateUpdatingParams>} LogObject<quotesDueDateUpdatingParams>
 */
export function quotesDueDateUpdating(params) {
    return { evid: 463, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'quotesDateOfIssueUpdating' event (evid: 464)
 *
 * Event description: Invoice Date of Issue Updating
 *
 * @param {quotesDateOfIssueUpdatingParams} params - The parameters for this event
 * @property {GUID} uuid - uuid
 * @property {string} view_type - view_type
 * @property {DateTime} date_of_issue - date_of_issue
 * @property {string} platform - platform
 * @property {string} msid - msid
 * @property {GUID} invoice_id - invoice guid
 * @return {LogObject<quotesDateOfIssueUpdatingParams>} LogObject<quotesDateOfIssueUpdatingParams>
 */
export function quotesDateOfIssueUpdating(params) {
    return { evid: 464, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'quotesAddDiscount' event (evid: 465)
 *
 * Event description: user finish to add a discount
 *
 * @param {quotesAddDiscountParams} params - The parameters for this event
 * @property {GUID} uuid - uuid
 * @property {string} view_type - view_type
 * @property {string} platform - platform
 * @property {string} discount - discount percentage
 * @property {string} msid - msid
 * @property {GUID} invoice_id - invoice guid
 * @return {LogObject<quotesAddDiscountParams>} LogObject<quotesAddDiscountParams>
 */
export function quotesAddDiscount(params) {
    return { evid: 465, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'quotesChooseAProduct' event (evid: 466)
 *
 * Event description: Quotes - Choose a Product
 *
 * @param {quotesChooseAProductParams} params - The parameters for this event
 * @property {GUID} uuid - uuid
 * @property {string} view_type - view_type
 * @property {string} productSource - which vertical product was choosen ( Stores, Invoices, Bookings) App_def_id
 * @property {string} productName - product_name
 * @property {string} productId - product_id
 * @property {string} platform - platform
 * @property {string} msid - msid
 * @property {GUID} invoice_id - invoice guid
 * @return {LogObject<quotesChooseAProductParams>} LogObject<quotesChooseAProductParams>
 */
export function quotesChooseAProduct(params) {
    return { evid: 466, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'quotesRemoveProduct' event (evid: 467)
 *
 * Event description: Quotes - remove Product
 *
 * @param {quotesRemoveProductParams} params - The parameters for this event
 * @property {GUID} uuid - uuid
 * @property {string} view_type - view_type
 * @property {number} product_id - product_id
 * @property {string} platform - platform
 * @property {string} msid - msid
 * @property {GUID} invoice_id - invoice guid
 * @return {LogObject<quotesRemoveProductParams>} LogObject<quotesRemoveProductParams>
 */
export function quotesRemoveProduct(params) {
    return { evid: 467, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'quotesEditProductOrService' event (evid: 468)
 *
 * Event description: edit Product or service (line item)
 *
 * @param {quotesEditProductOrServiceParams} params - The parameters for this event
 * @property {GUID} uuid - uuid
 * @property {string} view_type - view_type
 * @property {number} product_id - product_id
 * @property {string} productName - product_name
 * @property {string} platform - platform
 * @property {string} msid - msid
 * @property {GUID} invoice_id - invoice guid
 * @return {LogObject<quotesEditProductOrServiceParams>} LogObject<quotesEditProductOrServiceParams>
 */
export function quotesEditProductOrService(params) {
    return { evid: 468, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'quotesSelectTax' event (evid: 469)
 *
 * Event description: Quotes - edit Product
 *
 * @param {quotesSelectTaxParams} params - The parameters for this event
 * @property {GUID} uuid - uuid
 * @property {number} taxRate - taxRate
 * @property {string} view_type - view_type
 * @property {string} tax_name - tax_name
 * @property {number} product_id - product_id
 * @property {string} contact_id - contact_id
 * @property {string} platform - platform
 * @property {string} msid - msid
 * @property {GUID} invoice_id - invoice guid
 * @return {LogObject<quotesSelectTaxParams>} LogObject<quotesSelectTaxParams>
 */
export function quotesSelectTax(params) {
    return { evid: 469, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'dashboardSiteClickCancelBackOnTransferSiteActionWindow' event (evid: 47)
 *
 * Event description: when user click on quick action, and then click on cancel when the quick action window is opened
 *
 * @param {dashboardSiteClickCancelBackOnTransferSiteActionWindowParams} params - The parameters for this event
 * @property {string} name - name of quick action (transfer,etc.)
 * @property {string} stage_process - {transfer_details_summary, transfer_options_select}
 * @property {string} view_type - view_type
 * @property {string} origin - --
 * @property {string} platform - platform
 * @property {string} hosting - ma/editor
 * @property {GUID} msid - --
 * @return {LogObject<dashboardSiteClickCancelBackOnTransferSiteActionWindowParams>} LogObject<dashboardSiteClickCancelBackOnTransferSiteActionWindowParams>
 */
export function dashboardSiteClickCancelBackOnTransferSiteActionWindow(params) {
    return { evid: 47, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'quotesAddingBusinessLogo' event (evid: 470)
 *
 * Event description: User added business logo (mobile)
 *
 * @param {quotesAddingBusinessLogoParams} params - The parameters for this event
 * @property {GUID} uuid - uuid
 * @property {string} view_type - view_type
 * @property {string} platform - platform
 * @property {string} msid - msid
 * @return {LogObject<quotesAddingBusinessLogoParams>} LogObject<quotesAddingBusinessLogoParams>
 */
export function quotesAddingBusinessLogo(params) {
    return { evid: 470, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'quotesAddingBusinessName' event (evid: 471)
 *
 * Event description: User added business logo (mobile)
 *
 * @param {quotesAddingBusinessNameParams} params - The parameters for this event
 * @property {GUID} uuid - uuid
 * @property {string} view_type - view_type
 * @property {string} platform - platform
 * @property {string} msid - msid
 * @return {LogObject<quotesAddingBusinessNameParams>} LogObject<quotesAddingBusinessNameParams>
 */
export function quotesAddingBusinessName(params) {
    return { evid: 471, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'quotesClickSaveOnAddBusinessDetailsPage' event (evid: 472)
 *
 * Event description: Click Save On Add Business Details Page (mobile)
 *
 * @param {quotesClickSaveOnAddBusinessDetailsPageParams} params - The parameters for this event
 * @property {GUID} uuid - uuid
 * @property {string} view_type - view_type
 * @property {string} platform - platform
 * @property {string} msid - msid
 * @return {LogObject<quotesClickSaveOnAddBusinessDetailsPageParams>} LogObject<quotesClickSaveOnAddBusinessDetailsPageParams>
 */
export function quotesClickSaveOnAddBusinessDetailsPage(params) {
    return { evid: 472, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'quotesBoardingPageClickClose' event (evid: 473)
 *
 * Event description: Quotes - Boarding Page - click close  (mobile)
 *
 * @param {quotesBoardingPageClickCloseParams} params - The parameters for this event
 * @property {GUID} uuid - uuid
 * @property {string} view_type - view_type
 * @property {string} platform - platform
 * @property {string} msid - msid
 * @return {LogObject<quotesBoardingPageClickCloseParams>} LogObject<quotesBoardingPageClickCloseParams>
 */
export function quotesBoardingPageClickClose(params) {
    return { evid: 473, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'quotesGetTheWixAppBannerDisplayed' event (evid: 474)
 *
 * Event description: Get the Wix app banner is displayed in invoices app
 *
 * @param {quotesGetTheWixAppBannerDisplayedParams} params - The parameters for this event
 * @property {string} name - banner name {get wix app}
 * @property {string} view_type - view_type
 * @property {string} platform - platform
 * @property {GUID} msid - msid
 * @return {LogObject<quotesGetTheWixAppBannerDisplayedParams>} LogObject<quotesGetTheWixAppBannerDisplayedParams>
 */
export function quotesGetTheWixAppBannerDisplayed(params) {
    return { evid: 474, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'quotesDismissGetWixAppBanner' event (evid: 475)
 *
 * Event description: dismiss get wix app banner
 *
 * @param {quotesDismissGetWixAppBannerParams} params - The parameters for this event
 * @property {string} name - banner name {get wix app}
 * @property {string} view_type - view_type
 * @property {string} platform - platform
 * @property {GUID} msid - msid
 * @return {LogObject<quotesDismissGetWixAppBannerParams>} LogObject<quotesDismissGetWixAppBannerParams>
 */
export function quotesDismissGetWixAppBanner(params) {
    return { evid: 475, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'quotesClickCtaInGetWixAppBanner' event (evid: 476)
 *
 * Event description: User clicks on CTA (get the wix app) in get wix app banner
 *
 * @param {quotesClickCtaInGetWixAppBannerParams} params - The parameters for this event
 * @property {string} name - banner name {get wix app}
 * @property {string} view_type - view_type
 * @property {string} platform - platform
 * @property {GUID} msid - msid
 * @return {LogObject<quotesClickCtaInGetWixAppBannerParams>} LogObject<quotesClickCtaInGetWixAppBannerParams>
 */
export function quotesClickCtaInGetWixAppBanner(params) {
    return { evid: 476, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'quotesPrintInvoiceSrc5Evid477' event (evid: 477)
 *
 * Event description: Quotes - Print Invoice
 *
 * @param {quotesPrintInvoiceSrc5Evid477Params} params - The parameters for this event
 * @property {string} paymentType - 'Recurring','One Time'
 * @property {string} view_type - view_type
 * @property {string} origin - customer for UoU, my invoices for users
 * @property {string} platform - platform
 * @property {string} msid - msid
 * @property {GUID} invoice_id - invoice guid
 * @return {LogObject<quotesPrintInvoiceSrc5Evid477Params>} LogObject<quotesPrintInvoiceSrc5Evid477Params>
 */
export function quotesPrintInvoiceSrc5Evid477(params) {
    return { evid: 477, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'quotesPayInvoiceClick' event (evid: 478)
 *
 * Event description: Quotes - Pay Invoice Click
 *
 * @param {quotesPayInvoiceClickParams} params - The parameters for this event
 * @property {number} totalAmountLong - total price multiplied by 100000
 * @property {GUID} externalId - An external id of an entity, relevant to the invoiceSource application
 * @property {string} paymentType - 'Recurring','One Time'
 * @property {string} view_type - view_type
 * @property {string} invoiceType - ’recurringAutoCharge’/ 'recurring'/ 'one time'
 * @property {string} origin - customer for UoU, my invoices for users
 * @property {GUID} invoiceSource - by app_def_id
 * @property {string} currency - currency
 * @property {string} platform - platform
 * @property {string} msid - msid
 * @property {GUID} invoice_id - invoice guid
 * @return {LogObject<quotesPayInvoiceClickParams>} LogObject<quotesPayInvoiceClickParams>
 */
export function quotesPayInvoiceClick(params) {
    return { evid: 478, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'quotesCloseManagePlanBillingTooltip' event (evid: 479)
 *
 * Event description: Quotes - Close manage plan billing tooltip
 *
 * @param {quotesCloseManagePlanBillingTooltipParams} params - The parameters for this event
 * @property {string} choose - 'Got it','Close'
 * @property {string} view_type - view_type
 * @property {string} platform - platform
 * @property {string} msid - msid
 * @property {GUID} invoice_id - invoice guid
 * @return {LogObject<quotesCloseManagePlanBillingTooltipParams>} LogObject<quotesCloseManagePlanBillingTooltipParams>
 */
export function quotesCloseManagePlanBillingTooltip(params) {
    return { evid: 479, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'dashboardSiteClickNextOnTransferSiteActionFirstWindow' event (evid: 48)
 *
 * Event description: when user click on quick action, and then click next after chooses relevant transfer options
 *
 * @param {dashboardSiteClickNextOnTransferSiteActionFirstWindowParams} params - The parameters for this event
 * @property {string} name - name of quick action (transfer,etc.)
 * @property {string} stage_process - deprecated
 * @property {string} stepLabel - recipient-step, options-step, confirmation-step, success-step
 * @property {boolean} transferPremium - true if marked
 * @property {boolean} keepCopy - true if marked
 * @property {string} view_type - view_type
 * @property {string} origin - --
 * @property {boolean} transferDomain - true if marked
 * @property {string} platform - platform
 * @property {boolean} addAdmin - true if marked
 * @property {string} hosting - ma/editor
 * @property {boolean} isContributor - true if email is contact
 * @property {GUID} msid - --
 * @return {LogObject<dashboardSiteClickNextOnTransferSiteActionFirstWindowParams>} LogObject<dashboardSiteClickNextOnTransferSiteActionFirstWindowParams>
 */
export function dashboardSiteClickNextOnTransferSiteActionFirstWindow(params) {
    return { evid: 48, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'quotesCreateInvoiceToggleRecurring' event (evid: 480)
 *
 * Event description: Quotes - Create invoice - Toggle Recurring
 *
 * @param {quotesCreateInvoiceToggleRecurringParams} params - The parameters for this event
 * @property {boolean} toggle - true if it's Recurring on, false for oposite
 * @property {string} view_type - view_type
 * @property {string} platform - platform
 * @property {string} msid - msid
 * @return {LogObject<quotesCreateInvoiceToggleRecurringParams>} LogObject<quotesCreateInvoiceToggleRecurringParams>
 */
export function quotesCreateInvoiceToggleRecurring(params) {
    return { evid: 480, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'quotesPrintFromPreviewPage' event (evid: 481)
 *
 * Event description: Quotes - Resend from preview page
 *
 * @param {quotesPrintFromPreviewPageParams} params - The parameters for this event
 * @property {string} view_type - view_type
 * @property {string} platform - platform
 * @property {string} msid - msid
 * @return {LogObject<quotesPrintFromPreviewPageParams>} LogObject<quotesPrintFromPreviewPageParams>
 */
export function quotesPrintFromPreviewPage(params) {
    return { evid: 481, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'quotesPreviewFromInsideTheInvoiceCreation' event (evid: 482)
 *
 * Event description: Quotes - Preview from inside the invoice creation
 *
 * @param {quotesPreviewFromInsideTheInvoiceCreationParams} params - The parameters for this event
 * @property {string} view_type - view_type
 * @property {string} platform - platform
 * @property {string} msid - msid
 * @return {LogObject<quotesPreviewFromInsideTheInvoiceCreationParams>} LogObject<quotesPreviewFromInsideTheInvoiceCreationParams>
 */
export function quotesPreviewFromInsideTheInvoiceCreation(params) {
    return { evid: 482, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'quotesCancelFromInsideTheInvoiceCreation' event (evid: 483)
 *
 * Event description: Quotes - Cancel from inside the invoice creation.
 *
 * @param {quotesCancelFromInsideTheInvoiceCreationParams} params - The parameters for this event
 * @property {string} view_type - view_type
 * @property {string} platform - platform
 * @property {string} msid - msid
 * @return {LogObject<quotesCancelFromInsideTheInvoiceCreationParams>} LogObject<quotesCancelFromInsideTheInvoiceCreationParams>
 */
export function quotesCancelFromInsideTheInvoiceCreation(params) {
    return { evid: 483, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'quotesPreviewFromTable' event (evid: 484)
 *
 * Event description: Quotes - Preview from table
 *
 * @param {quotesPreviewFromTableParams} params - The parameters for this event
 * @property {GUID} externalId - An external id of an entity, relevant to the invoiceSource application
 * @property {string} view_type - view_type
 * @property {string} origin - origin page - from which place this action was made (invoices, contacts full page, crm home...)
 * @property {GUID} appdefid - appDefId (application ID)
 * @property {string} platform - platform
 * @property {string} msid - msid
 * @property {GUID} invoice_id - invoice_guid
 * @return {LogObject<quotesPreviewFromTableParams>} LogObject<quotesPreviewFromTableParams>
 */
export function quotesPreviewFromTable(params) {
    return { evid: 484, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'mySitesEditSite' event (evid: 486)
 *
 * Event description: clicking on edit site in My Sites
 *
 * @param {mySitesEditSiteParams} params - The parameters for this event
 * @property {string} view_type - view_type
 * @property {string} ds_origin - destination - editor/ADI/editorX
 * @property {string} origin - {site_list_top, site_list_bottom, top_bar, account_templates,...}, site-list-partners-DIY
 * @property {string} view_level - view_level
 * @property {string} place - origin inside page
 * @property {boolean} is_premium - is_premium
 * @property {string} platform - platform
 * @property {string} hosting - hosting
 * @property {GUID} msid - msid
 * @property {boolean} is_published - is_published
 * @return {LogObject<mySitesEditSiteParams>} LogObject<mySitesEditSiteParams>
 */
export function mySitesEditSite(params) {
    return { evid: 486, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'sidebarCategoryItemsShown488' event (evid: 488)
 *
 * Event description: when a user hovers an item from the sidebar or when click on sidebar to expand and drop down is shown.
 *
 * @param {sidebarCategoryItemsShown488Params} params - The parameters for this event
 * @property {string} name - the active sidebar item the user hovers on (the unique name)/ click to expand on
 * @property {string} item_id - item_id
 * @property {string} hosting_platform - hosting_platform
 * @property {string} sidebar_name - the name appears in sidebar
 * @property {string} section_name - deprecated
 * @property {string} category_items_list - list of items viewed in the popup menu
 * @property {string} page_view - the page name of the page the user is in (the active page)
 * @property {string} view_type - view_type
 * @property {string} page_id - page_id
 * @property {string} sidebar_state - sidebar_state
 * @property {number} level_of_popover - level_of_popover
 * @property {string} origin - tooltip / sidebar
 * @property {string} disabled - disabled items
 * @property {string} platform - --
 * @property {string} hosting_platform_context_id - hosting_platform_context_id
 * @property {string} hosting - MA/editor/
 * @property {GUID} msid - site id
 * @return {LogObject<sidebarCategoryItemsShown488Params>} LogObject<sidebarCategoryItemsShown488Params>
 */
export function sidebarCategoryItemsShown488(params) {
    return { evid: 488, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'crmHomeCreateButtonClick' event (evid: 489)
 *
 * Event description: CRM Home - create button click
 *
 * @param {crmHomeCreateButtonClickParams} params - The parameters for this event
 * @property {GUID} uuid - uuid
 * @property {string} view_type - view_type
 * @property {string} platform - platform
 * @property {GUID} msid - msid
 * @return {LogObject<crmHomeCreateButtonClickParams>} LogObject<crmHomeCreateButtonClickParams>
 */
export function crmHomeCreateButtonClick(params) {
    return { evid: 489, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'dashboardSiteClickOnLegalCheckboxInTransferSiteSecondWindow' event (evid: 49)
 *
 * Event description: legal checkbox on/off
 *
 * @param {dashboardSiteClickOnLegalCheckboxInTransferSiteSecondWindowParams} params - The parameters for this event
 * @property {string} view_type - view_type
 * @property {boolean} check_box - true/false
 * @property {string} platform - platform
 * @property {string} hosting - ma/editor
 * @property {GUID} msid - site id
 * @return {LogObject<dashboardSiteClickOnLegalCheckboxInTransferSiteSecondWindowParams>} LogObject<dashboardSiteClickOnLegalCheckboxInTransferSiteSecondWindowParams>
 */
export function dashboardSiteClickOnLegalCheckboxInTransferSiteSecondWindow(params) {
    return { evid: 49, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'crmHomeCreateButtonChooseOption' event (evid: 490)
 *
 * Event description: CRM Home - create button choose option
 *
 * @param {crmHomeCreateButtonChooseOptionParams} params - The parameters for this event
 * @property {GUID} uuid - uuid
 * @property {string} option - which option the user choosed
 * @property {string} view_type - view_type
 * @property {string} platform - platform
 * @property {GUID} msid - msid
 * @return {LogObject<crmHomeCreateButtonChooseOptionParams>} LogObject<crmHomeCreateButtonChooseOptionParams>
 */
export function crmHomeCreateButtonChooseOption(params) {
    return { evid: 490, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'crmHomeSecondaryCtaClick' event (evid: 491)
 *
 * Event description: CRM Home - secondary CTA click.
 *
 * @param {crmHomeSecondaryCtaClickParams} params - The parameters for this event
 * @property {GUID} uuid - uuid
 * @property {string} view_type - view_type
 * @property {string} tabName - which tab the user choosed
 * @property {string} platform - platform
 * @property {GUID} msid - msid
 * @return {LogObject<crmHomeSecondaryCtaClickParams>} LogObject<crmHomeSecondaryCtaClickParams>
 */
export function crmHomeSecondaryCtaClick(params) {
    return { evid: 491, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'crmHomeCarouselClick' event (evid: 492)
 *
 * Event description: CRM Home - carousel click
 *
 * @param {crmHomeCarouselClickParams} params - The parameters for this event
 * @property {GUID} uuid - uuid
 * @property {string} view_type - view_type
 * @property {string} platform - platform
 * @property {GUID} msid - msid
 * @return {LogObject<crmHomeCarouselClickParams>} LogObject<crmHomeCarouselClickParams>
 */
export function crmHomeCarouselClick(params) {
    return { evid: 492, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'crmHomeManageYourFinancesChoose' event (evid: 493)
 *
 * Event description: CRM Home - manage your finances - choose.
 *
 * @param {crmHomeManageYourFinancesChooseParams} params - The parameters for this event
 * @property {GUID} uuid - uuid
 * @property {string} view_type - view_type
 * @property {string} tabName - which tab the user choose
 * @property {string} platform - platform
 * @property {GUID} msid - msid
 * @return {LogObject<crmHomeManageYourFinancesChooseParams>} LogObject<crmHomeManageYourFinancesChooseParams>
 */
export function crmHomeManageYourFinancesChoose(params) {
    return { evid: 493, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'crmHomeCustomerManagementToolsChoose' event (evid: 494)
 *
 * Event description: CRM Home - customer management tools - choose.
 *
 * @param {crmHomeCustomerManagementToolsChooseParams} params - The parameters for this event
 * @property {GUID} uuid - uuid
 * @property {string} view_type - view_type
 * @property {string} tabName - tab_name
 * @property {string} platform - platform
 * @property {GUID} msid - msid
 * @return {LogObject<crmHomeCustomerManagementToolsChooseParams>} LogObject<crmHomeCustomerManagementToolsChooseParams>
 */
export function crmHomeCustomerManagementToolsChoose(params) {
    return { evid: 494, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'quotesSettingsChangeTabs' event (evid: 497)
 *
 * Event description: Quotes - Settings - change tabs
 *
 * @param {quotesSettingsChangeTabsParams} params - The parameters for this event
 * @property {string} tab - tab name
 * @property {string} view_type - view_type
 * @property {string} platform - platform
 * @property {string} msid - msid
 * @return {LogObject<quotesSettingsChangeTabsParams>} LogObject<quotesSettingsChangeTabsParams>
 */
export function quotesSettingsChangeTabs(params) {
    return { evid: 497, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'quotesSettingsSuccessToast' event (evid: 498)
 *
 * Event description: Quotes - Settings - success toast
 *
 * @param {quotesSettingsSuccessToastParams} params - The parameters for this event
 * @property {string} view_type - view_type
 * @property {string} platform - platform
 * @property {string} msid - msid
 * @return {LogObject<quotesSettingsSuccessToastParams>} LogObject<quotesSettingsSuccessToastParams>
 */
export function quotesSettingsSuccessToast(params) {
    return { evid: 498, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'contactEnrichmentTemporaryEvent' event (evid: 499)
 *
 * Event description: contact enrichment requset
 *
 * @param {contactEnrichmentTemporaryEventParams} params - The parameters for this event
 * @property {string} view_type - view_type
 * @property {boolean} hasContacts - ignore this field
 * @property {string} origin - app that requested the enrichment
 * @property {string} pageView - ignore this field
 * @property {string} contact_id - contact id
 * @property {string} platform - platform
 * @property {GUID} msid - msid
 * @return {LogObject<contactEnrichmentTemporaryEventParams>} LogObject<contactEnrichmentTemporaryEventParams>
 */
export function contactEnrichmentTemporaryEvent(params) {
    return { evid: 499, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'dashboardClickOnConnectDomain' event (evid: 50)
 *
 * Event description: dashboard > click on connect domain.
 *
 * @param {dashboardClickOnConnectDomainParams} params - The parameters for this event
 * @property {string} view_type - view_type
 * @property {string} origin - origin
 * @property {string} platform - platform
 * @property {GUID} msid - msid
 * @return {LogObject<dashboardClickOnConnectDomainParams>} LogObject<dashboardClickOnConnectDomainParams>
 */
export function dashboardClickOnConnectDomain(params) {
    return { evid: 50, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'dashboardClickOnSelectPremiumPlan' event (evid: 51)
 *
 * Event description: dashboard > click on select premium plan.
 *
 * @param {dashboardClickOnSelectPremiumPlanParams} params - The parameters for this event
 * @property {string} referral_info - referral_info
 * @property {string} view_type - view_type
 * @property {string} platform - platform
 * @property {GUID} msid - msid
 * @return {LogObject<dashboardClickOnSelectPremiumPlanParams>} LogObject<dashboardClickOnSelectPremiumPlanParams>
 */
export function dashboardClickOnSelectPremiumPlan(params) {
    return { evid: 51, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'dashboardClickBuyDomainFirst' event (evid: 52)
 *
 * Event description: dashboard > click buy domain first.
 *
 * @param {dashboardClickBuyDomainFirstParams} params - The parameters for this event
 * @property {string} referral_info - referral_info
 * @property {string} view_type - view_type
 * @property {string} platform - platform
 * @property {GUID} msid - msid
 * @return {LogObject<dashboardClickBuyDomainFirstParams>} LogObject<dashboardClickBuyDomainFirstParams>
 */
export function dashboardClickBuyDomainFirst(params) {
    return { evid: 52, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'dashboardCloseConnectDomainPopUp' event (evid: 53)
 *
 * Event description: dashboard > close connect domain pop-up.
 *
 * @param {dashboardCloseConnectDomainPopUpParams} params - The parameters for this event
 * @property {string} view_type - view_type
 * @property {string} origin - origin
 * @property {string} platform - platform
 * @property {GUID} msid - msid
 * @return {LogObject<dashboardCloseConnectDomainPopUpParams>} LogObject<dashboardCloseConnectDomainPopUpParams>
 */
export function dashboardCloseConnectDomainPopUp(params) {
    return { evid: 53, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'dashboardBannerLoadingInit' event (evid: 54)
 *
 * Event description: Please add event for banners loading initiation (as we have for seeing, clicking and closing banners events src= 5 evid=14,34,36)
 *
 * @param {dashboardBannerLoadingInitParams} params - The parameters for this event
 * @property {string} name - banner name for identification
 * @property {string} view_type - view_type
 * @property {string} origin - origin
 * @property {string} platform - platform
 * @property {GUID} msid - msid
 * @return {LogObject<dashboardBannerLoadingInitParams>} LogObject<dashboardBannerLoadingInitParams>
 */
export function dashboardBannerLoadingInit(params) {
    return { evid: 54, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'engageEmailSettingsPageView' event (evid: 540)
 *
 * Event description: Quotes - Settings - error toast
 *
 * @param {engageEmailSettingsPageViewParams} params - The parameters for this event
 * @property {string} view_type - view_type
 * @property {string} platform - platform
 * @property {string} msid - msid
 * @return {LogObject<engageEmailSettingsPageViewParams>} LogObject<engageEmailSettingsPageViewParams>
 */
export function engageEmailSettingsPageView(params) {
    return { evid: 540, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'engageEmailSettingsUpdateValue' event (evid: 541)
 *
 * Event description: Quotes - Settings - add new tax
 *
 * @param {engageEmailSettingsUpdateValueParams} params - The parameters for this event
 * @property {string} view_type - view_type
 * @property {string} platform - platform
 * @property {string} msid - msid
 * @return {LogObject<engageEmailSettingsUpdateValueParams>} LogObject<engageEmailSettingsUpdateValueParams>
 */
export function engageEmailSettingsUpdateValue(params) {
    return { evid: 541, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'engageEmailSettingsSaveChangesClick' event (evid: 542)
 *
 * Event description: Quotes - Settings - edit tax
 *
 * @param {engageEmailSettingsSaveChangesClickParams} params - The parameters for this event
 * @property {string} view_type - view_type
 * @property {string} platform - platform
 * @property {string} msid - msid
 * @return {LogObject<engageEmailSettingsSaveChangesClickParams>} LogObject<engageEmailSettingsSaveChangesClickParams>
 */
export function engageEmailSettingsSaveChangesClick(params) {
    return { evid: 542, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'engageEmailSettingsCancelBack' event (evid: 544)
 *
 * Event description: Quotes - Settings - delete tax
 *
 * @param {engageEmailSettingsCancelBackParams} params - The parameters for this event
 * @property {string} view_type - view_type
 * @property {string} platform - platform
 * @property {string} msid - msid
 * @return {LogObject<engageEmailSettingsCancelBackParams>} LogObject<engageEmailSettingsCancelBackParams>
 */
export function engageEmailSettingsCancelBack(params) {
    return { evid: 544, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'engageEmailSettingsUnsavedChangesDialog' event (evid: 546)
 *
 * Event description: Quotes - click on share link
 *
 * @param {engageEmailSettingsUnsavedChangesDialogParams} params - The parameters for this event
 * @property {GUID} externalId - An external id of an entity, relevant to the invoiceSource application
 * @property {string} view_type - view_type
 * @property {GUID} invoiceId - invoiceId
 * @property {string} origin - more actions/invoice preview
 * @property {string} status - Creation form/Draft/Sent/Paid
 * @property {GUID} appdefid - appdefid of the source
 * @property {string} platform - platform
 * @property {string} msid - msid
 * @return {LogObject<engageEmailSettingsUnsavedChangesDialogParams>} LogObject<engageEmailSettingsUnsavedChangesDialogParams>
 */
export function engageEmailSettingsUnsavedChangesDialog(params) {
    return { evid: 546, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'dashboardBannerLoadingComplete' event (evid: 55)
 *
 * Event description: Please add event for banners loading completion (as we have for seeing, clicking and closing banners events src= 5 evid=14,34,36)
 *
 * @param {dashboardBannerLoadingCompleteParams} params - The parameters for this event
 * @property {string} name - banner name for identification
 * @property {string} view_type - view_type
 * @property {string} origin - origin
 * @property {string} platform - platform
 * @property {GUID} msid - msid
 * @return {LogObject<dashboardBannerLoadingCompleteParams>} LogObject<dashboardBannerLoadingCompleteParams>
 */
export function dashboardBannerLoadingComplete(params) {
    return { evid: 55, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'sideBarItemClick550' event (evid: 550)
 *
 * Event description: user clicks on an item from the sidebar in one of Giza's hosting platforms. currently in business manager it's not reported from Giza.
 *
 * @param {sideBarItemClick550Params} params - The parameters for this event
 * @property {string} name - unique item name that doesn't change when changing the name on the side bar
 * @property {GUID} prev_app_id - The app_id of the previous page/previous item (before clicking on item)
 * @property {string} item_id - item_id
 * @property {string} sub_section_name - when the sidebar is opened on a third level item- should represents the second level of the active name field, else=null
 * @property {string} hosting_platform - accountmanagr/bizmanagr/devcenter/etc.
 * @property {string} sidebar_name - deprecated
 * @property {string} section_name - the name of the source section (where the click occurred)
 * @property {string} previous_item_name - the previous unique item name that doesn't change when changing the name, this is the item which was highlighted before the click
 * @property {string} referral_info - referral parameter
 * @property {string} view_type - view_type
 * @property {boolean} is_from_main_sidebar - true if the click is from main sidebar and false if it's from sidebar dropdown tooltip
 * @property {string} sidebar_state - sidebar_state
 * @property {string} origin - tooltip / sidebar / add new
 * @property {string} sub_category_items_list - sub_category_items_list
 * @property {string} items_list - JSON of all the items the user saw in the sidebar when clicked on item- key:unique item name, value: number of notifications the user sees in this item. In case the type is navigated - please send the sidebar items list
 * @property {string} second_sub_category_items_list - when the sidebar is opened on a third level item- list of third level items in the expanded sidebar menu
 * @property {number} counter - The value inside the counter clicked (if counter exists)
 * @property {string} app_id - app_id of the item
 * @property {string} type - click/expand
 * @property {string} previous_sidebar_name - deprecated
 * @property {string} platform - platform
 * @property {string} hosting_platform_context_id - hosting_platform_context_id
 * @property {string} hosting - dashboard / editor / onboarding
 * @property {string} previous_item_id - previous_item_id
 * @property {GUID} msid - metasite id
 * @property {string} legacy_name - deprecated
 * @property {string} target_page_id - target_page_id
 * @return {LogObject<sideBarItemClick550Params>} LogObject<sideBarItemClick550Params>
 */
export function sideBarItemClick550(params) {
    return { evid: 550, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'bizManagerBizInfoFieldValueChangedNotSaved' event (evid: 551)
 *
 * Event description: user updates a field in the business info. reported only when field is out of focus
 *
 * @param {bizManagerBizInfoFieldValueChangedNotSavedParams} params - The parameters for this event
 * @property {string} name - name of field (key): business name, description, main category, sub category, etc
 * @property {string} sub_category - ADI business type of the selection in business info category
 * @property {string} hosting_platform - in case it's Wix studio Business info (account level business info page) then the value is 'my-account-2-dashboard' otherwise the value is null and it means it's BizMgr business info (site level business info)
 * @property {string} field_type - text, drop down, image, ..
 * @property {string} page_view - The page where the changes were made. before the new settings the page was only general info
 * @property {string} industry_id - industry_id of of the selected sub-category
 * @property {string} view_type - view_type
 * @property {string} structure_id - structure_id of the selected sub-category
 * @property {string} origin - app name
 * @property {string} category - category of of the selected sub-category
 * @property {string} fold_name - name of fold: basic info, contact info, location language and region,
 * @property {string} platform - platform
 * @property {string} location_details - 0- first location (create), 1-second location (add), 2- third location (add),...
 * @property {string} hosting - MA/editor
 * @property {GUID} msid - metasite id
 * @property {string} value - value of field: only for drop down fields
 * @return {LogObject<bizManagerBizInfoFieldValueChangedNotSavedParams>} LogObject<bizManagerBizInfoFieldValueChangedNotSavedParams>
 */
export function bizManagerBizInfoFieldValueChangedNotSaved(params) {
    return { evid: 551, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'bizManagerBizInfoClickOnSave' event (evid: 552)
 *
 * Event description: user saves changes in business info page
 *
 * @param {bizManagerBizInfoClickOnSaveParams} params - The parameters for this event
 * @property {string} name - list of fields, separated by commas
 * @property {string} hosting_platform - in case it's Wix studio Business info (account level business info page) then the value is 'my-account-2-dashboard' otherwise the value is null and it means it's BizMgr business info (site level business info)
 * @property {string} page_view - The page where the changes were made
 * @property {string} view_type - view_type
 * @property {string} origin - app
 * @property {string} place - place of save button: header, footer
 * @property {string} fold_name - list of fold names, separated by commas
 * @property {string} platform - platform
 * @property {string} location_details - 0- first location (create), 1-second location (add), 2- third location (add),...
 * @property {string} hosting - MA/editor
 * @property {GUID} msid - metasite id
 * @return {LogObject<bizManagerBizInfoClickOnSaveParams>} LogObject<bizManagerBizInfoClickOnSaveParams>
 */
export function bizManagerBizInfoClickOnSave(params) {
    return { evid: 552, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'bizManagerBizInfoSaveSuccess' event (evid: 553)
 *
 * Event description: changes were saved successfully
 *
 * @param {bizManagerBizInfoSaveSuccessParams} params - The parameters for this event
 * @property {string} name - list of fields, separated by commas
 * @property {string} sub_category - business type at the end
 * @property {string} hosting_platform - in case it's Wix studio Business info (account level business info page) then the value is 'my-account-2-dashboard' otherwise the value is null and it means it's BizMgr business info (site level business info)
 * @property {string} page_view - The page where the changes were made (website settings/business info/language and region)
 * @property {string} industry_id - industry_id of of the new sub-category
 * @property {string} view_type - view_type
 * @property {string} structure_id - structure_id of the new sub-category
 * @property {string} origin - app where modal was opened from
 * @property {string} category - category of of the new sub-category
 * @property {string} place - place of discard button: header, footer
 * @property {string} fold_name - list of fold names, separated by commas
 * @property {string} platform - platform
 * @property {string} location_details - 0- first location (create), 1-second location (add), 2- third location (add),...
 * @property {string} hosting - MA/editor
 * @property {GUID} msid - metasite id
 * @property {boolean} is_physical_address - true/false
 * @return {LogObject<bizManagerBizInfoSaveSuccessParams>} LogObject<bizManagerBizInfoSaveSuccessParams>
 */
export function bizManagerBizInfoSaveSuccess(params) {
    return { evid: 553, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'bizManagerBizInfoClickOnDiscardButton' event (evid: 554)
 *
 * Event description: user click on discard button
 *
 * @param {bizManagerBizInfoClickOnDiscardButtonParams} params - The parameters for this event
 * @property {string} hosting_platform - in case it's Wix studio Business info (account level business info page) then the value is 'my-account-2-dashboard' otherwise the value is null and it means it's BizMgr business info (site level business info)
 * @property {string} page_view - The page where the changes were made (website settings/business info/language and region)
 * @property {string} view_type - view_type
 * @property {string} origin - app
 * @property {string} place - place of discard button: header, footer
 * @property {string} platform - platform
 * @property {string} location_details - 0- first location (create), 1-second location (add), 2- third location (add),...
 * @property {string} hosting - MA/editor
 * @property {GUID} msid - metasite id
 * @return {LogObject<bizManagerBizInfoClickOnDiscardButtonParams>} LogObject<bizManagerBizInfoClickOnDiscardButtonParams>
 */
export function bizManagerBizInfoClickOnDiscardButton(params) {
    return { evid: 554, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'bizManagerBizInfoApproveDiscard' event (evid: 555)
 *
 * Event description: user approves to discard changes in the discard modal
 * or
 * user navigates away and doesn't want to keep changes
 *
 * @param {bizManagerBizInfoApproveDiscardParams} params - The parameters for this event
 * @property {string} hosting_platform - in case it's Wix studio Business info (account level business info page) then the value is 'my-account-2-dashboard' otherwise the value is null and it means it's BizMgr business info (site level business info)
 * @property {string} context - name of modal: discard modal, navigate away modal
 * @property {string} page_view - hosting: MA/editor/onboarding msid context: name of modal: discard modal, navigate away modal page_view: The page where the changes were made (website settings/business info/language and region)
 * @property {string} view_type - view_type
 * @property {string} platform - platform
 * @property {string} hosting - MA/editor
 * @property {GUID} msid - metasite id
 * @return {LogObject<bizManagerBizInfoApproveDiscardParams>} LogObject<bizManagerBizInfoApproveDiscardParams>
 */
export function bizManagerBizInfoApproveDiscard(params) {
    return { evid: 555, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'bizManagerBizInfoCancelDiscard' event (evid: 556)
 *
 * Event description: user clicks on X or Cancel in the discard modal
 *
 * @param {bizManagerBizInfoCancelDiscardParams} params - The parameters for this event
 * @property {string} page_view - The page where the changes were made (website settings/business info/language and region)
 * @property {string} view_type - view_type
 * @property {string} origin - app
 * @property {string} platform - platform
 * @property {string} location_details - 0- first location (create), 1-second location (add), 2- third location (add),...
 * @property {string} hosting - MA/editor
 * @property {GUID} msid - metasite id
 * @return {LogObject<bizManagerBizInfoCancelDiscardParams>} LogObject<bizManagerBizInfoCancelDiscardParams>
 */
export function bizManagerBizInfoCancelDiscard(params) {
    return { evid: 556, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'bizManagerBizInfoNavigateAwayDialogIsShown' event (evid: 557)
 *
 * Event description: user navigates away and gets the navigate away modal
 *
 * @param {bizManagerBizInfoNavigateAwayDialogIsShownParams} params - The parameters for this event
 * @property {string} view_type - view_type
 * @property {string} platform - platform
 * @property {string} hosting - MA/editor
 * @property {GUID} msid - metasite id
 * @return {LogObject<bizManagerBizInfoNavigateAwayDialogIsShownParams>} LogObject<bizManagerBizInfoNavigateAwayDialogIsShownParams>
 */
export function bizManagerBizInfoNavigateAwayDialogIsShown(params) {
    return { evid: 557, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'bizManagerBizInfoNavigateAwayStayInPage' event (evid: 558)
 *
 * Event description: user chooses to stay in page when the navigate away modal is shown
 *
 * @param {bizManagerBizInfoNavigateAwayStayInPageParams} params - The parameters for this event
 * @property {string} view_type - view_type
 * @property {string} platform - platform
 * @property {string} hosting - MA/editor
 * @property {GUID} msid - metasite id
 * @return {LogObject<bizManagerBizInfoNavigateAwayStayInPageParams>} LogObject<bizManagerBizInfoNavigateAwayStayInPageParams>
 */
export function bizManagerBizInfoNavigateAwayStayInPage(params) {
    return { evid: 558, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'bizManagerBizInfoClickOnButton' event (evid: 559)
 *
 * Event description: user clicks a button, e.g "add logo", "add payment",  "edit shipping", etc.
 *
 * @param {bizManagerBizInfoClickOnButtonParams} params - The parameters for this event
 * @property {string} name - name of field (key): business name, description, main category, sub category, etc
 * @property {string} view_type - view_type
 * @property {string} fold_name - name of fold: basic info, contact info, location language and region,
 * @property {string} platform - platform
 * @property {string} hosting - MA/editor
 * @property {GUID} msid - metasite id
 * @return {LogObject<bizManagerBizInfoClickOnButtonParams>} LogObject<bizManagerBizInfoClickOnButtonParams>
 */
export function bizManagerBizInfoClickOnButton(params) {
    return { evid: 559, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'siteHistoryViewerNotLoaded' event (evid: 56)
 *
 * Event description: error on loading of the viewer iframe in site history
 *
 * @param {siteHistoryViewerNotLoadedParams} params - The parameters for this event
 * @property {string} referralInfo - editor / home
 * @property {string} view_type - view_type
 * @property {string} platform - platform
 * @return {LogObject<siteHistoryViewerNotLoadedParams>} LogObject<siteHistoryViewerNotLoadedParams>
 */
export function siteHistoryViewerNotLoaded(params) {
    return { evid: 56, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'bizManagerBizInfoNavigateAwayLeaveThisPage' event (evid: 560)
 *
 * Event description: user chooses to leave the page when the navigate away modal is shown
 *
 * @param {bizManagerBizInfoNavigateAwayLeaveThisPageParams} params - The parameters for this event
 * @property {string} view_type - view_type
 * @property {string} platform - platform
 * @property {string} hosting - MA/editor
 * @property {GUID} msid - metasite id
 * @return {LogObject<bizManagerBizInfoNavigateAwayLeaveThisPageParams>} LogObject<bizManagerBizInfoNavigateAwayLeaveThisPageParams>
 */
export function bizManagerBizInfoNavigateAwayLeaveThisPage(params) {
    return { evid: 560, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'bizManagerStartLoading' event (evid: 561)
 *
 * Event description: user click to open Biz manager
 *
 * @param {bizManagerStartLoadingParams} params - The parameters for this event
 * @property {GUID} context - when the context is site - send msid, when the context is app for example (like in devCenter) send appDefId, etc.
 * @property {string} view_type - view_type
 * @property {number} screen_width - screen width of the user screen
 * @property {boolean} initial_load - first load
 * @property {string} app_ids - all applications installed om Biz Mgr
 * @property {number} window_width - window width of the user screen
 * @property {number} loading_time_from_performance_now - loading_time_from_performance_now
 * @property {number} screen_height - screen height of the user screen
 * @property {string} app_id - --
 * @property {number} window_height - window height of the user screen
 * @property {string} platform - platform
 * @property {number} time_to_first_byte - time in ms until the first time the user sees any feedback rather than empty page
 * @property {string} hosting - from where the user opened Biz manager
 * @property {GUID} msid - metasite id
 * @return {LogObject<bizManagerStartLoadingParams>} LogObject<bizManagerStartLoadingParams>
 */
export function bizManagerStartLoading(params) {
    return { evid: 561, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'bizManagerFinishLoading' event (evid: 562)
 *
 * Event description: Biz Manager loaded successfully
 *
 * @param {bizManagerFinishLoadingParams} params - The parameters for this event
 * @property {string} view_type - view_type
 * @property {number} num_of_bundles - number of initials bundles from app template config
 * @property {boolean} initial_load - first load
 * @property {string} app_id - --
 * @property {string} platform - platform
 * @property {string} hosting - from where the user opened Biz manager
 * @property {GUID} msid - metasite id
 * @property {number} loading_time - loading time of page
 * @return {LogObject<bizManagerFinishLoadingParams>} LogObject<bizManagerFinishLoadingParams>
 */
export function bizManagerFinishLoading(params) {
    return { evid: 562, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'bizManagerModuleLoadingStart' event (evid: 564)
 *
 * Event description: module that is loaded in the biz manager (like Stores, Shoutout, etc.)
 *
 * @param {bizManagerModuleLoadingStartParams} params - The parameters for this event
 * @property {string} wixsession - authentication token. if the session exists, then the user is logged in.
 * @property {string} prev_module_id - last module loaded
 * @property {string} referral_info - specific button triggered the the view loading
 * @property {string} view_type - view_type
 * @property {boolean} initial_load - first load
 * @property {string} origin - specific button triggered the the view loading (== referral info from editor)
 * @property {GUID} app_id - application id
 * @property {string} platform - platform
 * @property {string} origin_app_id - origin_app_id (what app opened the bizmgr)
 * @property {string} hosting - MA/editor
 * @property {GUID} msid - metasite id
 * @property {string} module_id - requested module
 * @return {LogObject<bizManagerModuleLoadingStartParams>} LogObject<bizManagerModuleLoadingStartParams>
 */
export function bizManagerModuleLoadingStart(params) {
    return { evid: 564, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'bizManagerModuleLoadingFinish' event (evid: 565)
 *
 * Event description: module that is loaded in the biz manager (like Stores, Shoutout, etc.)
 *
 * @param {bizManagerModuleLoadingFinishParams} params - The parameters for this event
 * @property {string} wixsession - authentication token. if the session exists, then the user is logged in.
 * @property {string} referral_info - specific button triggered the the view loading
 * @property {string} view_type - view_type
 * @property {boolean} initial_load - first load
 * @property {string} origin - specific button triggered the the view loading (== referral info from editor)
 * @property {GUID} app_id - application id
 * @property {string} platform - platform
 * @property {string} origin_app_id - origin_app_id (what app opened the bizmgr)
 * @property {string} hosting - MA/editor
 * @property {GUID} msid - metasite id
 * @property {string} module_id - requested module
 * @property {number} loading_time - loading time from module loading start
 * @return {LogObject<bizManagerModuleLoadingFinishParams>} LogObject<bizManagerModuleLoadingFinishParams>
 */
export function bizManagerModuleLoadingFinish(params) {
    return { evid: 565, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'bizManagerNavigateToViewStart' event (evid: 566)
 *
 * Event description: user's click triggers the Router to start a navigation
 *
 * @param {bizManagerNavigateToViewStartParams} params - The parameters for this event
 * @property {string} wixsession - authentication token. if the session exists, then the user is logged in.
 * @property {string} prev_module_id - *not in use*
 * @property {string} referral_info - specific button that triggers the navigation
 * @property {string} view_type - view_type
 * @property {string} sub_view - page in app
 * @property {string} prev_view - last view loaded
 * @property {GUID} app_id - last  application loaded
 * @property {string} prev_sub_view - prev page in app
 * @property {string} platform - platform
 * @property {string} hosting - MA/editor
 * @property {GUID} msid - metasite id
 * @property {string} module_id - *not in use*
 * @property {string} view - requested view
 * @return {LogObject<bizManagerNavigateToViewStartParams>} LogObject<bizManagerNavigateToViewStartParams>
 */
export function bizManagerNavigateToViewStart(params) {
    return { evid: 566, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'dashboardClickOnCreatePriorityTicketExperts' event (evid: 57)
 *
 * Event description: User click on 'Create Priority Ticket' - available for Experts
 *
 * @param {dashboardClickOnCreatePriorityTicketExpertsParams} params - The parameters for this event
 * @property {string} view_type - view_type
 * @property {string} origin_app - if dashboard then 'MAD'
 * @property {string} origin - location of the click
 * @property {string} platform - platform
 * @return {LogObject<dashboardClickOnCreatePriorityTicketExpertsParams>} LogObject<dashboardClickOnCreatePriorityTicketExpertsParams>
 */
export function dashboardClickOnCreatePriorityTicketExperts(params) {
    return { evid: 57, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'bizManagerClickOnBackInSidebarItem' event (evid: 570)
 *
 * Event description: user clicks on back from the sidebar in the business manager
 *
 * @param {bizManagerClickOnBackInSidebarItemParams} params - The parameters for this event
 * @property {string} name - unique name that doesn't change when changing the name on the side bar
 * @property {string} sidebar_name - the name that appears in the sidebar - can be changed
 * @property {string} view_type - view_type
 * @property {string} app_id - app_id of the item
 * @property {string} platform - platform
 * @property {string} hosting - MA/editor
 * @property {GUID} msid - metasite id
 * @property {string} legacy_name - deprecated
 * @return {LogObject<bizManagerClickOnBackInSidebarItemParams>} LogObject<bizManagerClickOnBackInSidebarItemParams>
 */
export function bizManagerClickOnBackInSidebarItem(params) {
    return { evid: 570, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'bizManagerSetupWidgetIsDisplayed' event (evid: 573)
 *
 * Event description: TPA setup widget is displayed in biz mgr
 *
 * @param {bizManagerSetupWidgetIsDisplayedParams} params - The parameters for this event
 * @property {number} done_steps - number of done steps in setup
 * @property {string} asset_campaign_guid - asset_campaign_guid
 * @property {string} view_type - view_type
 * @property {number} skipped_steps - skipped_steps
 * @property {number} steps - number of steps in setup
 * @property {string} widget_state - minimized/expanded
 * @property {string} platform - platform
 * @property {string} hosting - MA/editor
 * @property {GUID} msid - metasite id
 * @property {string} module_id - module  name
 * @return {LogObject<bizManagerSetupWidgetIsDisplayedParams>} LogObject<bizManagerSetupWidgetIsDisplayedParams>
 */
export function bizManagerSetupWidgetIsDisplayed(params) {
    return { evid: 573, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'bizManagerMinimizeExpandSetupWidget' event (evid: 574)
 *
 * Event description: user minimizes/expands TPA setup widget in biz mgr
 *
 * @param {bizManagerMinimizeExpandSetupWidgetParams} params - The parameters for this event
 * @property {number} done_steps - number of done steps in setup
 * @property {string} view_type - view_type
 * @property {number} skipped_steps - skipped_steps
 * @property {string} app_id - app def id
 * @property {number} steps - number of steps in setup
 * @property {string} widget_state - minimized/expanded
 * @property {string} platform - platform
 * @property {string} hosting - MA/editor
 * @property {GUID} msid - metasite id
 * @property {string} module_id - module name
 * @return {LogObject<bizManagerMinimizeExpandSetupWidgetParams>} LogObject<bizManagerMinimizeExpandSetupWidgetParams>
 */
export function bizManagerMinimizeExpandSetupWidget(params) {
    return { evid: 574, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'bizManagerSetupWidgetShowMessageComplete' event (evid: 575)
 *
 * Event description: setup widget show message complete
 *
 * @param {bizManagerSetupWidgetShowMessageCompleteParams} params - The parameters for this event
 * @property {string} asset_campaign_guid - id for phase is setup- ids to be consistent with premium events
 * @property {string} view_type - view_type
 * @property {string} sub_view - page in app
 * @property {string} origin - light_box/progress_bar_popup
 * @property {string} platform - platform
 * @property {string} hosting - ADI/MA/editor
 * @property {GUID} msid - metasite id
 * @property {string} module_id - module name
 * @property {string} view - requested view
 * @return {LogObject<bizManagerSetupWidgetShowMessageCompleteParams>} LogObject<bizManagerSetupWidgetShowMessageCompleteParams>
 */
export function bizManagerSetupWidgetShowMessageComplete(params) {
    return { evid: 575, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'bizManagerSetupWidgetClickCtaAfterShowMessageComplete' event (evid: 576)
 *
 * Event description: Click CTA after show message complete
 *
 * @param {bizManagerSetupWidgetClickCtaAfterShowMessageCompleteParams} params - The parameters for this event
 * @property {string} asset_campaign_guid - asset_campaign_guid
 * @property {string} click_type - click/ close
 * @property {string} view_type - view_type
 * @property {string} origin - light_box/progress_bar_popup
 * @property {string} platform - platform
 * @property {string} hosting - ADI/MA/editor
 * @property {GUID} msid - metasite id
 * @property {string} module_id - module name
 * @return {LogObject<bizManagerSetupWidgetClickCtaAfterShowMessageCompleteParams>} LogObject<bizManagerSetupWidgetClickCtaAfterShowMessageCompleteParams>
 */
export function bizManagerSetupWidgetClickCtaAfterShowMessageComplete(params) {
    return { evid: 576, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'bizManagerDisplayAnalyticsWidget' event (evid: 577)
 *
 * Event description: Display the Widget only after Setup is complete or doesn't exist.
 *
 * @param {bizManagerDisplayAnalyticsWidgetParams} params - The parameters for this event
 * @property {string} view_type - view_type
 * @property {string} app_id - app id of the vertical that displays the widget.
 * @property {string} platform - platform
 * @property {string} hosting - ADI/MA/editor
 * @property {GUID} msid - metasite id
 * @property {string} module_id - module name
 * @return {LogObject<bizManagerDisplayAnalyticsWidgetParams>} LogObject<bizManagerDisplayAnalyticsWidgetParams>
 */
export function bizManagerDisplayAnalyticsWidget(params) {
    return { evid: 577, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'bizManagerClickOnHelpCenterInDashboardFooter' event (evid: 578)
 *
 * Event description: user click on help center in dashboard footer
 *
 * @param {bizManagerClickOnHelpCenterInDashboardFooterParams} params - The parameters for this event
 * @property {string} name - the item that was clicked {Help/Send feedback}
 * @property {string} view_type - view_type
 * @property {string} app_id - app_id installed on biz mgr [deprecated]
 * @property {string} platform - platform
 * @property {string} hosting - ADI/MA/editor
 * @return {LogObject<bizManagerClickOnHelpCenterInDashboardFooterParams>} LogObject<bizManagerClickOnHelpCenterInDashboardFooterParams>
 */
export function bizManagerClickOnHelpCenterInDashboardFooter(params) {
    return { evid: 578, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'bizManagerClickOnWidgetCta' event (evid: 579)
 *
 * Event description: user clicked on a CTA in TPA setup widget in biz mgr
 *
 * @param {bizManagerClickOnWidgetCtaParams} params - The parameters for this event
 * @property {number} done_steps - number of done steps in setup
 * @property {number} step_id - deprecated
 * @property {string} step - step id
 * @property {GUID} step_guid - deprecated
 * @property {string} view_type - view_type
 * @property {number} skipped_steps - skipped_steps
 * @property {string} app_id - app def id
 * @property {number} steps - number of steps in setup
 * @property {string} platform - platform
 * @property {string} hosting - MA/editor
 * @property {GUID} msid - metasite id
 * @property {string} module_id - module name
 * @return {LogObject<bizManagerClickOnWidgetCtaParams>} LogObject<bizManagerClickOnWidgetCtaParams>
 */
export function bizManagerClickOnWidgetCta(params) {
    return { evid: 579, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'transferSiteResendTransferEmailClick' event (evid: 58)
 *
 * Event description: user clicked on resend transfer email
 *
 * @param {transferSiteResendTransferEmailClickParams} params - The parameters for this event
 * @property {string} view_type - view_type
 * @property {string} platform - platform
 * @property {string} hosting - MA /Editor
 * @property {GUID} msid - msid
 * @return {LogObject<transferSiteResendTransferEmailClickParams>} LogObject<transferSiteResendTransferEmailClickParams>
 */
export function transferSiteResendTransferEmailClick(params) {
    return { evid: 58, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'bizManagerHtmlLoaded' event (evid: 580)
 *
 * Event description: Biz Mgr Html loaded after user click to open an app
 *
 * @param {bizManagerHtmlLoadedParams} params - The parameters for this event
 * @property {string} view_type - view_type
 * @property {GUID} app_instance_id - --
 * @property {string} app_ids - app_ids
 * @property {string} platform - platform
 * @property {string} hosting - from where the user opened Biz manager {ADI/MA/Editor}
 * @property {GUID} msid - msid
 * @return {LogObject<bizManagerHtmlLoadedParams>} LogObject<bizManagerHtmlLoadedParams>
 */
export function bizManagerHtmlLoaded(params) {
    return { evid: 580, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'bizManagerViewStartLoading' event (evid: 581)
 *
 * Event description: View/Sub View Start loading
 *
 * @param {bizManagerViewStartLoadingParams} params - The parameters for this event
 * @property {string} referral_info - specific button triggered the the view loading
 * @property {string} view_type - view_type
 * @property {string} sub_view - page in app/module
 * @property {GUID} app_instance_id - --
 * @property {boolean} initial_load - True if first load
 * @property {string} app_ids - app_ids
 * @property {string} prev_view - origin view / module / app
 * @property {string} prev_sub_view - previous page in app/module
 * @property {string} platform - platform
 * @property {string} hosting - ADI/MA/editor
 * @property {GUID} msid - --
 * @property {string} view - requested view/ module/ app
 * @return {LogObject<bizManagerViewStartLoadingParams>} LogObject<bizManagerViewStartLoadingParams>
 */
export function bizManagerViewStartLoading(params) {
    return { evid: 581, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'bizManagerViewFinishLoading' event (evid: 582)
 *
 * Event description: View/Sub View Start loading
 *
 * @param {bizManagerViewFinishLoadingParams} params - The parameters for this event
 * @property {string} view_type - view_type
 * @property {string} sub_view - page in app
 * @property {GUID} app_instance_id - --
 * @property {boolean} initial_load - True if first load
 * @property {string} app_ids - app_ids
 * @property {string} prev_view - origin view
 * @property {string} prev_sub_view - prev page in app
 * @property {string} platform - platform
 * @property {string} hosting - ADI/MA/editor
 * @property {GUID} msid - --
 * @property {string} view - requested view
 * @property {number} loading_time - loading time of page , sent only if this is first load
 * @return {LogObject<bizManagerViewFinishLoadingParams>} LogObject<bizManagerViewFinishLoadingParams>
 */
export function bizManagerViewFinishLoading(params) {
    return { evid: 582, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'bizManagerShowTooltip' event (evid: 583)
 *
 * Event description: tooltip is shown
 *
 * @param {bizManagerShowTooltipParams} params - The parameters for this event
 * @property {string} name - tooltip name
 * @property {string} asset_campaign_guid - when whats next then place
 * @property {string} view_type - view_type
 * @property {boolean} is_hover - true if tooltip shown upon hover
 * @property {string} app_ids - all apps in dashboard (array)
 * @property {string} place - where tooltip was shown (sidebar, rename dialog)
 * @property {string} platform - platform
 * @property {string} hosting - MA/editor
 * @property {GUID} msid - metasite id
 * @property {string} template_id - ping template id
 * @return {LogObject<bizManagerShowTooltipParams>} LogObject<bizManagerShowTooltipParams>
 */
export function bizManagerShowTooltip(params) {
    return { evid: 583, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'bizManagerClickLinkFromTooltip' event (evid: 584)
 *
 * Event description: user clicked on a link from the tooltip
 *
 * @param {bizManagerClickLinkFromTooltipParams} params - The parameters for this event
 * @property {string} name - link name
 * @property {string} click_type - click link / close
 * @property {string} view_type - view_type
 * @property {string} origin - The component that the tooltip appears on
 * @property {string} platform - platform
 * @property {string} hosting - Editor/MA
 * @property {GUID} msid - msid
 * @property {string} value - Link URL
 * @property {string} template_id - ping template id
 * @return {LogObject<bizManagerClickLinkFromTooltipParams>} LogObject<bizManagerClickLinkFromTooltipParams>
 */
export function bizManagerClickLinkFromTooltip(params) {
    return { evid: 584, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'bizManagerBusinessInfoMergeDialogShown' event (evid: 585)
 *
 * Event description: This dialog will alert the user about the change to his settings.
 * It will be displayed only in case of a conflict (my account and other verticals) in the merge process
 *
 * @param {bizManagerBusinessInfoMergeDialogShownParams} params - The parameters for this event
 * @property {string} view_type - view_type
 * @property {string} merged_apps - merged app def id, use delimiter "," between each app_id
 * @property {string} platform - platform
 * @property {string} hosting - MA/editor/ADI
 * @property {GUID} msid - metasite id
 * @return {LogObject<bizManagerBusinessInfoMergeDialogShownParams>} LogObject<bizManagerBusinessInfoMergeDialogShownParams>
 */
export function bizManagerBusinessInfoMergeDialogShown(params) {
    return { evid: 585, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'bizManagerBusinessInfoMergeDialogApprove' event (evid: 586)
 *
 * Event description: This dialog will alert the user about the change to his settings.
 * It will be displayed only in case of a conflict (my account and other verticals) in the merge process. This event represents approval of merging
 *
 * @param {bizManagerBusinessInfoMergeDialogApproveParams} params - The parameters for this event
 * @property {string} view_type - view_type
 * @property {string} merged_apps - merged app def id, use delimiter "," between each app_id
 * @property {string} platform - platform
 * @property {string} hosting - MA/editor/ADI
 * @property {GUID} msid - metasite id
 * @return {LogObject<bizManagerBusinessInfoMergeDialogApproveParams>} LogObject<bizManagerBusinessInfoMergeDialogApproveParams>
 */
export function bizManagerBusinessInfoMergeDialogApprove(params) {
    return { evid: 586, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'bizManagerBusinessInfoMergeDialogClose' event (evid: 587)
 *
 * Event description: This dialog will alert the user about the change to his settings.
 * It will be displayed only in case of a conflict (my account and other verticals) in the merge process. This event represents closing the dialog
 *
 * @param {bizManagerBusinessInfoMergeDialogCloseParams} params - The parameters for this event
 * @property {string} view_type - view_type
 * @property {string} merged_apps - merged app def id, use delimiter "," between each app_id
 * @property {string} platform - platform
 * @property {string} hosting - MA/editor/ADI
 * @property {GUID} msid - metasite id
 * @return {LogObject<bizManagerBusinessInfoMergeDialogCloseParams>} LogObject<bizManagerBusinessInfoMergeDialogCloseParams>
 */
export function bizManagerBusinessInfoMergeDialogClose(params) {
    return { evid: 587, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'managerFullStoryRecordingStarted' event (evid: 588)
 *
 * Event description: FullStory started recording session
 *
 * @param {managerFullStoryRecordingStartedParams} params - The parameters for this event
 * @property {Url} videoUrl - FullStory url
 * @property {string} view_type - view_type
 * @property {GUID} esi - esi
 * @property {string} platform - platform
 * @property {GUID} msid - metasite id
 * @return {LogObject<managerFullStoryRecordingStartedParams>} LogObject<managerFullStoryRecordingStartedParams>
 */
export function managerFullStoryRecordingStarted(params) {
    return { evid: 588, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'bizManagerDismissTooltip' event (evid: 589)
 *
 * Event description: tooltip is dismissed manually
 *
 * @param {bizManagerDismissTooltipParams} params - The parameters for this event
 * @property {string} name - tooltip name
 * @property {string} view_type - view_type
 * @property {string} place - where tooltip was shown (sidebar, rename dialog)
 * @property {string} platform - platform
 * @property {string} hosting - MA/editor
 * @property {GUID} msid - metasite id
 * @return {LogObject<bizManagerDismissTooltipParams>} LogObject<bizManagerDismissTooltipParams>
 */
export function bizManagerDismissTooltip(params) {
    return { evid: 589, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'transferSiteGetTransferLinkClick' event (evid: 59)
 *
 * Event description: user clicked on get transfer link
 *
 * @param {transferSiteGetTransferLinkClickParams} params - The parameters for this event
 * @property {string} view_type - view_type
 * @property {string} platform - platform
 * @property {string} hosting - MA /Editor
 * @property {GUID} msid - msid
 * @return {LogObject<transferSiteGetTransferLinkClickParams>} LogObject<transferSiteGetTransferLinkClickParams>
 */
export function transferSiteGetTransferLinkClick(params) {
    return { evid: 59, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'assetView' event (evid: 590)
 *
 * Event description: what's next asset shown
 *
 * @param {assetViewParams} params - The parameters for this event
 * @property {GUID} assetCampaignGuid - Placement Id from dealer
 * @property {string} promotionAssetType - bizMgrNavigation / video / externalUrl
 * @property {string} offeringGuid - offer guid
 * @property {string} bannerLocationOnPage - 0,1,2,3 ../hover/bubble (progress bar)
 * @property {string} item_mode - open / close
 * @property {string} asset_version - asset_version
 * @property {string} suggestionTags - tag name
 * @property {string} tagName - tag_name
 * @property {string} group_id - id of category in setup widget
 * @property {string} asset_campaign_guid - Placement Id from dealer
 * @property {GUID} item_id - --
 * @property {string} visibility_trigger - normal/scrolling to view/ arrow
 * @property {string} tag - tag
 * @property {string} view_type - view_type
 * @property {string} campaign_name - campaign_name
 * @property {string} offerState - offer_state
 * @property {string} asset_location_on_page - 0,1,2,3 ../hover/bubble (progress bar)
 * @property {string} offering_guid - offer guid
 * @property {boolean} is_step_expanded - is_step_expanded
 * @property {number} asset_location_from_group_list - item location inside the category
 * @property {string} origin - origin
 * @property {string} rank_str - rank_str
 * @property {boolean} is_micro_action - is_micro_action
 * @property {string} asset_campaign_id - Offering name from dealer
 * @property {string} promotion_asset_type - bizMgrNavigation / video / externalUrl
 * @property {GUID} campaignId - campaign_id
 * @property {string} platform - platform
 * @property {string} hosting - ADI/MA/editor/dashboard
 * @property {GUID} msid - site guid
 * @property {string} campaign_id - campaign_id
 * @property {string} premium_badge - the item requires upgrade
 * @return {LogObject<assetViewParams>} LogObject<assetViewParams>
 */
export function assetView(params) {
    return { evid: 590, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'assetClick' event (evid: 591)
 *
 * Event description: When the user clicks on a dealer asset in the new Home (activity) page
 *
 * @param {assetClickParams} params - The parameters for this event
 * @property {GUID} assetCampaignGuid - placement id
 * @property {string} clickType - cta / remove / fold / unfold
 * @property {string} promotionAssetType - bizMgrNavigation / video / externalUrl
 * @property {string} offeringGuid - offer guid
 * @property {string} bannerLocationOnPage - (0,1,2,3)
 * @property {string} item_mode - item_mode
 * @property {string} asset_version - asset_version
 * @property {string} suggestionTags - tag name
 * @property {string} group_id - id of category in setup widget
 * @property {string} asset_campaign_guid - placement id
 * @property {GUID} item_id - assets guid
 * @property {string} visibility_trigger - normal/step_completed
 * @property {string} tag - tag
 * @property {string} lastTag - last_tag
 * @property {string} click_type - cta / remove / fold / unfold
 * @property {number} rank - rank
 * @property {string} view_type - view_type
 * @property {string} campaign_name - campaign_name
 * @property {string} asset_location_on_page - (0,1,2,3)
 * @property {string} offering_guid - offer guid
 * @property {boolean} isMainCta - is_main_cta
 * @property {number} asset_location_from_group_list - item location inside the category
 * @property {string} origin - page/section/dash (page/section for suggestions widget)
 * @property {string} asset_campaign_id - Offer name
 * @property {string} promotion_asset_type - bizMgrNavigation / video / externalUrl
 * @property {GUID} campaignId - campaign_id
 * @property {string} platform - platform
 * @property {string} hosting - ADI/MA/editor
 * @property {GUID} msid - site guid
 * @property {string} campaign_id - campaign_id
 * @property {string} premium_badge - the item requires upgrade
 * @return {LogObject<assetClickParams>} LogObject<assetClickParams>
 */
export function assetClick(params) {
    return { evid: 591, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'bizManagerWhatSNextCloseVideoAsset' event (evid: 592)
 *
 * Event description: what's next video asset closed, with percentage watched
 *
 * @param {bizManagerWhatSNextCloseVideoAssetParams} params - The parameters for this event
 * @property {number} percentage - percentage watched 0-100
 * @property {GUID} group_id - the dealers group from which the asset is being chosen
 * @property {string} asset_campaign_guid - ids to be consistent with premium events
 * @property {GUID} item_id - assets guid
 * @property {string} view_type - view_type
 * @property {string} asset_location_on_page - (0,1,2,3)
 * @property {string} offering_guid - ids to be consistent with premium events
 * @property {number} asset_location_from_group_list - the priority of the asset (from 30)
 * @property {string} asset_campaign_id - ids to be consistent with premium events
 * @property {string} promotion_asset_type - video
 * @property {string} platform - platform
 * @property {string} hosting - ADI/MA/editor
 * @property {GUID} msid - meta site guid
 * @return {LogObject<bizManagerWhatSNextCloseVideoAssetParams>} LogObject<bizManagerWhatSNextCloseVideoAssetParams>
 */
export function bizManagerWhatSNextCloseVideoAsset(params) {
    return { evid: 592, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'bizManagerShowUrgentMessages' event (evid: 593)
 *
 * Event description: show urgent messages
 *
 * @param {bizManagerShowUrgentMessagesParams} params - The parameters for this event
 * @property {string} asset_campaign_guid - ids to be consistent with premium events
 * @property {string} view_type - view_type
 * @property {string} offering_guid - ids to be consistent with premium events
 * @property {string} asset_campaign_id - ids to be consistent with premium events
 * @property {string} platform - platform
 * @property {string} hosting - ADI/MA/editor
 * @property {GUID} msid - site guid
 * @return {LogObject<bizManagerShowUrgentMessagesParams>} LogObject<bizManagerShowUrgentMessagesParams>
 */
export function bizManagerShowUrgentMessages(params) {
    return { evid: 593, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'bizManagerUrgentMessagesClicked' event (evid: 594)
 *
 * Event description: urgent messages clicked
 *
 * @param {bizManagerUrgentMessagesClickedParams} params - The parameters for this event
 * @property {string} asset_campaign_guid - ids to be consistent with premium events
 * @property {string} click_type - click/ close
 * @property {string} view_type - view_type
 * @property {string} offering_guid - ids to be consistent with premium events
 * @property {string} asset_campaign_id - ids to be consistent with premium events
 * @property {string} platform - platform
 * @property {string} hosting - ADI/MA/editor
 * @property {GUID} msid - site guid
 * @return {LogObject<bizManagerUrgentMessagesClickedParams>} LogObject<bizManagerUrgentMessagesClickedParams>
 */
export function bizManagerUrgentMessagesClicked(params) {
    return { evid: 594, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'bizManagerDashboardAssetClickOnArrow' event (evid: 597)
 *
 * Event description: asset click on arrow
 *
 * @param {bizManagerDashboardAssetClickOnArrowParams} params - The parameters for this event
 * @property {string} asset_campaign_guid - ids to be consistent with premium events
 * @property {string} click_type - left / right/ link
 * @property {string} view_type - view_type
 * @property {string} platform - platform
 * @property {string} hosting - ADI/MA/editor
 * @property {GUID} msid - site guid
 * @return {LogObject<bizManagerDashboardAssetClickOnArrowParams>} LogObject<bizManagerDashboardAssetClickOnArrowParams>
 */
export function bizManagerDashboardAssetClickOnArrow(params) {
    return { evid: 597, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'bizManagerOpenPanelStart' event (evid: 598)
 *
 * Event description: panel is starting to load
 *
 * @param {bizManagerOpenPanelStartParams} params - The parameters for this event
 * @property {string} view_type - view_type
 * @property {string} panel_name - the panel that was opened
 * @property {string} sub_view - page in app
 * @property {string} contact_id - contact_id
 * @property {string} platform - platform
 * @property {string} hosting - MA/editor
 * @property {GUID} msid - msid
 * @property {string} view - requested view
 * @return {LogObject<bizManagerOpenPanelStartParams>} LogObject<bizManagerOpenPanelStartParams>
 */
export function bizManagerOpenPanelStart(params) {
    return { evid: 598, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'bizManagerOpenPanelFinish' event (evid: 599)
 *
 * Event description: panel is starting to load
 *
 * @param {bizManagerOpenPanelFinishParams} params - The parameters for this event
 * @property {string} view_type - view_type
 * @property {string} panel_name - the panel that was opened
 * @property {string} sub_view - page in app
 * @property {string} contact_id - contact_id
 * @property {string} platform - platform
 * @property {string} hosting - MA/editor
 * @property {number} loading_time_from_interactive - loading_time_from_interactive (from 657)
 * @property {GUID} msid - msid
 * @property {string} initiator - click on contact name/ i button
 * @property {string} view - requested view
 * @property {number} loading_time - time from start opening the panel till end
 * @return {LogObject<bizManagerOpenPanelFinishParams>} LogObject<bizManagerOpenPanelFinishParams>
 */
export function bizManagerOpenPanelFinish(params) {
    return { evid: 599, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'transferSiteCancelTransferClick' event (evid: 60)
 *
 * Event description: user clicked on cancel transfer and cancel dialog is opened
 *
 * @param {transferSiteCancelTransferClickParams} params - The parameters for this event
 * @property {string} view_type - view_type
 * @property {string} platform - platform
 * @property {string} hosting - MA /Editor
 * @property {GUID} msid - msid
 * @return {LogObject<transferSiteCancelTransferClickParams>} LogObject<transferSiteCancelTransferClickParams>
 */
export function transferSiteCancelTransferClick(params) {
    return { evid: 60, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'dummyEventForSiteMembers' event (evid: 600)
 *
 * Event description: user / app closed the panel
 *
 * @param {dummyEventForSiteMembersParams} params - The parameters for this event
 * @property {string} source - X button / app / navigation
 * @property {string} view_type - view_type
 * @property {string} panel_name - the panel that was opened
 * @property {string} sub_view - page in app
 * @property {string} platform - platform
 * @property {string} hosting - MA/editor
 * @property {GUID} msid - msid
 * @property {string} initiator - contact name/ i button
 * @property {string} view - requested view
 * @return {LogObject<dummyEventForSiteMembersParams>} LogObject<dummyEventForSiteMembersParams>
 */
export function dummyEventForSiteMembers(params) {
    return { evid: 600, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'transferSiteCancelTransferClickApprove' event (evid: 61)
 *
 * Event description: user clicks approve cancel transfer
 *
 * @param {transferSiteCancelTransferClickApproveParams} params - The parameters for this event
 * @property {string} view_type - view_type
 * @property {string} platform - platform
 * @property {string} hosting - MA /Editor
 * @property {GUID} msid - msid
 * @return {LogObject<transferSiteCancelTransferClickApproveParams>} LogObject<transferSiteCancelTransferClickApproveParams>
 */
export function transferSiteCancelTransferClickApprove(params) {
    return { evid: 61, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'transferSiteCancelTransferAbort' event (evid: 62)
 *
 * Event description: user clicks on "don't cancel transfer" or closes dialog with x
 *
 * @param {transferSiteCancelTransferAbortParams} params - The parameters for this event
 * @property {string} view_type - view_type
 * @property {string} platform - platform
 * @property {string} hosting - MA /Editor
 * @property {GUID} msid - msid
 * @return {LogObject<transferSiteCancelTransferAbortParams>} LogObject<transferSiteCancelTransferAbortParams>
 */
export function transferSiteCancelTransferAbort(params) {
    return { evid: 62, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'transferSiteOpenTransferDialogClick' event (evid: 63)
 *
 * Event description: user clicks on transfer site and dialog is opened
 *
 * @param {transferSiteOpenTransferDialogClickParams} params - The parameters for this event
 * @property {string} view_type - view_type
 * @property {string} origin - quick-actions/roles-contributor/roles-owner
 * @property {string} platform - platform
 * @property {string} hosting - MA /Editor
 * @property {string} block_from_transfer_reason - Block from transferring a site
 * @property {GUID} msid - msid
 * @return {LogObject<transferSiteOpenTransferDialogClickParams>} LogObject<transferSiteOpenTransferDialogClickParams>
 */
export function transferSiteOpenTransferDialogClick(params) {
    return { evid: 63, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'transferSiteReceiverOpenCompleteTransferDialog' event (evid: 64)
 *
 * Event description: receiver clicked on accept transfer from mail, the dashboard is open and an complete transfer dialog is open
 *
 * @param {transferSiteReceiverOpenCompleteTransferDialogParams} params - The parameters for this event
 * @property {string} view_type - view_type
 * @property {string} platform - platform
 * @property {string} hosting - MA/Editor
 * @property {GUID} msid - msid
 * @return {LogObject<transferSiteReceiverOpenCompleteTransferDialogParams>} LogObject<transferSiteReceiverOpenCompleteTransferDialogParams>
 */
export function transferSiteReceiverOpenCompleteTransferDialog(params) {
    return { evid: 64, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'quotesNewQuoteClick' event (evid: 65)
 *
 * Event description: Click on create new quote
 *
 * @param {quotesNewQuoteClickParams} params - The parameters for this event
 * @property {GUID} original_quoteId - in case of duplicate: original quote guid
 * @property {string} view_type - view_type
 * @property {string} origin - origin page
 * @property {string} platform - bm/mobile. null indicates bm
 * @property {string} msid - msid
 * @property {GUID} quoteId - quote_guid
 * @return {LogObject<quotesNewQuoteClickParams>} LogObject<quotesNewQuoteClickParams>
 */
export function quotesNewQuoteClick(params) {
    return { evid: 65, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'bizManagerClickOnSetupSkipUndo' event (evid: 656)
 *
 * Event description: user clicked on a CTA in TPA setup widget in biz mgr
 *
 * @param {bizManagerClickOnSetupSkipUndoParams} params - The parameters for this event
 * @property {number} done_steps - number of done steps in setup
 * @property {number} step_id - deprecated
 * @property {string} step - step id
 * @property {string} click_type - skip/undo
 * @property {GUID} step_guid - deprecated
 * @property {string} view_type - view_type
 * @property {number} skipped_steps - skipped_steps
 * @property {string} app_id - app_id
 * @property {number} steps - number of steps in setup
 * @property {string} platform - platform
 * @property {string} hosting - MA/editor
 * @property {GUID} msid - metasite id
 * @property {string} module_id - module name
 * @return {LogObject<bizManagerClickOnSetupSkipUndoParams>} LogObject<bizManagerClickOnSetupSkipUndoParams>
 */
export function bizManagerClickOnSetupSkipUndo(params) {
    return { evid: 656, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'bizManagerOpenPanelInteractive' event (evid: 657)
 *
 * Event description: panel is interactive
 *
 * @param {bizManagerOpenPanelInteractiveParams} params - The parameters for this event
 * @property {string} view_type - view_type
 * @property {string} panel_name - the panel that was opened
 * @property {string} sub_view - page in app
 * @property {string} platform - platform
 * @property {string} hosting - MA/editor
 * @property {GUID} msid - msid
 * @property {string} view - requested view
 * @property {number} loading_time - time from start opening the panel till interactive
 * @return {LogObject<bizManagerOpenPanelInteractiveParams>} LogObject<bizManagerOpenPanelInteractiveParams>
 */
export function bizManagerOpenPanelInteractive(params) {
    return { evid: 657, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'dashboardAccountSettingsHoverOverSendConfirmationI' event (evid: 66)
 *
 * Event description: user hovers the i of 'send confirmation email'
 *
 * @param {dashboardAccountSettingsHoverOverSendConfirmationIParams} params - The parameters for this event
 * @property {string} view_type - view_type
 * @property {string} platform - platform
 * @return {LogObject<dashboardAccountSettingsHoverOverSendConfirmationIParams>} LogObject<dashboardAccountSettingsHoverOverSendConfirmationIParams>
 */
export function dashboardAccountSettingsHoverOverSendConfirmationI(params) {
    return { evid: 66, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'phoneVerificationHoverOnMotivation' event (evid: 660)
 *
 * Event description: hover on "why add a mobile number?"
 *
 * @param {phoneVerificationHoverOnMotivationParams} params - The parameters for this event
 * @property {GUID} uuid - uuid
 * @property {string} view_type - view_type
 * @property {string} platform - platform
 * @return {LogObject<phoneVerificationHoverOnMotivationParams>} LogObject<phoneVerificationHoverOnMotivationParams>
 */
export function phoneVerificationHoverOnMotivation(params) {
    return { evid: 660, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'mobilePhoneNumberConfirmationPopUpClickOkForSendingSms' event (evid: 661)
 *
 * Event description: request for sms has sent
 *
 * @param {mobilePhoneNumberConfirmationPopUpClickOkForSendingSmsParams} params - The parameters for this event
 * @property {GUID} uuid - uuid
 * @property {string} hashed_phone - hashed_phone
 * @property {string} view_type - view_type
 * @property {string} origin - send / resend
 * @property {string} mode - add/edit
 * @property {string} platform - platform
 * @return {LogObject<mobilePhoneNumberConfirmationPopUpClickOkForSendingSmsParams>} LogObject<mobilePhoneNumberConfirmationPopUpClickOkForSendingSmsParams>
 */
export function mobilePhoneNumberConfirmationPopUpClickOkForSendingSms(params) {
    return { evid: 661, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'mobilePhoneNumberConfirmationPopUpClickConfirmForSmsCode' event (evid: 662)
 *
 * Event description: the final user confirmation before the server validates the number
 *
 * @param {mobilePhoneNumberConfirmationPopUpClickConfirmForSmsCodeParams} params - The parameters for this event
 * @property {GUID} uuid - uuid
 * @property {string} hashed_phone - hashed_phone
 * @property {string} view_type - view_type
 * @property {string} code - confirmation code
 * @property {string} mode - add/edit
 * @property {string} platform - platform
 * @return {LogObject<mobilePhoneNumberConfirmationPopUpClickConfirmForSmsCodeParams>} LogObject<mobilePhoneNumberConfirmationPopUpClickConfirmForSmsCodeParams>
 */
export function mobilePhoneNumberConfirmationPopUpClickConfirmForSmsCode(params) {
    return { evid: 662, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'phoneVerificationPhoneValidation' event (evid: 665)
 *
 * Event description: after inserting the password, the wizard opens.
 *
 * @param {phoneVerificationPhoneValidationParams} params - The parameters for this event
 * @property {string} view_type - view_type
 * @property {string} platform - platform
 * @return {LogObject<phoneVerificationPhoneValidationParams>} LogObject<phoneVerificationPhoneValidationParams>
 */
export function phoneVerificationPhoneValidation(params) {
    return { evid: 665, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'phoneVerificationCodeValidation' event (evid: 666)
 *
 * Event description: validates the code entered
 *
 * @param {phoneVerificationCodeValidationParams} params - The parameters for this event
 * @property {GUID} uuid - uuid
 * @property {string} view_type - view_type
 * @property {string} validstatus - good, expired, wrong, error
 * @property {string} platform - platform
 * @return {LogObject<phoneVerificationCodeValidationParams>} LogObject<phoneVerificationCodeValidationParams>
 */
export function phoneVerificationCodeValidation(params) {
    return { evid: 666, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'mobilePhoneNumberConfirmationOpenPopUp' event (evid: 667)
 *
 * Event description: the first trigger to open the confirmation pop up. can come from "save changes" or by "confirm your phone"
 *
 * @param {mobilePhoneNumberConfirmationOpenPopUpParams} params - The parameters for this event
 * @property {string} view_type - view_type
 * @property {string} platform - platform
 * @return {LogObject<mobilePhoneNumberConfirmationOpenPopUpParams>} LogObject<mobilePhoneNumberConfirmationOpenPopUpParams>
 */
export function mobilePhoneNumberConfirmationOpenPopUp(params) {
    return { evid: 667, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'dashboardAccountSettingsClickLearnMoreInI' event (evid: 67)
 *
 * Event description: user clicks 'learn more' in i
 *
 * @param {dashboardAccountSettingsClickLearnMoreInIParams} params - The parameters for this event
 * @property {string} view_type - view_type
 * @property {string} platform - platform
 * @return {LogObject<dashboardAccountSettingsClickLearnMoreInIParams>} LogObject<dashboardAccountSettingsClickLearnMoreInIParams>
 */
export function dashboardAccountSettingsClickLearnMoreInI(params) {
    return { evid: 67, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'bizManagerSetupProgressBarIsDisplayed' event (evid: 672)
 *
 * Event description: setup progress bar is displayed in side bar
 *
 * @param {bizManagerSetupProgressBarIsDisplayedParams} params - The parameters for this event
 * @property {number} done_steps - number of done steps in setup
 * @property {string} asset_campaign_guid - the phase that is displayed to the user (e.g. setup phase)
 * @property {string} view_type - view_type
 * @property {number} skipped_steps - number of skipped steps in setup
 * @property {number} steps - number of steps in setup
 * @property {string} platform - platform
 * @property {string} hosting - MA/editor
 * @property {GUID} msid - metasite id
 * @return {LogObject<bizManagerSetupProgressBarIsDisplayedParams>} LogObject<bizManagerSetupProgressBarIsDisplayedParams>
 */
export function bizManagerSetupProgressBarIsDisplayed(params) {
    return { evid: 672, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'bizManagerNewBadgeShow' event (evid: 673)
 *
 * Event description: 'new' badge show on the sidebar
 *
 * @param {bizManagerNewBadgeShowParams} params - The parameters for this event
 * @property {string} name - unique name that doesn't change when changing the name on the side bar
 * @property {string} sidebar_name - the name that appears in the sidebar - can be changed
 * @property {string} view_type - view_type
 * @property {string} platform - platform
 * @property {string} hosting - MA/editor
 * @property {GUID} msid - metasite id
 * @return {LogObject<bizManagerNewBadgeShowParams>} LogObject<bizManagerNewBadgeShowParams>
 */
export function bizManagerNewBadgeShow(params) {
    return { evid: 673, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'mobilePhoneNumberConfirmationClickOnEdit' event (evid: 678)
 *
 * Event description: Update recovery phone number (account settings redesign) - click on edit number
 *
 * @param {mobilePhoneNumberConfirmationClickOnEditParams} params - The parameters for this event
 * @property {string} view_type - view_type
 * @property {string} platform - platform
 * @return {LogObject<mobilePhoneNumberConfirmationClickOnEditParams>} LogObject<mobilePhoneNumberConfirmationClickOnEditParams>
 */
export function mobilePhoneNumberConfirmationClickOnEdit(params) {
    return { evid: 678, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'accountSettingsClickOnManagePreferences' event (evid: 679)
 *
 * Event description: The user clicks on 'manage preferences' in account settings (redesign)
 *
 * @param {accountSettingsClickOnManagePreferencesParams} params - The parameters for this event
 * @property {string} view_type - view_type
 * @property {string} platform - platform
 * @return {LogObject<accountSettingsClickOnManagePreferencesParams>} LogObject<accountSettingsClickOnManagePreferencesParams>
 */
export function accountSettingsClickOnManagePreferences(params) {
    return { evid: 679, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'dashboardAccountSettingsClickSendConfirmation' event (evid: 68)
 *
 * Event description: user click send confirmation in account settings
 *
 * @param {dashboardAccountSettingsClickSendConfirmationParams} params - The parameters for this event
 * @property {string} view_type - view_type
 * @property {string} platform - platform
 * @return {LogObject<dashboardAccountSettingsClickSendConfirmationParams>} LogObject<dashboardAccountSettingsClickSendConfirmationParams>
 */
export function dashboardAccountSettingsClickSendConfirmation(params) {
    return { evid: 68, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'accountSettingsDeactivateAccountClickOnLearnMore' event (evid: 680)
 *
 * Event description: The user clicks on 'Learn more' after clicking the "i" icon, in account settings (redesign), in a few possible locations on the page
 *
 * @param {accountSettingsDeactivateAccountClickOnLearnMoreParams} params - The parameters for this event
 * @property {string} view_type - view_type
 * @property {string} section - deactivate account/recovery phone/two factor authentication/2FA disable/username/email address
 * @property {string} platform - platform
 * @return {LogObject<accountSettingsDeactivateAccountClickOnLearnMoreParams>} LogObject<accountSettingsDeactivateAccountClickOnLearnMoreParams>
 */
export function accountSettingsDeactivateAccountClickOnLearnMore(params) {
    return { evid: 680, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'twoFactorAuthenticationSetupEnableClick' event (evid: 681)
 *
 * Event description: The user click on 'enable' to enable phone 2fa
 *
 * @param {twoFactorAuthenticationSetupEnableClickParams} params - The parameters for this event
 * @property {string} view_type - view_type
 * @property {string} click_from - security box/main page
 * @property {string} origin - account settings page/app modal/email modal/second best
 * @property {string} platform - platform
 * @return {LogObject<twoFactorAuthenticationSetupEnableClickParams>} LogObject<twoFactorAuthenticationSetupEnableClickParams>
 */
export function twoFactorAuthenticationSetupEnableClick(params) {
    return { evid: 681, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'accountSettingsUpdatesConfirmEnterPassword' event (evid: 682)
 *
 * Event description: The user clicks on 'ok' after entering the password, in the 'enter password' modal that pops up when updating account settings.
 *
 * @param {accountSettingsUpdatesConfirmEnterPasswordParams} params - The parameters for this event
 * @property {string} view_type - view_type
 * @property {boolean} is_valid - true/false
 * @property {string} platform - platform
 * @property {string} action - 2FA enable/2FA disable/2FA edit/add recovery phone/remove recovery phone/edit recovery phone/username/email address
 * @return {LogObject<accountSettingsUpdatesConfirmEnterPasswordParams>} LogObject<accountSettingsUpdatesConfirmEnterPasswordParams>
 */
export function accountSettingsUpdatesConfirmEnterPassword(params) {
    return { evid: 682, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'twoFactorAuthenticationSetupSendCode' event (evid: 683)
 *
 * Event description: The user clicks on 'send code' or 'resend verification code' in the verify phone dialog box, after entering a phone number
 *
 * @param {twoFactorAuthenticationSetupSendCodeParams} params - The parameters for this event
 * @property {string} view_type - view_type
 * @property {string} phone_type - new phone/account phone
 * @property {string} mode - enable/edit
 * @property {string} platform - platform
 * @property {string} action - send/resend
 * @property {string} origin - The origin of the page (Account settings \ 2fa enforcement)
 * @return {LogObject<twoFactorAuthenticationSetupSendCodeParams>} LogObject<twoFactorAuthenticationSetupSendCodeParams>
 */
export function twoFactorAuthenticationSetupSendCode(params) {
    return { evid: 683, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'twoFactorAuthenticationSetupConfirmCodeClick' event (evid: 684)
 *
 * Event description: The user clicks on 'confirm' after entering the 6-digit code he received in an sms
 *
 * @param {twoFactorAuthenticationSetupConfirmCodeClickParams} params - The parameters for this event
 * @property {string} view_type - view_type
 * @property {string} mode - enable/edit
 * @property {boolean} is_valid - did the user enter the correct code sent to his mobile device
 * @property {string} platform - platform
 * @property {string} origin - The origin of the page (Account settings \ 2fa enforcement)
 * @return {LogObject<twoFactorAuthenticationSetupConfirmCodeClickParams>} LogObject<twoFactorAuthenticationSetupConfirmCodeClickParams>
 */
export function twoFactorAuthenticationSetupConfirmCodeClick(params) {
    return { evid: 684, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'twoFactorAuthenticationSetupEditNumber' event (evid: 685)
 *
 * Event description: The user clicks on 'edit number' to update the phone number chosen for 2-factor authentication
 *
 * @param {twoFactorAuthenticationSetupEditNumberParams} params - The parameters for this event
 * @property {string} view_type - view_type
 * @property {string} click_from - security box/main page
 * @property {string} platform - platform
 * @return {LogObject<twoFactorAuthenticationSetupEditNumberParams>} LogObject<twoFactorAuthenticationSetupEditNumberParams>
 */
export function twoFactorAuthenticationSetupEditNumber(params) {
    return { evid: 685, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'twoFactorAuthenticationSetupDisableAction' event (evid: 686)
 *
 * Event description: The user clicks on 'disable' to disable phone 2FA
 *
 * @param {twoFactorAuthenticationSetupDisableActionParams} params - The parameters for this event
 * @property {string} view_type - view_type
 * @property {string} platform - platform
 * @return {LogObject<twoFactorAuthenticationSetupDisableActionParams>} LogObject<twoFactorAuthenticationSetupDisableActionParams>
 */
export function twoFactorAuthenticationSetupDisableAction(params) {
    return { evid: 686, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'twoFactorAuthenticationSetupDisableClick' event (evid: 687)
 *
 * Event description: The user clicks on "disable" in the disable modal for 2-factor authentication (confirms disable)
 *
 * @param {twoFactorAuthenticationSetupDisableClickParams} params - The parameters for this event
 * @property {string} view_type - view_type
 * @property {string} platform - platform
 * @return {LogObject<twoFactorAuthenticationSetupDisableClickParams>} LogObject<twoFactorAuthenticationSetupDisableClickParams>
 */
export function twoFactorAuthenticationSetupDisableClick(params) {
    return { evid: 687, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'accountSettingsSetPasswordModalLoad' event (evid: 688)
 *
 * Event description: When a user tries to access account settings after social signup (which means he didn't choose a wix password when signing up), the set password modal pops up and asks him to choose an account password.
 *
 * @param {accountSettingsSetPasswordModalLoadParams} params - The parameters for this event
 * @property {string} view_type - view_type
 * @property {string} platform - platform
 * @return {LogObject<accountSettingsSetPasswordModalLoadParams>} LogObject<accountSettingsSetPasswordModalLoadParams>
 */
export function accountSettingsSetPasswordModalLoad(params) {
    return { evid: 688, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'accountSettingsOnRequestToUnlockField' event (evid: 689)
 *
 * Event description: The user clicks in 'username' or 'email address' fields in account settings  (these fields are locked and the user must enter the account password). Once the user enters the correct password, these fields stay unlocked for the next 5 minutes and this event will not be sent again for those 5 minutes.
 *
 * @param {accountSettingsOnRequestToUnlockFieldParams} params - The parameters for this event
 * @property {string} view_type - view_type
 * @property {string} click_from - security box/main page
 * @property {string} platform - platform
 * @property {string} field_name - username/email address/2FA enable/2FA disable/2FA edit
 * @return {LogObject<accountSettingsOnRequestToUnlockFieldParams>} LogObject<accountSettingsOnRequestToUnlockFieldParams>
 */
export function accountSettingsOnRequestToUnlockField(params) {
    return { evid: 689, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'quotesFilterQuotes' event (evid: 69)
 *
 * Event description: user filters the Quotes view
 *
 * @param {quotesFilterQuotesParams} params - The parameters for this event
 * @property {string} name - name of filter
 * @property {string} view_type - view_type
 * @property {string} origin_device - web,native
 * @property {string} platform - platform
 * @property {string} filter_type - period, currency, display
 * @property {string} msid - msid
 * @property {number} num_of_quotes - number of quotes the user has
 * @return {LogObject<quotesFilterQuotesParams>} LogObject<quotesFilterQuotesParams>
 */
export function quotesFilterQuotes(params) {
    return { evid: 69, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'accountSettingsUpdatesConfirmPasswordModalLoad' event (evid: 690)
 *
 * Event description: Confirm password modal loads successfully after the user tries to make changes in account settings
 *
 * @param {accountSettingsUpdatesConfirmPasswordModalLoadParams} params - The parameters for this event
 * @property {string} view_type - view_type
 * @property {string} platform - platform
 * @property {string} action - 2FA enable/2FA disable/2FA edit/add recovery phone/remove recovery phone/edit recovery phone/username/email address
 * @return {LogObject<accountSettingsUpdatesConfirmPasswordModalLoadParams>} LogObject<accountSettingsUpdatesConfirmPasswordModalLoadParams>
 */
export function accountSettingsUpdatesConfirmPasswordModalLoad(params) {
    return { evid: 690, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'accountSettingsForgotPasswordClick' event (evid: 691)
 *
 * Event description: When a user clicks on "forgot password" in account settings
 *
 * @param {accountSettingsForgotPasswordClickParams} params - The parameters for this event
 * @property {string} view_type - view_type
 * @property {string} platform - platform
 * @return {LogObject<accountSettingsForgotPasswordClickParams>} LogObject<accountSettingsForgotPasswordClickParams>
 */
export function accountSettingsForgotPasswordClick(params) {
    return { evid: 691, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'accountSettingsManagePrivacyPreferences' event (evid: 695)
 *
 * Event description: The user clicks on 'manage preferences' in the 'privacy preferences' section
 *
 * @param {accountSettingsManagePrivacyPreferencesParams} params - The parameters for this event
 * @property {string} view_type - view_type
 * @property {string} platform - platform
 * @return {LogObject<accountSettingsManagePrivacyPreferencesParams>} LogObject<accountSettingsManagePrivacyPreferencesParams>
 */
export function accountSettingsManagePrivacyPreferences(params) {
    return { evid: 695, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'accountSettingsTwoFactorAuthenticationSetupSendCodeSuccess' event (evid: 696)
 *
 * Event description: The code was successfully sent to the user's phone after he clicked on send code
 *
 * @param {accountSettingsTwoFactorAuthenticationSetupSendCodeSuccessParams} params - The parameters for this event
 * @property {string} view_type - view_type
 * @property {string} mode - enable/edit
 * @property {string} platform - platform
 * @property {string} action - send/resend
 * @property {string} origin - The page origin
 * @return {LogObject<accountSettingsTwoFactorAuthenticationSetupSendCodeSuccessParams>} LogObject<accountSettingsTwoFactorAuthenticationSetupSendCodeSuccessParams>
 */
export function accountSettingsTwoFactorAuthenticationSetupSendCodeSuccess(params) {
    return { evid: 696, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'accountSettingsTwoFactorAuthenticationSetupSendCodeFailed' event (evid: 697)
 *
 * Event description: The code was not sent to the user's phone after he clicked on send code
 *
 * @param {accountSettingsTwoFactorAuthenticationSetupSendCodeFailedParams} params - The parameters for this event
 * @property {string} view_type - view_type
 * @property {string} mode - enable/edit
 * @property {string} platform - platform
 * @property {string} action - send/resend
 * @property {string} origin - the page origin
 * @return {LogObject<accountSettingsTwoFactorAuthenticationSetupSendCodeFailedParams>} LogObject<accountSettingsTwoFactorAuthenticationSetupSendCodeFailedParams>
 */
export function accountSettingsTwoFactorAuthenticationSetupSendCodeFailed(params) {
    return { evid: 697, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'dashboardViewSite' event (evid: 72)
 *
 * Event description: dashboard > view site.
 *
 * @param {dashboardViewSiteParams} params - The parameters for this event
 * @property {GUID} site_id - site_id
 * @property {string} view_type - view_type
 * @property {string} origin - origin
 * @property {string} platform - platform
 * @property {GUID} msid - msid
 * @return {LogObject<dashboardViewSiteParams>} LogObject<dashboardViewSiteParams>
 */
export function dashboardViewSite(params) {
    return { evid: 72, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'quotesClickOnCopyLinkFromMoreActions' event (evid: 727)
 *
 * Event description: Quotes - click on copy-link from more actions
 *
 * @param {quotesClickOnCopyLinkFromMoreActionsParams} params - The parameters for this event
 * @property {string} view_type - view_type
 * @property {GUID} invoiceId - invoiceId
 * @property {string} platform - platform
 * @property {string} msid - msid
 * @return {LogObject<quotesClickOnCopyLinkFromMoreActionsParams>} LogObject<quotesClickOnCopyLinkFromMoreActionsParams>
 */
export function quotesClickOnCopyLinkFromMoreActions(params) {
    return { evid: 727, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'quotesErrorGenerateLinkFromMoreActions' event (evid: 728)
 *
 * Event description: Quotes - error generate link from more actions
 *
 * @param {quotesErrorGenerateLinkFromMoreActionsParams} params - The parameters for this event
 * @property {string} view_type - view_type
 * @property {GUID} invoiceId - invoiceId
 * @property {string} platform - platform
 * @property {string} msid - msid
 * @return {LogObject<quotesErrorGenerateLinkFromMoreActionsParams>} LogObject<quotesErrorGenerateLinkFromMoreActionsParams>
 */
export function quotesErrorGenerateLinkFromMoreActions(params) {
    return { evid: 728, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'quotesClickOnCreateLinkFromMoreActions' event (evid: 729)
 *
 * Event description: Quotes - click on create link from more actions
 *
 * @param {quotesClickOnCreateLinkFromMoreActionsParams} params - The parameters for this event
 * @property {string} view_type - view_type
 * @property {GUID} invoiceId - invoiceId
 * @property {string} platform - platform
 * @property {string} msid - msid
 * @return {LogObject<quotesClickOnCreateLinkFromMoreActionsParams>} LogObject<quotesClickOnCreateLinkFromMoreActionsParams>
 */
export function quotesClickOnCreateLinkFromMoreActions(params) {
    return { evid: 729, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'dashboardClickOnUpgrade' event (evid: 73)
 *
 * Event description: click on upgrade button in biz mgr
 *
 * @param {dashboardClickOnUpgradeParams} params - The parameters for this event
 * @property {string} view_type - view_type
 * @property {string} origin - where it was clicked from
 * @property {string} platform - platform
 * @property {string} hosting - (Editor/MA/...)
 * @property {GUID} msid - msid
 * @return {LogObject<dashboardClickOnUpgradeParams>} LogObject<dashboardClickOnUpgradeParams>
 */
export function dashboardClickOnUpgrade(params) {
    return { evid: 73, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'quotesSettingsChangeNumbering' event (evid: 730)
 *
 * Event description: Quotes - settings - change numbering
 *
 * @param {quotesSettingsChangeNumberingParams} params - The parameters for this event
 * @property {string} view_type - view_type
 * @property {string} platform - platform
 * @property {string} msid - msid
 * @return {LogObject<quotesSettingsChangeNumberingParams>} LogObject<quotesSettingsChangeNumberingParams>
 */
export function quotesSettingsChangeNumbering(params) {
    return { evid: 730, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'quotesHeaderPreview' event (evid: 732)
 *
 * Event description: Quotes - Header Preview.
 *
 * @param {quotesHeaderPreviewParams} params - The parameters for this event
 * @property {string} view_type - view_type
 * @property {string} platform - platform
 * @property {string} msid - msid
 * @return {LogObject<quotesHeaderPreviewParams>} LogObject<quotesHeaderPreviewParams>
 */
export function quotesHeaderPreview(params) {
    return { evid: 732, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'quotesOpenFirstCard' event (evid: 733)
 *
 * Event description: Quotes - Header Preview
 *
 * @param {quotesOpenFirstCardParams} params - The parameters for this event
 * @property {string} view_type - view_type
 * @property {string} platform - platform
 * @property {string} msid - msid
 * @return {LogObject<quotesOpenFirstCardParams>} LogObject<quotesOpenFirstCardParams>
 */
export function quotesOpenFirstCard(params) {
    return { evid: 733, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'quotesDropdownOption' event (evid: 734)
 *
 * Event description: Quotes - dropdown option
 *
 * @param {quotesDropdownOptionParams} params - The parameters for this event
 * @property {string} option - which option was choosen
 * @property {string} view_type - view_type
 * @property {string} text - if custom was picked which test added, in other options put null
 * @property {string} platform - platform
 * @property {string} msid - msid
 * @return {LogObject<quotesDropdownOptionParams>} LogObject<quotesDropdownOptionParams>
 */
export function quotesDropdownOption(params) {
    return { evid: 734, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'automationsAddFollowUpActionClick' event (evid: 736)
 *
 * Event description: Automations > Add follow up action click
 *
 * @param {automationsAddFollowUpActionClickParams} params - The parameters for this event
 * @property {string} view_type - view_type
 * @property {string} platform - platform
 * @property {GUID} msid - msid
 * @property {number} index - action added index
 * @return {LogObject<automationsAddFollowUpActionClickParams>} LogObject<automationsAddFollowUpActionClickParams>
 */
export function automationsAddFollowUpActionClick(params) {
    return { evid: 736, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'automationsDeleteActionStep' event (evid: 737)
 *
 * Event description: Automations > delete action step
 *
 * @param {automationsDeleteActionStepParams} params - The parameters for this event
 * @property {string} view_type - view_type
 * @property {string} platform - platform
 * @property {GUID} msid - msid
 * @return {LogObject<automationsDeleteActionStepParams>} LogObject<automationsDeleteActionStepParams>
 */
export function automationsDeleteActionStep(params) {
    return { evid: 737, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'quotesLimit5KCsvDownload' event (evid: 738)
 *
 * Event description: Quotes - limit 5K csv download
 *
 * @param {quotesLimit5KCsvDownloadParams} params - The parameters for this event
 * @property {string} view_type - view_type
 * @property {string} platform - platform
 * @property {string} msid - msid
 * @return {LogObject<quotesLimit5KCsvDownloadParams>} LogObject<quotesLimit5KCsvDownloadParams>
 */
export function quotesLimit5KCsvDownload(params) {
    return { evid: 738, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'accountSettingsStep1ToDisablePartnerDashboard' event (evid: 739)
 *
 * Event description: In account setting, the user clicked to disable Partner Dashboard and will need to confirm again to disable it
 *
 * @param {accountSettingsStep1ToDisablePartnerDashboardParams} params - The parameters for this event
 * @property {string} view_type - view_type
 * @property {string} platform - platform
 * @return {LogObject<accountSettingsStep1ToDisablePartnerDashboardParams>} LogObject<accountSettingsStep1ToDisablePartnerDashboardParams>
 */
export function accountSettingsStep1ToDisablePartnerDashboard(params) {
    return { evid: 739, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'quotesSearchQuotes' event (evid: 74)
 *
 * Event description: user searches  in the Quotes view
 *
 * @param {quotesSearchQuotesParams} params - The parameters for this event
 * @property {string} view_type - view_type
 * @property {string} text - text searched
 * @property {number} num_of_results - number of returned results
 * @property {string} origin_device - web,native
 * @property {string} platform - platform
 * @property {string} msid - msid
 * @property {number} num_of_quotes - number of quotes the user has
 * @return {LogObject<quotesSearchQuotesParams>} LogObject<quotesSearchQuotesParams>
 */
export function quotesSearchQuotes(params) {
    return { evid: 74, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'accountSettingsErrorWhenClickToDisablePartnerDashboard' event (evid: 740)
 *
 * Event description: In account setting, the user clicked to disable Partner Dashboard and receive an error because its a teams/custom branding account
 *
 * @param {accountSettingsErrorWhenClickToDisablePartnerDashboardParams} params - The parameters for this event
 * @property {string} view_type - view_type
 * @property {string} errorReason - Teams/Custom branding
 * @property {string} platform - platform
 * @return {LogObject<accountSettingsErrorWhenClickToDisablePartnerDashboardParams>} LogObject<accountSettingsErrorWhenClickToDisablePartnerDashboardParams>
 */
export function accountSettingsErrorWhenClickToDisablePartnerDashboard(params) {
    return { evid: 740, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'accountSettingsDisabledEnabledPartnerDashboard' event (evid: 741)
 *
 * Event description: enable or disable successfully the Partners Dashboard from account settings
 *
 * @param {accountSettingsDisabledEnabledPartnerDashboardParams} params - The parameters for this event
 * @property {string} view_type - view_type
 * @property {string} platform - platform
 * @property {string} action - ENABLE/DISABLE
 * @return {LogObject<accountSettingsDisabledEnabledPartnerDashboardParams>} LogObject<accountSettingsDisabledEnabledPartnerDashboardParams>
 */
export function accountSettingsDisabledEnabledPartnerDashboard(params) {
    return { evid: 741, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'automationsDuplicateStep' event (evid: 743)
 *
 * Event description: Automations > end of steps quota upgrade ascend
 *
 * @param {automationsDuplicateStepParams} params - The parameters for this event
 * @property {string} view_type - view_type
 * @property {string} platform - platform
 * @property {GUID} msid - msid
 * @return {LogObject<automationsDuplicateStepParams>} LogObject<automationsDuplicateStepParams>
 */
export function automationsDuplicateStep(params) {
    return { evid: 743, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'automationsAskMoreLink' event (evid: 744)
 *
 * Event description: Automations > ask for more actions in automation (link in the builder) after the user add 30 actions to automation
 *
 * @param {automationsAskMoreLinkParams} params - The parameters for this event
 * @property {string} view_type - view_type
 * @property {string} platform - platform
 * @property {GUID} msid - msid
 * @return {LogObject<automationsAskMoreLinkParams>} LogObject<automationsAskMoreLinkParams>
 */
export function automationsAskMoreLink(params) {
    return { evid: 744, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'crmHomeSendMessageToInbox' event (evid: 745)
 *
 * Event description: CRM Home - send message to inbox
 *
 * @param {crmHomeSendMessageToInboxParams} params - The parameters for this event
 * @property {string} view_type - view_type
 * @property {string} platform - platform
 * @property {GUID} msid - msid
 * @return {LogObject<crmHomeSendMessageToInboxParams>} LogObject<crmHomeSendMessageToInboxParams>
 */
export function crmHomeSendMessageToInbox(params) {
    return { evid: 745, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'crmHomeAddNewContactWidget' event (evid: 746)
 *
 * Event description: CRM Home - add new contact widget
 *
 * @param {crmHomeAddNewContactWidgetParams} params - The parameters for this event
 * @property {string} view_type - view_type
 * @property {string} platform - platform
 * @property {GUID} msid - msid
 * @return {LogObject<crmHomeAddNewContactWidgetParams>} LogObject<crmHomeAddNewContactWidgetParams>
 */
export function crmHomeAddNewContactWidget(params) {
    return { evid: 746, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'crmHomeChooseContactFromWidget' event (evid: 747)
 *
 * Event description: CRM Home - choose contact from widget
 *
 * @param {crmHomeChooseContactFromWidgetParams} params - The parameters for this event
 * @property {string} view_type - view_type
 * @property {GUID} contactId - contactId
 * @property {string} platform - platform
 * @property {GUID} msid - msid
 * @return {LogObject<crmHomeChooseContactFromWidgetParams>} LogObject<crmHomeChooseContactFromWidgetParams>
 */
export function crmHomeChooseContactFromWidget(params) {
    return { evid: 747, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'crmHomeSendMessageViaContactsWidget' event (evid: 748)
 *
 * Event description: CRM Home - send message via contacts widget
 *
 * @param {crmHomeSendMessageViaContactsWidgetParams} params - The parameters for this event
 * @property {string} view_type - view_type
 * @property {GUID} contactId - contactId
 * @property {string} platform - platform
 * @property {GUID} msid - msid
 * @return {LogObject<crmHomeSendMessageViaContactsWidgetParams>} LogObject<crmHomeSendMessageViaContactsWidgetParams>
 */
export function crmHomeSendMessageViaContactsWidget(params) {
    return { evid: 748, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'quotesEditQuote' event (evid: 75)
 *
 * Event description: edit quote
 *
 * @param {quotesEditQuoteParams} params - The parameters for this event
 * @property {string} view_type - view_type
 * @property {string} origin - my quotes, preview
 * @property {string} platform - platform
 * @property {string} msid - msid
 * @property {GUID} quoteId - quote guid
 * @return {LogObject<quotesEditQuoteParams>} LogObject<quotesEditQuoteParams>
 */
export function quotesEditQuote(params) {
    return { evid: 75, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'quotesPreviewQuote' event (evid: 76)
 *
 * Event description: preview quote
 *
 * @param {quotesPreviewQuoteParams} params - The parameters for this event
 * @property {string} source - from where the quote open {feed, more-->quotes}
 * @property {string} view_type - view_type
 * @property {string} origin - my quotes, edit quotes
 * @property {string} origin_device - web,native
 * @property {string} platform - platform
 * @property {string} msid - msid
 * @property {GUID} quoteId - quote guid
 * @return {LogObject<quotesPreviewQuoteParams>} LogObject<quotesPreviewQuoteParams>
 */
export function quotesPreviewQuote(params) {
    return { evid: 76, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'quotesCreateQuoteSaveDraftClick' event (evid: 77)
 *
 * Event description: Create quote - Save draft button click
 *
 * @param {quotesCreateQuoteSaveDraftClickParams} params - The parameters for this event
 * @property {string} view_type - view_type
 * @property {string} origin - create quote, edit quote
 * @property {string} platform - platform
 * @property {string} msid - msid
 * @property {GUID} quoteId - quote guid
 * @return {LogObject<quotesCreateQuoteSaveDraftClickParams>} LogObject<quotesCreateQuoteSaveDraftClickParams>
 */
export function quotesCreateQuoteSaveDraftClick(params) {
    return { evid: 77, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'quotesCreateQuoteSaveDraftComplete' event (evid: 78)
 *
 * Event description: Create quote - Save draft completed
 *
 * @param {quotesCreateQuoteSaveDraftCompleteParams} params - The parameters for this event
 * @property {string} view_type - view_type
 * @property {string} origin - create quote, edit quote
 * @property {string} platform - platform
 * @property {string} msid - msid
 * @property {GUID} quoteId - quote guid
 * @return {LogObject<quotesCreateQuoteSaveDraftCompleteParams>} LogObject<quotesCreateQuoteSaveDraftCompleteParams>
 */
export function quotesCreateQuoteSaveDraftComplete(params) {
    return { evid: 78, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'quotesCreateQuoteSaveDraftFailed' event (evid: 79)
 *
 * Event description: Create quote - Save draft failed
 *
 * @param {quotesCreateQuoteSaveDraftFailedParams} params - The parameters for this event
 * @property {string} view_type - view_type
 * @property {string} reason - failure reason
 * @property {string} origin - create quote, edit quote
 * @property {string} platform - platform
 * @property {string} msid - msid
 * @property {GUID} quoteId - quote guid
 * @return {LogObject<quotesCreateQuoteSaveDraftFailedParams>} LogObject<quotesCreateQuoteSaveDraftFailedParams>
 */
export function quotesCreateQuoteSaveDraftFailed(params) {
    return { evid: 79, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'uouUnsubscribePageView' event (evid: 798)
 *
 * Event description: the page view UOU sees when they click unsubscribe from sms notification
 *
 * @param {uouUnsubscribePageViewParams} params - The parameters for this event
 * @property {GUID} visitor_id - visitor_id of uou
 * @property {string} view_type - view_type
 * @property {GUID} notification_Id - notification id of unsubscribe sms
 * @property {string} platform - platform
 * @property {GUID} msid - msid
 * @property {string} device - mobile
 * @return {LogObject<uouUnsubscribePageViewParams>} LogObject<uouUnsubscribePageViewParams>
 */
export function uouUnsubscribePageView(params) {
    return { evid: 798, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'uouUnsubscribeClick' event (evid: 799)
 *
 * Event description: when UOU click unsubscribe/cancel from unsubscribe page view
 *
 * @param {uouUnsubscribeClickParams} params - The parameters for this event
 * @property {string} click_type - click/cancel
 * @property {GUID} visitor_id - visitor_id of uou
 * @property {string} view_type - view_type
 * @property {GUID} notification_Id - notification id of unsubscribe sms
 * @property {string} platform - platform
 * @property {GUID} msid - msid
 * @property {string} device - mobile
 * @return {LogObject<uouUnsubscribeClickParams>} LogObject<uouUnsubscribeClickParams>
 */
export function uouUnsubscribeClick(params) {
    return { evid: 799, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'dashboardCreateNewSite' event (evid: 80)
 *
 * Event description: user adds a new site from different origins (site_list_top, site_list_bottom, top_bar, account_templates), where account_templates = account -> temlpates
 *
 * @param {dashboardCreateNewSiteParams} params - The parameters for this event
 * @property {string} source - source
 * @property {string} view_type - view_type
 * @property {string} sub_view - sub_view
 * @property {string} creation_type - in case the click is on item in the creation menu of wix studio report: create from blank/use wix templates/ use your custom templates/build on wix classic editor. Otherwise null.
 * @property {string} origin - sites-list-enterprise
 * @property {string} view_level - view_level
 * @property {string} platform - deprecated
 * @return {LogObject<dashboardCreateNewSiteParams>} LogObject<dashboardCreateNewSiteParams>
 */
export function dashboardCreateNewSite(params) {
    return { evid: 80, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'dashboardSiteSelectorPopupShown' event (evid: 81)
 *
 * Event description: when a user selected an ADI site when his previous action is not suitable for ADI (add app etc... )
 *
 * @param {dashboardSiteSelectorPopupShownParams} params - The parameters for this event
 * @property {string} name - popup name
 * @property {string} view_type - view_type
 * @property {string} siteTypeName - ADI/Editor
 * @property {string} platform - platform
 * @property {GUID} msid - site guid
 * @return {LogObject<dashboardSiteSelectorPopupShownParams>} LogObject<dashboardSiteSelectorPopupShownParams>
 */
export function dashboardSiteSelectorPopupShown(params) {
    return { evid: 81, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'crmHomeViewContactViaContactsWidget' event (evid: 819)
 *
 * Event description: CRM Home - view contact via contacts widget
 *
 * @param {crmHomeViewContactViaContactsWidgetParams} params - The parameters for this event
 * @property {string} view_type - view_type
 * @property {GUID} contactId - contactId
 * @property {string} platform - platform
 * @property {GUID} msid - msid
 * @return {LogObject<crmHomeViewContactViaContactsWidgetParams>} LogObject<crmHomeViewContactViaContactsWidgetParams>
 */
export function crmHomeViewContactViaContactsWidget(params) {
    return { evid: 819, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'dashboardSiteSelectorPopupClose' event (evid: 82)
 *
 * Event description: when a user closed ADI popup
 *
 * @param {dashboardSiteSelectorPopupCloseParams} params - The parameters for this event
 * @property {string} name - popup name
 * @property {string} view_type - view_type
 * @property {string} siteTypeName - ADI/Editor
 * @property {string} platform - platform
 * @property {GUID} msid - site guid
 * @return {LogObject<dashboardSiteSelectorPopupCloseParams>} LogObject<dashboardSiteSelectorPopupCloseParams>
 */
export function dashboardSiteSelectorPopupClose(params) {
    return { evid: 82, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'crmHomeSeeAllContactsViaContactsWidget' event (evid: 820)
 *
 * Event description: CRM Home - see all contacts via contacts widget
 *
 * @param {crmHomeSeeAllContactsViaContactsWidgetParams} params - The parameters for this event
 * @property {string} view_type - view_type
 * @property {string} platform - platform
 * @property {GUID} msid - msid
 * @return {LogObject<crmHomeSeeAllContactsViaContactsWidgetParams>} LogObject<crmHomeSeeAllContactsViaContactsWidgetParams>
 */
export function crmHomeSeeAllContactsViaContactsWidget(params) {
    return { evid: 820, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'crmHomeImportContactsViaContactsBanner' event (evid: 821)
 *
 * Event description: CRM Home - import contacts via contacts banner
 *
 * @param {crmHomeImportContactsViaContactsBannerParams} params - The parameters for this event
 * @property {string} view_type - view_type
 * @property {string} platform - platform
 * @property {GUID} msid - msid
 * @return {LogObject<crmHomeImportContactsViaContactsBannerParams>} LogObject<crmHomeImportContactsViaContactsBannerParams>
 */
export function crmHomeImportContactsViaContactsBanner(params) {
    return { evid: 821, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'crmHomeTasksWidgetAddNewTask' event (evid: 822)
 *
 * Event description: CRM Home - Tasks widget - add new task
 *
 * @param {crmHomeTasksWidgetAddNewTaskParams} params - The parameters for this event
 * @property {string} view_type - view_type
 * @property {string} platform - platform
 * @property {GUID} msid - msid
 * @return {LogObject<crmHomeTasksWidgetAddNewTaskParams>} LogObject<crmHomeTasksWidgetAddNewTaskParams>
 */
export function crmHomeTasksWidgetAddNewTask(params) {
    return { evid: 822, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'crmHomeTasksWidgetSeeAllTasks' event (evid: 823)
 *
 * Event description: CRM Home - Tasks widget - see all tasks
 *
 * @param {crmHomeTasksWidgetSeeAllTasksParams} params - The parameters for this event
 * @property {string} view_type - view_type
 * @property {string} platform - platform
 * @property {GUID} msid - msid
 * @return {LogObject<crmHomeTasksWidgetSeeAllTasksParams>} LogObject<crmHomeTasksWidgetSeeAllTasksParams>
 */
export function crmHomeTasksWidgetSeeAllTasks(params) {
    return { evid: 823, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'dashboardSiteSelectorPopupSelectAction' event (evid: 83)
 *
 * Event description: users selection in the popup- go to editor/ stay in ADI
 *
 * @param {dashboardSiteSelectorPopupSelectActionParams} params - The parameters for this event
 * @property {string} name - popup name
 * @property {string} view_type - view_type
 * @property {string} siteTypeName - ADI/Editor
 * @property {string} platform - platform
 * @property {GUID} msid - site guid
 * @property {string} action - go to editor/ stay in ADI
 * @return {LogObject<dashboardSiteSelectorPopupSelectActionParams>} LogObject<dashboardSiteSelectorPopupSelectActionParams>
 */
export function dashboardSiteSelectorPopupSelectAction(params) {
    return { evid: 83, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'quotesEmailQuotesPage' event (evid: 84)
 *
 * Event description: email invoice pop up
 *
 * @param {quotesEmailQuotesPageParams} params - The parameters for this event
 * @property {string} view_type - view_type
 * @property {string} origin - origin page
 * @property {string} origin_device - web,native
 * @property {boolean} resend - resend mode?
 * @property {string} platform - platform
 * @property {string} msid - msid
 * @property {GUID} quoteId - quote guid
 * @return {LogObject<quotesEmailQuotesPageParams>} LogObject<quotesEmailQuotesPageParams>
 */
export function quotesEmailQuotesPage(params) {
    return { evid: 84, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'crmHomeWorkflowsWidgetGoToWorkflows' event (evid: 844)
 *
 * Event description: CRM Home - workflows widget - go to workflows
 *
 * @param {crmHomeWorkflowsWidgetGoToWorkflowsParams} params - The parameters for this event
 * @property {string} view_type - view_type
 * @property {string} platform - platform
 * @property {GUID} msid - msid
 * @return {LogObject<crmHomeWorkflowsWidgetGoToWorkflowsParams>} LogObject<crmHomeWorkflowsWidgetGoToWorkflowsParams>
 */
export function crmHomeWorkflowsWidgetGoToWorkflows(params) {
    return { evid: 844, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'toastShown85' event (evid: 85)
 *
 * Event description: a toast is shown in one of Giza's hosting platform. currently, in case of business manager - the reporting is from business manager itself and not from Giza. in the meantime to get business manager toasts filter hosting is not null
 *
 * @param {toastShown85Params} params - The parameters for this event
 * @property {string} name - toast name, supplied by toast initiator
 * @property {string} hosting_platform - hosting_platform
 * @property {string} active_page_id - active_page_id
 * @property {string} scope - toast scope {app/ dashboard/my-sites}
 * @property {string} trigger_entity_type - trigger_entity_type
 * @property {string} view_type - view_type
 * @property {string} severity - high, normal, low
 * @property {string} type - standard, error, warning, success, premium
 * @property {string} platform - platform
 * @property {string} hosting_platform_context_id - hosting_platform_context_id
 * @property {string} hosting - MA/editor/dashboard
 * @property {number} timeout - miliseconds to auto hide toast, 0 is sticky toast
 * @property {GUID} msid - metasite id
 * @property {string} trigger_entity_id - trigger_entity_id
 * @property {string} toast_timeout - toast_timeout
 * @property {string} message - message
 * @property {string} app_id - app_id
 * @return {LogObject<toastShown85Params>} LogObject<toastShown85Params>
 */
export function toastShown85(params) {
    return { evid: 85, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'crmHomeWorkflowsWidgetUseTemplate' event (evid: 852)
 *
 * Event description: CRM Home - workflows widget - use template
 *
 * @param {crmHomeWorkflowsWidgetUseTemplateParams} params - The parameters for this event
 * @property {string} view_type - view_type
 * @property {string} template - which template the user chosen
 * @property {string} platform - platform
 * @property {GUID} msid - msid
 * @return {LogObject<crmHomeWorkflowsWidgetUseTemplateParams>} LogObject<crmHomeWorkflowsWidgetUseTemplateParams>
 */
export function crmHomeWorkflowsWidgetUseTemplate(params) {
    return { evid: 852, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'crmHomeWorkflowsWidgetStartFromScratch' event (evid: 853)
 *
 * Event description: CRM Home - workflows widget - start from scratch
 *
 * @param {crmHomeWorkflowsWidgetStartFromScratchParams} params - The parameters for this event
 * @property {string} view_type - view_type
 * @property {string} platform - platform
 * @property {GUID} msid - msid
 * @return {LogObject<crmHomeWorkflowsWidgetStartFromScratchParams>} LogObject<crmHomeWorkflowsWidgetStartFromScratchParams>
 */
export function crmHomeWorkflowsWidgetStartFromScratch(params) {
    return { evid: 853, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'crmHomeIntegrationsCommunicationsViewAll' event (evid: 854)
 *
 * Event description: CRM Home - integrations - communications view all
 *
 * @param {crmHomeIntegrationsCommunicationsViewAllParams} params - The parameters for this event
 * @property {string} view_type - view_type
 * @property {string} platform - platform
 * @property {GUID} msid - msid
 * @return {LogObject<crmHomeIntegrationsCommunicationsViewAllParams>} LogObject<crmHomeIntegrationsCommunicationsViewAllParams>
 */
export function crmHomeIntegrationsCommunicationsViewAll(params) {
    return { evid: 854, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'crmHomeIntegrationsCommunicationsConnect' event (evid: 855)
 *
 * Event description: CRM Home - integrations - communications connect
 *
 * @param {crmHomeIntegrationsCommunicationsConnectParams} params - The parameters for this event
 * @property {string} view_type - view_type
 * @property {string} connectTab - which connection the user choose
 * @property {string} platform - platform
 * @property {GUID} msid - msid
 * @return {LogObject<crmHomeIntegrationsCommunicationsConnectParams>} LogObject<crmHomeIntegrationsCommunicationsConnectParams>
 */
export function crmHomeIntegrationsCommunicationsConnect(params) {
    return { evid: 855, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'toastClicked86' event (evid: 86)
 *
 * Event description: user clicks on toast CTA or dismisses toast in one of Giza's hosting platform. currently, in case of business manager - the reporting is from business manager itself and not from Giza. in the meantime to get business manager toasts filter hosting is not null
 *
 * @param {toastClicked86Params} params - The parameters for this event
 * @property {string} name - toast name, supplied by toast initiator
 * @property {string} hosting_platform - hosting_platform
 * @property {string} active_page_id - active_page_id
 * @property {string} scope - toast scope {app/ dashboard}
 * @property {string} trigger_entity_type - trigger_entity_type
 * @property {string} click_type - CTA/dismiss
 * @property {string} view_type - view_type
 * @property {string} severity - high, normal, low
 * @property {string} type - info, error, warning, success, premium
 * @property {string} platform - platform
 * @property {string} hosting_platform_context_id - hosting_platform_context_id
 * @property {string} hosting - MA/editor/dashboard
 * @property {number} timeout - seconds to auto hide toast, 0 is sticky toast
 * @property {GUID} msid - metasite id
 * @property {string} trigger_entity_id - trigger_entity_id
 * @property {string} toast_timeout - toast_timeout
 * @return {LogObject<toastClicked86Params>} LogObject<toastClicked86Params>
 */
export function toastClicked86(params) {
    return { evid: 86, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'crmHomeIntegrationsMarketingViewAll' event (evid: 860)
 *
 * Event description: CRM Home - integrations - marketing view all
 *
 * @param {crmHomeIntegrationsMarketingViewAllParams} params - The parameters for this event
 * @property {string} view_type - view_type
 * @property {string} platform - platform
 * @property {GUID} msid - msid
 * @return {LogObject<crmHomeIntegrationsMarketingViewAllParams>} LogObject<crmHomeIntegrationsMarketingViewAllParams>
 */
export function crmHomeIntegrationsMarketingViewAll(params) {
    return { evid: 860, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'quotesEmailQuotePageCancelClick' event (evid: 87)
 *
 * Event description: email quote - clicked on cancel
 *
 * @param {quotesEmailQuotePageCancelClickParams} params - The parameters for this event
 * @property {string} view_type - view_type
 * @property {string} origin - origin page
 * @property {string} origin_device - web,native
 * @property {boolean} resend - resend mode?
 * @property {string} platform - platform
 * @property {string} msid - msid
 * @property {GUID} quoteId - quote guid
 * @return {LogObject<quotesEmailQuotePageCancelClickParams>} LogObject<quotesEmailQuotePageCancelClickParams>
 */
export function quotesEmailQuotePageCancelClick(params) {
    return { evid: 87, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'quotesPrintQuote' event (evid: 88)
 *
 * Event description: print quote
 *
 * @param {quotesPrintQuoteParams} params - The parameters for this event
 * @property {string} view_type - view_type
 * @property {string} origin - my invoices, preview
 * @property {string} platform - platform
 * @property {string} msid - msid
 * @property {GUID} quoteId - quote guid
 * @return {LogObject<quotesPrintQuoteParams>} LogObject<quotesPrintQuoteParams>
 */
export function quotesPrintQuote(params) {
    return { evid: 88, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'quotesDownloadPdfQuote' event (evid: 89)
 *
 * Event description: click on save as PDF on quote
 *
 * @param {quotesDownloadPdfQuoteParams} params - The parameters for this event
 * @property {string} view_type - view_type
 * @property {string} origin - customer for UoU, my quote for users
 * @property {string} platform - platform
 * @property {string} msid - msid
 * @property {GUID} quoteId - quote guid
 * @return {LogObject<quotesDownloadPdfQuoteParams>} LogObject<quotesDownloadPdfQuoteParams>
 */
export function quotesDownloadPdfQuote(params) {
    return { evid: 89, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'finishLoading8900' event (evid: 8900)
 *
 * Event description: when Giza finish loading
 *
 * @param {finishLoading8900Params} params - The parameters for this event
 * @property {string} hosting_platform - accountmanagr/bizmanagr/devcenter/etc.
 * @property {string} view_type - view_type
 * @property {number} screen_width - the screen width
 * @property {number} window_width - the window width
 * @property {number} screen_height - the screen hight
 * @property {number} window_height - the window height
 * @property {string} platform - platform
 * @property {string} hosting_platform_context_id - context id: when the context is site - msid, when the context is app_id (like in devCenter f.e) - appDefId. In account manager is null
 * @property {number} loading_time - loading time of the platform in ms (time from Giza start loading event)
 * @return {LogObject<finishLoading8900Params>} LogObject<finishLoading8900Params>
 */
export function finishLoading8900(params) {
    return { evid: 8900, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'automationsShowSuggestionsBannerToggle' event (evid: 8902)
 *
 * Event description: show  or hide suggestions (carousal banner) toggle
 *
 * @param {automationsShowSuggestionsBannerToggleParams} params - The parameters for this event
 * @property {boolean} show - show or hide suggestions
 * @property {string} view_type - view_type
 * @property {string} platform - platform
 * @property {GUID} msid - msid
 * @return {LogObject<automationsShowSuggestionsBannerToggleParams>} LogObject<automationsShowSuggestionsBannerToggleParams>
 */
export function automationsShowSuggestionsBannerToggle(params) {
    return { evid: 8902, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'automationsClickOnLearnMoreFromErrorIcon' event (evid: 8903)
 *
 * Event description: Automations > click on ‘learn more’ from error icon
 *
 * @param {automationsClickOnLearnMoreFromErrorIconParams} params - The parameters for this event
 * @property {string} view_type - view_type
 * @property {GUID} rule_id - rule_id
 * @property {string} errorType - for example: ‘connectZapier’
 * @property {string} origin - origin
 * @property {string} platform - platform
 * @property {GUID} msid - msid
 * @return {LogObject<automationsClickOnLearnMoreFromErrorIconParams>} LogObject<automationsClickOnLearnMoreFromErrorIconParams>
 */
export function automationsClickOnLearnMoreFromErrorIcon(params) {
    return { evid: 8903, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'automationsHoverOnTheErrorIcon' event (evid: 8904)
 *
 * Event description: Automations > hover on the error icon
 *
 * @param {automationsHoverOnTheErrorIconParams} params - The parameters for this event
 * @property {string} view_type - view_type
 * @property {GUID} rule_id - rule_id
 * @property {string} errorType - for example: ‘connectZapier’
 * @property {string} origin - origin
 * @property {string} platform - platform
 * @property {GUID} msid - msid
 * @return {LogObject<automationsHoverOnTheErrorIconParams>} LogObject<automationsHoverOnTheErrorIconParams>
 */
export function automationsHoverOnTheErrorIcon(params) {
    return { evid: 8904, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'automationsUserChangeRuleName' event (evid: 8905)
 *
 * Event description: Automations > user change rule (automation) name
 *
 * @param {automationsUserChangeRuleNameParams} params - The parameters for this event
 * @property {string} previousName - previous rule name
 * @property {string} newName - new rule name
 * @property {string} view_type - view_type
 * @property {string} recipeName - recipeName
 * @property {string} origin - automation table, wizard etc.
 * @property {string} platform - platform
 * @property {GUID} msid - msid
 * @property {GUID} ruleId - rule id
 * @return {LogObject<automationsUserChangeRuleNameParams>} LogObject<automationsUserChangeRuleNameParams>
 */
export function automationsUserChangeRuleName(params) {
    return { evid: 8905, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'exposureEventForPaginationTest' event (evid: 8906)
 *
 * Event description: will be sent when users enter to my sites page, providing data about folders number
 *
 * @param {exposureEventForPaginationTestParams} params - The parameters for this event
 * @property {number} folders_number - the number of folders in the root (1st level)
 * @property {boolean} is_pagination_user - True if the user has more than 50 folders in the root, false if less
 * @property {string} view_type - view_type
 * @property {string} platform - deprecated
 * @return {LogObject<exposureEventForPaginationTestParams>} LogObject<exposureEventForPaginationTestParams>
 */
export function exposureEventForPaginationTest(params) {
    return { evid: 8906, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'automationsGenerateaAutomationLink' event (evid: 8916)
 *
 * Event description: Automations > Expert mode > generate_link / copy_link
 *
 * @param {automationsGenerateaAutomationLinkParams} params - The parameters for this event
 * @property {string} view_type - view_type
 * @property {GUID} rule_id - rule_id
 * @property {string} buttonName - ‘generate_link’ / ‘copy_link ‘
 * @property {string} rule_name - rule_name
 * @property {string} platform - platform
 * @property {GUID} msid - msid
 * @return {LogObject<automationsGenerateaAutomationLinkParams>} LogObject<automationsGenerateaAutomationLinkParams>
 */
export function automationsGenerateaAutomationLink(params) {
    return { evid: 8916, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'invoiceSettingsSelectTaxDetailsCustomFieldCheckbox' event (evid: 8917)
 *
 * Event description: How user select to show taxes in Invoice
 *
 * @param {invoiceSettingsSelectTaxDetailsCustomFieldCheckboxParams} params - The parameters for this event
 * @property {boolean} showTaxAmount - whether net taxes is shown in invoice (tax breakdown)
 * @property {boolean} showItemsSubtotalPerTax - is payments received section is shown in invoice
 * @property {string} view_type - view_type
 * @property {boolean} showTaxColumn - is tax is shown per line item
 * @property {boolean} checkbox - checked or un-checked
 * @property {string} value2 - ‘other setting same modal value (enambled/disabled)
 * @property {string} platform - Web/ Mobile
 * @property {GUID} msid - msid
 * @property {string} value - ‘tax per line item’/ ‘net tax amount’
 * @return {LogObject<invoiceSettingsSelectTaxDetailsCustomFieldCheckboxParams>} LogObject<invoiceSettingsSelectTaxDetailsCustomFieldCheckboxParams>
 */
export function invoiceSettingsSelectTaxDetailsCustomFieldCheckbox(params) {
    return { evid: 8917, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'invoiceSettingsClickOnLink' event (evid: 8918)
 *
 * Event description: When a user click on some strings/values which takes to another page
 *
 * @param {invoiceSettingsClickOnLinkParams} params - The parameters for this event
 * @property {string} view_type - view_type
 * @property {string} modal_name - modal name ( example: ‘Tax setting’s)
 * @property {string} origin - tab name (example: ‘Invoice’)
 * @property {string} platform - platform
 * @property {string} msid - msid
 * @property {string} value - value clicked ( example: ’General’)
 * @return {LogObject<invoiceSettingsClickOnLinkParams>} LogObject<invoiceSettingsClickOnLinkParams>
 */
export function invoiceSettingsClickOnLink(params) {
    return { evid: 8918, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'clickOnSuggestionTags' event (evid: 8919)
 *
 * Event description: when the user switch between tags
 *
 * @param {clickOnSuggestionTagsParams} params - The parameters for this event
 * @property {string} tagName - selected tag
 * @property {string} clickType - click_type
 * @property {string} view_type - view_type
 * @property {string} tagList - tag_list
 * @property {string} origin - page/section (section for widget over home, page for all)
 * @property {string} currentTag - current_tag
 * @property {string} platform - deprecated
 * @property {GUID} msid - msid
 * @return {LogObject<clickOnSuggestionTagsParams>} LogObject<clickOnSuggestionTagsParams>
 */
export function clickOnSuggestionTags(params) {
    return { evid: 8919, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'bookingAnywhereNoPermission' event (evid: 8920)
 *
 * Event description: when the user dont have the permissio and he hover
 *
 * @param {bookingAnywhereNoPermissionParams} params - The parameters for this event
 * @property {string} view_type - view_type
 * @property {string} buttonName - share services or manage calendar
 * @property {string} platform - depercated
 * @property {GUID} msid - --
 * @return {LogObject<bookingAnywhereNoPermissionParams>} LogObject<bookingAnywhereNoPermissionParams>
 */
export function bookingAnywhereNoPermission(params) {
    return { evid: 8920, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'addNoteTermClick' event (evid: 8923)
 *
 * Event description: Clicking on ‘Add’ note or term in PayME request
 *
 * @param {addNoteTermClickParams} params - The parameters for this event
 * @property {string} source - productSource
 * @property {string} view_type - view_type
 * @property {GUID} appDefId - appDefId
 * @property {string} invoiceType - ’recurringAutoCharge’/ 'recurring'/ 'one time'
 * @property {string} origin - create invoice, edit invoice
 * @property {string} platform - platform
 * @property {string} msid - msid
 * @property {GUID} invoice_id - invoice guid
 * @return {LogObject<addNoteTermClickParams>} LogObject<addNoteTermClickParams>
 */
export function addNoteTermClick(params) {
    return { evid: 8923, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'wixInvoicesClickingOnGroupsDropDownInSettings' event (evid: 8929)
 *
 * Event description: Clicking on Particular drop down ( Header details, Business Info, Tax settings, Footer Notes)
 *
 * @param {wixInvoicesClickingOnGroupsDropDownInSettingsParams} params - The parameters for this event
 * @property {string} view_type - view_type
 * @property {string} platform - mobile/web
 * @property {string} card - Header details, Business Info, Tax settings, Footer Notes)
 * @property {GUID} msid - msid
 * @property {string} value - open/close
 * @return {LogObject<wixInvoicesClickingOnGroupsDropDownInSettingsParams>} LogObject<wixInvoicesClickingOnGroupsDropDownInSettingsParams>
 */
export function wixInvoicesClickingOnGroupsDropDownInSettings(params) {
    return { evid: 8929, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'invoicesSettingsSaveButton' event (evid: 8930)
 *
 * Event description: When Invoices settings is Saved by clicking on button
 *
 * @param {invoicesSettingsSaveButtonParams} params - The parameters for this event
 * @property {string} invoiceNumber - invoiceNumber
 * @property {boolean} showTaxAmount - whether net taxes is shown in invoice
 * @property {boolean} hasLogo - weather logo is uploaded
 * @property {string} documentName - documentName
 * @property {boolean} showItemsSubtotalPerTax - is items subtotal per tax group is shown in invoice
 * @property {string} customFields - what custom fields is added (header fields, business custom fields, footer notes)
 * @property {string} invoiceEmail - what is written in email that is sending to cutomer
 * @property {string} view_type - view_type
 * @property {boolean} showTaxColumn - is tax is shown per line item
 * @property {string} card_name - Header details, Business Info, Tax settings, Footer Notes)
 * @property {string} origin - From which place it was saved: ‘Discard Modal’ , ‘Save button’
 * @property {boolean} showTransactionDetails - is payments received section is shown in invoice
 * @property {string} platform - mobile/web
 * @property {GUID} msid - msid
 * @return {LogObject<invoicesSettingsSaveButtonParams>} LogObject<invoicesSettingsSaveButtonParams>
 */
export function invoicesSettingsSaveButton(params) {
    return { evid: 8930, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'websiteCardPageUsability' event (evid: 8931)
 *
 * Event description: when a user see the main card in the website page
 *
 * @param {websiteCardPageUsabilityParams} params - The parameters for this event
 * @property {boolean} onlyDomain - false
 * @property {boolean} editPremision - true
 * @property {boolean} isConnectedDomainModal - true
 * @property {boolean} settingPremision - true
 * @property {boolean} isPublished - true
 * @property {string} view_type - view_type
 * @property {boolean} liveSitePremision - true
 * @property {boolean} domainPremision - true
 * @property {boolean} isPremium - true
 * @property {string} platform - platform
 * @property {GUID} msid - msid
 * @property {DateTime} lastPublishDate - date stamp
 * @return {LogObject<websiteCardPageUsabilityParams>} LogObject<websiteCardPageUsabilityParams>
 */
export function websiteCardPageUsability(params) {
    return { evid: 8931, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'websiteCardPageFailedCommit' event (evid: 8932)
 *
 * Event description: when a user failed to complete load the card
 *
 * @param {websiteCardPageFailedCommitParams} params - The parameters for this event
 * @property {string} view_type - view_type
 * @property {string} failReason - server,network,validation
 * @property {string} platform - platform
 * @property {GUID} msid - site
 * @return {LogObject<websiteCardPageFailedCommitParams>} LogObject<websiteCardPageFailedCommitParams>
 */
export function websiteCardPageFailedCommit(params) {
    return { evid: 8932, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'wixInvoicesLeavingSettingsWithoutSavingPopUp' event (evid: 8934)
 *
 * Event description: Wix Invoices: Leaving Settings without saving pop up. Discard Changes Modal
 *
 * @param {wixInvoicesLeavingSettingsWithoutSavingPopUpParams} params - The parameters for this event
 * @property {string} view_type - view_type
 * @property {string} modal_name - weather its ‘Discard modal’, clicking on discard or clicking anywhere else, getting ‘Save changes’ modal
 * @property {string} fieldName - where user clicked to go
 * @property {string} platform - platform
 * @property {string} msid - msid
 * @return {LogObject<wixInvoicesLeavingSettingsWithoutSavingPopUpParams>} LogObject<wixInvoicesLeavingSettingsWithoutSavingPopUpParams>
 */
export function wixInvoicesLeavingSettingsWithoutSavingPopUp(params) {
    return { evid: 8934, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'discardModalClick' event (evid: 8935)
 *
 * Event description: In Invoices settings Discard modal chosen action
 *
 * @param {discardModalClickParams} params - The parameters for this event
 * @property {string} view_type - view_type
 * @property {string} modal_name - weather its ‘Discard modal’, clicking on discard or clicking anywhere else, getting ‘Save changes’ modal
 * @property {string} platform - mobile/web
 * @property {GUID} msid - msid
 * @property {string} value - ‘Discard’, ‘x’, ‘Close’
 * @return {LogObject<discardModalClickParams>} LogObject<discardModalClickParams>
 */
export function discardModalClick(params) {
    return { evid: 8935, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'wixInvoicesClickOnTabsToChoseProductFrom' event (evid: 8936)
 *
 * Event description: Wix Invoices - click on tabs to chose product from
 *
 * @param {wixInvoicesClickOnTabsToChoseProductFromParams} params - The parameters for this event
 * @property {string} button_name - Invoice, Store, Bookings
 * @property {string} view_type - view_type
 * @property {string} productSource - app_deff_id
 * @property {string} platform - platform
 * @property {string} msid - msid
 * @return {LogObject<wixInvoicesClickOnTabsToChoseProductFromParams>} LogObject<wixInvoicesClickOnTabsToChoseProductFromParams>
 */
export function wixInvoicesClickOnTabsToChoseProductFrom(params) {
    return { evid: 8936, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'invoiceSettingsSaveButtonClick' event (evid: 8937)
 *
 * Event description: In Invoices settings Save button click
 *
 * @param {invoiceSettingsSaveButtonClickParams} params - The parameters for this event
 * @property {string} view_type - view_type
 * @property {string} origin - From which place it was saved: ‘Discard Modal’ , ‘Save button’
 * @property {string} platform - mobile/web
 * @property {GUID} msid - msid
 * @return {LogObject<invoiceSettingsSaveButtonClickParams>} LogObject<invoiceSettingsSaveButtonClickParams>
 */
export function invoiceSettingsSaveButtonClick(params) {
    return { evid: 8937, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'wixInvoicesSavingItemDescription' event (evid: 8938)
 *
 * Event description: Wix Invoices: Saving Item Description
 *
 * @param {wixInvoicesSavingItemDescriptionParams} params - The parameters for this event
 * @property {string} view_type - view_type
 * @property {string} productSource - product source
 * @property {string} origin - create product, edit product
 * @property {string} platform - platform
 * @property {string} msid - msid
 * @return {LogObject<wixInvoicesSavingItemDescriptionParams>} LogObject<wixInvoicesSavingItemDescriptionParams>
 */
export function wixInvoicesSavingItemDescription(params) {
    return { evid: 8938, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'clickStartGuideOrCloseDoItWithMeTool' event (evid: 8949)
 *
 * Event description: Start to use ‘Do it with me’ Tool
 *
 * @param {clickStartGuideOrCloseDoItWithMeToolParams} params - The parameters for this event
 * @property {string} view_type - view_type
 * @property {string} origin - origin page - from which place this action was made (Invoice Dashboard/ Invoice Form/Watch Tutorial)
 * @property {string} type - Start Guide/cancel
 * @property {string} platform - platform
 * @property {string} msid - msid
 * @return {LogObject<clickStartGuideOrCloseDoItWithMeToolParams>} LogObject<clickStartGuideOrCloseDoItWithMeToolParams>
 */
export function clickStartGuideOrCloseDoItWithMeTool(params) {
    return { evid: 8949, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'automationsActionUserClickOnItemActionOption' event (evid: 8950)
 *
 * Event description: User click on button/link/dropdown option in the follow up item (component) in the action options.
 * In automation wizard
 *
 * @param {automationsActionUserClickOnItemActionOptionParams} params - The parameters for this event
 * @property {string} actionKey - action English key
 * @property {string} inputName - display name / button name
 * @property {string} flowType - ‘create’/ ‘edit'
 * @property {GUID} actionId - action_id
 * @property {string} view_type - view_type
 * @property {number} actionIndex - first action =0
 * @property {string} buttonName - button_name
 * @property {GUID} actionAppId - action provider app id
 * @property {string} platform - platform
 * @property {GUID} msid - msid
 * @property {string} inputType - input_type
 * @property {GUID} ruleId - rule_id
 * @property {number} inputLevel - how many dropdowns parents
 * @return {LogObject<automationsActionUserClickOnItemActionOptionParams>} LogObject<automationsActionUserClickOnItemActionOptionParams>
 */
export function automationsActionUserClickOnItemActionOption(params) {
    return { evid: 8950, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'automationsActionUserEnterInputOnActionItem' event (evid: 8951)
 *
 * Event description: User enter input to a follow up item (component) in the action options.
 * In automation wizard
 *
 * @param {automationsActionUserEnterInputOnActionItemParams} params - The parameters for this event
 * @property {string} actionKey - action English key
 * @property {string} inputName - input display name
 * @property {string} flowType - create or edit
 * @property {GUID} actionId - action_id
 * @property {string} view_type - view_type
 * @property {number} actionIndex - first action =0
 * @property {GUID} actionAppId - action provider app id
 * @property {string} platform - platform
 * @property {GUID} msid - msid
 * @property {string} inputType - input_type
 * @property {string} value - input value
 * @property {GUID} ruleId - rule_id
 * @property {number} inputLevel - how many dropdowns parents
 * @return {LogObject<automationsActionUserEnterInputOnActionItemParams>} LogObject<automationsActionUserEnterInputOnActionItemParams>
 */
export function automationsActionUserEnterInputOnActionItem(params) {
    return { evid: 8951, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'automationsWidgetDisplayLoading' event (evid: 8952)
 *
 * Event description: Automations - Automation widget display
 *
 * @param {automationsWidgetDisplayLoadingParams} params - The parameters for this event
 * @property {boolean} isCardOpen - if the collapse of the widget is opened by default or not
 * @property {string} view_type - view_type
 * @property {string} ruleIdsArray - rule_ids_array
 * @property {string} origin - origin which this action was made
 * @property {string} type - widget type -row, dashboard , v2 etc
 * @property {GUID} appId - app_id
 * @property {string} platform - platform
 * @property {GUID} msid - msid
 * @return {LogObject<automationsWidgetDisplayLoadingParams>} LogObject<automationsWidgetDisplayLoadingParams>
 */
export function automationsWidgetDisplayLoading(params) {
    return { evid: 8952, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'wixInvoicesChargeWithCreditCardClick' event (evid: 8954)
 *
 * Event description: Charge with credit card on invoice click (MOTO)
 *
 * @param {wixInvoicesChargeWithCreditCardClickParams} params - The parameters for this event
 * @property {string} view_type - view_type
 * @property {string} origin - my invoices,preview,create invoice
 * @property {string} status - Creation form/Draft/Sent/Paid
 * @property {string} origin_device - web,native
 * @property {GUID} invoiceSource - invoice_source_id
 * @property {string} type - MOTO/ POS
 * @property {string} platform - platform
 * @property {string} msid - msid
 * @property {GUID} invoice_id - invoice guid
 * @property {boolean} fully_paid - true for fully paid selected, false for partial payment selected
 * @return {LogObject<wixInvoicesChargeWithCreditCardClickParams>} LogObject<wixInvoicesChargeWithCreditCardClickParams>
 */
export function wixInvoicesChargeWithCreditCardClick(params) {
    return { evid: 8954, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'wixInvoicesPaymentMethodClick' event (evid: 8956)
 *
 * Event description: Wix Invoices Payment method click in modal
 *
 * @param {wixInvoicesPaymentMethodClickParams} params - The parameters for this event
 * @property {string} view_type - view_type
 * @property {GUID} appDefId - appDefId of the source
 * @property {string} origin - my invoices,preview
 * @property {string} origin_device - web,native
 * @property {string} platform - platform
 * @property {string} msid - msid
 * @property {GUID} invoice_id - invoice guid
 * @property {boolean} fully_paid - true for fully paid selected, false for partial payment selected
 * @return {LogObject<wixInvoicesPaymentMethodClickParams>} LogObject<wixInvoicesPaymentMethodClickParams>
 */
export function wixInvoicesPaymentMethodClick(params) {
    return { evid: 8956, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'wixInvoicesToastIsShown' event (evid: 8957)
 *
 * Event description: When a payment is made by user ( Recorded, Moto) and Toast is shown.
 *
 * @param {wixInvoicesToastIsShownParams} params - The parameters for this event
 * @property {string} name - toast name, supplied by toast initiator
 * @property {string} view_type - view_type
 * @property {string} origin - "my invoices", "preview"
 * @property {string} type - standard, error, warning, success, premium
 * @property {string} platform - platform
 * @property {number} timeout - miliseconds to auto hide toast, 0 is sticky toast
 * @property {GUID} msid - metasite id
 * @return {LogObject<wixInvoicesToastIsShownParams>} LogObject<wixInvoicesToastIsShownParams>
 */
export function wixInvoicesToastIsShown(params) {
    return { evid: 8957, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'wixInvoicesRequestPaymentClickInAutomation' event (evid: 8958)
 *
 * Event description: Wix Invoices Request Payment click in Automation
 *
 * @param {wixInvoicesRequestPaymentClickInAutomationParams} params - The parameters for this event
 * @property {string} view_type - view_type
 * @property {string} origin - Chosen app in which this automation was clicked (Now only Bookings)
 * @property {string} origin_device - web,native
 * @property {string} platform - platform
 * @property {string} msid - msid
 * @return {LogObject<wixInvoicesRequestPaymentClickInAutomationParams>} LogObject<wixInvoicesRequestPaymentClickInAutomationParams>
 */
export function wixInvoicesRequestPaymentClickInAutomation(params) {
    return { evid: 8958, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'wixInvoicesChargeWithCreditCardClickInTheModalMoto' event (evid: 8959)
 *
 * Event description: Charge with credit card in modal click (MOTO)
 *
 * @param {wixInvoicesChargeWithCreditCardClickInTheModalMotoParams} params - The parameters for this event
 * @property {string} view_type - view_type
 * @property {boolean} is_new - New or Edited Invoice (True Or False)
 * @property {string} origin - my invoices,preview,create invoice
 * @property {string} origin_device - web,native
 * @property {GUID} invoiceSource - invoice_source_id
 * @property {string} type - MOTO/POS
 * @property {string} platform - plstform
 * @property {string} msid - msid
 * @property {GUID} invoice_id - invoice guid
 * @property {boolean} fully_paid - true for fully paid selected, false for partial payment selected
 * @return {LogObject<wixInvoicesChargeWithCreditCardClickInTheModalMotoParams>} LogObject<wixInvoicesChargeWithCreditCardClickInTheModalMotoParams>
 */
export function wixInvoicesChargeWithCreditCardClickInTheModalMoto(params) {
    return { evid: 8959, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'wixInvoicesMotoCashierWidgetIsShown' event (evid: 8960)
 *
 * Event description: When a user is choosing MOTO, cashier widget is shown
 *
 * @param {wixInvoicesMotoCashierWidgetIsShownParams} params - The parameters for this event
 * @property {number} totalAmountLong - Invoice total amount
 * @property {string} name - Opened/Clicked Charge/Processed ( Three stages defines the flow, when modal is opened and a user put details in cashiers modal, then user is clicking charge and final stage if the data is good it is processing). Exact values: 'opened' | 'clicked charge' | 'paid'
 * @property {boolean} is_deposit - invoice has deposit
 * @property {string} view_type - view_type
 * @property {boolean} is_new - New or Edited Invoice
 * @property {string} origin - origin
 * @property {string} currency - currency of the amount paid
 * @property {number} paidAmountLong - Total amount that is paid, comes only when name=paid or name-clickedcharge
 * @property {string} type - MOTO/POS
 * @property {string} platform - platform
 * @property {GUID} msid - metasite id
 * @property {GUID} invoice_id - invoice_id
 * @property {boolean} fully_paid - Is the full invoice amount is going to be paid or part of the total amount
 * @return {LogObject<wixInvoicesMotoCashierWidgetIsShownParams>} LogObject<wixInvoicesMotoCashierWidgetIsShownParams>
 */
export function wixInvoicesMotoCashierWidgetIsShown(params) {
    return { evid: 8960, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'wixInvoicesMotoPaidModal' event (evid: 8961)
 *
 * Event description: When a user paid invoice with MOTO and modal (Deposit or full amount is shown)
 *
 * @param {wixInvoicesMotoPaidModalParams} params - The parameters for this event
 * @property {boolean} is_deposit - true/false
 * @property {string} view_type - view_type
 * @property {string} origin - origin
 * @property {string} origin_device - web,native
 * @property {string} platform - platform
 * @property {GUID} msid - metasite id
 * @property {GUID} invoice_id - invoice_guid
 * @return {LogObject<wixInvoicesMotoPaidModalParams>} LogObject<wixInvoicesMotoPaidModalParams>
 */
export function wixInvoicesMotoPaidModal(params) {
    return { evid: 8961, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'wixInvoicesAutomationDynamicValueClick' event (evid: 8963)
 *
 * Event description: When a user is clicking on dynamic value
 *
 * @param {wixInvoicesAutomationDynamicValueClickParams} params - The parameters for this event
 * @property {string} view_type - view_type
 * @property {string} origin - Chosen app in which this automation was clicked (Now only Bookings)
 * @property {string} origin_device - web,native
 * @property {string} platform - platform
 * @property {string} msid - msid
 * @property {string} action - click/add
 * @return {LogObject<wixInvoicesAutomationDynamicValueClickParams>} LogObject<wixInvoicesAutomationDynamicValueClickParams>
 */
export function wixInvoicesAutomationDynamicValueClick(params) {
    return { evid: 8963, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'wixInvoicesClickingOnNextMobile' event (evid: 8965)
 *
 * Event description: When a user is clicking on ‘Next’ while creating or Previewing existing
 *
 * @param {wixInvoicesClickingOnNextMobileParams} params - The parameters for this event
 * @property {string} view_type - view_type
 * @property {string} status - Creation Form/Draft
 * @property {string} invoiceSource - app def id
 * @property {string} platform - web/mobile
 * @property {GUID} msid - --
 * @property {GUID} invoice_id - invoice_id
 * @return {LogObject<wixInvoicesClickingOnNextMobileParams>} LogObject<wixInvoicesClickingOnNextMobileParams>
 */
export function wixInvoicesClickingOnNextMobile(params) {
    return { evid: 8965, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'wixInvoicesBannerToUpgradeToPremiumShown' event (evid: 8966)
 *
 * Event description: Banner to upgrade to Premium shown
 *
 * @param {wixInvoicesBannerToUpgradeToPremiumShownParams} params - The parameters for this event
 * @property {string} name - banner name (upgrade to business premium)
 * @property {string} view_type - view_type
 * @property {string} origin - origin page, my invoices ( on mobile, when creating from list), create invoice - on web, when creating for the first time
 * @property {string} origin_device - web,native
 * @property {string} platform - platform
 * @property {GUID} msid - msid
 * @return {LogObject<wixInvoicesBannerToUpgradeToPremiumShownParams>} LogObject<wixInvoicesBannerToUpgradeToPremiumShownParams>
 */
export function wixInvoicesBannerToUpgradeToPremiumShown(params) {
    return { evid: 8966, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'wixInvoicesBannerToUpgradeToPremiumClick' event (evid: 8967)
 *
 * Event description: Banner to upgrade to Premium click
 *
 * @param {wixInvoicesBannerToUpgradeToPremiumClickParams} params - The parameters for this event
 * @property {string} name - upgrade to business premium
 * @property {string} view_type - view_type
 * @property {string} origin - banner, modal which shows when clicking on ( Send via email, Send in Invoice Form, Share link, Charge with Credit card)
 * @property {string} origin_device - web,native
 * @property {string} platform - platform
 * @property {GUID} msid - msid
 * @return {LogObject<wixInvoicesBannerToUpgradeToPremiumClickParams>} LogObject<wixInvoicesBannerToUpgradeToPremiumClickParams>
 */
export function wixInvoicesBannerToUpgradeToPremiumClick(params) {
    return { evid: 8967, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'wixInvoicesOpenShareLinkModal' event (evid: 8968)
 *
 * Event description: When share link modal is opened
 *
 * @param {wixInvoicesOpenShareLinkModalParams} params - The parameters for this event
 * @property {GUID} externalId - An external id of an entity, relevant to the invoiceSource application
 * @property {string} view_type - view_type
 * @property {GUID} invoiceId - invoiceId
 * @property {string} origin - more actions/invoice preview
 * @property {string} status - Creation form/Draft/Sent/Paid
 * @property {GUID} appdefid - appdefid of the source
 * @property {string} platform - platform
 * @property {string} msid - msid
 * @return {LogObject<wixInvoicesOpenShareLinkModalParams>} LogObject<wixInvoicesOpenShareLinkModalParams>
 */
export function wixInvoicesOpenShareLinkModal(params) {
    return { evid: 8968, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'wixInvoicesBannerToConnectPaymentMethods' event (evid: 8969)
 *
 * Event description: Wix Invoices- Banner to connect Payment Methods
 *
 * @param {wixInvoicesBannerToConnectPaymentMethodsParams} params - The parameters for this event
 * @property {string} name - banner name
 * @property {string} view_type - view_type
 * @property {string} origin - origin page, my invoices ( on mobile, when creating from list), create invoice - on web, when creating for the first time
 * @property {string} origin_device - web,native
 * @property {string} platform - platform
 * @property {GUID} msid - msid
 * @return {LogObject<wixInvoicesBannerToConnectPaymentMethodsParams>} LogObject<wixInvoicesBannerToConnectPaymentMethodsParams>
 */
export function wixInvoicesBannerToConnectPaymentMethods(params) {
    return { evid: 8969, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'wixInvoicesBannerToConnectPaymentMethodClick' event (evid: 8970)
 *
 * Event description: Wix Invoices - Banner to connect Payment Method click
 *
 * @param {wixInvoicesBannerToConnectPaymentMethodClickParams} params - The parameters for this event
 * @property {string} name - banner name
 * @property {string} view_type - view_type
 * @property {string} origin - origin page, my invoices ( on mobile, when creating from list), create invoice - on web, when creating for the first time
 * @property {string} origin_device - web,native
 * @property {string} platform - platform
 * @property {GUID} msid - msid
 * @return {LogObject<wixInvoicesBannerToConnectPaymentMethodClickParams>} LogObject<wixInvoicesBannerToConnectPaymentMethodClickParams>
 */
export function wixInvoicesBannerToConnectPaymentMethodClick(params) {
    return { evid: 8970, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'gizaFirstBiteIsShown' event (evid: 8971)
 *
 * Event description: When First Byte in session is shown in one of Giza's hosting platforms.
 * This is actually a 'feedback' event, the time to first feedback is the 'ms' in the implicit fields.
 *
 * @param {gizaFirstBiteIsShownParams} params - The parameters for this event
 * @property {string} hosting_platform - accountmanagr/bizmanagr/devcenter/etc.
 * @property {string} view_type - view_type
 * @property {string} platform - platform
 * @property {number} time_to_first_byte - time_to_first_byte
 * @property {string} hosting_platform_context_id - context id: when the context is site - msid, when the context is app_id (like in devCenter f.e) - appDefId. In account manager is null
 * @return {LogObject<gizaFirstBiteIsShownParams>} LogObject<gizaFirstBiteIsShownParams>
 */
export function gizaFirstBiteIsShown(params) {
    return { evid: 8971, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'wixInvoicesClickOnDynamicValueInAutomation' event (evid: 8973)
 *
 * Event description: Clicking on Dynamic Value
 *
 * @param {wixInvoicesClickOnDynamicValueInAutomationParams} params - The parameters for this event
 * @property {string} view_type - view_type
 * @property {string} origin - Chosen app in which this automation was clicked (Now only Bookings)
 * @property {string} origin_device - web,native
 * @property {string} platform - platform
 * @property {string} msid - msid
 * @return {LogObject<wixInvoicesClickOnDynamicValueInAutomationParams>} LogObject<wixInvoicesClickOnDynamicValueInAutomationParams>
 */
export function wixInvoicesClickOnDynamicValueInAutomation(params) {
    return { evid: 8973, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'priorityASuggestionCarouselInteraction' event (evid: 8974)
 *
 * Event description: when the user click on carousel
 *
 * @param {priorityASuggestionCarouselInteractionParams} params - The parameters for this event
 * @property {number} totalPriortySeen - if click next if it was 1,2,3 and 4 for previous
 * @property {string} view_type - view_type
 * @property {string} type - type of navigation (next, previous)
 * @property {string} platform - deprecated
 * @property {GUID} msid - msid
 * @return {LogObject<priorityASuggestionCarouselInteractionParams>} LogObject<priorityASuggestionCarouselInteractionParams>
 */
export function priorityASuggestionCarouselInteraction(params) {
    return { evid: 8974, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'priorityAEssentialShown' event (evid: 8975)
 *
 * Event description: when the users see the section
 *
 * @param {priorityAEssentialShownParams} params - The parameters for this event
 * @property {number} numOffer - how many offers he have in the section
 * @property {string} view_type - view_type
 * @property {boolean} isCarousel - true if he have carousel (more than 4 offers)
 * @property {string} platform - platform
 * @property {GUID} msid - msid
 * @return {LogObject<priorityAEssentialShownParams>} LogObject<priorityAEssentialShownParams>
 */
export function priorityAEssentialShown(params) {
    return { evid: 8975, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'automationAutomationWidgetClickOnLinkInTheSubtitle' event (evid: 8979)
 *
 * Event description: Automation - Automation widget - Click on link in the subtitle
 *
 * @param {automationAutomationWidgetClickOnLinkInTheSubtitleParams} params - The parameters for this event
 * @property {string} linkText - ‘manage automation’ etc.
 * @property {string} view_type - view_type
 * @property {string} origin - origin which this action was made
 * @property {string} destinationPage - where the link lead to (i.e ‘wizard’ / ‘automation main page’)
 * @property {string} type - widget type -row, dashboard , v2 etc
 * @property {string} platform - platform
 * @property {GUID} msid - msid
 * @return {LogObject<automationAutomationWidgetClickOnLinkInTheSubtitleParams>} LogObject<automationAutomationWidgetClickOnLinkInTheSubtitleParams>
 */
export function automationAutomationWidgetClickOnLinkInTheSubtitle(params) {
    return { evid: 8979, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'automationsVerifyConfigErrorDisplayToTheUser' event (evid: 8980)
 *
 * Event description: Automations - verify config - error display to the user
 *
 * @param {automationsVerifyConfigErrorDisplayToTheUserParams} params - The parameters for this event
 * @property {string} ctaText - The text on cta button
 * @property {string} providerAppId - error provider app id
 * @property {string} location - ‘wizard’/ ’sidebar’
 * @property {string} displayType - ‘display’/’hover’/’popup’
 * @property {string} errorJson - error_json
 * @property {number} numOfErrors - num_of_errors in the automation
 * @property {string} errorIndex - error location between all errors
 * @property {string} view_type - view_type
 * @property {string} errorProvider - error app provider
 * @property {GUID} rule_id - rule_id
 * @property {string} errorConfiguration - error id
 * @property {string} triggerKey - trigger_key
 * @property {string} flow - ‘create’/’edit
 * @property {string} platform - platform
 * @property {GUID} msid - msid
 * @return {LogObject<automationsVerifyConfigErrorDisplayToTheUserParams>} LogObject<automationsVerifyConfigErrorDisplayToTheUserParams>
 */
export function automationsVerifyConfigErrorDisplayToTheUser(params) {
    return { evid: 8980, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'automationsVerifyConfigUserClickOnCta' event (evid: 8981)
 *
 * Event description: Automations - verify config - user click on CTA
 *
 * @param {automationsVerifyConfigUserClickOnCtaParams} params - The parameters for this event
 * @property {string} ctaText - The text on cta button
 * @property {string} providerAppId - providerAppId
 * @property {string} location - ‘wizard’/ ’sidebar’
 * @property {string} displayType - ‘display’/’hover’/’popup’
 * @property {string} errorJson - error_json
 * @property {number} numOfErrors - num_of_errors in the automation
 * @property {string} errorIndex - error location between all errors
 * @property {string} view_type - view_type
 * @property {string} errorProvider - error app provider
 * @property {GUID} rule_id - rule_id
 * @property {string} errorConfiguration - error id
 * @property {string} flow - ‘create’/’edit
 * @property {string} platform - platform
 * @property {GUID} msid - msid
 * @return {LogObject<automationsVerifyConfigUserClickOnCtaParams>} LogObject<automationsVerifyConfigUserClickOnCtaParams>
 */
export function automationsVerifyConfigUserClickOnCta(params) {
    return { evid: 8981, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'automationsVerifyConfigErrorShowHideToTheUser' event (evid: 8982)
 *
 * Event description: Automations - verify config - error show/hide to the user
 *
 * @param {automationsVerifyConfigErrorShowHideToTheUserParams} params - The parameters for this event
 * @property {string} providerAppId - providerAppId
 * @property {string} location - ‘wizard’/ ’sidebar’
 * @property {string} displayType - ‘display’/’hover’/’popup’
 * @property {string} errorJson - error_json
 * @property {string} view_type - view_type
 * @property {GUID} rule_id - rule_id
 * @property {string} errorConfiguration - error id
 * @property {string} platform - platform
 * @property {GUID} msid - msid
 * @property {string} action - ’hide’/’show’
 * @return {LogObject<automationsVerifyConfigErrorShowHideToTheUserParams>} LogObject<automationsVerifyConfigErrorShowHideToTheUserParams>
 */
export function automationsVerifyConfigErrorShowHideToTheUser(params) {
    return { evid: 8982, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'automationsVerifyConfigUserClickOnCheckIssueAgain' event (evid: 8983)
 *
 * Event description: Automations - verify config - user click on check issue again
 *
 * @param {automationsVerifyConfigUserClickOnCheckIssueAgainParams} params - The parameters for this event
 * @property {string} providerAppId - providerAppId
 * @property {string} location - ‘wizard’/ ’sidebar’
 * @property {string} errorJson - error_json
 * @property {number} numOfErrors - num_of_errors in the automation
 * @property {string} errorIndex - error location between all errors
 * @property {string} view_type - view_type
 * @property {string} errorProvider - error app provider
 * @property {GUID} rule_id - rule_id
 * @property {string} errorConfiguration - error id
 * @property {string} flow - ‘create’/’edit
 * @property {string} platform - platform
 * @property {GUID} msid - msid
 * @return {LogObject<automationsVerifyConfigUserClickOnCheckIssueAgainParams>} LogObject<automationsVerifyConfigUserClickOnCheckIssueAgainParams>
 */
export function automationsVerifyConfigUserClickOnCheckIssueAgain(params) {
    return { evid: 8983, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'automationsVerifyConfigClickOnButtonInVerifyConfigPopupModal' event (evid: 8984)
 *
 * Event description: Automations - verify config - click on button in verify config popup modal
 *
 * @param {automationsVerifyConfigClickOnButtonInVerifyConfigPopupModalParams} params - The parameters for this event
 * @property {string} providerAppId - providerAppId
 * @property {number} numOfErrors - num_of_errors in the automation
 * @property {string} view_type - view_type
 * @property {GUID} rule_id - rule_id
 * @property {string} errorConfiguration - error id
 * @property {string} flow - ‘create’/’edit
 * @property {string} buttonName - ‘activate anyway’/’keep editing’ /  ‘X’ etc
 * @property {string} platform - platform
 * @property {GUID} msid - msid
 * @return {LogObject<automationsVerifyConfigClickOnButtonInVerifyConfigPopupModalParams>} LogObject<automationsVerifyConfigClickOnButtonInVerifyConfigPopupModalParams>
 */
export function automationsVerifyConfigClickOnButtonInVerifyConfigPopupModal(params) {
    return { evid: 8984, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'automationGetQuotaRiskCounterDisplay' event (evid: 8987)
 *
 * Event description: Automation - Get quota - Risk counter display
 *
 * @param {automationGetQuotaRiskCounterDisplayParams} params - The parameters for this event
 * @property {string} view_type - view_type
 * @property {number} numOfRisks - quotas with risks
 * @property {string} platform - platform
 * @property {GUID} msid - msid
 * @return {LogObject<automationGetQuotaRiskCounterDisplayParams>} LogObject<automationGetQuotaRiskCounterDisplayParams>
 */
export function automationGetQuotaRiskCounterDisplay(params) {
    return { evid: 8987, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'automationGetQuotaClickOnManageYourQuota' event (evid: 8988)
 *
 * Event description: Automation - Get quota - Click on ‘manage your quota’
 *
 * @param {automationGetQuotaClickOnManageYourQuotaParams} params - The parameters for this event
 * @property {string} view_type - view_type
 * @property {number} numOfRisks - quotas with risks
 * @property {string} platform - platform
 * @property {GUID} msid - msid
 * @return {LogObject<automationGetQuotaClickOnManageYourQuotaParams>} LogObject<automationGetQuotaClickOnManageYourQuotaParams>
 */
export function automationGetQuotaClickOnManageYourQuota(params) {
    return { evid: 8988, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'automationGetQuotaViewOrClickOnQuotaInQuotaManagerSeparateEventPerEachQuota' event (evid: 8990)
 *
 * Event description: When user see or click on a quota ( ‘display’/ ‘click on tooltip’) from automation quota manager
 *
 * @param {automationGetQuotaViewOrClickOnQuotaInQuotaManagerSeparateEventPerEachQuotaParams} params - The parameters for this event
 * @property {string} ctaText - The text on cta button
 * @property {string} eventType - ‘display’/ ‘click on tooltip’
 * @property {number} subSectionIndex - quota location in section
 * @property {string} quotaProviderId - action provider app id
 * @property {string} actionKey - action key
 * @property {number} maxQuotaNumber - max_quota_number
 * @property {string} view_type - view_type
 * @property {number} actionSectionIndex - action location
 * @property {boolean} isAtRisk - is_at_risk
 * @property {string} quotaName - quota_name
 * @property {string} platform - platform
 * @property {number} actionSectionCount - How many diffrent actions in manager
 * @property {GUID} msid - msid
 * @property {number} currentNumber - current_number
 * @return {LogObject<automationGetQuotaViewOrClickOnQuotaInQuotaManagerSeparateEventPerEachQuotaParams>} LogObject<automationGetQuotaViewOrClickOnQuotaInQuotaManagerSeparateEventPerEachQuotaParams>
 */
export function automationGetQuotaViewOrClickOnQuotaInQuotaManagerSeparateEventPerEachQuota(params) {
    return { evid: 8990, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'automationsExpertModeTurnOnOff' event (evid: 8992)
 *
 * Event description: Automations > Expert mode > turn on/ off
 *
 * @param {automationsExpertModeTurnOnOffParams} params - The parameters for this event
 * @property {string} view_type - view_type
 * @property {string} platform - platform
 * @property {GUID} msid - msid
 * @property {string} value - value
 * @return {LogObject<automationsExpertModeTurnOnOffParams>} LogObject<automationsExpertModeTurnOnOffParams>
 */
export function automationsExpertModeTurnOnOff(params) {
    return { evid: 8992, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'clickOnAddAtTheDynamicFieldModal' event (evid: 8993)
 *
 * Event description: The event will be sent when the user clicks 'add' at the dynamic value modal.
 *
 * @param {clickOnAddAtTheDynamicFieldModalParams} params - The parameters for this event
 * @property {string} format - will be sent only for a date value
 * @property {string} actionKey - action English key
 * @property {string} view_type - view_type
 * @property {GUID} actionAppId - action provider app id
 * @property {string} platform - platform
 * @property {GUID} msid - msid
 * @property {string} inputType - input_type
 * @property {string} value - input value
 * @return {LogObject<clickOnAddAtTheDynamicFieldModalParams>} LogObject<clickOnAddAtTheDynamicFieldModalParams>
 */
export function clickOnAddAtTheDynamicFieldModal(params) {
    return { evid: 8993, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'automationGetQuotaClickOnQuotaCtaInQuotaManager' event (evid: 8994)
 *
 * Event description: When user click on a quotaa CTA from automation quota manager
 *
 * @param {automationGetQuotaClickOnQuotaCtaInQuotaManagerParams} params - The parameters for this event
 * @property {string} ctaText - The text on cta button
 * @property {string} quotaProviderId - action provider app id
 * @property {string} actionKey - action key
 * @property {string} view_type - view_type
 * @property {number} actionSectionIndex - actionSectionIndex
 * @property {boolean} isAtRisk - At least one at risk
 * @property {string} quotaName - quota_name
 * @property {string} platform - platform
 * @property {number} actionSectionCount - actionSectionCount
 * @property {GUID} msid - msid
 * @return {LogObject<automationGetQuotaClickOnQuotaCtaInQuotaManagerParams>} LogObject<automationGetQuotaClickOnQuotaCtaInQuotaManagerParams>
 */
export function automationGetQuotaClickOnQuotaCtaInQuotaManager(params) {
    return { evid: 8994, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'getBrandedAppAlertIsShownAutomationSendAPushNotification' event (evid: 8995)
 *
 * Event description: The event will be sent when the Get Branded app alert is shown at the Automation send a push notification
 *
 * @param {getBrandedAppAlertIsShownAutomationSendAPushNotificationParams} params - The parameters for this event
 * @property {GUID} actionId - id uniqe to action
 * @property {string} view_type - view_type
 * @property {GUID} rule_id - rule_id
 * @property {string} triggerKey - The trigger key
 * @property {GUID} actionAppId - the app id of the vertical/company id of the action provider
 * @property {string} platform - platform
 * @property {GUID} msid - msid
 * @return {LogObject<getBrandedAppAlertIsShownAutomationSendAPushNotificationParams>} LogObject<getBrandedAppAlertIsShownAutomationSendAPushNotificationParams>
 */
export function getBrandedAppAlertIsShownAutomationSendAPushNotification(params) {
    return { evid: 8995, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'automationsWizardRemoveTimingCondition' event (evid: 8996)
 *
 * Event description: user remove timing/condition in automation wizard
 *
 * @param {automationsWizardRemoveTimingConditionParams} params - The parameters for this event
 * @property {string} flowType - flow in which the save happens: {create, edit}
 * @property {string} recipe_name - recipe name
 * @property {string} view_type - view_type
 * @property {GUID} rule_id - if this trigger all ready customized, null if it first time customization
 * @property {string} section - ‘timing’ / ‘condition’
 * @property {string} triggerApp - trigger vertical / app / TPA
 * @property {string} platform - platform
 * @property {GUID} msid - msid
 * @property {string} action - ‘click on remove’ / ‘approve deletion’
 * @property {string} triggerName - triggerName
 * @property {number} index - the action number when multi action
 * @return {LogObject<automationsWizardRemoveTimingConditionParams>} LogObject<automationsWizardRemoveTimingConditionParams>
 */
export function automationsWizardRemoveTimingCondition(params) {
    return { evid: 8996, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'automationsWizardLimitFrequency' event (evid: 8997)
 *
 * Event description: Automations > Wizard > limit frequency
 *
 * @param {automationsWizardLimitFrequencyParams} params - The parameters for this event
 * @property {string} flowType - flow in which the save happens: {create, edit}
 * @property {string} recipe_name - recipe name
 * @property {string} view_type - view_type
 * @property {GUID} rule_id - if this trigger all ready customized, null if it first time customization
 * @property {string} triggerApp - trigger_app
 * @property {string} platform - platform
 * @property {GUID} msid - msid
 * @property {string} value - value of rule
 * @property {string} triggerName - trigger_name
 * @return {LogObject<automationsWizardLimitFrequencyParams>} LogObject<automationsWizardLimitFrequencyParams>
 */
export function automationsWizardLimitFrequency(params) {
    return { evid: 8997, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'faSetupClickFromAccountSecurityBox' event (evid: 8998)
 *
 * Event description: The user clicked on '2fa enable/edit' from account security box in account settings
 *
 * @param {faSetupClickFromAccountSecurityBoxParams} params - The parameters for this event
 * @property {string} context - "enable"/"edit"/"disable"
 * @property {string} view_type - view_type
 * @property {string} platform - platform
 * @return {LogObject<faSetupClickFromAccountSecurityBoxParams>} LogObject<faSetupClickFromAccountSecurityBoxParams>
 */
export function faSetupClickFromAccountSecurityBox(params) {
    return { evid: 8998, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'activityLoginSeeRecentLoginsClick' event (evid: 8999)
 *
 * Event description: The user clicked on 'See recent logins' from the account security box in account settings
 *
 * @param {activityLoginSeeRecentLoginsClickParams} params - The parameters for this event
 * @property {string} view_type - view_type
 * @property {string} platform - platform
 * @return {LogObject<activityLoginSeeRecentLoginsClickParams>} LogObject<activityLoginSeeRecentLoginsClickParams>
 */
export function activityLoginSeeRecentLoginsClick(params) {
    return { evid: 8999, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'quotesDeleteQuoteClick' event (evid: 90)
 *
 * Event description: delete quote click
 *
 * @param {quotesDeleteQuoteClickParams} params - The parameters for this event
 * @property {string} view_type - view_type
 * @property {string} origin_device - web,native
 * @property {string} platform - platform
 * @property {string} msid - msid
 * @property {GUID} quoteId - quote guid
 * @return {LogObject<quotesDeleteQuoteClickParams>} LogObject<quotesDeleteQuoteClickParams>
 */
export function quotesDeleteQuoteClick(params) {
    return { evid: 90, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'activityLogLogOutFromAllDevicesClick' event (evid: 9003)
 *
 * Event description: The user clicked on 'Log out from all devices' from Login activity in account settings
 *
 * @param {activityLogLogOutFromAllDevicesClickParams} params - The parameters for this event
 * @property {string} view_type - view_type
 * @property {string} platform - platform
 * @return {LogObject<activityLogLogOutFromAllDevicesClickParams>} LogObject<activityLogLogOutFromAllDevicesClickParams>
 */
export function activityLogLogOutFromAllDevicesClick(params) {
    return { evid: 9003, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'activityLogViewLoginHistoryClick' event (evid: 9004)
 *
 * Event description: The user clicked on 'View login history' from Login activity in account settings
 *
 * @param {activityLogViewLoginHistoryClickParams} params - The parameters for this event
 * @property {string} view_type - view_type
 * @property {string} platform - platform
 * @return {LogObject<activityLogViewLoginHistoryClickParams>} LogObject<activityLogViewLoginHistoryClickParams>
 */
export function activityLogViewLoginHistoryClick(params) {
    return { evid: 9004, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'activityLogNotYouClick' event (evid: 9005)
 *
 * Event description: The user clicked on 'Not you?' on a specific device from Login activity box in account settings
 *
 * @param {activityLogNotYouClickParams} params - The parameters for this event
 * @property {string} deviceName - OS Device name (Android / Mac OS ....)
 * @property {string} browser - Browser name (Chrome / Firefox ... )
 * @property {string} view_type - view_type
 * @property {string} loaction - Location of the device (city + Country)
 * @property {DateTime} lastLoginDate - Last login date and time of the device
 * @property {string} origin - "acccount_settings" / "login_history_modal"
 * @property {string} platform - platform
 * @return {LogObject<activityLogNotYouClickParams>} LogObject<activityLogNotYouClickParams>
 */
export function activityLogNotYouClick(params) {
    return { evid: 9005, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'automationsWizardUserClickOnConditionSection' event (evid: 9006)
 *
 * Event description: Automations wizard > user click on condition section (open section or close)
 *
 * @param {automationsWizardUserClickOnConditionSectionParams} params - The parameters for this event
 * @property {string} flowType - user create or edit automation
 * @property {string} recipe_name - recipe name
 * @property {string} view_type - view_type
 * @property {GUID} rule_id - if this trigger all ready customized, null if it first time customization
 * @property {GUID} triggerAppId - trigger_app_id
 * @property {string} triggerKey - trigger_key
 * @property {number} actionIndex - in multi action automations
 * @property {string} platform - platform
 * @property {GUID} msid - msid
 * @property {string} action - user action: addd condition/ close/open section
 * @return {LogObject<automationsWizardUserClickOnConditionSectionParams>} LogObject<automationsWizardUserClickOnConditionSectionParams>
 */
export function automationsWizardUserClickOnConditionSection(params) {
    return { evid: 9006, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'automationsWizardUserCustomizeCondition' event (evid: 9007)
 *
 * Event description: Automations wizard > user customize condition. all changes in condition section
 *
 * @param {automationsWizardUserCustomizeConditionParams} params - The parameters for this event
 * @property {string} flowType - flow in which the save happens: {create, edit}
 * @property {string} recipe_name - recipe name
 * @property {string} view_type - view_type
 * @property {GUID} rule_id - if this trigger all ready customized, null if it first time customization
 * @property {GUID} triggerAppId - trigger_app_id
 * @property {string} triggerKey - trigger_key
 * @property {number} actionIndex - action_index
 * @property {string} fieldType - field path, operator, value 1, value 2
 * @property {string} platform - platform
 * @property {string} dropdownType - field path, operator, value 1, value 2
 * @property {GUID} msid - msid
 * @property {string} value - user input
 * @property {number} criteriaIndex - 1,2,...
 * @return {LogObject<automationsWizardUserCustomizeConditionParams>} LogObject<automationsWizardUserCustomizeConditionParams>
 */
export function automationsWizardUserCustomizeCondition(params) {
    return { evid: 9007, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'automationsWizardUserRemoveConditionOrCriteria' event (evid: 9008)
 *
 * Event description: Automations wizard > user remove criteria in condition section
 *
 * @param {automationsWizardUserRemoveConditionOrCriteriaParams} params - The parameters for this event
 * @property {string} flowType - flow in which the save happens: {create, edit}
 * @property {string} recipe_name - recipe name
 * @property {boolean} finalRemove - is it the final step to delete
 * @property {string} view_type - view_type
 * @property {GUID} rule_id - if this trigger all ready customized, null if it first time customization
 * @property {GUID} triggerAppId - trigger_app_id
 * @property {string} triggerKey - trigger_key
 * @property {number} actionIndex - action_index
 * @property {string} platform - platform
 * @property {GUID} msid - msid
 * @property {string} item - criteria 1 / criteria 2/ criteria …’
 * @return {LogObject<automationsWizardUserRemoveConditionOrCriteriaParams>} LogObject<automationsWizardUserRemoveConditionOrCriteriaParams>
 */
export function automationsWizardUserRemoveConditionOrCriteria(params) {
    return { evid: 9008, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'automationsWizardUserAddCriteriaToCondition' event (evid: 9009)
 *
 * Event description: Automations wizard > user add criteria to condition
 *
 * @param {automationsWizardUserAddCriteriaToConditionParams} params - The parameters for this event
 * @property {string} flowType - flow in which the save happens: {create, edit}
 * @property {string} view_type - view_type
 * @property {GUID} rule_id - if this trigger all ready customized, null if it first time customization
 * @property {string} triggerKey - trigger_key
 * @property {number} actionIndex - action_index
 * @property {string} platform - platform
 * @property {GUID} msid - msid
 * @property {number} criteriaIndex - 2,3,4,..
 * @return {LogObject<automationsWizardUserAddCriteriaToConditionParams>} LogObject<automationsWizardUserAddCriteriaToConditionParams>
 */
export function automationsWizardUserAddCriteriaToCondition(params) {
    return { evid: 9009, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'activityLogLogOutFromDevicesModalCta' event (evid: 9010)
 *
 * Event description: Modal choice and CTA in the "log out from all devices" in the activity log in the account settings
 *
 * @param {activityLogLogOutFromDevicesModalCtaParams} params - The parameters for this event
 * @property {string} view_type - view_type
 * @property {string} cta - "next" / "confirm"
 * @property {string} choice - ""change_password " / "log_out_all_devices"
 * @property {string} platform - platform
 * @return {LogObject<activityLogLogOutFromDevicesModalCtaParams>} LogObject<activityLogLogOutFromDevicesModalCtaParams>
 */
export function activityLogLogOutFromDevicesModalCta(params) {
    return { evid: 9010, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'activityLogDonTRecognizeThisDeviceModalCta' event (evid: 9011)
 *
 * Event description: CTA in the "Don't recognize this device" in the activity log in the account settings
 *
 * @param {activityLogDonTRecognizeThisDeviceModalCtaParams} params - The parameters for this event
 * @property {string} view_type - view_type
 * @property {string} origin - "login_history_table" / "login_history_modal"
 * @property {string} cta - "change_password" / "cancel"
 * @property {string} platform - platform
 * @return {LogObject<activityLogDonTRecognizeThisDeviceModalCtaParams>} LogObject<activityLogDonTRecognizeThisDeviceModalCtaParams>
 */
export function activityLogDonTRecognizeThisDeviceModalCta(params) {
    return { evid: 9011, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'createNewWorkspace' event (evid: 9014)
 *
 * Event description: user clicks on  create a new workspace
 *
 * @param {createNewWorkspaceParams} params - The parameters for this event
 * @property {number} num_workspaces - number of workspaces (=accounts) the logged user is connected to
 * @property {string} page_view - Dashboard / my sites
 * @property {string} view_type - view_type
 * @property {string} account_type - the current logged account id's type (workspace type), DIY/Partners/Studio/enterprise
 * @property {string} origin - workspace selector
 * @property {string} platform - platform
 * @return {LogObject<createNewWorkspaceParams>} LogObject<createNewWorkspaceParams>
 */
export function createNewWorkspace(params) {
    return { evid: 9014, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'workspaceSelectorSelectWorkspace' event (evid: 9015)
 *
 * Event description: when the user clicks on a workspace in the workspace selector
 *
 * @param {workspaceSelectorSelectWorkspaceParams} params - The parameters for this event
 * @property {number} num_workspaces - number of workspaces (=accounts) the logged user is connected to
 * @property {string} page_view - Dashboard / my sites
 * @property {number} clicked_workspace_index - the location of the workspace in the workspace selector list  (0 is first, 1 is second…)
 * @property {string} view_type - view_type
 * @property {string} account_type - the current logged account id's type (workspace type), DIY/Partners/Studio/enterprise
 * @property {GUID} clicked_workspace_id - the selected workspace's id
 * @property {string} clicked_workspace_role - the logged user's role in the selected workspace
 * @property {string} platform - platform
 * @return {LogObject<workspaceSelectorSelectWorkspaceParams>} LogObject<workspaceSelectorSelectWorkspaceParams>
 */
export function workspaceSelectorSelectWorkspace(params) {
    return { evid: 9015, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'workspaceActionMenuDropDownListShown' event (evid: 9016)
 *
 * Event description: user clicks on Workspace Setting of a specific workspace in the workspace selector
 *
 * @param {workspaceActionMenuDropDownListShownParams} params - The parameters for this event
 * @property {number} num_workspaces - number of workspaces (=accounts) the logged user is connected to
 * @property {string} page_view - Dashboard / my sites
 * @property {string} view_type - view_type
 * @property {string} account_type - the current logged account id's type (workspace type), DIY/Partners/Studio/enterprise
 * @property {string} platform - platform
 * @return {LogObject<workspaceActionMenuDropDownListShownParams>} LogObject<workspaceActionMenuDropDownListShownParams>
 */
export function workspaceActionMenuDropDownListShown(params) {
    return { evid: 9016, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'workspaceActionMenuItemClick' event (evid: 9017)
 *
 * Event description: when the user clicks on 'Learn more' in one of the workspace selector tooltips
 *
 * @param {workspaceActionMenuItemClickParams} params - The parameters for this event
 * @property {string} location - the tooltip's location (workspace selector info/ Workspace Action Menu)
 * @property {number} num_workspaces - number of workspaces (=accounts) the logged user is connected to
 * @property {string} page_view - Dashboard / my sites
 * @property {string} view_type - view_type
 * @property {string} account_type - the current logged account id's type (workspace type), DIY/Partners/Studio/enterprise
 * @property {Url} link - link to the KB the 'Learn more' referrer to
 * @property {string} platform - platform
 * @return {LogObject<workspaceActionMenuItemClickParams>} LogObject<workspaceActionMenuItemClickParams>
 */
export function workspaceActionMenuItemClick(params) {
    return { evid: 9017, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'workspaceSelectorClickOnLearnMoreInTooltips' event (evid: 9018)
 *
 * Event description: user clicks on one of the entry points to WixStudio
 *
 * @param {workspaceSelectorClickOnLearnMoreInTooltipsParams} params - The parameters for this event
 * @property {string} page_view - Dashboard / my sites
 * @property {string} view_type - view_type
 * @property {string} origin - the entry point location (account menu/header)
 * @property {string} platform - platform
 * @return {LogObject<workspaceSelectorClickOnLearnMoreInTooltipsParams>} LogObject<workspaceSelectorClickOnLearnMoreInTooltipsParams>
 */
export function workspaceSelectorClickOnLearnMoreInTooltips(params) {
    return { evid: 9018, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'workspaceSelectorWorkspaceSettingClick' event (evid: 9019)
 *
 * Event description: event send when a WixStudio entry point is shown
 *
 * @param {workspaceSelectorWorkspaceSettingClickParams} params - The parameters for this event
 * @property {string} page_view - Dashboard / my sites
 * @property {string} view_type - view_type
 * @property {string} origin - the entry point location
 * @property {string} platform - platform
 * @return {LogObject<workspaceSelectorWorkspaceSettingClickParams>} LogObject<workspaceSelectorWorkspaceSettingClickParams>
 */
export function workspaceSelectorWorkspaceSettingClick(params) {
    return { evid: 9019, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'dashboardSiteClickRadioButtonOnTransferSiteMiddleStepWindow' event (evid: 9020)
 *
 * Event description: user licked one of the radio buttons on the middle step window in transfer site flow, fired every time the user clicks on one
 *
 * @param {dashboardSiteClickRadioButtonOnTransferSiteMiddleStepWindowParams} params - The parameters for this event
 * @property {string} view_type - view_type
 * @property {string} choice - 'client', 'agency', 'other'
 * @property {string} platform - platform
 * @property {GUID} msid - msid
 * @return {LogObject<dashboardSiteClickRadioButtonOnTransferSiteMiddleStepWindowParams>} LogObject<dashboardSiteClickRadioButtonOnTransferSiteMiddleStepWindowParams>
 */
export function dashboardSiteClickRadioButtonOnTransferSiteMiddleStepWindow(params) {
    return { evid: 9020, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'accountSettingsCloseYourWorkspacePageLoad' event (evid: 9021)
 *
 * Event description: user enter the "close workspace" page
 *
 * @param {accountSettingsCloseYourWorkspacePageLoadParams} params - The parameters for this event
 * @property {string} view_type - view_type
 * @property {string} platform - platform
 * @return {LogObject<accountSettingsCloseYourWorkspacePageLoadParams>} LogObject<accountSettingsCloseYourWorkspacePageLoadParams>
 */
export function accountSettingsCloseYourWorkspacePageLoad(params) {
    return { evid: 9021, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'accountSettingsCloseYourWorkspaceCloseWorkspaceRequestSummited' event (evid: 9022)
 *
 * Event description: the user clicks on the "close workspace" button
 *
 * @param {accountSettingsCloseYourWorkspaceCloseWorkspaceRequestSummitedParams} params - The parameters for this event
 * @property {string} view_type - view_type
 * @property {string} reason - why are you closing the workspace
 * @property {string} platform - platform
 * @property {string} free_text - users feedback
 * @return {LogObject<accountSettingsCloseYourWorkspaceCloseWorkspaceRequestSummitedParams>} LogObject<accountSettingsCloseYourWorkspaceCloseWorkspaceRequestSummitedParams>
 */
export function accountSettingsCloseYourWorkspaceCloseWorkspaceRequestSummited(params) {
    return { evid: 9022, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'workspaceSettingsDeleteAccountWorkspace' event (evid: 9023)
 *
 * Event description: the user clicks on the "delete workspace"/"delete workspace and close account" button
 *
 * @param {workspaceSettingsDeleteAccountWorkspaceParams} params - The parameters for this event
 * @property {string} context - what button the user clicked - "delete workspace"/"delete workspace and close account"
 * @property {string} view_type - view_type
 * @property {string} platform - platform
 * @property {GUID} workspace_id - what workspace the user closes
 * @return {LogObject<workspaceSettingsDeleteAccountWorkspaceParams>} LogObject<workspaceSettingsDeleteAccountWorkspaceParams>
 */
export function workspaceSettingsDeleteAccountWorkspace(params) {
    return { evid: 9023, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'workspaceSettingsChangesSaved' event (evid: 9024)
 *
 * Event description: user clicks "save" on the workspace setting page after he did a change in the workspace name, prefix or both.
 *
 * @param {workspaceSettingsChangesSavedParams} params - The parameters for this event
 * @property {string} view_type - view_type
 * @property {string} changes - what the user changed when he clicked save ("name"/"prefix"/"name and prefix")
 * @property {string} platform - platform
 * @property {GUID} workspace_id - what workspace the user closes
 * @return {LogObject<workspaceSettingsChangesSavedParams>} LogObject<workspaceSettingsChangesSavedParams>
 */
export function workspaceSettingsChangesSaved(params) {
    return { evid: 9024, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'wixInvoicesBannerWhenCreatingInvoiceOrder' event (evid: 9025)
 *
 * Event description: When an Invoice is creating thru Invoice & Order F-nality, but customer information is needed
 *
 * @param {wixInvoicesBannerWhenCreatingInvoiceOrderParams} params - The parameters for this event
 * @property {string} name - Opened, Closed, Edit
 * @property {string} view_type - view_type
 * @property {string} platform - platform
 * @property {GUID} msid - metasite id
 * @return {LogObject<wixInvoicesBannerWhenCreatingInvoiceOrderParams>} LogObject<wixInvoicesBannerWhenCreatingInvoiceOrderParams>
 */
export function wixInvoicesBannerWhenCreatingInvoiceOrder(params) {
    return { evid: 9025, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'automationsResetPreinstalledAutomation' event (evid: 9026)
 *
 * Event description: Automations - reset preinstalled automation (action field:  ‘click on reset’ / ‘approve reset’)
 *
 * @param {automationsResetPreinstalledAutomationParams} params - The parameters for this event
 * @property {string} view_type - view_type
 * @property {GUID} rule_id - rule_id
 * @property {string} origin - where from the user clicked:  ‘table’ / ‘panel’ / ‘wizard’
 * @property {string} preinstalledName - preinstalled name
 * @property {string} platform - platform
 * @property {GUID} preinstalledId - preinstalled component id
 * @property {GUID} msid - msid
 * @property {string} action - ‘click on reset’ / ‘approve reset’
 * @return {LogObject<automationsResetPreinstalledAutomationParams>} LogObject<automationsResetPreinstalledAutomationParams>
 */
export function automationsResetPreinstalledAutomation(params) {
    return { evid: 9026, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'automationsResetPreinstalledAutomationHoverTooltip' event (evid: 9027)
 *
 * Event description: Automations - reset preinstalled automation - hover tooltip
 *
 * @param {automationsResetPreinstalledAutomationHoverTooltipParams} params - The parameters for this event
 * @property {string} view_type - view_type
 * @property {GUID} rule_id - rule_id
 * @property {string} origin - where from the user clicked:  ‘table’ / ‘panel’ / ‘wizard’
 * @property {string} preinstalledName - preinstalled name
 * @property {string} platform - platform
 * @property {GUID} preinstalledId - preinstalled component id
 * @property {GUID} msid - msid
 * @return {LogObject<automationsResetPreinstalledAutomationHoverTooltipParams>} LogObject<automationsResetPreinstalledAutomationHoverTooltipParams>
 */
export function automationsResetPreinstalledAutomationHoverTooltip(params) {
    return { evid: 9027, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'automationsResetPreinstalledAutomationResetStatusBmToast' event (evid: 9028)
 *
 * Event description: Automations - reset preinstalled automation - reset status (BM toast)
 *
 * @param {automationsResetPreinstalledAutomationResetStatusBmToastParams} params - The parameters for this event
 * @property {string} view_type - view_type
 * @property {GUID} rule_id - rule_id
 * @property {string} origin - where from the user clicked:  ‘table’ / ‘panel’ / ‘wizard’
 * @property {string} status - ‘failed’ / ‘success’
 * @property {string} preinstalledName - preinstalled name
 * @property {string} platform - platform
 * @property {GUID} preinstalledId - preinstalled component id
 * @property {GUID} msid - msid
 * @return {LogObject<automationsResetPreinstalledAutomationResetStatusBmToastParams>} LogObject<automationsResetPreinstalledAutomationResetStatusBmToastParams>
 */
export function automationsResetPreinstalledAutomationResetStatusBmToast(params) {
    return { evid: 9028, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'transferSiteSecondStepWindowViewClick' event (evid: 9031)
 *
 * Event description: user licked one of the radio buttons on the middle step window in transfer site flow, fired every time the user clicks on one
 *
 * @param {transferSiteSecondStepWindowViewClickParams} params - The parameters for this event
 * @property {string} clickType - keep role/create a copy/remove create a cope/remove keep role/remove transfer premium/transfer premium/transfer domain/remove transfer domain/null if view only
 * @property {string} view_type - view_type
 * @property {boolean} isPremium - is site premium
 * @property {string} platform - platform
 * @property {GUID} msid - msid
 * @return {LogObject<transferSiteSecondStepWindowViewClickParams>} LogObject<transferSiteSecondStepWindowViewClickParams>
 */
export function transferSiteSecondStepWindowViewClick(params) {
    return { evid: 9031, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'invoicesSettingsSelectPaymentsReceivedOption' event (evid: 9032)
 *
 * Event description: When the user changes the 'Payments received' section options in Invoices Settings
 *
 * @param {invoicesSettingsSelectPaymentsReceivedOptionParams} params - The parameters for this event
 * @property {string} view_type - view_type
 * @property {boolean} showTransactionDetails - whether to show payments received section in invoice
 * @property {string} platform - web/mobile
 * @property {GUID} msid - msid
 * @return {LogObject<invoicesSettingsSelectPaymentsReceivedOptionParams>} LogObject<invoicesSettingsSelectPaymentsReceivedOptionParams>
 */
export function invoicesSettingsSelectPaymentsReceivedOption(params) {
    return { evid: 9032, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'homeItemLoadedWithPimple' event (evid: 9035)
 *
 * Event description: Home Item Loaded With Pimple
 *
 * @param {homeItemLoadedWithPimpleParams} params - The parameters for this event
 * @property {string} view_type - view_type
 * @property {string} origin - sidebar/...
 * @property {number} counter - the counter
 * @property {string} type - action required
 * @property {string} platform - platform
 * @return {LogObject<homeItemLoadedWithPimpleParams>} LogObject<homeItemLoadedWithPimpleParams>
 */
export function homeItemLoadedWithPimple(params) {
    return { evid: 9035, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'hoverOnHomeItemWithPimple' event (evid: 9036)
 *
 * Event description: Hover on Home Item With Pimple
 *
 * @param {hoverOnHomeItemWithPimpleParams} params - The parameters for this event
 * @property {string} view_type - view_type
 * @property {string} origin - sidebar/...
 * @property {number} counter - the counter
 * @property {string} type - action required
 * @property {string} platform - ma
 * @return {LogObject<hoverOnHomeItemWithPimpleParams>} LogObject<hoverOnHomeItemWithPimpleParams>
 */
export function hoverOnHomeItemWithPimple(params) {
    return { evid: 9036, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'automationUserClickOnKb' event (evid: 9037)
 *
 * Event description: User click on KB in automation product
 *
 * @param {automationUserClickOnKbParams} params - The parameters for this event
 * @property {Url} kbUrl - kb_url
 * @property {string} linkLocation - wizard / home_page / widget / creation_modal
 * @property {string} view_type - view_type
 * @property {GUID} rule_id - if this trigger all ready customized, null if it first time customization
 * @property {string} kbName - kb_name
 * @property {string} platform - platform
 * @property {GUID} msid - msid
 * @return {LogObject<automationUserClickOnKbParams>} LogObject<automationUserClickOnKbParams>
 */
export function automationUserClickOnKb(params) {
    return { evid: 9037, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'automationErrorsAndIssuesInVeloAction' event (evid: 9038)
 *
 * Event description: Automation - errors in velo action 'run Velo code' display or not display
 *
 * @param {automationErrorsAndIssuesInVeloActionParams} params - The parameters for this event
 * @property {number} duration - duration until the error displays
 * @property {string} actionKey - action English key
 * @property {string} errorMessage - error_message
 * @property {string} flowType - create or edit
 * @property {GUID} actionId - action_id
 * @property {string} view_type - view_type
 * @property {number} actionIndex - first action =0
 * @property {GUID} actionAppId - action provider app id
 * @property {string} platform - platform
 * @property {GUID} msid - msid
 * @property {string} value - input value
 * @property {GUID} ruleId - rule_id
 * @return {LogObject<automationErrorsAndIssuesInVeloActionParams>} LogObject<automationErrorsAndIssuesInVeloActionParams>
 */
export function automationErrorsAndIssuesInVeloAction(params) {
    return { evid: 9038, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'searchInSitesDropdown' event (evid: 9039)
 *
 * Event description: The user searched for a site in the sites dropdown (in the header). will be sent when the users already see results
 *
 * @param {searchInSitesDropdownParams} params - The parameters for this event
 * @property {string} page_view - my-sites /dashboard / account settings
 * @property {string} view_type - view_type
 * @property {string} search_term - what did the user search?
 * @property {number} num_sites - how many sites connected to the current user?
 * @property {string} platform - platform
 * @property {GUID} msid - -
 * @property {number} num_results - how many search results are there?
 * @return {LogObject<searchInSitesDropdownParams>} LogObject<searchInSitesDropdownParams>
 */
export function searchInSitesDropdown(params) {
    return { evid: 9039, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'searchInSitesDropdownEndProcess' event (evid: 9040)
 *
 * Event description: How did the search for a site in the sites dropdown (in the header) end?
 *
 * @param {searchInSitesDropdownEndProcessParams} params - The parameters for this event
 * @property {string} page_view - my-sites /dashboard / account settings
 * @property {string} view_type - view_type
 * @property {string} search_term - what did the user search?
 * @property {string} end_type - how did the search end? Site selected / Search dismissed (even when closing site selector) / Show more results / Go to all sites
 * @property {number} num_sites - how many sites connected to the current user?
 * @property {string} platform - platform
 * @property {GUID} msid - -
 * @property {number} num_results - how many search results are there?
 * @return {LogObject<searchInSitesDropdownEndProcessParams>} LogObject<searchInSitesDropdownEndProcessParams>
 */
export function searchInSitesDropdownEndProcess(params) {
    return { evid: 9040, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'devModeOnEntryPoint' event (evid: 9041)
 *
 * Event description: when a user clicks on a dev mode on entry point
 *
 * @param {devModeOnEntryPointParams} params - The parameters for this event
 * @property {string} entryPoint - automations
 * @property {string} view_type - view_type
 * @property {boolean} status - true/false
 * @property {string} platform - platform
 * @property {string} action - dev_mode
 * @return {LogObject<devModeOnEntryPointParams>} LogObject<devModeOnEntryPointParams>
 */
export function devModeOnEntryPoint(params) {
    return { evid: 9041, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'quotesDeleteQuotePageOk' event (evid: 91)
 *
 * Event description: OK clicked in delete page
 *
 * @param {quotesDeleteQuotePageOkParams} params - The parameters for this event
 * @property {string} view_type - view_type
 * @property {string} origin_device - web,native
 * @property {string} platform - platform
 * @property {string} msid - msid
 * @property {GUID} quoteId - quote guid
 * @return {LogObject<quotesDeleteQuotePageOkParams>} LogObject<quotesDeleteQuotePageOkParams>
 */
export function quotesDeleteQuotePageOk(params) {
    return { evid: 91, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'quotesDeleteQuotePageCancel' event (evid: 92)
 *
 * Event description: cancel in delete page (for every close (cancel, x, background click))
 *
 * @param {quotesDeleteQuotePageCancelParams} params - The parameters for this event
 * @property {string} view_type - view_type
 * @property {string} origin_device - web,native
 * @property {string} platform - platform
 * @property {string} msid - msid
 * @property {GUID} quoteId - quote guid
 * @return {LogObject<quotesDeleteQuotePageCancelParams>} LogObject<quotesDeleteQuotePageCancelParams>
 */
export function quotesDeleteQuotePageCancel(params) {
    return { evid: 92, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'quotesMarkAsAccepted' event (evid: 93)
 *
 * Event description: Click on the 'send invoice' button (before the actual sending)
 *
 * @param {quotesMarkAsAcceptedParams} params - The parameters for this event
 * @property {GUID} instanceId - instance_id
 * @property {number} totalAmountLong - Total amount of the invoice, INTEGER multiplied by 100000
 * @property {boolean} createOrder - create_order
 * @property {GUID} uuid - uuid
 * @property {string} paymentType - 'one time','recurring'
 * @property {string} view_type - view_type
 * @property {GUID} invoiceId - invoice_guid
 * @property {string} origin - create invoice, edit invoice
 * @property {string} currency - currency
 * @property {string} platform - platform
 * @property {string} msid - msid
 * @return {LogObject<quotesMarkAsAcceptedParams>} LogObject<quotesMarkAsAcceptedParams>
 */
export function quotesMarkAsAccepted(params) {
    return { evid: 93, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'quotesCreateInvoiceFromQuotes' event (evid: 94)
 *
 * Event description: user send invoice
 *
 * @param {quotesCreateInvoiceFromQuotesParams} params - The parameters for this event
 * @property {GUID} instanceId - instance_id
 * @property {number} totalAmountLong - Total amount of the invoice, INTEGER multiplied by 100000
 * @property {boolean} createOrder - create order?
 * @property {GUID} uuid - uuid
 * @property {string} depositType - The optional type of the invoice deposit. Possible values: "FLAT"/"PERCENTAGE".
 * @property {string} paymentType - 'one time','recurring'
 * @property {string} view_type - view_type
 * @property {GUID} invoiceId - invoice_guid
 * @property {string} origin - origin
 * @property {string} invoiceTitle - invoiceTitle
 * @property {string} invoiceSource - by app_def_id
 * @property {string} currency - currency
 * @property {string} platform - platform
 * @property {string} msid - msid
 * @property {number} discountPercentage - discountPercentage
 * @return {LogObject<quotesCreateInvoiceFromQuotesParams>} LogObject<quotesCreateInvoiceFromQuotesParams>
 */
export function quotesCreateInvoiceFromQuotes(params) {
    return { evid: 94, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'quotesMarkAsAcceptedSrc5Evid95' event (evid: 95)
 *
 * Event description: User click on Mark as accepted
 *
 * @param {quotesMarkAsAcceptedSrc5Evid95Params} params - The parameters for this event
 * @property {string} view_type - view_type
 * @property {string} platform - platform
 * @property {string} msid - msid
 * @property {GUID} quoteId - quote guid
 * @return {LogObject<quotesMarkAsAcceptedSrc5Evid95Params>} LogObject<quotesMarkAsAcceptedSrc5Evid95Params>
 */
export function quotesMarkAsAcceptedSrc5Evid95(params) {
    return { evid: 95, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'quotesCreateInvoiceFromQuotesSrc5Evid96' event (evid: 96)
 *
 * Event description: User click on Create Invoice (from Price Quotes)
 *
 * @param {quotesCreateInvoiceFromQuotesSrc5Evid96Params} params - The parameters for this event
 * @property {string} view_type - view_type
 * @property {string} platform - platform
 * @property {string} msid - msid
 * @property {GUID} quoteId - quote guid
 * @return {LogObject<quotesCreateInvoiceFromQuotesSrc5Evid96Params>} LogObject<quotesCreateInvoiceFromQuotesSrc5Evid96Params>
 */
export function quotesCreateInvoiceFromQuotesSrc5Evid96(params) {
    return { evid: 96, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'removePhoneNumberRemoveClicked' event (evid: 97)
 *
 * Event description: verification pop up before deleting the phone
 *
 * @param {removePhoneNumberRemoveClickedParams} params - The parameters for this event
 * @property {string} view_type - view_type
 * @property {string} platform - platform
 * @return {LogObject<removePhoneNumberRemoveClickedParams>} LogObject<removePhoneNumberRemoveClickedParams>
 */
export function removePhoneNumberRemoveClicked(params) {
    return { evid: 97, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'removePhoneNumberRemoveNumberClicked' event (evid: 98)
 *
 * Event description: First button for remove phone number (in account settings page)
 *
 * @param {removePhoneNumberRemoveNumberClickedParams} params - The parameters for this event
 * @property {string} view_type - view_type
 * @property {string} platform - platform
 * @return {LogObject<removePhoneNumberRemoveNumberClickedParams>} LogObject<removePhoneNumberRemoveNumberClickedParams>
 */
export function removePhoneNumberRemoveNumberClicked(params) {
    return { evid: 98, src: 5, endpoint: 'dash', params: params };
}
/**
 * A function to create a log object for the 'removePhoneNumberPhoneRemovalAsked' event (evid: 99)
 *
 * Event description: After entering a verified password, removing phone process starts
 *
 * @param {removePhoneNumberPhoneRemovalAskedParams} params - The parameters for this event
 * @property {string} hashed_phone - hashed phone
 * @property {string} view_type - view_type
 * @property {string} platform - platform
 * @return {LogObject<removePhoneNumberPhoneRemovalAskedParams>} LogObject<removePhoneNumberPhoneRemovalAskedParams>
 */
export function removePhoneNumberPhoneRemovalAsked(params) {
    return { evid: 99, src: 5, endpoint: 'dash', params: params };
}
//# sourceMappingURL=index.js.map